webpackJsonp([1],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	__webpack_require__(1807);
	
	__webpack_require__(3964);
	
	__webpack_require__(2192);
	
	var _modulesBrowserInfo = __webpack_require__(2191);
	
	var _modulesBrowserInfo2 = _interopRequireDefault(_modulesBrowserInfo);
	
	var _AppBrowserSupportJsx = __webpack_require__(2171);
	
	var _AppBrowserSupportJsx2 = _interopRequireDefault(_AppBrowserSupportJsx);
	
	var _reactDom = __webpack_require__(41);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AppAppJsx = __webpack_require__(2168);
	
	var _AppAppJsx2 = _interopRequireDefault(_AppAppJsx);
	
	var browser = (0, _modulesBrowserInfo2['default'])();
	var supported = browser.version >= (_AppBrowserSupportJsx2['default'][browser.name] || 0);
	
	if (!supported) {
	  var lines = ['Este sitio no puede ser visualizado con este navegador.', 'Se requiere alguno de los siguientes navegadores:'];
	
	  for (var key in _AppBrowserSupportJsx2['default']) {
	    var val = key;
	
	    if (val == 'IE') {
	      val = 'Internet Explorer';
	    }
	
	    lines.push(val + ' ' + _AppBrowserSupportJsx2['default'][key] + '+');
	  }
	
	  document.documentElement.innerHTML = lines.join('<br />');
	} else {
	  var main = function main() {
	    var app = document.createElement('div');
	    document.body.appendChild(app);
	    _reactDom2['default'].render(_react2['default'].createElement(_AppAppJsx2['default'], null), app);
	  };
	
	  $.ajaxSetup({ cache: false });
	
	  if (!String.prototype.startsWith) {
	    String.prototype.startsWith = function (searchString, position) {
	      position = position || 0;
	      return this.indexOf(searchString, position) === position;
	    };
	  }
	
	  Number.isInteger = Number.isInteger || function (value) {
	    return typeof value === "number" && isFinite(value) && Math.floor(value) === value;
	  };
	
	  main();
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(35)))

/***/ }),

/***/ 29:
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function autoBind(that) {
	  var props = Object.getOwnPropertyNames(Object.getPrototypeOf(that));
	  var methodNames = props.filter(function (prop) {
	    return typeof that[prop] === 'function';
	  });
	  methodNames.forEach(function (methodName) {
	    var fn = that[methodName];
	    that[methodName] = function () {
	      return fn.apply(that, arguments);
	    };
	  });
	};

/***/ }),

/***/ 134:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _ramda = __webpack_require__(27);
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var NumberInput = (function (_React$Component) {
	  _inherits(NumberInput, _React$Component);
	
	  function NumberInput(props) {
	    _classCallCheck(this, NumberInput);
	
	    _get(Object.getPrototypeOf(NumberInput.prototype), 'constructor', this).call(this, props);
	
	    this.onChange = this.props.onChange || function () {
	      return 0;
	    };
	    this.onValueChange = this.onValueChange.bind(this);
	
	    if (!this.validNumber(this.props.min)) {
	      throw new Error('Invalid property: min.');
	    }
	
	    if (!this.validNumber(this.props.max)) {
	      throw new Error('Invalid property: max.');
	    }
	
	    this.min = this.toNumber(this.props.min);
	    this.max = this.toNumber(this.props.max);
	
	    if (this.min > this.max) {
	      throw new Error('min must be less than or equal to max.');
	    }
	
	    this.delegatedProps = (0, _ramda.clone)(this.props);
	    delete this.delegatedProps.type;
	    delete this.delegatedProps.value;
	    delete this.delegatedProps.onChange;
	  }
	
	  _createClass(NumberInput, [{
	    key: 'render',
	    value: function render() {
	      if (!this.validNumber(this.props.value)) {
	        throw new Error('value must be a number');
	      }
	
	      if (this.min > this.props.value || this.max < this.props.value) {
	        throw new Error('value must be in the range [min, max]');
	      }
	
	      return _react2['default'].createElement('input', _extends({ type: 'text', value: this.props.value, onChange: this.onValueChange }, this.delegatedProps));
	    }
	  }, {
	    key: 'onValueChange',
	    value: function onValueChange(event) {
	      var newValue = event.target.value.trim();
	      if (newValue.length === 0) {
	        newValue = this.min;
	      }
	
	      if (!this.validNumber(newValue)) {
	        return;
	      }
	
	      var newValueAsNumber = this.toNumber(newValue);
	
	      if (this.validValue(newValueAsNumber)) {
	        this.onChange(newValueAsNumber);
	        return;
	      }
	
	      var insertedOne = function insertedOne(previous, current) {
	        previous = previous.toString();
	        current = current.toString();
	
	        if (previous.length - current.length !== -1) {
	          return false;
	        }
	
	        var indexOfChange = -1;
	        for (var i = 0; i < Math.min(previous.length, current.length); i++) {
	          if (previous[i] !== current[i]) {
	            return { indexOfChange: i };
	          }
	        }
	
	        return { indexOfChange: Math.min(previous.length, current.length) };
	      };
	
	      var change = insertedOne(this.props.value, newValueAsNumber);
	      if (change) {
	        var indexOfChange = change.indexOfChange;
	        var prevString = this.props.value.toString();
	        var newString = newValueAsNumber.toString();
	        var updatedValueAsString = undefined;
	
	        if (indexOfChange === prevString.length) {
	          updatedValueAsString = prevString.substring(0, prevString.length - 1) + newString[newString.length - 1];
	        } else {
	          updatedValueAsString = prevString.substring(0, indexOfChange) + newString[indexOfChange] + prevString.substring(indexOfChange + 1);
	        }
	
	        var updatedValue = parseInt(updatedValueAsString);
	        if (this.validValue(updatedValue)) {
	          this.onChange(updatedValue);
	        }
	      }
	    }
	  }, {
	    key: 'validValue',
	    value: function validValue(value) {
	      if (!this.validNumber(value)) {
	        return false;
	      }
	
	      var num = this.toNumber(value);
	      return num >= this.min && num <= this.max;
	    }
	  }, {
	    key: 'toNumber',
	    value: function toNumber(value) {
	      if (typeof value === 'number') {
	        return value;
	      }
	
	      if (typeof value === 'string') {
	        if (!/^\d+$/.test(value)) {
	          return NaN;
	        }
	
	        return parseInt(value);
	      }
	
	      return NaN;
	    }
	  }, {
	    key: 'validNumber',
	    value: function validNumber(value) {
	      return !isNaN(this.toNumber(value));
	    }
	  }]);
	
	  return NumberInput;
	})(_react2['default'].Component);
	
	exports['default'] = NumberInput;
	module.exports = exports['default'];

/***/ }),

/***/ 153:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var Administration = (function (_React$Component) {
	  _inherits(Administration, _React$Component);
	
	  function Administration(props) {
	    _classCallCheck(this, Administration);
	
	    _get(Object.getPrototypeOf(Administration.prototype), 'constructor', this).call(this, props);
	  }
	
	  _createClass(Administration, [{
	    key: 'render',
	    value: function render() {
	      return _react2['default'].createElement(
	        'div',
	        { style: { cursor: 'progress' }, className: 'sk-fading-circle' },
	        _react2['default'].createElement('div', { className: 'sk-circle1 sk-circle' }),
	        _react2['default'].createElement('div', { className: 'sk-circle2 sk-circle' }),
	        _react2['default'].createElement('div', { className: 'sk-circle3 sk-circle' }),
	        _react2['default'].createElement('div', { className: 'sk-circle4 sk-circle' }),
	        _react2['default'].createElement('div', { className: 'sk-circle5 sk-circle' }),
	        _react2['default'].createElement('div', { className: 'sk-circle6 sk-circle' }),
	        _react2['default'].createElement('div', { className: 'sk-circle7 sk-circle' }),
	        _react2['default'].createElement('div', { className: 'sk-circle8 sk-circle' }),
	        _react2['default'].createElement('div', { className: 'sk-circle9 sk-circle' }),
	        _react2['default'].createElement('div', { className: 'sk-circle10 sk-circle' }),
	        _react2['default'].createElement('div', { className: 'sk-circle11 sk-circle' }),
	        _react2['default'].createElement('div', { className: 'sk-circle12 sk-circle' })
	      );
	    }
	  }]);
	
	  return Administration;
	})(_react2['default'].Component);
	
	exports['default'] = Administration;
	module.exports = exports['default'];

/***/ }),

/***/ 349:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ramda = __webpack_require__(27);
	
	var isNumber = (0, _ramda.allPass)([(0, _ramda.compose)(_ramda.not, isNaN), (0, _ramda.is)(Number)]);
	
	var formatPercentage = function formatPercentage(x) {
	  return Math.round(x * 100) + "%";
	};
	
	var makeValidator = (0, _ramda.compose)(_ramda.allPass, (0, _ramda.map)((0, _ramda.compose)((0, _ramda.apply)(_ramda.propSatisfies), _ramda.reverse)), _ramda.toPairs);
	
	var validateObject = function validateObject(validations, obj) {
	  return (0, _ramda.allPass)([(0, _ramda.is)(Object), makeValidator(validations)], obj);
	};
	
	exports["default"] = {
	  isNumber: isNumber,
	  formatPercentage: formatPercentage,
	  validateObject: (0, _ramda.curryN)(2, validateObject)
	};
	module.exports = exports["default"];

/***/ }),

/***/ 440:
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(2485);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(439)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js?sourceMap!../../node_modules/sass-loader/index.js?sourceMap!./app.scss", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js?sourceMap!../../node_modules/sass-loader/index.js?sourceMap!./app.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),

/***/ 454:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _ramda = __webpack_require__(27);
	
	var _props = ['L1', 'A1', 'V1', 'I1', 'L2', 'A2', 'V2', 'I2'];
	
	var adjectiveToProperty = {
	  'alentador': 'FD 8',
	  'analitico': 'FI 7',
	  'artistico': 'FD 8',
	  'competitivo': 'FI 7',
	  'confiable': 'PD 2',
	  'conservador': 'PI 1',
	  'creativo': 'FD 8',
	  'cuantitativo': 'FI 7',
	  'decisivo': 'FI 7',
	  'firme': 'FI 7',
	  'detallista': 'PI 1',
	  'empatico': 'PD 2',
	  'espacial': 'FD 8',
	  'espiritual': 'PD 2',
	  'laborioso': 'PI 1',
	  'logico': 'FI 7',
	  'matematico': 'FI 7',
	  'metaforico': 'FD 8',
	  'metodico': 'PI 1',
	  'minucioso': 'PI 1',
	  'objetivo': 'FI 7',
	  'personal': 'PD 2',
	  'precavido': 'PI 1',
	  'sensible': 'PD 2',
	  'sensitivo': 'PI 1',
	  'sentimental': 'PD 2',
	  'simultaneo': 'FD 8',
	  'sintetizador': 'FD 8',
	  'tranquilizador': 'PD 2'
	};
	
	exports['default'] = {
	  props: function props() {
	    return (0, _ramda.clone)(_props);
	  },
	  adjectiveToProperty: adjectiveToProperty,
	  'default': function _default() {
	    return {
	      L1: 0,
	      A1: 0,
	      V1: 0,
	      I1: 0,
	      L2: 0,
	      A2: 0,
	      V2: 0,
	      I2: 0
	    };
	  }
	};
	module.exports = exports['default'];

/***/ }),

/***/ 455:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	var q1Questions = ['Me gustan los retos dificiles a corto plazo y bajo presión.', 'Me gusta hacer las cosas bien desde la primera vez. Me gusta el trabajo de calidad, sin errores.', 'Soy una persona de carácter controlado, tranquilo y bastante sereno.', 'Soy una persona que se relaciona con facilidad, tengo amigos y conocidos en muchos lugares.', 'Las dificultades en el trabajo me motivan a hacer un esfuerzo mayor.', 'Soy calculador y cuidadoso para tomar decisiones, no soy tan "aventado".', 'Por naturaleza parece que soy un buen mediador para la solución de conflictos. Soy un pacificador.', 'Necesito estar en contacto con personas, me resulta dificil estar a solas conmigo.', 'Enfrento los conflictos de forma directa, abierta y franca.', 'Me gusta trabajar con procesos, procedimientos e instrucciones que son claras.', 'Mis amigos dicen que soy una persona de buen trato con los demás.', 'Soy muy divertido, abierto y me gusta relacionarme con personas.', 'Soy directo(a) con las personas al grado que me dicen que soy franco en exceso y, a veces, rudo.', 'Detecto con facilidad en dónde pueden fallar los proyectos o en dónde habrá obstáculos.', 'Me gusta el trabajo que requiere concentración y perserverar con calma para lograr resultados.', 'Tiendo a ser una persona muy optimista y positiva, siempre veo el vaso medio lleno.', 'Me gusta confrontar a la gente para aclarar la comunicación.', 'Tiendo a ser introspectivo me analizo a mi mismo con frecuencia.', 'Pocas veces me enojo o dejo salir mis emociones.', 'Soy emocional y subjetivo, veo las cosas según como me siento.', 'Prefiero trabajar sin presión, con objetivos que demandan tiempo suficiente y armonía.', 'Me gusta trabajar con rapidez y soy tolerante con los errores que cometo.', 'Tiendo a ser impaciente, soy activo y cambio de actividad con frecuencia.', 'Prefiero trabajar con cosas o ideas, me gustan las actividades solitarias.', 'No me gusta tener problemas en el trabajo.', 'Prefiero tomar decisiones con audacia (rápido y con riesgo), los planes los hago sobre la marcha si es necesario.', 'Soy indiferente a los problemas entre personas, prefiero que otros les ayuden.', 'Estar a solas conmigo o hacer actividades yo solo me gusta y lo disfruto.', 'No me gustan los conflictos, me siento incómodo, prefiero evitarlos.', 'Me gustar trabajar a mi propio estilo, con libertar de acción, es dificil trabajar con muchos procedimientos e instrucciones.', 'Me resulta difícil escuchar y ser paciente con las personas.', 'Soy una persona seria y de carácter reservado con los demás.', 'Soy una persona cordial, me gusta que las personas se sientan bien conmigo.', 'Estoy enfocado en el resultado de la tarea que debo realizar, no cuido los detalles.', 'Me gusta el trabajo variado con tareas o actividades diferentes y cambiantes. Trabajar en una sola cosa me disgusta.', 'Tiendo a ser una persona crítica de las cosas o personas, por lo general veo el "vaso medio vacío" en las situaciones que vivo.', 'No me gusta antagonizar o llevar la contra a las personas.', 'No me gusta analizarme o revisar mi desempeño.', 'Me altero con facilidad y mis emociones brotan.', 'Soy una persona objetiva, veo las cosas como son independientemente de mis emociones.'];
	
	exports.q1Questions = q1Questions;
	var q2Questions = [['Entusiasta', 'Rápido(a)', 'Lógico(a)', 'Apacible'], ['Cauteloso(a)', 'Decidido(a)', 'Receptivo(a)', 'Bondadoso(a)'], ['Amigable', 'Preciso(a)', 'Franco(a)', 'Tranquilo(a)'], ['Elocuente', 'Controlado(a)', 'Tolerante', 'Decisivo(a)'], ['Atrevido', 'Concienzudo(a)', 'Comunicativo(a)', 'Moderado(a)'], ['Ameno(a)', 'Ingenioso(a)', 'Investigador(a)', 'Acepta riesgos'], ['Expresivo(a)', 'Cuidadoso(a)', 'Dominante', 'Sensible'], ['Extrovertido(a)', 'Precavido(a)', 'Constante', 'Impaciente'], ['Discreto(a)', 'Complaciente', 'Encantador', 'Insistente'], ['Valeroso(a)', 'Anima a los demás', 'Pacífico(a)', 'Perfeccionista'], ['Reservado(a)', 'Atento(a)', 'Osado(a)', 'Alegre'], ['Estimulante', 'Gentil', 'Perceptivo(a)', 'Independiente'], ['Competitivo(a)', 'Considerado(a)', 'Alegre', 'Sagaz'], ['Meticuloso(a)', 'Obediente', 'Ideas firmes', 'Alentador(a)'], ['Popular', 'Reflexivo(a)', 'Tenaz', 'Calmado(a)'], ['Analítico(a)', 'Audaz', 'Leal', 'Promotor(a)'], ['Sociable', 'Paciente', 'Auto suficiente', 'Certero(a)'], ['Adaptable', 'Resuelto(a)', 'Prevenido(a)', 'Vivaz'], ['Agresivo(a)', 'Impetuoso(a)', 'Amistoso(a)', 'Discerniente'], ['De trato fácil', 'Compasivo(a)', 'Cauto(a)', 'Habla directo'], ['Evaluador(a)', 'Generoso(a)', 'Animado(a)', 'Persistente'], ['Impulsivo(a)', 'Cuida los detalles', 'Enérgico(a)', 'Tranquilo(a)'], ['Sociable', 'Sistemático(a)', 'Vigoroso(a)', 'Tolerante(a)'], ['Cautivador(a)', 'Contento(a)', 'Exigente', 'Apegado(a) a normas'], ['Le agrada discutir', 'Metódico(a)', 'Comedido(a)', 'Desenvuelto(a)'], ['Jovial', 'Preciso(a)', 'Directo(a)', 'Ecuánime'], ['Inquieto(a)', 'Amable', 'Elocuente', 'Cuidadoso(a)'], ['Prudente', 'Pionero', 'Espontáneo(a)', 'Colaborador(a)']];
	
	exports.q2Questions = q2Questions;
	var q3Questions = [['1) Nombre', '2) Empresa/Escuela', '3) Edad actual', '4) Sexo'], ['5) Entre las edades de 6 y 16 años, ¿dónde vivió usted?', '6) ¿Usted se crió en un ambiente con varios idiomas?', '7) ¿Cuántos hermanos o hermanas tiene usted?', '8) ¿Fue usted…?', '9) ¿Usted trabajó fuera de la casa cuando era niño(a)?', '10) ¿Sus padres tienen título universitario?', '11) Su propio titulo universitario y titulos de posgrado, de tenerlos.', '12) Su actual puesto de trabajo y breve descripción'], ['13) De niño(a), recuerdo haber disfrutado', '14) De niño(a), yo era', '15) En la escuela yo:', '16) Entre 9 y 12 años de edad mi actividad o proyecto favorito era:', '17) Entre los 14 y los 18 años obtenia buenas calificaciones y me gustaba:', '18) Entre los 14 y los 18 años yo disfrutaba:', '19) Después de la escuela y en los fines de semana, me gustaba:', '20) Después de la escuela y en los fines de semana, por lo general, pasaba el tiempo libre:', '21) Cuando leía solo, prefería leer:', '22) De joven yo era:'], ['23) En su trabajo actual, ¿Cuáles son las dos actividades o tareas que usted disfruta más? Identifique y explique cada una de ellas, en detalle, qué es lo que usted disfruta más de esas tareas.  Sea específico(a).', '24) Ahora, identifique dos tareas o actividades que usted no disfruta y explique en detealle qué es lo que no le gusta o qué encuentra frustrante, difícil o aburrido acerca de hacer cada una de ellas.  Sea bien específico(a).', '25) En el trabajo disfruto y soy bueno(a) para:', '26) En el trabajo soy bueno(a) para:', '27) En el trabajo disfruto y soy bueno(a) para:', '28) En el trabajo disfruto y soy bueno(a) para:', '29) En el trabajo disfruto y soy bueno(a) para:', '30) En el trabajo, estoy más a gusto cuando tengo la responsabilidad de:', '31) Mi área de trabajo:', '32) Cuando tengo que tomar una decisión difícil, me inclino hacia:', '33) En una situación de conflico, tengo la tendencia a: ', '34) En el trabajo, la impresión positiva que doy a otros es que soy:', '35) En el trabajo, lo negativo que otros ven en mí, es que soy:', '36) Me gusta más trabajar en un proyecto cuando:', '37) Mi problema al comunicarme con otros es que tengo la tendencia a:', '38) Las personas a quienes no les agrado, tienen la tendencia de encontrarme:', '39) Cuando quiero influir en la forma de pensar o en el comportamiento de otros, generalmente yo:', '40) Cuando tengo que tomar una decisión, lo más probable es que yo:'], ['41) Lejos del trabajo (y sin considerar a mi pareja), me siento atraído(a) por amistades que son:', '42) La mayoría de las veces, lo demás me ven como:', '43) Cuando voy a una galería de arte o museo, prefiero:', '44) Al relacionarme con personas que conozco socialmente, tiendo a considerar:', '45) Cuando decido cocinar, yo:', '46) Cuando voy de vacaciones, generalmente prefiero:', '47) Si me dan a escoger las siguientes opciones, lo más probable es que decoraría mi casa con:', '48) En mi tiempo libre, fuera del trabajo, me dedico a:', '49) Cuando invierto, lo hago:', '50) Por lo general paso mi tiempo libre:'], ['51) Cuando hablo, por lo general:', '52) Cuando leo:', '53) Con respecto a la intuición, yo:', '54) Con respecto al éxito:', '55) Soy naturalmente:', '56) Soy naturalmente:', '57) Soy naturalmente:', '58) Soy naturalmente:', '59) Soy naturalmente:', '60) Soy naturalmente:', '61) Soy naturalmente:', '62) De los 7 adjetivos que MÁS lo describen en las preguntas 55 a 61, ¿cuál es el que más lo describe?', '63) Identifique dos tareas o actividades que usted hace bien, pero que en realidad no le gustan.  Explique en detalle qué es lo que no disfruta de ellas.', '64) Identifique el "modelo visual" que lo describe a usted, Escoja primero al modelo que MEJOR lo describey despues al modelo que NADA lo describe.'], ['65) ¿De niño(a), lo consideraban a usted altamente susceptible / emocional?', '66) ¿Actualmente, se considera a sí mismo una persona altamente susceptible / emocional?', '67) ¿Actualmente, otras personas lo consideran a usted altamente susceptible / emocional?', '68) Lea el siguiente conjunto de adjetivos, seleccione de 4 a 6 palabras que juntas describen cómo se ha sentido durante los últimos 3 años.', '69) ¿Cuál de las palabras que selecciono en la pregunta anterior es la que mejor lo describe en los ultimos 3 años', '70) Ahora, lea los mismos adjetivos de nuevo, y seleccione de 4 a 6 que describan como se ha sentido en los últimos tres meses.', '71) ¿Cuál de las palabras que selecciono en la pregunta anterior es la que mejor lo describe en los tres meses'], ['Muerte de un miembro de su familia', 'Muerte de un amigo muy cercano', 'Enfermedad', 'Hospitalización', 'Enfermedad de un miembro cercano de la familia', 'Nueva escuela', 'Responsabilidad de trabajo nueva/adicional', 'Cambio de colegio', 'Viajes mas o menos frecuentes', 'Problemas financieros', 'Mudanza o nueva casa', 'Mudanza a nueva ciudad', 'Compra de casa nueva', 'Noviazgo', 'Rompimiento de noviazgo', 'Problemas con mis padres', 'Separación o divorcio de mis padres', 'Problemas o pleitos legales', 'Accidente de automóvil']];
	
	exports.q3Questions = q3Questions;
	//52
	//44
	//0 = text; 1 = int; 2 = select 1; 3 = select 2; 4 = select 3; 5= select all; 6= select 4 a 6; 7 = num veces
	
	var q3Answers = [[[0, 1], [0, 2], [1, 3], [2, 4, 'Masculino', 'Femenino']], [[2, 5, 'En una ciudad', 'En un pueblo pequeño', 'En una zona rural'], [2, 6, 'Si', 'No'], [1, 7], [2, 8, 'Hijo(a) unico(a)', 'Primogenito(a)', 'Hija mayor, pero no la mayor de los hermanos', 'Hijo(a) menor', 'Ninguna de las anteriores'], [2, 9, 'No', 'Sí, porque yo queria', 'Sí, porque mi familia necesitaba el dinero'], [2, 10, 'No', 'Uno', 'Los dos'], [0, 11], [0, 12]], [[4, 13, 'Ser responsable y hacer tareas y trabajos especificos para mis maestros y padres', 'Jugar con otros niños', 'Entretenerme creando juguetes y cosas con que jugar', 'Jugar con herramientas y desarmar juguetes y cosas para averiguar como funcionan', 'Jugar a disfrazarme con ropas viejas y/o disfraces'], [4, 14, 'Lider innato', 'Aficionado(a) a jugar en equipo', 'De espiritu libre, que seguia mis propios gustos', 'Sensible y cariñoso(a)'], [4, 15, 'Me portaba bien y estudiaba mucho', 'Obtenia calificaciones altas facilmente', 'Fantaseaba mucho, era un soñador', 'Hablaba mucho con mis amigos y les escribía notas en clase'], [4, 16, 'Organizar y catalogar colecciones de hojas, estampillas, figuritas o monedas en un álbum.', 'Medir, examinar o evaluar algo con precisión', 'Dibujar y pintar mapas', 'Cantar'], [4, 17, 'Problemas y teoremas de matemáticas', 'Idiomas', 'Geometria', 'Ortografia'], [4, 18, 'Lógica matemática/Ingeniería', 'Historia', 'Cálculo', 'Física', 'Química', 'Educación Cívica', 'Música', 'Actuación/Teatro'], [4, 19, 'Calcular las probabilidades de algún proyecto', 'Estar con mis amigos(as)', 'Jugar deportes de equipo', 'Hacer a solas lo que yo quería', 'Andar solo (caminando o en bicicleta)', 'Participar en grupos de debate', 'Bailar', 'Cantar en los coros'], [4, 20, 'Explorando', 'Participando en algún grupo de jóvenes (Ej. Boy Scouts, etc.)', 'Pintando o dibujando', 'Desarmando y construyendo vehículos de motores', 'Liderando la hinchada de mi equipo favorito. Animando mi grupo social.', 'Estructurando proyectos de ciencias', 'Armando modelos de vehículos y aviones', 'Actuando en grupos de teatro', 'Escribiendo poesías', 'Tocando música'], [4, 21, 'Biografías', 'Historia', 'Libros de guerras y grandes generales', 'Ciencia ficción', 'Libros de aventuras', 'Relatos fantásticos', 'Relatos verdaderos acerca de animales', 'Revistas y libros de ciencias', 'Filosofía', 'Historias de amor'], [5, 22, 'Solitario(a)', 'Tímido(a)', 'Dislexico(a)', 'Ávido léctor(a)', 'Inadaptado(a)', 'Hiperactivo(a)', 'Competitivo(a)', 'Rebelde', 'Menos femenina que el resto', 'Menos masculino que el resto']], [[0, 23], [0, 24], [4, 25, 'Análisis financieros', 'Recopilar y mantener documentos  (archivos y registros).', 'Aconsejar a otros, especialmente si están sufriendo, están tristes o con problemas.', 'Innovar'], [4, 26, ' Negociar y me gusta buscar la manera de ganar', 'Estimular o motivar a otros y atraer a la gente con mi entusiasmo', 'Ejecutar tareas administrativas de rutina y raramente cometo errores en los detalles.', 'Celebrar, soy generalmente el primero en saber cual es el momento para una fiesta o para reunirse.'], [4, 27, 'Programar actividades / Mantener mi agenda', 'Lanzar proyectos nuevos', ' Formular, evaluar y priorizar opciones', 'Animar y motivar a otros'], [4, 28, 'Organizar', 'Ser estratégico', 'Ser creativo', 'Armonizar'], [4, 29, 'Reconocer enseguida signos de discordia/desacuerdo', 'Localizar problemas', 'Analizar diferencias', 'Seguir instrucciones'], [4, 30, 'Tomar decisiones difíciles que implican necesidades y prioridades conflictivas.', 'Usar y seguir procedimientos', 'Sintetizar información y materiales para armar una nueva teoría o producto.', 'Mantenerme en contacto con los sentimientos de los demás'], [4, 31, 'Están un poco abarrotadas con varios objetos personales alrededor.', 'A menudo parecen desordenados debido a la cantidad de materiales de distintas tareas que tengo amontonados en todo espacio disponible, incluyendo las sillas y el piso.', 'Están bien organizados, con materiales necesarios y cercanos para disponer de ellos fácilmente.', 'Está libre de todo a excepción del proyecto en el cual estoy trabajando en ese momento.'], [4, 32, 'Lo convincente', 'Lo establecido', 'Lo nuevo y diferente', 'Lo enternecedor y significativo'], [4, 33, 'Buscar la forma de ganar', 'Encontrar una solución donde todos cooperamos/colaboramos.', 'Tratar de que la otra persona llegue a un acuerdo', 'Callarme y trato de evadir o escaparme de ese ambiente.'], [4, 34, 'Minucioso y práctico', 'Brillante intelectualmente, pero algo complicado.', 'Sensible y ofrezco respaldo', 'Astuto y lógico'], [4, 35, 'Calculador', 'Aburrido y monótono', 'Inefectivo y hablo demasiado', 'En las nubes'], [4, 36, 'Me dan una meta específica y me dicen que tengo que llevarla a cabo como sea.', 'Me dan tareas específicas con instrucciones y me dejan efectuarlas sin interrupción.', 'Me posibilitan hacer algo "significativo", mientras trabajo y hablo con otras personas.', 'Puedo experimentar con ideas audaces.'], [4, 37, 'Ser impaciente con alguien que expresa ideas que se ve no pensó claramente.', 'Preferir conversaciones sobre temas puntuales del aquí y el ahora.', 'No escuchar discusiones de estrategia o economía', 'Aburrirme rápidamente con alguien que es muy detallado en sus explicaciones.'], [4, 38, 'Simple, cándido y demasiado excitable', 'Demasiado impredecible', 'Impersonal o desinteresado', 'Aburrido y poco interesante'], [4, 39, 'Les presento un argumento lógico, sólido y firme', 'Les recuerdo las reglas, procedimientos y objetivos existentes.', 'Les doy una visión de lo que es posible', 'Trato de conocerlos más para agradarles y que me tomen más confianza.'], [4, 40, 'Analice los pro y los contra para determinar qué solución presentará más beneficios y menos perjuicios.', 'Confíe en mi intuición', 'Escoja soluciones que antes han sido experimentadas con éxito (si no en mi empresa, en otro sitio).', 'Escoja soluciones que harán que la mayoría se sienta feliz']], [[4, 41, 'Racionales y bien informadas', 'Prácticas y sensitivas', 'Imaginativas y creativas', 'Sensibles y cariñosas'], [4, 42, 'Alguien que sabe a dónde va y que posee la capacidad para llegar a su meta.', 'Una persona confiable, segura y responsable, que hace las cosas y logra sus objetivos.', 'Una persona atenta y servicial', 'Una persona creativa y con visión'], [4, 43, 'Leer el folleto que dan en la entrada para así saber qué esperar.  Cuando voy veo todo con cuidado y presto atención.', 'Ir con alguien concido con quien pueda compartir mis reacciones y sentimientos acerca de lo que vemos.', 'Si es posible, evito ir.  Pero si es en una exhibición especial o a la que considero que tengo que ir, entonces trato de encontrar qué es importante acerca de dicha exhibición.', 'Andar bien rápido, solo, aunque haya ido con un grupo o con otra persona.'], [4, 44, 'Si parecen saber lo que están haciendo y a dónde van', 'Pueden aportar ideas interesantes', 'Si parecen tranquilas, calladas  y confiables', ' Si son personas divertidas'], [4, 45, 'Cocino creativamente y casi nunca sigo las reglas', 'Prefiero que todos comamos juntos, sentados en una mesa donde podamos conversar y compartir.', 'A menudo uso utensilios especiales y tomo los tiempos de todo con exactitud.', 'Uso y sigo las recetas al pie de la letra, por lo general, las mismas que he usado antes.'], [4, 46, 'Reunirme con mis seres queridos', 'Tomar un viaje bien planeado hacia algún lugar muy conocido (tal vez un tour orgnaizado).', 'Ir lejos (a algún lugar tranquilo)', 'Viajes de aventura', 'Hacer algo como ir de pesca o cacería, para lo cual tengo que usar algún instrumento o herramienta de precisión.'], [4, 47, 'Caracoles, plantas y fotos de mi familia y amigos', 'Cosas que tengan emblemas/escudos de productos o de equipos con los que me identifico/pertenezco', 'Pinturas y esculturas', 'Equipos electrónicos y mecánicos'], [4, 48, 'Actividades planeadas regularmente, solo o con otros.', 'Con actividades informales no planeadas con otras personas', 'Reparando algo o haciendo trabajos manuales', 'Reflexionando sobre la vida'], [4, 49, 'Buscando obtener una ganancia  a partir de él.', 'Cuidadosamente, de forma segura, sin malgastarlo', 'Arriesgadamente, comprando objetos novedosos', 'En mis amigos y en la amistad'], [2, 50, 'Haciendo lo que yo quiero.', 'Haciendo lo que mi familia quiere hacer.', 'Haciendo lo que necesito.', 'Haciendo lo que mi familia necesita.']], [[4, 51, 'Soy breve y conciso', 'Relato lo que pasó o lo que se necesita hacer', 'Soy expresivo y a veces inspirado', 'Soy conversador y agradable'], [4, 52, 'Leo o le doy un vistazo a la sinopsis y material clave de expertos.', 'Hojeo una gran cantidad de cosas varias, a veces al mismo tiempo, sin terminarlas y dejándolas abiertas para leerlas después.', 'Leo manuales y libros de cómo hacer cosas', 'Leo novelas románticas'], [4, 53, 'Soy muy intuitivo acerca de nuevas ideas, productos o instrucciones', 'Soy muy intuitivo acerca de la gente', 'Creo en la intuición, pero personalmente no soy muy intuitivo', 'No creo en la intuición'], [4, 54, 'Se llega al éxito personal y profesional a base de autodisciplina y eficiencia.', 'El éxito se encuentra tomando en cuenta la dimensión espiritual y la calidad de las relaciones con los demás.', 'El éxito se alcanza haciendo uso de la innovación, la originalidad y la evolución como los valores mas importantes.', 'Se es exitoso al ser una persona con poder y capacidad de decisión.', 'Se es exitoso al lograr los objetivos que permiten reunir dinero y obtener bienes materiales.'], [4, 55, 'Personal', 'Detallista', 'Matemático', 'Espacial'], [4, 56, 'Cuantitativo', 'Minucioso', 'Confiable', 'Artístico'], [4, 57, 'Decisivo, firme', 'Empático', 'Alentador', 'Sensitivo'], [4, 58, 'Objetivo', 'Sintetizador', 'Precavido', 'Tranquilizador'], [4, 59, 'Conservador', 'Analítico', 'Sensible', 'Simultáneo'], [4, 60, 'Competitivo', 'Metódico', 'Metafórico', 'Sentimental'], [4, 61, 'Laborioso', 'Espiritual', 'Lógico', 'Creativo'], [9, 62], [0, 63], [3, 64, 'Espiral', 'Flecha', 'Escalera', 'Olas']], [[2, 65, 'Si', 'No'], [2, 66, 'Si', 'No'], [2, 67, 'Si', 'No'], [6, 68, 'Alegre', 'Satisfecho', 'Excitado', 'Apasionado', 'Estado Critico', 'Ansioso', 'Deprimido', 'Desilusionado', 'Seguro de si mismo', 'Feliz', 'Tranquilo', 'Dispuesto', 'Emocional', 'Miedoso', 'Incomodo', 'Cansado', 'Abrumado', 'Sentimental', 'Entusiasmado', 'Encantado', 'Frustrado', 'Controlado', 'Triste', 'Inseguro', 'Tenso', 'Asustado', 'Orgulloso', 'Pacifico', 'Desesperanzado', 'Enojado', 'Defensivo', 'Nervioso', 'Determinado', 'Contento', 'Preocupado'], [8, 69], [6, 70, 'Alegre', 'Satisfecho', 'Excitado', 'Apasionado', 'Estado Critico', 'Ansioso', 'Deprimido', 'Desilusionado', 'Seguro de si mismo', 'Feliz', 'Tranquilo', 'Dispuesto', 'Emocional', 'Miedoso', 'Incomodo', 'Cansado', 'Abrumado', 'Sentimental', 'Entusiasmado', 'Encantado', 'Frustrado', 'Controlado', 'Triste', 'Inseguro', 'Tenso', 'Asustado', 'Orgulloso', 'Pacifico', 'Desesperanzado', 'Enojado', 'Defensivo', 'Nervioso', 'Determinado', 'Contento', 'Preocupado'], [8, 71]], [[1, 72], [1, 73], [1, 74], [1, 75], [1, 76], [1, 77], [1, 78], [1, 79], [1, 80], [1, 81], [1, 82], [1, 83], [1, 84], [1, 85], [1, 86], [1, 87], [1, 88], [1, 89], [1, 90]]];
	
	exports.q3Answers = q3Answers;
	var q3QuestionsTeen = [['1) Nombre', '2) Empresa/Escuela', '3) Edad actual', '4) Sexo'], ['5) Entre las edades de 6 y 16 años, ¿dónde vivió usted?', '6) ¿Usted se crió en un ambiente con varios idiomas?', '7) ¿Cuántos hermanos o hermanas tiene usted?', '8) ¿Fue usted…?', '9) ¿Usted trabajó fuera de la casa cuando era niño(a)?', '10) ¿Sus padres tienen título universitario?', '11) Su grado escolar.', '12) Ocupación'], ['13) De niño(a), recuerdo haber disfrutado', '14) De niño(a), yo era', '15) En la escuela yo:', '16) Entre el 4° y el 7° grado mi actividad o proyecto favorito era:', '17) En la escuela preparatoria / secundaria obtuve buenas calificaciones y me gustaba:', '18) En la escuela preparatoria / secundaria me gustaba:', '19) Después de la escuela y en los fines de semana, me gusta:', '20) Después de la escuela y en los fines de semana, por lo general, paso el tiempo libre:', '21) Cuando leo solo, prefiero leer:', '22) De niño(a) yo era:'], ['23) En sus tareas habituales, ¿Cuáles son las dos actividades o tareas que usted disfruta más? Identifique y explique cada una de ellas, en detalle, qué es lo que usted disfruta más de esas tareas.  Sea específico(a).', '24) Ahora, identifique dos tareas o actividades que usted no disfruta y explique en detealle qué es lo que no le gusta o qué encuentra frustrante, difícil o aburrido acerca de hacer cada una de ellas.  Sea bien específico(a).', '25) Me gusta y soy bueno para:', '26) Cuando realizo actividades, soy bueno para:', '27) Me gusta y soy bueno para:', '28) Me gusta y soy bueno para:', '29) Me gusta y soy bueno para:', '30) En mis tareas habituales, estoy más a gusto cuando tengo la responsabilidad de:', '31) Mi área de labores, mi estudio o mi escritorio:', '32) Cuando tengo que tomar una decisión difícil, me inclino hacia:', '33) En una situación de conflico, tengo la tendencia a: ', '34) La impresión positiva que doy a otros es que soy:', '35) Lo negativo que otros ven de mi, es que soy:', '36) Me gusta más trabajar en un proyecto cuando:', '37) Mi problema al comunicarme con otros es que tengo la tendencia a:', '38) Las personas a quienes no les agrado, tienen la tendencia de encontrarme:', '39) Cuando quiero influir en la forma de pensar o en el comportamiento de otros, generalmente yo:', '40) Cuando tengo que tomar una decisión, lo más probable es que yo:'], ['41) Lejos de mis tareas habituales, me siento atraído por amistades que son:', '42) La mayoría de las veces, lo demás me ven como:', '43) Cuando voy a una galería de arte o museo, prefiero:', '44) Al relacionarme con personas que conozco socialmente, tiendo a considerar:', '45) Si preparo una comida, yo:', '46) Cuando voy de vacaciones, generalmente prefiero:', '47) Si me dan a escoger las siguientes opciones, lo más probable es que decoraría mi casa con:', '48) En mi tiempo libre, lejos de mis tareas habituales, paso mi tiempo:', '49) Cuando tengo la posibilidad de invertir mi dinero, lo hago:', '50) Por lo general paso mi tiempo libre:'], ['51) Cuando hablo, por lo general:', '52) Cuando leo:', '53) Con respecto a la intuición, yo:', '54) Con respecto al éxito:', '55) Soy naturalmente:', '56) Soy naturalmente:', '57) Soy naturalmente:', '58) Soy naturalmente:', '59) Soy naturalmente:', '60) Soy naturalmente:', '61) Soy naturalmente:', '62) De los 7 adjetivos que MÁS lo describen en las preguntas 55 a 61, ¿cuál es el que más lo describe?', '63) Identifique dos tareas o actividades que usted hace bien, pero que en realidad no le gustan.  Explique en detalle qué es lo que no disfruta de ellas.', '64) Identifique el "modelo visual" que lo describe a usted, Escoja primero al modelo que MEJOR lo describey despues al modelo que NADA lo describe.'], ['65) ¿De niño(a), lo consideraban a usted altamente susceptible / emocional?', '66) ¿Actualmente, se considera a sí mismo una persona altamente susceptible / emocional?', '67) ¿Actualmente, otras personas lo consideran a usted altamente susceptible / emocional?', '68) Lea el siguiente conjunto de adjetivos, seleccione de 4 a 6 palabras que juntas describen cómo se ha sentido durante los últimos 3 años.', '69) ¿Cuál de las palabras que selecciono en la pregunta anterior es la que mejor lo describe en los ultimos 3 años', '70) Ahora, lea los mismos adjetivos de nuevo, y seleccione de 4 a 6 que describan como se ha sentido en los últimos tres meses.', '71) ¿Cuál de las palabras que selecciono en la pregunta anterior es la que mejor lo describe en los tres meses'], ['Muerte de un miembro de su familia', 'Muerte de un amigo muy cercano', 'Enfermedad', 'Hospitalización', 'Enfermedad de un miembro cercano de la familia', 'Nueva escuela', 'Responsabilidad de trabajo nueva/adicional', 'Cambio de colegio', 'Viajes mas o menos frecuentes', 'Problemas financieros', 'Mudanza o nueva casa', 'Mudanza a nueva ciudad', 'Compra de casa nueva', 'Noviazgo', 'Rompimiento de noviazgo', 'Problemas con mis padres', 'Separación o divorcio de mis padres', 'Problemas o pleitos legales', 'Accidente de automóvil']];
	exports.q3QuestionsTeen = q3QuestionsTeen;

/***/ }),

/***/ 456:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _ramda = __webpack_require__(27);
	
	var _modulesUtils = __webpack_require__(349);
	
	var _modulesUtils2 = _interopRequireDefault(_modulesUtils);
	
	var _props = (0, _ramda.xprod)('AN', 'XTNA').map((0, _ramda.join)(''));
	
	var deriveProp = function deriveProp(prop1, prop2) {
	  return Math.round((parseInt(prop1) + parseInt(prop2)) / 18 * 100);
	};
	
	var deriveProperties = function deriveProperties(props) {
	  return {
	    NTar: deriveProp(props.NX, props.NT),
	    NPer: deriveProp(props.NN, props.NA),
	    NRef: deriveProp(props.NT, props.NN),
	    NAcc: deriveProp(props.NA, props.NX),
	    ATar: deriveProp(props.AX, props.AT),
	    APer: deriveProp(props.AN, props.AA),
	    ARef: deriveProp(props.AT, props.AN),
	    AAcc: deriveProp(props.AA, props.AX)
	  };
	};
	
	var getResults = function getResults(props) {
	  var derivedProperties = deriveProperties(props);
	  var changes = {
	    dX: Math.abs(props.NX - props.AX),
	    dT: Math.abs(props.NT - props.AT),
	    dN: Math.abs(props.NN - props.AN),
	    dA: Math.abs(props.NA - props.AA)
	  };
	
	  var change = changes.dX + changes.dT + changes.dN + changes.dA;
	  var consistency = 1 - change / (props.NX + props.NT + props.NN + props.NA);
	
	  var profileNames = ['EXPLORADOR', 'CONSTRUCTOR', 'CONSEJERO', 'ANIMADOR'];
	  var xtna = 'XTNA'.split('');
	
	  var getProfile = function getProfile(prefix) {
	    var value = function value(x) {
	      return props[prefix + xtna[x]];
	    };
	    var sort1 = function sort1(a, b) {
	      return value(a) - value(b);
	    };
	    var order = [0, 1, 2, 3].sort(sort1);
	    var sort2 = function sort2(a, b) {
	      return value(a) + a / 10 - value(b) + b / 10;
	    };
	    var profileIndices = order.filter(function (x) {
	      return value(x) >= value(order[2]);
	    }).sort(sort2);
	
	    if (value((0, _ramda.last)(profileIndices)) > 6) {
	      profileIndices = profileIndices.filter(function (x) {
	        return value(x) > 6;
	      });
	    }
	
	    var profiles = (0, _ramda.map)((0, _ramda.prop)(_ramda.__, profileNames), (0, _ramda.reverse)(profileIndices));
	    return profiles;
	  };
	
	  var NProfile = getProfile('N'),
	      AProfile = getProfile('A');
	
	  return {
	    derivedProperties: derivedProperties,
	    changes: changes,
	    change: change,
	    consistency: consistency,
	    NProfile: NProfile,
	    AProfile: AProfile
	  };
	};
	
	var validForm = _modulesUtils2['default'].validateObject((0, _ramda.fromPairs)(_props.map(function (prop) {
	  return [prop, (0, _ramda.allPass)([(0, _ramda.is)(Number), (0, _ramda.lte)(_ramda.__, 9), (0, _ramda.gte)(_ramda.__, 0)])];
	})));
	
	exports['default'] = {
	  props: function props() {
	    return (0, _ramda.clone)(_props);
	  },
	  'default': function _default() {
	    return (0, _ramda.fromPairs)(_props.map((0, _ramda.compose)(_ramda.reverse, (0, _ramda.append)(_ramda.__, [1]))));
	  },
	  deriveProperties: deriveProperties,
	  getResults: getResults,
	  validForm: validForm
	};
	module.exports = exports['default'];

/***/ }),

/***/ 457:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _XTNA = __webpack_require__(456);
	
	var _XTNA2 = _interopRequireDefault(_XTNA);
	
	var _ChartJsx = __webpack_require__(664);
	
	var _ChartJsx2 = _interopRequireDefault(_ChartJsx);
	
	var _FormJsx = __webpack_require__(1021);
	
	var _FormJsx2 = _interopRequireDefault(_FormJsx);
	
	var _ResultsJsx = __webpack_require__(1022);
	
	var _ResultsJsx2 = _interopRequireDefault(_ResultsJsx);
	
	exports['default'] = {
	  XTNA: _XTNA2['default'],
	  XTNAChart: _ChartJsx2['default'],
	  XTNAForm: _FormJsx2['default'],
	  XTNAResults: _ResultsJsx2['default']
	};
	module.exports = exports['default'];

/***/ }),

/***/ 661:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var _token = localStorage.getItem('token');
	
	(function (open) {
	  XMLHttpRequest.prototype.open = function () {
	    open.apply(this, arguments);
	    if (_token) {
	      this.setRequestHeader('x-access-token', _token);
	    }
	  };
	})(XMLHttpRequest.prototype.open);
	
	exports['default'] = {
	  saveToken: function saveToken(token) {
	    localStorage.setItem('token', token);
	    _token = token;
	  },
	  clearToken: function clearToken() {
	    localStorage.setItem('token', '');
	    _token = null;
	  }
	};
	module.exports = exports['default'];

/***/ }),

/***/ 662:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(41);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _ramda = __webpack_require__(27);
	
	var _modulesAutoBind = __webpack_require__(29);
	
	var _modulesAutoBind2 = _interopRequireDefault(_modulesAutoBind);
	
	var _Benzinger = __webpack_require__(454);
	
	var _Benzinger2 = _interopRequireDefault(_Benzinger);
	
	var colors = {
	  blue: 'rgb(0, 0, 255)',
	  red: 'rgb(255, 0, 0)',
	  black: 'rgb(0, 0, 0)',
	  axis: 'rgb(192, 192, 192)',
	  gray: 'rgb(217, 217, 217)',
	  white: 'rgb(255, 255, 255)',
	  border: 'rgb(117, 113, 113)'
	};
	
	var BenzingerChart = (function (_React$Component) {
	  _inherits(BenzingerChart, _React$Component);
	
	  function BenzingerChart(props) {
	    _classCallCheck(this, BenzingerChart);
	
	    _get(Object.getPrototypeOf(BenzingerChart.prototype), 'constructor', this).call(this, props);
	    (0, _modulesAutoBind2['default'])(this);
	    this.state = { canvas: null };
	  }
	
	  _createClass(BenzingerChart, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var canvas = document.createElement('canvas');
	      canvas.setAttribute('style', 'width: 100%; height: 100%;');
	      canvas.setAttribute('width', canvas.offsetWidth);
	      canvas.setAttribute('height', canvas.offsetWidth);
	      canvas.setAttribute('id', this.props.id);
	      _reactDom2['default'].findDOMNode(this).appendChild(canvas);
	      this.setState({ canvas: canvas });
	      window.addEventListener('resize', this.handleResize);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('resize', this.handleResize);
	      _reactDom2['default'].findDOMNode(this).removeChild(this.state.canvas);
	    }
	  }, {
	    key: 'handleResize',
	    value: function handleResize() {
	      this.setState({ windowWidth: window.innerWidth });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.state.canvas) {
	        this.renderCanvas(this.state.canvas);
	      }
	
	      return _react2['default'].createElement('div', { style: { marginBottom: '10px' } });
	    }
	  }, {
	    key: 'getProps',
	    value: function getProps() {
	      return (0, _ramda.merge)(this.props, {
	        L2: Math.min(150, this.props.L2 * 4),
	        A2: Math.min(150, this.props.A2 * 4),
	        V2: Math.min(150, this.props.V2 * 4),
	        I2: Math.min(150, this.props.I2 * 4)
	      });
	    }
	  }, {
	    key: 'renderCanvas',
	    value: function renderCanvas(canvas) {
	      var _this = this;
	
	      canvas.setAttribute('width', canvas.offsetWidth);
	      canvas.setAttribute('height', canvas.offsetWidth);
	      this.width = (0, _ramda.multiply)(canvas.offsetWidth);
	      this.height = (0, _ramda.multiply)(canvas.offsetWidth);
	
	      var ctx = canvas.getContext('2d');
	      var width = this.width,
	          height = this.height;
	      var center = { x: width(.5), y: height(.5) };
	
	      ctx.clearRect(0, 0, width(1), height(1));
	
	      //inner circles
	      ctx.lineWidth = 0;
	
	      ctx.beginPath();
	      ctx.arc(center.x, center.y, width(.50), 0, 2 * Math.PI, false);
	      ctx.fillStyle = colors.border;
	      ctx.fill();
	
	      ctx.beginPath();
	      ctx.arc(center.x, center.y, width(.448), 0, 2 * Math.PI, false);
	      ctx.fillStyle = colors.white;
	      ctx.fill();
	
	      ctx.beginPath();
	      ctx.arc(center.x, center.y, width(.370), 0, 2 * Math.PI, false);
	      ctx.fillStyle = colors.gray;
	      ctx.fill();
	
	      ctx.beginPath();
	      ctx.arc(center.x, center.y, width(.294), 0, 2 * Math.PI, false);
	      ctx.fillStyle = colors.white;
	      ctx.fill();
	
	      ctx.beginPath();
	      ctx.arc(center.x, center.y, width(.149), 0, 2 * Math.PI, false);
	      ctx.fillStyle = colors.gray;
	      ctx.fill();
	
	      // dashed lines
	      ctx.lineWidth = 1;
	      ctx.strokeStyle = colors.axis;
	      ctx.dashedLine(width(.5), height(.1), width(.5), height(.9), 2);
	      ctx.dashedLine(width(.1), height(.5), width(.9), height(.5), 2);
	
	      // draw numbers
	      ctx.textAlign = 'center';
	      ctx.textBaseline = 'middle';
	      ctx.fillStyle = colors.black;
	      ctx.font = '7pt Arial';
	      for (var quadrant = 0; quadrant < 4; quadrant++) {
	        for (var num = 2; num < 13; num += 2) {
	          var position = this.getDiagonalPosition(num * 10, quadrant);
	          ctx.fillText((num * 10).toString(), position.x, position.y);
	        }
	      }
	
	      ctx.fillStyle = colors.white;
	      ctx.font = 'bold 11pt Arial';
	
	      var letters = ['8', '7', '1', '2'];
	      var offset = [[-15, -11], [15, -11], [15, 11], [-15, 11]];
	      var p = this.getProps();
	      var addOffset = [Math.max(p.V1, p.V2), Math.max(p.A1, p.A2), Math.max(p.L1, p.L2), Math.max(p.I1, p.I2)].map(function (x) {
	        return x > 115;
	      });
	      (0, _ramda.addIndex)(_ramda.forEach)(function (letter, index) {
	        var pos = _this.getDiagonalPosition(129.4, index);
	        ctx.fillText(letter, pos.x + (addOffset[index] && offset[index][0]), pos.y + (addOffset[index] && offset[index][1]));
	      }, letters);
	
	      // draw text
	      ctx.textAlign = 'center';
	      ctx.textBaseline = 'middle';
	
	      ctx.fillStyle = colors.black;
	      ctx.font = '7pt Arial';
	
	      ctx.fillText('CONCEPTUAL', width(.5), height(.08));
	      ctx.fillText('ESTRATEGIA', width(.5), height(.11));
	
	      ctx.fillText('PRÁCTICO', width(.5), height(.89));
	      ctx.fillText('EJECUCIÓN', width(.5), height(.92));
	
	      var drawVertical = function drawVertical(text, xPos, yPos) {
	        (0, _ramda.addIndex)(_ramda.forEach)(function (letter, index) {
	          var letterHeight = 9;
	          ctx.fillText(letter, xPos, yPos - text.length * letterHeight / 2 + 4 + letterHeight * index);
	        }, text);
	      };
	
	      drawVertical('RACIONAL', width(.08), height(.5));
	      drawVertical('TÉCNICO', width(.11), height(.5));
	
	      drawVertical('ARTÍSTICO', width(.89), height(.5));
	      drawVertical('CREATIVO', width(.92), height(.5));
	
	      ctx.font = '7pt Arial';
	      ctx.save();
	      var textPos = this.getDiagonalPosition(140, 2);
	      ctx.translate(textPos.x, textPos.y);
	      ctx.rotate(Math.PI / 4);
	      ctx.fillText('POSTERIOR IZQUIERDO', 0, 0);
	      ctx.restore();
	
	      ctx.save();
	      textPos = this.getDiagonalPosition(140, 0);
	      ctx.translate(textPos.x, textPos.y);
	      ctx.rotate(Math.PI / 4);
	      ctx.fillText('FRONTAL DERECHO', 0, 0);
	      ctx.restore();
	
	      ctx.save();
	      textPos = this.getDiagonalPosition(140, 3);
	      ctx.translate(textPos.x, textPos.y);
	      ctx.rotate(-Math.PI / 4);
	      ctx.fillText('POSTERIOR DERECHO', 0, 0);
	      ctx.restore();
	
	      ctx.save();
	      textPos = this.getDiagonalPosition(140, 1);
	      ctx.translate(textPos.x, textPos.y);
	      ctx.rotate(-Math.PI / 4);
	      ctx.fillText('FRONTAL IZQUIERDO', 0, 0);
	      ctx.restore();
	
	      // plot points
	      var mapPropToPos = (0, _ramda.compose)((0, _ramda.addIndex)(_ramda.map)(this.getDiagonalPosition), (0, _ramda.map)((0, _ramda.prop)(_ramda.__, this.getProps())));
	
	      var line = function line(x1, y1, x2, y2) {
	        ctx.beginPath();
	        ctx.moveTo(x1, y1);
	        ctx.lineTo(x2, y2);
	        ctx.stroke();
	      };
	
	      var dashLine = ctx.dashedLine.bind(ctx);
	      var drawLines = function drawLines(positions, color, dashed, offsetX, offsetY) {
	        ctx.fillStyle = color;
	        ctx.strokeStyle = color;
	        ctx.lineWidth = 3;
	
	        // draw lines
	        for (var i = 0; i < 4; i++) {
	          var pos1 = positions[i];
	          var pos2 = positions[(i + 1) % 4];
	          (dashed ? line : dashLine)(pos1.x + offsetX, pos1.y + offsetY, pos2.x + offsetX, pos2.y + offsetY, 2);
	        }
	      };
	
	      ctx.font = 'bold 7pt Arial';
	      ctx.textAlign = 'center';
	      ctx.textBaseline = 'middle';
	      ctx.fillStyle = colors.white;
	
	      var drawCircles = function drawCircles(positions, properties, color, offsetX, offsetY) {
	        // draw circles
	        var i = 0;
	        (0, _ramda.forEach)(function (pos) {
	          ctx.fillStyle = color;
	          ctx.beginPath();
	          ctx.arc(pos.x + offsetX, pos.y + offsetY, width(.025), 0, 2 * Math.PI, false);
	          ctx.fill();
	          ctx.fillStyle = colors.white;
	          ctx.fillText(_this.getProps()[properties[i++]], pos.x + offsetX, pos.y + offsetY);
	        }, positions);
	      };
	
	      var quadrants2 = { L2: 2, A2: 1, V2: 0, I2: 3 };
	      var positions2 = mapPropToPos(_Benzinger2['default'].props().filter(function (prop) {
	        return prop[1] == '2';
	      }).sort(function (a, b) {
	        return quadrants2[a] - quadrants2[b];
	      }));
	      drawLines(positions2, colors.blue, false, -2, 2);
	      var props2 = _Benzinger2['default'].props().filter(function (prop) {
	        return prop[1] == '2';
	      });
	      drawCircles(positions2, [props2[2], props2[1], props2[0], props2[3]], colors.blue, -2, 2);
	
	      var quadrants1 = { L1: 2, A1: 1, V1: 0, I1: 3 };
	      var positions1 = mapPropToPos(_Benzinger2['default'].props().filter(function (prop) {
	        return prop[1] == '1';
	      }).sort(function (a, b) {
	        return quadrants1[a] - quadrants1[b];
	      }));
	      drawLines(positions1, colors.red, true, 2, -2);
	      var props1 = _Benzinger2['default'].props().filter(function (prop) {
	        return prop[1] == '1';
	      });
	      drawCircles(positions1, [props1[2], props1[1], props1[0], props1[3]], colors.red, 2, -2);
	    }
	  }, {
	    key: 'getDiagonalPosition',
	    value: function getDiagonalPosition(scale, quadrant) {
	      var rightSide = quadrant === 0 || quadrant === 3;
	      var upSide = quadrant === 0 || quadrant === 1;
	
	      var zeroOffsetX = this.width(.45) / 121.5 * Math.sin(Math.PI / 4) * scale * (rightSide ? 1 : -1);
	      var zeroOffsetY = this.height(.45) / 121.5 * Math.sin(Math.PI / 4) * scale * (upSide ? -1 : 1);
	
	      return {
	        x: this.width(.5) + zeroOffsetX,
	        y: this.height(.5) + zeroOffsetY
	      };
	    }
	  }]);
	
	  return BenzingerChart;
	})(_react2['default'].Component);
	
	exports['default'] = BenzingerChart;
	module.exports = exports['default'];

/***/ }),

/***/ 663:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _ramda = __webpack_require__(27);
	
	var _ramda2 = _interopRequireDefault(_ramda);
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _modulesAutoBind = __webpack_require__(29);
	
	var _modulesAutoBind2 = _interopRequireDefault(_modulesAutoBind);
	
	var Table = (function (_React$Component) {
	  _inherits(Table, _React$Component);
	
	  function Table(props) {
	    _classCallCheck(this, Table);
	
	    _get(Object.getPrototypeOf(Table.prototype), 'constructor', this).call(this, props);
	    (0, _modulesAutoBind2['default'])(this);
	    this.state = {
	      justSelected: null
	    };
	  }
	
	  _createClass(Table, [{
	    key: 'render',
	    value: function render() {
	      var widthSum = _ramda2['default'].compose(_ramda2['default'].sum, _ramda2['default'].map(_ramda2['default'].prop('maxWidth')))(this.props.columns);
	      return _react2['default'].createElement(
	        'table',
	        { className: 'table table-striped', style: { width: '100%' } },
	        _react2['default'].createElement(
	          'thead',
	          null,
	          _react2['default'].createElement(
	            'tr',
	            { style: { cursor: 'pointer' } },
	            this.props.columns.map(function (column) {
	              return _react2['default'].createElement(
	                'th',
	                { key: column.id, style: { overflow: 'hidden', maxWidth: column.maxWidth / widthSum * 100 + '%' }, onClick: this.handleSort(column.id) },
	                column.label,
	                _react2['default'].createElement('span', { style: this.props.sort.column === column.id && this.props.sort.order === 'asc' ? { transform: 'rotate(180deg)' } : {}, className: this.props.sort.column === column.id ? 'caret' : '' })
	              );
	            }, this)
	          )
	        ),
	        _react2['default'].createElement(
	          'tbody',
	          null,
	          this.props.data.map(function (row, index) {
	            return _react2['default'].createElement(
	              'tr',
	              { key: index, style: this.props.selectedIndex === index ? { backgroundColor: '#5BC0DE' } : {}, onClick: this.handleRowClick(index) },
	              this.props.columns.map(function (column) {
	                return _react2['default'].createElement(
	                  'td',
	                  { key: column.id },
	                  row[column.id]
	                );
	              }, this)
	            );
	          }, this)
	        )
	      );
	    }
	  }, {
	    key: 'handleSort',
	    value: function handleSort(column) {
	      var _this = this;
	
	      return function () {
	        return _this.props.onSort({
	          column: column,
	          order: column === _this.props.sort.column && _this.props.sort.order === 'desc' ? 'asc' : 'desc'
	        });
	      };
	    }
	  }, {
	    key: 'handleRowClick',
	    value: function handleRowClick(index) {
	      var _this2 = this;
	
	      return function () {
	        if (_this2.state.justSelected) {
	          clearTimeout(_this2.state.justSelected[1]);
	        }
	        if (_this2.state.justSelected && _this2.state.justSelected[0] === index) {
	          _this2.props.onRowDoubleClick({ row: _this2.props.data[index], index: index });
	        } else {
	          var timeoutId = setTimeout(function () {
	            return _this2.setState({ justSelected: null });
	          }, 500);
	          _this2.props.onRowClick({ row: _this2.props.data[index], index: index });
	          _this2.setState({ justSelected: [index, timeoutId] });
	        }
	      };
	    }
	  }]);
	
	  return Table;
	})(_react2['default'].Component);
	
	exports['default'] = Table;
	module.exports = exports['default'];

/***/ }),

/***/ 664:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _ramda = __webpack_require__(27);
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(41);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _modulesAutoBind = __webpack_require__(29);
	
	var _modulesAutoBind2 = _interopRequireDefault(_modulesAutoBind);
	
	var _XTNA = __webpack_require__(456);
	
	var _XTNA2 = _interopRequireDefault(_XTNA);
	
	var colors = {
	  border: 'rgb(117, 113, 113)',
	  innerSquare: 'rgb(217, 217, 217)',
	  red: 'rgb(255, 0, 0)',
	  blue: 'rgb(0, 0, 255)',
	  black: 'rgb(0, 0, 0)',
	  white: 'rgb(255, 255, 255)',
	  axis: 'rgb(192, 192, 192)'
	};
	
	var XTNAChart = (function (_React$Component) {
	  _inherits(XTNAChart, _React$Component);
	
	  function XTNAChart(props) {
	    _classCallCheck(this, XTNAChart);
	
	    _get(Object.getPrototypeOf(XTNAChart.prototype), 'constructor', this).call(this, props);
	    (0, _modulesAutoBind2['default'])(this);
	    this.state = { canvas: null };
	  }
	
	  _createClass(XTNAChart, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var canvas = document.createElement('canvas');
	      canvas.setAttribute('style', 'width: 100%; height: 100%;');
	      canvas.setAttribute('width', canvas.offsetWidth);
	      canvas.setAttribute('height', canvas.offsetWidth);
	      canvas.setAttribute('id', this.props.id);
	      _reactDom2['default'].findDOMNode(this).appendChild(canvas);
	      this.setState({ canvas: canvas });
	      window.addEventListener('resize', this.handleResize);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('resize', this.handleResize);
	      _reactDom2['default'].findDOMNode(this).removeChild(this.state.canvas);
	    }
	  }, {
	    key: 'handleResize',
	    value: function handleResize() {
	      this.setState({ windowWidth: window.innerWidth });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.state.canvas) {
	        this.renderCanvas(this.state.canvas);
	      }
	
	      return _react2['default'].createElement('div', { style: { marginBottom: '10px' } });
	    }
	  }, {
	    key: 'renderCanvas',
	    value: function renderCanvas(canvas) {
	      var _this = this;
	
	      canvas.setAttribute('width', canvas.offsetWidth);
	      canvas.setAttribute('height', canvas.offsetWidth);
	      this.width = (0, _ramda.multiply)(canvas.offsetWidth);
	      this.height = (0, _ramda.multiply)(canvas.offsetWidth);
	
	      var ctx = canvas.getContext('2d');
	      var width = this.width,
	          height = this.height;
	
	      // gray border
	      ctx.fillStyle = colors.border;
	      ctx.fillRect(0, 0, width(1), height(1));
	      ctx.clearRect(width(.05), height(.05), width(.9), height(.9));
	
	      // draw derived properties     
	      ctx.fillStyle = colors.red;
	      ctx.fillRect(width(.38), 0, width(.07), height(.05));
	      ctx.fillRect(width(.38), height(.95), width(.07), height(.05));
	      ctx.fillRect(0, height(.38), width(.05), height(.07));
	      ctx.fillRect(width(.95), height(.38), width(.05), height(.07));
	
	      ctx.fillStyle = colors.blue;
	      ctx.fillRect(width(.55), 0, width(.07), height(.05));
	      ctx.fillRect(width(.55), height(.95), width(.07), height(.05));
	      ctx.fillRect(0, height(.55), width(.05), height(.07));
	      ctx.fillRect(width(.95), height(.55), width(.05), height(.07));
	
	      ctx.textAlign = 'center';
	      ctx.textBaseline = 'middle';
	      ctx.fillStyle = colors.white;
	      ctx.font = 'bold 9pt Arial';
	
	      var derivedProperties = _XTNA2['default'].deriveProperties(this.props);
	
	      ctx.fillText(derivedProperties.NRef, width(.415), height(.025));
	      ctx.fillText(derivedProperties.NAcc, width(.415), height(.975));
	      ctx.fillText(derivedProperties.NTar, width(.025), height(.415));
	      ctx.fillText(derivedProperties.NPer, width(.975), height(.415));
	
	      ctx.fillText(derivedProperties.ARef, width(.585), height(.025));
	      ctx.fillText(derivedProperties.AAcc, width(.585), height(.975));
	      ctx.fillText(derivedProperties.ATar, width(.025), height(.585));
	      ctx.fillText(derivedProperties.APer, width(.975), height(.585));
	
	      // inner gray square
	      ctx.fillStyle = colors.innerSquare;
	      ctx.fillRect(width(.2), height(.2), width(.6), height(.6));
	      ctx.clearRect(width(.34), height(.34), width(.32), height(.32));
	
	      // dashed lines
	      ctx.lineWidth = 1;
	      ctx.strokeStyle = colors.axis;
	      ctx.dashedLine(width(.5), height(.1), width(.5), height(.9), 2);
	      ctx.dashedLine(width(.1), height(.5), width(.9), height(.5), 2);
	
	      // draw text
	      ctx.textAlign = 'center';
	      ctx.textBaseline = 'middle';
	      ctx.fillStyle = colors.white;
	      ctx.font = 'bold 11pt Arial';
	
	      var letters = 'NTXA'.split('');
	      (0, _ramda.addIndex)(_ramda.forEach)(function (letter, index) {
	        var pos = _this.getDiagonalPosition(10.5, index);
	        ctx.fillText(letter, pos.x, pos.y);
	      }, letters);
	
	      ctx.fillStyle = colors.black;
	      ctx.font = '7pt Arial';
	      ctx.fillText('REFLEXIÓN', width(.5), height(.07));
	      ctx.fillText('ACCIÓN', width(.5), height(.93));
	
	      var drawVertical = function drawVertical(text, xPos, yPos) {
	        (0, _ramda.addIndex)(_ramda.forEach)(function (letter, index) {
	          ctx.fillText(letter, xPos, yPos - text.length * 10 / 2 + 4 + 10 * index);
	        }, text);
	      };
	
	      drawVertical('TAREAS', width(.07), height(.5));
	      drawVertical('PERSONAS', width(.93), height(.5));
	
	      // draw numbers
	      ctx.textAlign = 'center';
	      ctx.textBaseline = 'middle';
	      ctx.fillStyle = colors.black;
	      ctx.font = '7pt Arial';
	      for (var quadrant = 0; quadrant < 4; quadrant++) {
	        for (var num = 1; num < 10; num++) {
	          var position = this.getDiagonalPosition(num, quadrant);
	          ctx.fillText(num.toString(), position.x, position.y);
	        }
	      }
	
	      // plot points
	      var mapPropToPos = (0, _ramda.compose)((0, _ramda.addIndex)(_ramda.map)(this.getDiagonalPosition), (0, _ramda.map)((0, _ramda.prop)(_ramda.__, this.props)));
	
	      var dashLine = ctx.dashedLine.bind(ctx);
	      var line = function line(x1, y1, x2, y2) {
	        ctx.beginPath();
	        ctx.moveTo(x1, y1);
	        ctx.lineTo(x2, y2);
	        ctx.stroke();
	      };
	
	      var drawLines = function drawLines(positions, color, dashed, offsetX, offsetY) {
	        offsetX = offsetX || 0;
	        offsetY = offsetY || 0;
	        ctx.fillStyle = color;
	        ctx.strokeStyle = color;
	        ctx.lineWidth = 3;
	
	        // draw lines
	        for (var i = 0; i < 4; i++) {
	          var pos1 = positions[i];
	          var pos2 = positions[(i + 1) % 4];
	          (dashed ? dashLine : line)(pos1.x + offsetX, pos1.y + offsetY, pos2.x + offsetX, pos2.y + offsetY, 2);
	        }
	      };
	
	      ctx.font = 'bold 9pt Arial';
	      ctx.textAlign = 'center';
	      ctx.textBaseline = 'middle';
	      ctx.fillStyle = colors.white;
	
	      var drawSquares = function drawSquares(positions, properties, color, offsetX, offsetY) {
	        offsetX = offsetX || 0;
	        offsetY = offsetY || 0;
	
	        // draw squares
	        var i = 0;
	        (0, _ramda.forEach)(function (pos) {
	          ctx.fillStyle = color;
	          ctx.fillRect(pos.x - width(.025) + offsetX, pos.y - height(.025) + offsetY, width(.05), height(.05));
	          ctx.fillStyle = colors.white;
	          ctx.fillText(_this.props[properties[i++]], pos.x + offsetX, pos.y + offsetY);
	        }, positions);
	      };
	
	      var getPropNames = function getPropNames(type) {
	        return _XTNA2['default'].props().filter((0, _ramda.compose)((0, _ramda.equals)(type), _ramda.head));
	      };
	
	      var naturalProperties = getPropNames('N');
	      var adaptedProperties = getPropNames('A');
	
	      var quadrants = { X: 2, T: 1, N: 0, A: 3 };
	      var naturalPositions = mapPropToPos(naturalProperties.sort(function (a, b) {
	        return quadrants[a[1]] - quadrants[b[1]];
	      }));
	      var adaptedPositions = mapPropToPos(adaptedProperties.sort(function (a, b) {
	        return quadrants[a[1]] - quadrants[b[1]];
	      }));
	
	      drawLines(naturalPositions, colors.red, false, 2, -2);
	      drawLines(adaptedPositions, colors.blue, true, -2, 2);
	      drawSquares(adaptedPositions, adaptedProperties, colors.blue, -2, 2);
	      drawSquares(naturalPositions, naturalProperties, colors.red, 2, -2);
	    }
	  }, {
	    key: 'getDiagonalPosition',
	    value: function getDiagonalPosition(scale, quadrant) {
	      var rightSide = quadrant === 0 || quadrant === 3;
	      var upSide = quadrant === 0 || quadrant === 1;
	
	      var zeroOffsetX = this.width(.45) / 10 * scale * (rightSide ? 1 : -1);
	      var zeroOffsetY = this.height(.45) / 10 * scale * (upSide ? -1 : 1);
	
	      return {
	        x: this.width(.5) + zeroOffsetX,
	        y: this.height(.5) + zeroOffsetY
	      };
	    }
	  }]);
	
	  return XTNAChart;
	})(_react2['default'].Component);
	
	exports['default'] = XTNAChart;
	module.exports = exports['default'];

/***/ }),

/***/ 744:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fbe694c234fb05b0b2bbbee15a582348.png";

/***/ }),

/***/ 1009:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _ramda = __webpack_require__(27);
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _modulesAutoBind = __webpack_require__(29);
	
	var _modulesAutoBind2 = _interopRequireDefault(_modulesAutoBind);
	
	var _modulesNumberInputJsx = __webpack_require__(134);
	
	var _modulesNumberInputJsx2 = _interopRequireDefault(_modulesNumberInputJsx);
	
	var _ChartJsx = __webpack_require__(662);
	
	var _ChartJsx2 = _interopRequireDefault(_ChartJsx);
	
	__webpack_require__(440);
	
	var _Benzinger = __webpack_require__(454);
	
	var _Benzinger2 = _interopRequireDefault(_Benzinger);
	
	var expectedCol = { backgroundColor: 'white', fontSize: '80%', border: '0px' };
	var resultCell = { backgroundColor: '#595959', color: 'white' };
	var header = { border: '0px', fontSize: '65%', backgroundColor: 'white' };
	
	var BenzingerChartDataForm = (function (_React$Component) {
	  _inherits(BenzingerChartDataForm, _React$Component);
	
	  function BenzingerChartDataForm(props) {
	    _classCallCheck(this, BenzingerChartDataForm);
	
	    _get(Object.getPrototypeOf(BenzingerChartDataForm.prototype), 'constructor', this).call(this, props);
	    (0, _modulesAutoBind2['default'])(this);
	    this.state = {
	      imagen: ['0', '0', '0', '0'],
	      adjetivo: '',
	      totalExIn: [0, 0],
	      adultoExIn: [0, 0],
	      jovenExIn: [0, 0],
	      posDetNegEst: [0, 0, 0, 0],
	      adultoStats: {
	        AT: [0, 0, 0, 0],
	        ATL: [0, 0, 0, 0],
	        AA: [0, 0, 0, 0]
	      },
	      jovenStats: [0, 0, 0, 0]
	    };
	  }
	
	  _createClass(BenzingerChartDataForm, [{
	    key: 'render',
	    value: function render() {
	      return _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement(
	          'table',
	          { className: 'yellow-input-table', style: { tableLayout: 'fixed', marginBottom: '10px' } },
	          _react2['default'].createElement(
	            'tbody',
	            null,
	            _react2['default'].createElement(
	              'tr',
	              null,
	              _react2['default'].createElement(
	                'td',
	                { style: { visibility: 'hidden', border: '0px' } },
	                '.'
	              ),
	              R.map(function (prop) {
	                return _react2['default'].createElement(
	                  'td',
	                  { style: header, key: 'posDetNegEst' + prop },
	                  prop
	                );
	              }, ['POS', 'DET', 'NEG', 'EST'])
	            ),
	            this.renderPosDetNegEst(),
	            _react2['default'].createElement(
	              'tr',
	              { style: { visibility: 'hidden', border: 'white' } },
	              R.map(function (i) {
	                return _react2['default'].createElement('td', { key: 'empty1' + i, style: { border: '0px' } });
	              }, [0, 1, 2, 3, 4, 5])
	            ),
	            _react2['default'].createElement(
	              'tr',
	              null,
	              ['', 'FI 7', 'PI 1', 'PD 2', 'FD 8', 'SUM'].map(function (prop) {
	                return _react2['default'].createElement(
	                  'td',
	                  { style: header, key: prop },
	                  prop
	                );
	              })
	            ),
	            this.renderAdultoStatsRow('AT', 'Adulto Trabajo', 144),
	            this.renderAdultoStatsRow('ATL', 'Adulto T. Libre', 81),
	            this.renderAdultoStatsRow('AA', 'Adulto Autodesc.', 90),
	            this.renderAdultoTotal(),
	            _react2['default'].createElement(
	              'tr',
	              { style: { visibility: 'hidden', border: 'white' } },
	              R.map(function (i) {
	                return _react2['default'].createElement('td', { key: 'empty2' + i, style: { border: '0px' } });
	              }, [0, 1, 2, 3, 4, 5])
	            ),
	            _react2['default'].createElement(
	              'tr',
	              { style: { visibility: 'hidden' } },
	              _react2['default'].createElement(
	                'td',
	                null,
	                '.'
	              ),
	              _react2['default'].createElement(
	                'td',
	                null,
	                '.'
	              ),
	              _react2['default'].createElement(
	                'td',
	                null,
	                '.'
	              ),
	              _react2['default'].createElement(
	                'td',
	                null,
	                '.'
	              ),
	              _react2['default'].createElement(
	                'td',
	                null,
	                '.'
	              )
	            ),
	            this.renderJovenImagen(),
	            this.renderJovenAdjetivo(),
	            this.renderJovenRow(),
	            this.renderJovenTotal(),
	            _react2['default'].createElement(
	              'tr',
	              { style: { visibility: 'hidden', border: 'white' } },
	              R.map(function (i) {
	                return _react2['default'].createElement('td', { key: 'empty2' + i, style: { border: '0px' } });
	              }, [0, 1, 2, 3, 4, 5])
	            ),
	            _react2['default'].createElement(
	              'tr',
	              null,
	              _react2['default'].createElement(
	                'td',
	                { style: { visibility: 'hidden', border: '0px' } },
	                '.'
	              ),
	              R.map(function (prop) {
	                return _react2['default'].createElement(
	                  'td',
	                  { style: header, key: 'rowJoven' + prop },
	                  prop
	                );
	              }, ['EX', 'IN'])
	            ),
	            this.renderExIn('adulto', 'Adulto'),
	            this.renderExIn('joven', 'Joven'),
	            this.renderExIn('total', 'Total')
	          )
	        )
	      );
	    }
	  }, {
	    key: 'notifyChange',
	    value: function notifyChange(newState) {
	      var st = R.merge(this.state, newState);
	      this.props.onChange({
	        A1: st.adultoStats.AT[0] + st.adultoStats.AA[0] + st.adultoStats.ATL[0],
	        L1: st.adultoStats.AT[1] + st.adultoStats.AA[1] + st.adultoStats.ATL[1],
	        I1: st.adultoStats.AT[2] + st.adultoStats.AA[2] + st.adultoStats.ATL[2],
	        V1: st.adultoStats.AT[3] + st.adultoStats.AA[3] + st.adultoStats.ATL[3],
	        A2: st.jovenStats[0],
	        L2: st.jovenStats[1],
	        I2: st.jovenStats[2],
	        V2: st.jovenStats[3],
	        adultoStats: st.adultoStats,
	        imagen: st.imagen,
	        jovenExIn: st.jovenExIn,
	        adultoExIn: st.adultoExIn,
	        totalExIn: st.totalExIn,
	        adjetivo: st.adjetivo,
	        posDetNegEst: st.posDetNegEst,
	        valid: true
	      });
	    }
	  }, {
	    key: 'setStateAndNotify',
	    value: function setStateAndNotify(state) {
	      this.setState(state);
	      this.notifyChange(state);
	    }
	  }, {
	    key: 'renderExIn',
	    value: function renderExIn(field, label) {
	      var _this = this;
	
	      var onChange = function onChange(index) {
	        return function (value) {
	          return _this.setStateAndNotify(_defineProperty({}, field + 'ExIn', R.update(index, value, _this.state[field + 'ExIn'])));
	        };
	      };
	      return _react2['default'].createElement(
	        'tr',
	        null,
	        _react2['default'].createElement(
	          'td',
	          null,
	          label
	        ),
	        _react2['default'].createElement(
	          'td',
	          null,
	          _react2['default'].createElement(_modulesNumberInputJsx2['default'], { className: 'form-control', onChange: onChange(0), value: this.state[field + 'ExIn'][0], min: '0', max: '30' })
	        ),
	        _react2['default'].createElement(
	          'td',
	          null,
	          _react2['default'].createElement(_modulesNumberInputJsx2['default'], { className: 'form-control', onChange: onChange(1), value: this.state[field + 'ExIn'][1], min: '0', max: '30' })
	        )
	      );
	    }
	  }, {
	    key: 'renderPosDetNegEst',
	    value: function renderPosDetNegEst() {
	      var _this2 = this;
	
	      var renderCell = function renderCell(prop, index) {
	        return _react2['default'].createElement(
	          'td',
	          { key: 'rowPosDetNegEst' + index },
	          _react2['default'].createElement(_modulesNumberInputJsx2['default'], { className: 'form-control', onChange: _this2.handlePosDetNegEstChange(index), value: _this2.state.posDetNegEst[index], min: '0', max: '50' })
	        );
	      };
	      return _react2['default'].createElement(
	        'tr',
	        null,
	        _react2['default'].createElement(
	          'td',
	          { style: { visibility: 'hidden' } },
	          '.'
	        ),
	        R.addIndex(R.map)(renderCell, ['POS', 'DET', 'NEG', 'EST'])
	      );
	    }
	  }, {
	    key: 'handlePosDetNegEstChange',
	    value: function handlePosDetNegEstChange(index) {
	      var _this3 = this;
	
	      return function (value) {
	        var statValues = _this3.state.posDetNegEst;
	        var newValues = R.update(index, value, statValues);
	        _this3.setStateAndNotify({ posDetNegEst: newValues });
	      };
	    }
	  }, {
	    key: 'renderJovenTotal',
	    value: function renderJovenTotal() {
	      var _this4 = this;
	
	      return _react2['default'].createElement(
	        'tr',
	        null,
	        _react2['default'].createElement(
	          'td',
	          null,
	          'Joven x 4'
	        ),
	        R.map(function (index) {
	          return _react2['default'].createElement(
	            'td',
	            { style: resultCell, key: 'rowJovenTotal' + index },
	            _this4.state.jovenStats[index] * 4
	          );
	        }, [0, 1, 2, 3]),
	        _react2['default'].createElement('td', { style: resultCell })
	      );
	    }
	  }, {
	    key: 'renderJovenRow',
	    value: function renderJovenRow() {
	      var _this5 = this;
	
	      var renderJovenCell = function renderJovenCell(prop, index) {
	        return _react2['default'].createElement(
	          'td',
	          { key: 'rowJoven' + prop },
	          _react2['default'].createElement(_modulesNumberInputJsx2['default'], { className: 'form-control', onChange: _this5.handleJovenStatChange(index), value: _this5.state.jovenStats[index], min: '0', max: '100' })
	        );
	      };
	      return _react2['default'].createElement(
	        'tr',
	        null,
	        _react2['default'].createElement(
	          'td',
	          { key: 'rowJoven' },
	          'Joven'
	        ),
	        R.addIndex(R.map)(renderJovenCell, ['FI', 'PI', 'PD', 'FD']),
	        _react2['default'].createElement(
	          'td',
	          { style: resultCell, key: 'rowJovenSum' },
	          R.sum(this.state.jovenStats)
	        ),
	        _react2['default'].createElement(
	          'td',
	          { style: expectedCol },
	          '81'
	        )
	      );
	    }
	  }, {
	    key: 'renderJovenAdjetivo',
	    value: function renderJovenAdjetivo() {
	      var _this6 = this;
	
	      return _react2['default'].createElement(
	        'tr',
	        null,
	        _react2['default'].createElement(
	          'td',
	          null,
	          'Adjetivo'
	        ),
	        _react2['default'].createElement(
	          'td',
	          { colSpan: '4' },
	          _react2['default'].createElement('input', { type: 'text', value: this.state.adjetivo, onChange: function (event) {
	              return _this6.setStateAndNotify({ adjetivo: event.target.value });
	            } })
	        ),
	        _react2['default'].createElement('td', { style: resultCell })
	      );
	    }
	  }, {
	    key: 'renderJovenImagen',
	    value: function renderJovenImagen() {
	      var _this7 = this;
	
	      var onImagenChange = function onImagenChange(index) {
	        return function (event) {
	          var newVal = event.target.value.toUpperCase();
	          var prevVal = _this7.state.imagen[index];
	          var val = null;
	          if (newVal === '') val = '0';else if (newVal.length === 1) val = newVal;else if (newVal.length > 2) return;else if (newVal[0] === prevVal) val = newVal[1];else if (newVal[1] === prevVal) val = newVal[0];
	          if (val !== '0' && val !== 'M' && val !== 'N') return;
	
	          var newImagen = R.update(index, val, _this7.state.imagen);
	          if (val !== '0') for (var i = 0; i < 4; i++) {
	            if (i != index && newImagen[i] === val) newImagen[i] = '0';
	          }_this7.setStateAndNotify({ imagen: newImagen });
	        };
	      };
	
	      var cellStyle = function cellStyle(value) {
	        return { backgroundColor: value === 'M' ? 'green' : value === 'N' ? 'orange' : '#fffd38', color: value === 'M' ? 'white' : 'black' };
	      };
	
	      return _react2['default'].createElement(
	        'tr',
	        null,
	        _react2['default'].createElement(
	          'td',
	          null,
	          'Imagen'
	        ),
	        R.addIndex(R.map)(function (prop, index) {
	          return _react2['default'].createElement(
	            'td',
	            { style: cellStyle(_this7.state.imagen[index]), key: 'rowJovenImage' + prop },
	            _react2['default'].createElement('input', { style: cellStyle(_this7.state.imagen[index]), type: 'text', value: _this7.state.imagen[index], onChange: onImagenChange(index) })
	          );
	        }, ['FI', 'PI', 'PD', 'FD']),
	        _react2['default'].createElement('td', { style: resultCell })
	      );
	    }
	  }, {
	    key: 'renderAdultoStatsRow',
	    value: function renderAdultoStatsRow(stat, label, expectedSum) {
	      var _this8 = this;
	
	      var resultValue = R.sum(this.state.adultoStats[stat]);
	      var matchesExpected = resultValue === expectedSum;
	      var resultColor = resultValue === 0 ? '#595959' : matchesExpected ? 'green' : 'red';
	      var renderAdultoCell = function renderAdultoCell(prop, index) {
	        return _react2['default'].createElement(
	          'td',
	          { key: 'row' + stat + prop },
	          _react2['default'].createElement(_modulesNumberInputJsx2['default'], { className: 'form-control', onChange: _this8.handleAdultoStatChange(stat, index), value: _this8.state.adultoStats[stat][index], min: '0', max: '144' })
	        );
	      };
	      return _react2['default'].createElement(
	        'tr',
	        null,
	        _react2['default'].createElement(
	          'td',
	          { key: 'row' + stat },
	          label
	        ),
	        R.addIndex(R.map)(renderAdultoCell, ['FI', 'PI', 'PD', 'FD']),
	        _react2['default'].createElement(
	          'td',
	          { style: { backgroundColor: resultColor, color: 'white' }, key: 'row' + stat + 'sum' },
	          resultValue
	        ),
	        _react2['default'].createElement(
	          'td',
	          { style: expectedCol },
	          expectedSum
	        )
	      );
	    }
	  }, {
	    key: 'renderAdultoTotal',
	    value: function renderAdultoTotal() {
	      var _this9 = this;
	
	      var expectedValue = 315;
	      var resultValue = R.sum(this.state.adultoStats['AT']) + R.sum(this.state.adultoStats['ATL']) + R.sum(this.state.adultoStats['AA']);
	      var matchesExpected = resultValue === expectedValue;
	      var resultColor = resultValue === 0 ? '#fffd38' : matchesExpected ? 'green' : 'red';
	      return _react2['default'].createElement(
	        'tr',
	        null,
	        _react2['default'].createElement(
	          'td',
	          { key: 'rowAdultoTotal' },
	          'Adulto Total'
	        ),
	        R.map(function (index) {
	          return _react2['default'].createElement(
	            'td',
	            { style: resultCell, key: 'rowAdultoTotal' + index },
	            _this9.state.adultoStats['AT'][index] + _this9.state.adultoStats['ATL'][index] + _this9.state.adultoStats['AA'][index]
	          );
	        }, [0, 1, 2, 3]),
	        _react2['default'].createElement(
	          'td',
	          { style: { backgroundColor: resultColor, color: resultValue !== 0 ? 'white' : 'black' }, key: 'adultoTotalSum' },
	          resultValue
	        ),
	        _react2['default'].createElement(
	          'td',
	          { style: expectedCol },
	          expectedValue
	        )
	      );
	    }
	  }, {
	    key: 'handleAdultoStatChange',
	    value: function handleAdultoStatChange(stat, index) {
	      var _this10 = this;
	
	      return function (value) {
	        var statValues = _this10.state.adultoStats[stat];
	        var newValues = R.update(index, value, statValues);
	        _this10.setStateAndNotify({ adultoStats: (0, _ramda.merge)(_this10.state.adultoStats, _defineProperty({}, stat, newValues)) });
	      };
	    }
	  }, {
	    key: 'handleJovenStatChange',
	    value: function handleJovenStatChange(index) {
	      var _this11 = this;
	
	      return function (value) {
	        var statValues = _this11.state.jovenStats;
	        var newValues = R.update(index, value, statValues);
	        _this11.setStateAndNotify({ jovenStats: newValues });
	      };
	    }
	  }, {
	    key: 'handleStatChange',
	    value: function handleStatChange(id) {
	      var _this12 = this;
	
	      return function (value) {
	        _this12.props.onStatChange((0, _ramda.merge)(_this12.props.stats, _defineProperty({}, id, value)));
	      };
	    }
	  }, {
	    key: 'renderProp',
	    value: function renderProp(type) {
	      var _this13 = this;
	
	      return function (prop) {
	        var cell = _this13.props.editable === false ? _this13.props.value[prop] : _react2['default'].createElement(_modulesNumberInputJsx2['default'], { className: 'form-control', onChange: _this13.handleChange(prop), value: _this13.props.value[prop], min: '0', max: [150, 59][type] });
	        return _react2['default'].createElement(
	          'td',
	          { key: prop },
	          cell
	        );
	      };
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange(field) {
	      var _this14 = this;
	
	      return function (value) {
	        var _merge3;
	
	        _this14.props.onChange((0, _ramda.merge)(_this14.props.value, (_merge3 = {}, _defineProperty(_merge3, field, value), _defineProperty(_merge3, 'valid', true), _merge3)));
	      };
	    }
	  }]);
	
	  return BenzingerChartDataForm;
	})(_react2['default'].Component);
	
	exports['default'] = BenzingerChartDataForm;
	module.exports = exports['default'];

/***/ }),

/***/ 1010:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _ramda = __webpack_require__(27);
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _modulesAutoBind = __webpack_require__(29);
	
	var _modulesAutoBind2 = _interopRequireDefault(_modulesAutoBind);
	
	var _modulesUtils = __webpack_require__(349);
	
	var _modulesUtils2 = _interopRequireDefault(_modulesUtils);
	
	__webpack_require__(440);
	
	var BenzingerResults = (function (_React$Component) {
	  _inherits(BenzingerResults, _React$Component);
	
	  function BenzingerResults(props) {
	    _classCallCheck(this, BenzingerResults);
	
	    _get(Object.getPrototypeOf(BenzingerResults.prototype), 'constructor', this).call(this, props);
	    (0, _modulesAutoBind2['default'])(this);
	  }
	
	  _createClass(BenzingerResults, [{
	    key: 'render',
	    value: function render() {
	      var dif = Math.abs(this.props.L1 - this.props.L2 * 4) + Math.abs(this.props.A1 - this.props.A2 * 4) + Math.abs(this.props.I1 - this.props.I2 * 4) + Math.abs(this.props.V1 - this.props.V2 * 4);
	      var sum = this.props.L2 * 4 + this.props.A2 * 4 + this.props.V2 * 4 + this.props.I2 * 4;
	
	      var results = {
	        changes: {
	          'dFI 7': Math.abs(this.props.A1 - this.props.A2 * 4),
	          'dPI 1': Math.abs(this.props.L1 - this.props.L2 * 4),
	          'dPD 2': Math.abs(this.props.I1 - this.props.I2 * 4),
	          'dFD 8': Math.abs(this.props.V1 - this.props.V2 * 4)
	        },
	        consistency: sum ? 1 - dif / sum : null,
	        change: dif
	      };
	
	      return _react2['default'].createElement(
	        'div',
	        { style: { marginBottom: '10px' } },
	        _react2['default'].createElement(
	          'center',
	          null,
	          _react2['default'].createElement(
	            'table',
	            { className: 'input-table', style: { marginBottom: '20px' } },
	            _react2['default'].createElement(
	              'thead',
	              null,
	              _react2['default'].createElement(
	                'tr',
	                null,
	                _react2['default'].createElement('td', null),
	                _react2['default'].createElement(
	                  'td',
	                  { key: 'Rac' },
	                  'Rac'
	                ),
	                _react2['default'].createElement(
	                  'td',
	                  { key: 'Cre' },
	                  'Cre'
	                ),
	                _react2['default'].createElement(
	                  'td',
	                  { key: 'Con' },
	                  'Con'
	                ),
	                _react2['default'].createElement(
	                  'td',
	                  { key: 'Prac' },
	                  'Prac'
	                )
	              )
	            ),
	            _react2['default'].createElement(
	              'tbody',
	              null,
	              _react2['default'].createElement(
	                'tr',
	                null,
	                _react2['default'].createElement(
	                  'td',
	                  null,
	                  _react2['default'].createElement(
	                    'b',
	                    null,
	                    'Adulto'
	                  )
	                ),
	                _react2['default'].createElement(
	                  'td',
	                  { key: 'racAdulto' },
	                  this.props.A1 + this.props.L1
	                ),
	                _react2['default'].createElement(
	                  'td',
	                  { key: 'creAdulto' },
	                  this.props.V1 + this.props.I1
	                ),
	                _react2['default'].createElement(
	                  'td',
	                  { key: 'conAdulto' },
	                  this.props.A1 + this.props.V1
	                ),
	                _react2['default'].createElement(
	                  'td',
	                  { key: 'pracAdulto' },
	                  this.props.L1 + this.props.I1
	                )
	              ),
	              _react2['default'].createElement(
	                'tr',
	                null,
	                _react2['default'].createElement(
	                  'td',
	                  null,
	                  _react2['default'].createElement(
	                    'b',
	                    null,
	                    'Joven'
	                  )
	                ),
	                _react2['default'].createElement(
	                  'td',
	                  { key: 'racJoven' },
	                  this.props.A2 * 4 + this.props.L2 * 4
	                ),
	                _react2['default'].createElement(
	                  'td',
	                  { key: 'creJoven' },
	                  this.props.V2 * 4 + this.props.I2 * 4
	                ),
	                _react2['default'].createElement(
	                  'td',
	                  { key: 'conJoven' },
	                  this.props.A2 * 4 + this.props.V2 * 4
	                ),
	                _react2['default'].createElement(
	                  'td',
	                  { key: 'pracJoven' },
	                  this.props.L2 * 4 + this.props.I2 * 4
	                )
	              )
	            )
	          )
	        ),
	        _react2['default'].createElement(
	          'div',
	          null,
	          _react2['default'].createElement(
	            'div',
	            null,
	            _react2['default'].createElement(
	              'label',
	              null,
	              'Índice de Consistencia:'
	            ),
	            ' ',
	            results.consistency === null ? '-' : _modulesUtils2['default'].formatPercentage(results.consistency)
	          ),
	          _react2['default'].createElement(
	            'div',
	            null,
	            _react2['default'].createElement(
	              'label',
	              null,
	              'Niveles de Cambio entre Adulto y Joven:'
	            ),
	            ' ',
	            results.change
	          ),
	          this.renderChanges(results.changes)
	        )
	      );
	    }
	  }, {
	    key: 'renderField',
	    value: function renderField(field) {
	      return _react2['default'].createElement(
	        'td',
	        { key: (0, _ramda.head)(field) },
	        (0, _ramda.tail)(field)
	      );
	    }
	  }, {
	    key: 'renderChanges',
	    value: function renderChanges(changes) {
	      return (0, _ramda.toPairs)(changes).map(function (change) {
	        return _react2['default'].createElement(
	          'div',
	          { key: (0, _ramda.tail)((0, _ramda.head)(change)) },
	          _react2['default'].createElement(
	            'label',
	            null,
	            'Cambios en ',
	            (0, _ramda.tail)((0, _ramda.head)(change)),
	            ':'
	          ),
	          ' ',
	          (0, _ramda.tail)(change)
	        );
	      });
	    }
	  }]);
	
	  return BenzingerResults;
	})(_react2['default'].Component);
	
	exports['default'] = BenzingerResults;
	module.exports = exports['default'];

/***/ }),

/***/ 1011:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _Benzinger = __webpack_require__(454);
	
	var _Benzinger2 = _interopRequireDefault(_Benzinger);
	
	var _ChartJsx = __webpack_require__(662);
	
	var _ChartJsx2 = _interopRequireDefault(_ChartJsx);
	
	var _FormJsx = __webpack_require__(1009);
	
	var _FormJsx2 = _interopRequireDefault(_FormJsx);
	
	var _ResultsJsx = __webpack_require__(1010);
	
	var _ResultsJsx2 = _interopRequireDefault(_ResultsJsx);
	
	exports['default'] = {
	  Benzinger: _Benzinger2['default'],
	  BenzingerChart: _ChartJsx2['default'],
	  BenzingerForm: _FormJsx2['default'],
	  BenzingerResults: _ResultsJsx2['default']
	};
	module.exports = exports['default'];

/***/ }),

/***/ 1012:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _ramda = __webpack_require__(27);
	
	var _ramda2 = _interopRequireDefault(_ramda);
	
	var _jquery = __webpack_require__(35);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bluebird = __webpack_require__(225);
	
	var _bluebird2 = _interopRequireDefault(_bluebird);
	
	var _reactBootstrapLibModal = __webpack_require__(413);
	
	var _reactBootstrapLibModal2 = _interopRequireDefault(_reactBootstrapLibModal);
	
	var _reactBootstrapLibAlert = __webpack_require__(252);
	
	var _reactBootstrapLibAlert2 = _interopRequireDefault(_reactBootstrapLibAlert);
	
	var _modulesAutoBind = __webpack_require__(29);
	
	var _modulesAutoBind2 = _interopRequireDefault(_modulesAutoBind);
	
	var _common = __webpack_require__(95);
	
	var _modulesSpinnerJsx = __webpack_require__(153);
	
	var _modulesSpinnerJsx2 = _interopRequireDefault(_modulesSpinnerJsx);
	
	var _reactBootstrapLibPagination = __webpack_require__(414);
	
	var _reactBootstrapLibPagination2 = _interopRequireDefault(_reactBootstrapLibPagination);
	
	var Licenses = (function (_React$Component) {
	  _inherits(Licenses, _React$Component);
	
	  function Licenses(props) {
	    _classCallCheck(this, Licenses);
	
	    _get(Object.getPrototypeOf(Licenses.prototype), 'constructor', this).call(this, props);
	    (0, _modulesAutoBind2['default'])(this);
	    this.state = {
	      numLicensesRequested: "",
	      loadingLicenses: false,
	      numLicenses: false
	    };
	  }
	
	  _createClass(Licenses, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.fetchLicenses();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this = this;
	
	      return _react2['default'].createElement(
	        'span',
	        null,
	        'Licencias Disponibles: ',
	        this.state.numLicenses || 0,
	        _react2['default'].createElement('input', { style: { marginLeft: '10px' }, type: 'number', min: '1', value: this.state.numLicensesRequested, onChange: function (event) {
	            return _this.setState({ numLicensesRequested: event.target.value });
	          }, placeholder: 'Solicitar licencias' }),
	        _react2['default'].createElement('input', { type: 'submit', value: 'Solicitar', onClick: this.addLicenses, disabled: this.state.numLicensesRequested === "" || this.state.loadingLicenses })
	      );
	    }
	  }, {
	    key: 'fetchLicenses',
	    value: function fetchLicenses() {
	      var _this2 = this;
	
	      return _bluebird2['default'].resolve(_jquery2['default'].ajax({
	        url: this.props.resourceUrl
	      })).then(function (_ref) {
	        var licenses = _ref.licenses;
	        return _this2.setState({ numLicenses: licenses });
	      })['catch'](function () {
	        return _this2.setState({ numLicenses: 0 });
	      });
	    }
	  }, {
	    key: 'addLicenses',
	    value: function addLicenses(event) {
	      var _this3 = this;
	
	      event.preventDefault();
	      var num = this.state.numLicensesRequested;
	      this.setState({ loadingLicenses: true, numLicensesRequested: "" });
	      return _bluebird2['default'].resolve(_jquery2['default'].ajax({
	        url: this.props.resourceUrl,
	        method: 'POST',
	        data: { licensesRequested: this.state.numLicensesRequested }
	      }))['catch'](function () {
	        return _this3.setState({ numLicensesRequested: num });
	      })['finally'](function () {
	        return _this3.setState({ loadingLicenses: false });
	      });
	    }
	  }]);
	
	  return Licenses;
	})(_react2['default'].Component);
	
	exports['default'] = Licenses;
	module.exports = exports['default'];

/***/ }),

/***/ 1013:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _ramda = __webpack_require__(27);
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _modulesAutoBind = __webpack_require__(29);
	
	var _modulesAutoBind2 = _interopRequireDefault(_modulesAutoBind);
	
	var _common = __webpack_require__(95);
	
	var _QuickSelectJsx = __webpack_require__(1015);
	
	var _QuickSelectJsx2 = _interopRequireDefault(_QuickSelectJsx);
	
	var _QuestionnairesData = __webpack_require__(455);
	
	var colors = ['', 'blue', 'blue', 'green', 'green'];
	var descriptions = ['', 'Nunca/casi nunca', 'Pocas veces', 'Frecuentemente', 'Siempre/casi siempre'];
	
	var Questionnaire1 = (function (_React$Component) {
	  _inherits(Questionnaire1, _React$Component);
	
	  function Questionnaire1(props) {
	    _classCallCheck(this, Questionnaire1);
	
	    _get(Object.getPrototypeOf(Questionnaire1.prototype), 'constructor', this).call(this, props);
	    (0, _modulesAutoBind2['default'])(this);
	    this.state = {};
	    this.editable = this.props.editable !== false;
	    this.enableLeaveMessage();
	  }
	
	  _createClass(Questionnaire1, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.enableLeaveMessage();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.onbeforeunload = null;
	    }
	  }, {
	    key: 'enableLeaveMessage',
	    value: function enableLeaveMessage() {
	      if (this.props.canSave) {
	        window.onbeforeunload = function (event) {
	          return (event || window.event).returnValue = 'Tienes cambios sin guardar.';
	        };
	      } else {
	        window.onbeforeunload = null;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var complete = _common.validations.finishedQuestionnaire1(this.props.value);
	      var incompleteError = function incompleteError() {
	        return alert('Faltan campos de llenar.');
	      };
	      var continueClasses = 'btn btn-lg btn-success';
	      if (!complete) {
	        continueClasses += ' disabled';
	      }
	
	      return _react2['default'].createElement(
	        'form',
	        null,
	        _react2['default'].createElement(
	          'h1',
	          null,
	          'Cuestionario 1'
	        ),
	        this.editable ? _react2['default'].createElement(
	          'div',
	          null,
	          _react2['default'].createElement(
	            'table',
	            { className: 'pull-right' },
	            _react2['default'].createElement(
	              'thead',
	              null,
	              _react2['default'].createElement(
	                'tr',
	                null,
	                _react2['default'].createElement('th', null),
	                _react2['default'].createElement(
	                  'th',
	                  { style: { width: '40px' } },
	                  _react2['default'].createElement(
	                    'b',
	                    null,
	                    'Escala'
	                  )
	                )
	              )
	            ),
	            _react2['default'].createElement(
	              'tbody',
	              null,
	              _react2['default'].createElement(
	                'tr',
	                null,
	                _react2['default'].createElement(
	                  'td',
	                  { style: { color: '#1AAF54' } },
	                  'Sí me describe, siempre o casi siempre.'
	                ),
	                _react2['default'].createElement(
	                  'td',
	                  { style: { textAlign: 'center', border: '1px solid black', background: '#1AAF54' } },
	                  _react2['default'].createElement(
	                    'b',
	                    null,
	                    '4'
	                  )
	                )
	              ),
	              _react2['default'].createElement(
	                'tr',
	                null,
	                _react2['default'].createElement(
	                  'td',
	                  { style: { color: '#1AAF54' } },
	                  'Sí me describe, la mayoría de las veces.'
	                ),
	                _react2['default'].createElement(
	                  'td',
	                  { style: { textAlign: 'center', border: '1px solid black', background: '#1AAF54' } },
	                  _react2['default'].createElement(
	                    'b',
	                    null,
	                    '3'
	                  )
	                )
	              ),
	              _react2['default'].createElement(
	                'tr',
	                null,
	                _react2['default'].createElement(
	                  'td',
	                  { style: { color: '#BE0712' } },
	                  'No me describe, la mayoría de las veces.'
	                ),
	                _react2['default'].createElement(
	                  'td',
	                  { style: { textAlign: 'center', border: '1px solid black', background: '#BE0712' } },
	                  _react2['default'].createElement(
	                    'b',
	                    null,
	                    '2'
	                  )
	                )
	              ),
	              _react2['default'].createElement(
	                'tr',
	                null,
	                _react2['default'].createElement(
	                  'td',
	                  { style: { color: '#BE0712' } },
	                  'No me describe, nunca o casi nunca.'
	                ),
	                _react2['default'].createElement(
	                  'td',
	                  { style: { textAlign: 'center', border: '1px solid black', background: '#BE0712' } },
	                  _react2['default'].createElement(
	                    'b',
	                    null,
	                    '1'
	                  )
	                )
	              )
	            )
	          ),
	          _react2['default'].createElement('br', null),
	          _react2['default'].createElement(
	            'h5',
	            null,
	            'Responde a cada una de las 40 frases descriptiva usando la siguiente escala:'
	          ),
	          _react2['default'].createElement(
	            'h5',
	            null,
	            'Se honesto contigo mismo para que el resultado sea de utilidad para ti y para el ejercicio.'
	          ),
	          _react2['default'].createElement('br', null),
	          _react2['default'].createElement('br', null)
	        ) : '',
	        (0, _ramda.addIndex)(_ramda.map)(this.renderQuestion, _QuestionnairesData.q1Questions),
	        this.editable ? _react2['default'].createElement(
	          'div',
	          { style: { textAlign: 'right' } },
	          _react2['default'].createElement(
	            'button',
	            { type: 'button', style: { display: 'inline-block', margin: '0px 10px' }, className: 'btn btn-lg btn-info', disabled: !this.props.canSave, onClick: this.props.onSave },
	            this.props.canSave ? 'Guardar' : 'Guardado'
	          ),
	          _react2['default'].createElement(
	            'button',
	            { type: 'button', style: { display: 'inline-block', margin: '0px 10px' }, className: continueClasses, onClick: complete ? this.props.onSubmit : incompleteError },
	            'Continuar'
	          )
	        ) : ''
	      );
	    }
	  }, {
	    key: 'renderQuestion',
	    value: function renderQuestion(question, index) {
	      var rowStyle = (0, _ramda.merge)({ borderRadius: '5px', padding: '15px 0px', margin: '25px 0px', verticalAlign: 'middle', backgroundColor: index % 2 ? '#EEEEEE' : '#DFDFDF' }, this.props.smallScreen ? { marginBottom: '30px' } : {});
	      return _react2['default'].createElement(
	        'div',
	        { className: 'row', style: rowStyle, key: '1' + index },
	        _react2['default'].createElement(
	          'div',
	          { className: 'col-lg-8 col-xs-12', style: { paddingTop: '10px' } },
	          _react2['default'].createElement(
	            'b',
	            null,
	            index + 1,
	            '.'
	          ),
	          ' ',
	          question
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'col-lg-2', style: { paddingTop: '10px' } },
	          _react2['default'].createElement(
	            'b',
	            { style: { color: colors[this.props.value[index]] } },
	            descriptions[this.props.value[index]]
	          )
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'col-lg-2 col-xs-12', style: { textAlign: this.props.smallScreen ? 'left' : 'right' } },
	          _react2['default'].createElement(_QuickSelectJsx2['default'], { editable: this.editable, values: (0, _ramda.range)(1, 5), value: this.props.value[index], onChange: this.handleOptionClick(index) })
	        )
	      );
	    }
	  }, {
	    key: 'handleOptionClick',
	    value: function handleOptionClick(index) {
	      var _this = this;
	
	      return function (value) {
	        _this.props.onChange((0, _ramda.adjust)((0, _ramda.always)(value), index, _this.props.value));
	      };
	    }
	  }]);
	
	  return Questionnaire1;
	})(_react2['default'].Component);
	
	exports['default'] = Questionnaire1;
	module.exports = exports['default'];

/***/ }),

/***/ 1014:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _ramda = __webpack_require__(27);
	
	var _ramda2 = _interopRequireDefault(_ramda);
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _modulesAutoBind = __webpack_require__(29);
	
	var _modulesAutoBind2 = _interopRequireDefault(_modulesAutoBind);
	
	var _QuickSelectJsx = __webpack_require__(1015);
	
	var _QuickSelectJsx2 = _interopRequireDefault(_QuickSelectJsx);
	
	var _common = __webpack_require__(95);
	
	var _OrderedSelectJsx = __webpack_require__(2178);
	
	var _OrderedSelectJsx2 = _interopRequireDefault(_OrderedSelectJsx);
	
	var _QuestionnairesData = __webpack_require__(455);
	
	var Questionnaire2 = (function (_React$Component) {
	  _inherits(Questionnaire2, _React$Component);
	
	  function Questionnaire2(props) {
	    _classCallCheck(this, Questionnaire2);
	
	    _get(Object.getPrototypeOf(Questionnaire2.prototype), 'constructor', this).call(this, props);
	    (0, _modulesAutoBind2['default'])(this);
	    this.state = {};
	    this.editable = this.props.editable !== false;
	    this.enableLeaveMessage();
	  }
	
	  _createClass(Questionnaire2, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.enableLeaveMessage();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.onbeforeunload = null;
	    }
	  }, {
	    key: 'enableLeaveMessage',
	    value: function enableLeaveMessage() {
	      if (this.props.canSave) {
	        window.onbeforeunload = function (event) {
	          return (event || window.event).returnValue = 'Tienes cambios sin guardar.';
	        };
	      } else {
	        window.onbeforeunload = null;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var complete = _common.validations.finishedQuestionnaire2(this.props.value);
	      var incompleteError = function incompleteError() {
	        return alert('Faltan campos de llenar.');
	      };
	      var continueClasses = 'btn btn-lg btn-success';
	      if (!complete) {
	        continueClasses += ' disabled';
	      }
	
	      return _react2['default'].createElement(
	        'form',
	        null,
	        _react2['default'].createElement(
	          'h1',
	          null,
	          'Cuestionario 2'
	        ),
	        this.editable ? _react2['default'].createElement(
	          'div',
	          null,
	          _react2['default'].createElement('br', null),
	          _react2['default'].createElement(
	            'p',
	            null,
	            '1. En cada grupo palabras elige la palabra que ',
	            _react2['default'].createElement(
	              'b',
	              { style: { color: '#5BC0DE' } },
	              'MEJOR'
	            ),
	            ' te describe.'
	          ),
	          _react2['default'].createElement(
	            'p',
	            null,
	            '2. De las tres palabras restantes elige la palabra que ',
	            _react2['default'].createElement(
	              'b',
	              { style: { color: '#FF0000' } },
	              'MENOS'
	            ),
	            ' te describe.'
	          ),
	          _react2['default'].createElement(
	            'p',
	            null,
	            'Para cambiar la palabra, da click sobre la palabra seleccionada.'
	          ),
	          _react2['default'].createElement('br', null)
	        ) : '',
	        _ramda2['default'].addIndex(_ramda2['default'].map)(this.renderQuestion, _QuestionnairesData.q2Questions),
	        this.editable ? _react2['default'].createElement(
	          'div',
	          { style: { textAlign: 'right' } },
	          _react2['default'].createElement(
	            'button',
	            { type: 'button', style: { display: 'inline-block', margin: '0px 10px' }, className: 'btn btn-lg btn-info', disabled: !this.props.canSave, onClick: this.props.onSave },
	            this.props.canSave ? 'Guardar' : 'Guardado'
	          ),
	          _react2['default'].createElement(
	            'button',
	            { type: 'button', style: { display: 'inline-block', margin: '0px 10px' }, className: continueClasses, onClick: complete ? this.props.onSubmit : incompleteError },
	            'Continuar'
	          )
	        ) : ''
	      );
	    }
	  }, {
	    key: 'renderQuestion',
	    value: function renderQuestion(options, index) {
	      return _react2['default'].createElement(
	        'div',
	        { key: index, className: 'col-md-3 col-sm-4 col-xs-12' },
	        _react2['default'].createElement(_OrderedSelectJsx2['default'], { editable: this.editable, selections: this.props.value[index], options: options, text: index + 1 + '.', onChange: this.handleSelectionChange(index) })
	      );
	    }
	  }, {
	    key: 'handleSelectionChange',
	    value: function handleSelectionChange(index) {
	      var _this = this;
	
	      return function (selections) {
	        _this.props.onChange(_ramda2['default'].adjust(_ramda2['default'].always(selections), index, _this.props.value));
	      };
	    }
	  }]);
	
	  return Questionnaire2;
	})(_react2['default'].Component);
	
	exports['default'] = Questionnaire2;
	module.exports = exports['default'];

/***/ }),

/***/ 1015:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _modulesAutoBind = __webpack_require__(29);
	
	var _modulesAutoBind2 = _interopRequireDefault(_modulesAutoBind);
	
	var QuickSelect = (function (_React$Component) {
	  _inherits(QuickSelect, _React$Component);
	
	  function QuickSelect(props) {
	    _classCallCheck(this, QuickSelect);
	
	    _get(Object.getPrototypeOf(QuickSelect.prototype), 'constructor', this).call(this, props);
	    (0, _modulesAutoBind2['default'])(this);
	    this.state = {};
	  }
	
	  _createClass(QuickSelect, [{
	    key: 'render',
	    value: function render() {
	      var _this = this;
	
	      var getClass = function getClass(value) {
	        return 'btn btn-default' + (_this.props.value === value ? ' btn-primary active' : '') + (!_this.props.editable ? ' disabled' : '');
	      };
	      return _react2['default'].createElement(
	        'div',
	        { className: 'btn-group inline-block' },
	        this.props.values.map(function (value) {
	          var _this2 = this;
	
	          return _react2['default'].createElement(
	            'span',
	            { key: value, className: getClass(value), onKeyPress: this.handleKeyPress(value), style: { cursor: this.props.editable ? 'pointer' : '' }, onClick: function () {
	                return _this2.props.editable && _this2.props.onChange(value);
	              }, tabIndex: '0' },
	            value
	          );
	        }, this)
	      );
	    }
	  }, {
	    key: 'handleKeyPress',
	    value: function handleKeyPress(value) {
	      var _this3 = this;
	
	      return function (event) {
	        if (event.keyCode === 0 || event.keyCode === 32) {
	          event.preventDefault();
	          _this3.props.onChange(value);
	        }
	      };
	    }
	  }]);
	
	  return QuickSelect;
	})(_react2['default'].Component);
	
	exports['default'] = QuickSelect;
	module.exports = exports['default'];

/***/ }),

/***/ 1016:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _ramda = __webpack_require__(27);
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _modulesAutoBind = __webpack_require__(29);
	
	var _modulesAutoBind2 = _interopRequireDefault(_modulesAutoBind);
	
	var _modulesPowerpointReplace = __webpack_require__(1024);
	
	var _modulesPowerpointReplace2 = _interopRequireDefault(_modulesPowerpointReplace);
	
	var _xtna = __webpack_require__(457);
	
	var _benzinger = __webpack_require__(1011);
	
	var _modulesUtils = __webpack_require__(349);
	
	var _modulesUtils2 = _interopRequireDefault(_modulesUtils);
	
	var FileSaver = null;
	
	var HumanFactorsReportGenerator = (function (_React$Component) {
	  _inherits(HumanFactorsReportGenerator, _React$Component);
	
	  function HumanFactorsReportGenerator(props) {
	    _classCallCheck(this, HumanFactorsReportGenerator);
	
	    _get(Object.getPrototypeOf(HumanFactorsReportGenerator.prototype), 'constructor', this).call(this, props);
	    (0, _modulesAutoBind2['default'])(this);
	    this.state = {};
	  }
	
	  _createClass(HumanFactorsReportGenerator, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (FileSaver === null) {
	        FileSaver = __webpack_require__(666);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2['default'].createElement(
	        'form',
	        { style: { marginBottom: '10px' } },
	        _react2['default'].createElement('input', { type: 'button', className: 'btn btn-success', onClick: this['export'], value: 'Reporte Human Factors', disabled: !this.props.valid })
	      );
	    }
	  }, {
	    key: 'unaccent',
	    value: function unaccent(text) {
	      text = text.replace(/á/g, 'a');
	      text = text.replace(/é/g, 'e');
	      text = text.replace(/í/g, 'i');
	      text = text.replace(/ó/g, 'o');
	      text = text.replace(/ú/g, 'u');
	      text = text.replace(/ñ/g, 'n');
	      text = text.replace(/Á/g, 'A');
	      text = text.replace(/É/g, 'I');
	      text = text.replace(/Í/g, 'E');
	      text = text.replace(/Ó/g, 'O');
	      text = text.replace(/Ú/g, 'U');
	      text = text.replace(/Ñ/g, 'N');
	      text = text.replace(/&/g, 'and');
	      return text;
	    }
	  }, {
	    key: 'export',
	    value: function _export() {
	      var _this = this;
	
	      //return Promise.resolve($.ajax({
	      //url: this.props.consumeLicense,
	      //method: 'POST',
	      //}))
	      return Promise.resolve(0).then(function () {
	        return _this.props.licenseConsumed();
	      }).then(function () {
	        return (0, _modulesPowerpointReplace2['default'])(_this.props.reportTemplateUrl, _this.getReplacements(), [1, 2, 10]);
	      }).then(function (blob) {
	        return FileSaver.saveAs(blob, 'Perfil Human Factors - ' + _this.unaccent(_this.props.personalData.name) + '.pptx');
	      });
	    }
	  }, {
	    key: 'getReplacements',
	    value: function getReplacements() {
	      var _this2 = this;
	
	      var changeResultValues = ['Factor consistente', 'Factor de cambio moderado', 'Factor de cambio intenso'];
	      var descriptions = ['alta consistencia', 'consistencia promedio alto', 'baja consistencia', 'muy baja consistencia'];
	
	      var xtna = (0, _ramda.fromPairs)((0, _ramda.map)(function (prop) {
	        return [prop, parseInt(_this2.props.xtna[prop])];
	      }, _xtna.XTNA.props()));
	      var benzinger = (0, _ramda.fromPairs)((0, _ramda.map)(function (prop) {
	        return [prop, (_this2.props.benzinger[prop] < 10 ? ' ' : '') + _this2.props.benzinger[prop]];
	      }, _benzinger.Benzinger.props()));
	      var personal = this.props.personalData;
	      var results = _xtna.XTNA.getResults(xtna);
	
	      var mapChangeToResult = function mapChangeToResult(change) {
	        return changeResultValues[(change >= 2) + (change >= 4)];
	      };
	      var changeResults = (0, _ramda.fromPairs)((0, _ramda.map)((0, _ramda.compose)(function (change) {
	        return [(0, _ramda.tail)((0, _ramda.head)(change)) + '_CHANGE_RESULT', mapChangeToResult((0, _ramda.tail)(change))];
	      }), (0, _ramda.toPairs)(results.changes)));
	
	      var dif = Math.abs(this.props.benzinger.L1 - this.props.benzinger.L2 * 4) + Math.abs(this.props.benzinger.A1 - this.props.benzinger.A2 * 4) + Math.abs(this.props.benzinger.I1 - this.props.benzinger.I2 * 4) + Math.abs(this.props.benzinger.V1 - this.props.benzinger.V2 * 4);
	      var sum = this.props.benzinger.L2 * 4 + this.props.benzinger.A2 * 4 + this.props.benzinger.V2 * 4 + this.props.benzinger.I2 * 4;
	
	      var benzingerResults = {
	        changes: {
	          'dFI 7': Math.abs(this.props.benzinger.A1 - this.props.benzinger.A2 * 4),
	          'dPI 1': Math.abs(this.props.benzinger.L1 - this.props.benzinger.L2 * 4),
	          'dPD 2': Math.abs(this.props.benzinger.I1 - this.props.benzinger.I2 * 4),
	          'dFD 8': Math.abs(this.props.benzinger.V1 - this.props.benzinger.V2 * 4)
	        },
	        consistency: sum ? 1 - dif / sum : null,
	        change: dif
	      };
	
	      var fixSpacing = function fixSpacing(num, spaces) {
	        if (num < 100) {
	          return ' ' + (spaces !== 1 ? ' ' : '') + num;
	        }
	
	        return num;
	      };
	
	      personal.company = this.unaccent(personal.company);
	
	      var stats = this.props.benzinger.adultoStats;
	      var ch = _modulesUtils2['default'].formatPercentage(benzingerResults.consistency);
	      var pc = _modulesUtils2['default'].formatPercentage;
	      var adultoSum = this.props.benzinger.A1 + this.props.benzinger.L1 + this.props.benzinger.I1 + this.props.benzinger.V1;
	      var jovenSum = this.props.benzinger.A2 + this.props.benzinger.L2 + this.props.benzinger.I2 + this.props.benzinger.V2;
	      var tSum = R.sum(stats.AT);
	      var tlSum = R.sum(stats.ATL);
	      var aSum = R.sum(stats.AA);
	      var imagen = this.props.benzinger.imagen;
	      var adjectiveProperty = _benzinger.Benzinger.adjectiveToProperty[this.unaccent(this.props.benzinger.adjetivo).toLowerCase()];
	      var textReplacements = (0, _ramda.mergeAll)([{
	        name: personal.name,
	        company: personal.company,
	        date: personal.date.format('DD/MM/YYYY'),
	        age: personal.age + ' años',
	        NAME: personal.name.toUpperCase(),
	        COMPANY: personal.company,
	        DATE: personal.date.format('DD MMMM YYYY'),
	        NPROFILE: results.NProfile.join(' - '),
	        APROFILE: results.AProfile.join(' - '),
	        CHANGE: results.change,
	        CONSISTENCY: (results.consistency !== 1 ? ' ' : '') + _modulesUtils2['default'].formatPercentage(results.consistency),
	        AFI: fixSpacing(this.props.benzinger.A1),
	        API: fixSpacing(this.props.benzinger.L1),
	        APD: fixSpacing(this.props.benzinger.I1),
	        AFD: fixSpacing(this.props.benzinger.V1),
	        JFI: fixSpacing(this.props.benzinger.A2 * 4),
	        JPI: fixSpacing(this.props.benzinger.L2 * 4),
	        JPD: fixSpacing(this.props.benzinger.I2 * 4),
	        JFD: fixSpacing(this.props.benzinger.V2 * 4),
	        AEX: this.props.e1,
	        AIN: this.props.i1,
	        JEX: this.props.e2,
	        JIN: this.props.i2,
	        TEX: fixSpacing(this.props.e1 + this.props.e2, 1),
	        TIN: fixSpacing(this.props.i1 + this.props.i2, 1),
	        ARAC: fixSpacing(this.props.benzinger.A1 + this.props.benzinger.L1),
	        ACRE: fixSpacing(this.props.benzinger.V1 + this.props.benzinger.I1),
	        ACON: fixSpacing(this.props.benzinger.A1 + this.props.benzinger.V1),
	        APRAC: fixSpacing(this.props.benzinger.L1 + this.props.benzinger.I1),
	        JRAC: fixSpacing(this.props.benzinger.A2 * 4 + this.props.benzinger.L2 * 4),
	        JCRE: fixSpacing(this.props.benzinger.V2 * 4 + this.props.benzinger.I2 * 4),
	        JCON: fixSpacing(this.props.benzinger.A2 * 4 + this.props.benzinger.V2 * 4),
	        JPRAC: fixSpacing(this.props.benzinger.L2 * 4 + this.props.benzinger.I2 * 4),
	        BCONSISTENCY: benzingerResults.consistency ? ch.length !== 4 ? ' ' + ch : ch : '    -',
	        BCHANGE: fixSpacing(benzingerResults.change),
	        JF7: pc(this.props.benzinger.A2 / jovenSum), JP1: pc(this.props.benzinger.L2 / jovenSum), JP2: pc(this.props.benzinger.I2 / jovenSum), JF8: pc(this.props.benzinger.V2 / jovenSum),
	        AF7: pc(this.props.benzinger.A1 / adultoSum), AP1: pc(this.props.benzinger.L1 / adultoSum), AP2: pc(this.props.benzinger.I1 / adultoSum), AF8: pc(this.props.benzinger.V1 / adultoSum),
	        TF7: pc(stats.AT[0] / tSum), TP1: pc(stats.AT[1] / tSum), TP2: pc(stats.AT[2] / tSum), TF8: pc(stats.AT[3] / tSum),
	        TLF7: pc(stats.ATL[0] / tlSum), TLP1: pc(stats.ATL[1] / tlSum), TLP2: pc(stats.ATL[2] / tlSum), TLF8: pc(stats.ATL[3] / tlSum),
	        AUF7: pc(stats.AA[0] / aSum), AUP1: pc(stats.AA[1] / aSum), AUP2: pc(stats.AA[2] / aSum), AUF8: pc(stats.AA[3] / aSum),
	        IF7: imagen[0] !== '0' ? 'FI 7' : '', IP1: imagen[1] !== '0' ? 'PI 1' : '', IP2: imagen[2] !== '0' ? 'PD 2' : '', IF8: imagen[3] !== '0' ? 'FD 8' : '',
	        ADF7: adjectiveProperty === 'FI 7' ? 'FI 7' : '',
	        ADP1: adjectiveProperty === 'PI 1' ? 'PI 1' : '',
	        ADP2: adjectiveProperty === 'PD 2' ? 'PD 2' : '',
	        ADF8: adjectiveProperty === 'FD 8' ? 'FD 8' : '',
	        EEP: this.props.benzinger.posDetNegEst[0], EED: this.props.benzinger.posDetNegEst[1], EEN: this.props.benzinger.posDetNegEst[2], EEE: this.props.benzinger.posDetNegEst[3],
	        JE: this.props.benzinger.jovenExIn[0], JI: this.props.benzinger.jovenExIn[1],
	        AE: this.props.benzinger.adultoExIn[0], AI: this.props.benzinger.adultoExIn[1],
	        TE: this.props.benzinger.totalExIn[0], TI: this.props.benzinger.totalExIn[1],
	        ADJETIVO: this.props.benzinger.adjetivo.toUpperCase()
	      }, xtna, benzinger, (0, _ramda.fromPairs)((0, _ramda.map)((0, _ramda.map)((0, _ramda.compose)(_ramda.toUpper, function (x) {
	        return x.toString();
	      })), (0, _ramda.toPairs)(results.derivedProperties))), (0, _ramda.fromPairs)((0, _ramda.toPairs)(results.changes).map(function (change) {
	        return [(0, _ramda.toUpper)((0, _ramda.head)(change)), (0, _ramda.tail)(change)];
	      })), changeResults]);
	
	      var index = (results.consistency < .75) + (results.consistency < .60) + (results.consistency < .40);
	      textReplacements.CONSISTENCY_RESULT = _modulesUtils2['default'].formatPercentage(results.consistency) + ' ' + descriptions[index];
	
	      var canvas1Array = $('canvas#' + this.props.chartsIds.xtna);
	      if (!canvas1Array.length) {
	        throw new Error('Canvas with id: ' + this.props.chartsIds.xtna + ' id not mounted.');
	      }
	
	      var canvas2Array = $('canvas#' + this.props.chartsIds.benzinger);
	      if (!canvas2Array.length) {
	        throw new Error('Canvas with id: ' + this.props.chartsIds.benzinger + ' id not mounted.');
	      }
	
	      var canvas3Array = $('canvas#' + this.props.chartsIds.xtnaTrabajo);
	      if (!canvas3Array.length) {
	        throw new Error('Canvas with id: ' + this.props.chartsIds.xtnaTrabajo + ' id not mounted.');
	      }
	
	      var r1 = [this.props.benzinger.A2, this.props.benzinger.L2, this.props.benzinger.I2, this.props.benzinger.V2];
	      var r2 = [this.props.benzinger.A1, this.props.benzinger.L1, this.props.benzinger.I1, this.props.benzinger.V1];
	      var r3 = stats.AT;
	      var r4 = stats.ATL;
	      var r5 = stats.AA;
	      var r6 = imagen.map(function (x) {
	        return x === 'M' ? 1 : x === 'N' ? -1 : 0;
	      });
	      var r7 = [adjectiveProperty === 'FI 7' ? 1 : 0, adjectiveProperty === 'PI 1' ? 1 : 0, adjectiveProperty === 'PD 2' ? 1 : 0, adjectiveProperty === 'FD 8' ? 1 : 0];
	
	      var swaps = {};
	
	      for (var i = 0; i < 7; i++) {
	        for (var j = 0; j < 4; j++) {
	          var k = 22 + i * 4 + j;
	          swaps['image' + k + '.tiff'] = 'image21.tiff';
	        }
	      }
	
	      var maxI = function maxI(arr) {
	        var ret = [0];
	        for (var i = 1; i < arr.length; i++) {
	          if (arr[i] > arr[ret[0]]) ret = [i];else if (Math.abs(arr[i] - arr[ret[0]]) < .0000001) ret.push(i);
	        }
	        return ret;
	      };
	
	      var minI = function minI(arr) {
	        var ret = [0];
	        for (var i = 1; i < arr.length; i++) {
	          if (arr[i] < arr[ret[0]]) ret = [i];else if (Math.abs(arr[i] - arr[ret[0]]) < .0000001) ret.push(i);
	        }
	        return ret;
	      };
	
	      var assignColors = function assignColors(imageIndex, values) {
	        var maxIs = maxI(values);
	        var minIs = minI(values);
	        if (R.equals(maxIs, minIs)) minIs = [];
	
	        var assignColor = function assignColor(imgNum) {
	          return function (num) {
	            return swaps['image' + (imageIndex + num) + '.tiff'] = 'image' + imgNum + '.tiff';
	          };
	        };
	
	        maxIs.forEach(assignColor(20));
	        minIs.forEach(assignColor(19));
	      };
	
	      assignColors(22, r1);
	      assignColors(26, r2);
	      assignColors(30, r3);
	      assignColors(34, r4);
	      assignColors(38, r5);
	      assignColors(42, r6);
	      swaps['image' + (46 + maxI(r7)[0]) + '.tiff'] = 'image20.tiff';
	
	      return {
	        text: textReplacements,
	        images: {
	          'image7.png': (0, _ramda.head)(canvas1Array).toDataURL().split(',')[1],
	          'image8.png': (0, _ramda.head)(canvas2Array).toDataURL().split(',')[1],
	          'image78.png': (0, _ramda.head)(canvas3Array).toDataURL().split(',')[1]
	        },
	        swaps: swaps
	      };
	    }
	  }]);
	
	  return HumanFactorsReportGenerator;
	})(_react2['default'].Component);
	
	exports['default'] = HumanFactorsReportGenerator;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(35)))

/***/ }),

/***/ 1017:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _ramda = __webpack_require__(27);
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(35);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _modulesAutoBind = __webpack_require__(29);
	
	var _modulesAutoBind2 = _interopRequireDefault(_modulesAutoBind);
	
	var _common = __webpack_require__(95);
	
	var _reactDatePicker = __webpack_require__(1701);
	
	var _reactDatePicker2 = _interopRequireDefault(_reactDatePicker);
	
	var _modulesNumberInputJsx = __webpack_require__(134);
	
	var _modulesNumberInputJsx2 = _interopRequireDefault(_modulesNumberInputJsx);
	
	var PersonalDataForm = (function (_React$Component) {
	  _inherits(PersonalDataForm, _React$Component);
	
	  function PersonalDataForm(props) {
	    _classCallCheck(this, PersonalDataForm);
	
	    _get(Object.getPrototypeOf(PersonalDataForm.prototype), 'constructor', this).call(this, props);
	    (0, _modulesAutoBind2['default'])(this);
	    this.state = { showingDatepicker: false };
	  }
	
	  _createClass(PersonalDataForm, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this = this;
	
	      (0, _jquery2['default'])(document).mouseup(function (event) {
	        var datepicker = (0, _jquery2['default'])('#datepicker');
	        var datepickerButton = (0, _jquery2['default'])('#datepicker-button');
	        if (!datepicker.is(event.target) && !datepickerButton.is(event.target) && datepicker.has(event.target).length === 0 && datepickerButton.has(event.target).length === 0) {
	          _this.setState({ showingDatepicker: false });
	          event.stopPropagation();
	        }
	      });
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      (0, _jquery2['default'])(document).off('mouseup');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var nameInput = _react2['default'].createElement('input', { type: 'text', onChange: this.handleChange('name'), value: this.props.value.name });
	      var companyInput = _react2['default'].createElement('input', { type: 'text', onChange: this.handleChange('company'), value: this.props.value.company });
	      var ageInput = _react2['default'].createElement(_modulesNumberInputJsx2['default'], { value: this.props.value.age, onChange: this.handleChange('age'), min: '0', max: '125' });
	      var datePicker = _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement(
	          'button',
	          { id: 'datepicker-button', type: 'button', onClick: this.toggleDatePicker, className: 'btn btn-sm btn-default' },
	          this.props.value.date.format('DD/MM/YYYY')
	        )
	      );
	
	      return _react2['default'].createElement(
	        'form',
	        { style: { marginBottom: '10px' } },
	        this.renderField('Nombre:', nameInput),
	        this.renderField('Empresa:', companyInput),
	        this.renderField('Fecha:', datePicker),
	        _react2['default'].createElement(
	          'div',
	          { id: 'datepicker' },
	          this.state.showingDatepicker ? _react2['default'].createElement(_reactDatePicker2['default'], { minDate: '2010-01-01', maxDate: '2050-01-01', date: this.props.value.date, onChange: (0, _ramda.compose)(this.toggleDatePicker, this.handleChange('date')), locale: 'es-MX' }) : ''
	        ),
	        this.renderField('Edad:', ageInput)
	      );
	    }
	  }, {
	    key: 'toggleDatePicker',
	    value: function toggleDatePicker() {
	      this.setState({ showingDatepicker: !this.state.showingDatepicker });
	    }
	  }, {
	    key: 'renderField',
	    value: function renderField(label, input) {
	      return _react2['default'].createElement(
	        'div',
	        { className: 'row form-inline', style: { 'marginBottom': '10px' } },
	        _react2['default'].createElement(
	          'div',
	          { className: 'col-xs-4' },
	          _react2['default'].createElement(
	            'label',
	            null,
	            label
	          )
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'col-xs-8' },
	          input
	        )
	      );
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange(fieldId) {
	      var _this2 = this;
	
	      return function (event, moment) {
	        var value = fieldId === 'age' ? event : fieldId === 'date' ? moment : event.target.value;
	        var newFormValue = (0, _ramda.merge)(_this2.props.value, _defineProperty({}, fieldId, value));
	        _this2.props.onChange((0, _ramda.merge)(newFormValue, { valid: PersonalDataForm.validForm(newFormValue) }));
	      };
	    }
	  }], [{
	    key: 'validForm',
	    value: function validForm(value) {
	      var formValidations = (0, _ramda.merge)((0, _ramda.pick)(['name', 'company', 'age'], _common.validations), { date: (0, _ramda.prop)('_isAMomentObject') });
	      return _common.validations.validateObject(formValidations, value);
	    }
	  }]);
	
	  return PersonalDataForm;
	})(_react2['default'].Component);
	
	exports['default'] = PersonalDataForm;
	module.exports = exports['default'];

/***/ }),

/***/ 1018:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _ramda = __webpack_require__(27);
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _modulesAutoBind = __webpack_require__(29);
	
	var _modulesAutoBind2 = _interopRequireDefault(_modulesAutoBind);
	
	var _modulesPowerpointReplace = __webpack_require__(1024);
	
	var _modulesPowerpointReplace2 = _interopRequireDefault(_modulesPowerpointReplace);
	
	var _xtna = __webpack_require__(457);
	
	var _modulesUtils = __webpack_require__(349);
	
	var _modulesUtils2 = _interopRequireDefault(_modulesUtils);
	
	var FileSaver = null;
	
	var XTNAReportGenerator = (function (_React$Component) {
	  _inherits(XTNAReportGenerator, _React$Component);
	
	  function XTNAReportGenerator(props) {
	    _classCallCheck(this, XTNAReportGenerator);
	
	    _get(Object.getPrototypeOf(XTNAReportGenerator.prototype), 'constructor', this).call(this, props);
	    (0, _modulesAutoBind2['default'])(this);
	    this.state = {};
	  }
	
	  _createClass(XTNAReportGenerator, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (FileSaver === null) {
	        FileSaver = __webpack_require__(666);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2['default'].createElement(
	        'form',
	        { style: { marginBottom: '10px' } },
	        _react2['default'].createElement('input', { type: 'button', className: 'btn btn-success', onClick: this['export'], value: 'Reporte XTNA', disabled: !this.props.valid })
	      );
	    }
	  }, {
	    key: 'unaccent',
	    value: function unaccent(text) {
	      text = text.replace(/á/g, 'a');
	      text = text.replace(/é/g, 'e');
	      text = text.replace(/í/g, 'i');
	      text = text.replace(/ó/g, 'o');
	      text = text.replace(/ú/g, 'u');
	      text = text.replace(/ñ/g, 'n');
	      text = text.replace(/Á/g, 'A');
	      text = text.replace(/É/g, 'I');
	      text = text.replace(/Í/g, 'E');
	      text = text.replace(/Ó/g, 'O');
	      text = text.replace(/Ú/g, 'U');
	      text = text.replace(/Ñ/g, 'N');
	      text = text.replace(/&/g, 'and');
	      return text;
	    }
	  }, {
	    key: 'export',
	    value: function _export() {
	      var _this = this;
	
	      //return Promise.resolve($.ajax({
	      //url: this.props.consumeLicense,
	      //method: 'POST',
	      //}))
	
	      return Promise.resolve(0).then(function () {
	        return _this.props.licenseConsumed();
	      }).then(function () {
	        return (0, _modulesPowerpointReplace2['default'])(_this.props.reportTemplateUrl, _this.getReplacements(), [1, 10, 19]);
	      }).then(function (blob) {
	        return FileSaver.saveAs(blob, 'Reporte XTNA - ' + _this.unaccent(_this.props.personalData.name) + '.pptx');
	      });
	    }
	  }, {
	    key: 'getReplacements',
	    value: function getReplacements() {
	      var _this2 = this;
	
	      var changeResultValues = ['Factor consistente', 'Factor de cambio moderado', 'Factor de cambio intenso'];
	      var descriptions = ['alta consistencia', 'consistencia promedio alto', 'baja consistencia', 'muy baja consistencia'];
	
	      var xtna = (0, _ramda.fromPairs)((0, _ramda.map)(function (prop) {
	        return [prop, parseInt(_this2.props.xtna[prop])];
	      }, _xtna.XTNA.props()));
	      var personal = this.props.personalData;
	      var results = _xtna.XTNA.getResults(xtna);
	
	      var mapChangeToResult = function mapChangeToResult(change) {
	        return changeResultValues[(change >= 2) + (change >= 4)];
	      };
	      var changeResults = (0, _ramda.fromPairs)((0, _ramda.map)((0, _ramda.compose)(function (change) {
	        return [(0, _ramda.tail)((0, _ramda.head)(change)) + '_CHANGE_RESULT', mapChangeToResult((0, _ramda.tail)(change))];
	      }), (0, _ramda.toPairs)(results.changes)));
	
	      personal.company = this.unaccent(personal.company);
	
	      var textReplacements = (0, _ramda.mergeAll)([{
	        name: personal.name,
	        NAME: personal.name.toUpperCase(),
	        COMPANY: personal.company,
	        DATE: personal.date.format('DD MMMM YYYY'),
	        company: personal.company,
	        date: personal.date.format('DD/MM/YYYY'),
	        age: personal.age + ' años',
	        NPROFILE: results.NProfile.join(' - '),
	        APROFILE: results.AProfile.join(' - '),
	        CHANGE: results.change,
	        CONSISTENCY: (results.consistency !== 1 ? ' ' : '') + _modulesUtils2['default'].formatPercentage(results.consistency)
	      }, xtna, (0, _ramda.fromPairs)((0, _ramda.map)((0, _ramda.map)((0, _ramda.compose)(_ramda.toUpper, function (x) {
	        return x.toString();
	      })), (0, _ramda.toPairs)(results.derivedProperties))), (0, _ramda.fromPairs)((0, _ramda.toPairs)(results.changes).map(function (change) {
	        return [(0, _ramda.toUpper)((0, _ramda.head)(change)), (0, _ramda.tail)(change)];
	      })), changeResults]);
	
	      var index = (results.consistency < .75) + (results.consistency < .60) + (results.consistency < .40);
	      textReplacements.CONSISTENCY_RESULT = _modulesUtils2['default'].formatPercentage(results.consistency) + ' ' + descriptions[index];
	
	      var canvasArray = $('canvas#' + this.props.chartsIds.xtna);
	      if (!canvasArray.length) {
	        throw new Error('Canvas with id: ' + this.props.chartsIds.xtna + ' id not mounted.');
	      }
	
	      var canvas2Array = $('canvas#' + this.props.chartsIds.xtnaTrabajo);
	      if (!canvas2Array.length) {
	        throw new Error('Canvas with id: ' + this.props.chartsIds.xtnaTrabajo + ' id not mounted.');
	      }
	
	      return {
	        text: textReplacements,
	        images: {
	          'image13.png': (0, _ramda.head)(canvasArray).toDataURL().split(',')[1],
	          'image38.png': (0, _ramda.head)(canvas2Array).toDataURL().split(',')[1]
	        }
	      };
	    }
	  }]);
	
	  return XTNAReportGenerator;
	})(_react2['default'].Component);
	
	exports['default'] = XTNAReportGenerator;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(35)))

/***/ }),

/***/ 1019:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _jquery = __webpack_require__(35);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrapLibAlert = __webpack_require__(252);
	
	var _reactBootstrapLibAlert2 = _interopRequireDefault(_reactBootstrapLibAlert);
	
	var _modulesAutoBind = __webpack_require__(29);
	
	var _modulesAutoBind2 = _interopRequireDefault(_modulesAutoBind);
	
	var _modulesSpinnerJsx = __webpack_require__(153);
	
	var _modulesSpinnerJsx2 = _interopRequireDefault(_modulesSpinnerJsx);
	
	var _UsersJsx = __webpack_require__(1020);
	
	var _UsersJsx2 = _interopRequireDefault(_UsersJsx);
	
	var _xtnaChartJsx = __webpack_require__(664);
	
	var _xtnaChartJsx2 = _interopRequireDefault(_xtnaChartJsx);
	
	var _xtnaResultsJsx = __webpack_require__(1022);
	
	var _xtnaResultsJsx2 = _interopRequireDefault(_xtnaResultsJsx);
	
	var _xtnaFormJsx = __webpack_require__(1021);
	
	var _xtnaFormJsx2 = _interopRequireDefault(_xtnaFormJsx);
	
	var _xtnaTrabajoChartJsx = __webpack_require__(1023);
	
	var _xtnaTrabajoChartJsx2 = _interopRequireDefault(_xtnaTrabajoChartJsx);
	
	var _benzingerBenzinger = __webpack_require__(454);
	
	var _benzingerBenzinger2 = _interopRequireDefault(_benzingerBenzinger);
	
	var _benzingerChartJsx = __webpack_require__(662);
	
	var _benzingerChartJsx2 = _interopRequireDefault(_benzingerChartJsx);
	
	var _benzingerFormJsx = __webpack_require__(1009);
	
	var _benzingerFormJsx2 = _interopRequireDefault(_benzingerFormJsx);
	
	var _benzingerResultsJsx = __webpack_require__(1010);
	
	var _benzingerResultsJsx2 = _interopRequireDefault(_benzingerResultsJsx);
	
	var _questionnairesQuestionnaire1Jsx = __webpack_require__(1013);
	
	var _questionnairesQuestionnaire1Jsx2 = _interopRequireDefault(_questionnairesQuestionnaire1Jsx);
	
	var _questionnairesQuestionnaire2Jsx = __webpack_require__(1014);
	
	var _questionnairesQuestionnaire2Jsx2 = _interopRequireDefault(_questionnairesQuestionnaire2Jsx);
	
	var _reportsXTNAReportGeneratorJsx = __webpack_require__(1018);
	
	var _reportsXTNAReportGeneratorJsx2 = _interopRequireDefault(_reportsXTNAReportGeneratorJsx);
	
	var _reportsHumanFactorsReportGeneratorJsx = __webpack_require__(1016);
	
	var _reportsHumanFactorsReportGeneratorJsx2 = _interopRequireDefault(_reportsHumanFactorsReportGeneratorJsx);
	
	var _questionnairesQuestionnairesData = __webpack_require__(455);
	
	var FileSaver = __webpack_require__(745);
	
	var UserDetails = (function (_React$Component) {
	  _inherits(UserDetails, _React$Component);
	
	  function UserDetails(props) {
	    _classCallCheck(this, UserDetails);
	
	    _get(Object.getPrototypeOf(UserDetails.prototype), 'constructor', this).call(this, props);
	    (0, _modulesAutoBind2['default'])(this);
	    this.state = { benzinger: _benzingerBenzinger2['default']['default'](), benzingerStats: { i1: 0, i2: 0, e1: 0, e2: 0 } };
	  }
	
	  _createClass(UserDetails, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this = this;
	
	      _jquery2['default'].ajax({
	        url: this.props.resourceUrl,
	        method: 'GET'
	      }).done(function (userResource) {
	        return _this.setState({ userResource: userResource });
	      }).fail(function () {
	        return _this.setState({ errorMessage: 'No se encontró el cliente.' });
	      });
	      window.addEventListener('resize', this.handleResize);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('resize', this.handleResize);
	    }
	  }, {
	    key: 'handleResize',
	    value: function handleResize() {
	      this.setState({ windowWidth: window.innerWidth });
	    }
	  }, {
	    key: 'unnacent',
	    value: function unnacent(name) {
	      var new_name = name;
	      new_name = new_name.replace(/á/g, 'a');
	      new_name = new_name.replace(/é/g, 'e');
	      new_name = new_name.replace(/í/g, 'i');
	      new_name = new_name.replace(/ó/g, 'o');
	      new_name = new_name.replace(/ú/g, 'u');
	      new_name = new_name.replace(/ñ/g, 'n');
	      new_name = new_name.replace(/Á/g, 'A');
	      new_name = new_name.replace(/É/g, 'I');
	      new_name = new_name.replace(/Í/g, 'E');
	      new_name = new_name.replace(/Ó/g, 'O');
	      new_name = new_name.replace(/Ú/g, 'U');
	      new_name = new_name.replace(/Ñ/g, 'N');
	      return new_name;
	    }
	  }, {
	    key: 'exportBenziger',
	    value: function exportBenziger() {
	      var name = this.unnacent(this.state.userResource.name);
	      fetch(this.props.exportBenziger, {
	        method: 'post',
	        headers: { 'Content-Type': 'application/json' },
	        body: JSON.stringify({
	          userId: this.state.userResource.id,
	          username: this.props.user.user,
	          userType: this.props.user.userType
	        }),
	        responseType: 'blob'
	      }).then(function (response) {
	        return response.blob();
	      }).then(function (blob) {
	        if (blob.size !== 0) {
	          FileSaver.saveAs(blob, 'Respuestas Benziger-' + name + '.xlsx');
	        } else {
	          alert('No ha completado el cuestionario.');
	        }
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      if (this.state.errorMessage) {
	        return _react2['default'].createElement(
	          _reactBootstrapLibAlert2['default'],
	          { bsStyle: 'danger', onDismiss: function () {
	              return _this2.setState({ errorMessage: null });
	            } },
	          this.state.errorMessage
	        );
	      }
	
	      if (!this.state.userResource) {
	        return _react2['default'].createElement(_modulesSpinnerJsx2['default'], null);
	      }
	
	      if (this.state.viewingAnswers) {
	        var _ret = (function () {
	          var data = undefined,
	              idx = 0;
	          if (_this2.state.viewingAnswers === 1) {
	            data = [['', 'Pregunta', 'Respuesta']].concat(_toConsumableArray(_questionnairesQuestionnairesData.q1Questions.map(function (q) {
	              return [idx + 1, q.replace(/,/g, ';'), _this2.state.userResource.questionnaire.answers[0][idx++]];
	            })));
	          } else {
	            data = [['', 'Más', 'Menos']].concat(_toConsumableArray(_questionnairesQuestionnairesData.q2Questions.map(function (q) {
	              var answer = _this2.state.userResource.questionnaire.answers[1][idx];
	              var lessIndex = answer[0] - 1;
	              var mostIndex = answer[1] - 1;
	              return [idx + 1, _questionnairesQuestionnairesData.q2Questions[idx][lessIndex], _questionnairesQuestionnairesData.q2Questions[idx++][mostIndex]];
	            })));
	          }
	          var csvContent = "data:text/csv;charset=utf-8,";
	          var dataString = '';
	          data.forEach(function (infoArray, index) {
	            dataString = infoArray.join(",");
	            csvContent += index < data.length ? dataString + "\n" : dataString;
	          });
	
	          csvContent = csvContent.replace(/á/g, 'a');
	          csvContent = csvContent.replace(/é/g, 'e');
	          csvContent = csvContent.replace(/í/g, 'i');
	          csvContent = csvContent.replace(/ó/g, 'o');
	          csvContent = csvContent.replace(/ú/g, 'u');
	          csvContent = csvContent.replace(/ñ/g, 'n');
	          csvContent = csvContent.replace(/Á/g, 'A');
	          csvContent = csvContent.replace(/É/g, 'I');
	          csvContent = csvContent.replace(/Í/g, 'E');
	          csvContent = csvContent.replace(/Ó/g, 'O');
	          csvContent = csvContent.replace(/Ú/g, 'U');
	          csvContent = csvContent.replace(/Ñ/g, 'N');
	
	          var smallScreen = _this2.state.windowWidth < 1200;
	          var questionnaire = _this2.state.viewingAnswers === 1 ? _react2['default'].createElement(_questionnairesQuestionnaire1Jsx2['default'], { smallScreen: smallScreen, value: _this2.state.userResource.questionnaire.answers[0], editable: false }) : _react2['default'].createElement(_questionnairesQuestionnaire2Jsx2['default'], { value: _this2.state.userResource.questionnaire.answers[1], editable: false });
	          return {
	            v: _react2['default'].createElement(
	              'div',
	              null,
	              _react2['default'].createElement(
	                'ol',
	                { className: 'breadcrumb' },
	                _react2['default'].createElement(
	                  'li',
	                  null,
	                  _react2['default'].createElement(
	                    'a',
	                    { href: '#/clientes' },
	                    'Clientes'
	                  )
	                ),
	                _react2['default'].createElement(
	                  'li',
	                  null,
	                  _react2['default'].createElement(
	                    'a',
	                    { onClick: function () {
	                        return _this2.setState({ viewingAnswers: null });
	                      } },
	                    _this2.state.userResource.name
	                  )
	                ),
	                _react2['default'].createElement(
	                  'li',
	                  { className: 'active' },
	                  'Cuestionario ',
	                  _this2.state.viewingAnswers
	                )
	              ),
	              _react2['default'].createElement(
	                'button',
	                { className: 'btn btn-success', onClick: function () {
	                    return window.open(encodeURI(csvContent));
	                  } },
	                'Exportar'
	              ),
	              questionnaire
	            )
	          };
	        })();
	
	        if (typeof _ret === 'object') return _ret.v;
	      }
	
	      return _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement(
	          'ol',
	          { className: 'breadcrumb' },
	          _react2['default'].createElement(
	            'li',
	            null,
	            _react2['default'].createElement(
	              'a',
	              { href: '#/clientes' },
	              'Clientes'
	            )
	          ),
	          _react2['default'].createElement(
	            'li',
	            { className: 'active' },
	            this.state.userResource.name
	          )
	        ),
	        this.renderRow(_react2['default'].createElement(
	          'b',
	          null,
	          'Id: '
	        ), this.state.userResource.id),
	        this.renderRow(_react2['default'].createElement(
	          'b',
	          null,
	          'Nombre: '
	        ), this.state.userResource.name),
	        this.renderRow(_react2['default'].createElement(
	          'b',
	          null,
	          'Empresa: '
	        ), this.state.userResource.company),
	        this.renderRow(_react2['default'].createElement(
	          'b',
	          null,
	          'Edad: '
	        ), this.state.userResource.age),
	        this.renderRow(_react2['default'].createElement(
	          'b',
	          null,
	          'Sexo: '
	        ), this.state.userResource.sex === 'M' ? 'Masculino' : this.state.userResource.sex === 'F' ? 'Femenino' : '-'),
	        this.renderRow(_react2['default'].createElement(
	          'b',
	          null,
	          'Fecha Creación: '
	        ), moment(this.state.userResource.creationdate).format('DD/MM/YYYY')),
	        this.renderRow(_react2['default'].createElement(
	          'b',
	          null,
	          'Fecha de Expiración: '
	        ), this.state.userResource.questionnaire.expirationDate ? moment(this.state.userResource.questionnaire.expirationDate).format('DD/MM/YYYY') : '-'),
	        this.renderRow(_react2['default'].createElement(
	          'b',
	          null,
	          'Estatus Cuestionario: '
	        ), _UsersJsx2['default'].getQuestionnaireStatus(this.state.userResource.questionnaire.stage)),
	        this.renderRow(_react2['default'].createElement(
	          'b',
	          null,
	          'Fecha de Respuesta: '
	        ), this.state.userResource.questionnaire.completionDate ? moment(this.state.userResource.questionnaire.completionDate).format('DD/MM/YYYY') : '-'),
	        this.renderRow(_react2['default'].createElement(
	          'b',
	          null,
	          'Email: '
	        ), this.state.userResource.email),
	        this.state.userResource.questionnaire.stage > 2 ? this.renderRow(_react2['default'].createElement(
	          'b',
	          null,
	          'Cuestionario 1:'
	        ), _react2['default'].createElement(
	          'button',
	          { type: 'button', className: 'btn btn-default', onClick: function () {
	              return _this2.setState({ viewingAnswers: 1 });
	            } },
	          'Ver Respuestas'
	        )) : '',
	        this.state.userResource.questionnaire.stage > 3 ? this.renderRow(_react2['default'].createElement(
	          'b',
	          null,
	          'Cuestionario 2:'
	        ), _react2['default'].createElement(
	          'button',
	          { type: 'button', className: 'btn btn-default', onClick: function () {
	              return _this2.setState({ viewingAnswers: 2 });
	            } },
	          'Ver Respuestas'
	        )) : '',
	        this.props.userType === 'admin' ? this.renderRow(_react2['default'].createElement(
	          'b',
	          null,
	          'Cuestionario Benziger:'
	        ), _react2['default'].createElement(
	          'button',
	          { type: 'button', className: 'btn btn-default', onClick: this.exportBenziger },
	          'Ver Respuestas'
	        )) : '',
	        this.state.userResource.questionnaire.stage === 4 ? _react2['default'].createElement(
	          'div',
	          null,
	          this.renderRow(_react2['default'].createElement(
	            'b',
	            null,
	            'Reportes: '
	          ), null),
	          this.renderRow(_react2['default'].createElement(_reportsXTNAReportGeneratorJsx2['default'], {
	            licenseConsumed: function () {
	              return 0;
	            },
	            personalData: R.merge(this.state.userResource, { date: moment(this.state.userResource.questionnaire.completionDate) }),
	            xtna: this.state.userResource.results.xtna,
	            valid: true,
	            chartsIds: { xtna: 'xtna-chart-' + this.state.userResource.id, xtnaTrabajo: 'xtna-trabajo-chart-' + this.state.userResource.id },
	            reportTemplateUrl: this.state.userResource._rels.xtnaReportTemplate }), _react2['default'].createElement(_reportsHumanFactorsReportGeneratorJsx2['default'], _extends({ licenseConsumed: function () {
	              return 0;
	            }, personalData: R.merge(this.state.userResource, { date: moment(this.state.userResource.questionnaire.completionDate) }), xtna: this.state.userResource.results.xtna, benzinger: this.state.benzinger, valid: true, chartsIds: { xtna: 'xtna-chart-' + this.state.userResource.id, benzinger: 'benzinger-chart-' + this.state.userResource.id, xtnaTrabajo: 'xtna-trabajo-chart-' + this.state.userResource.id }, reportTemplateUrl: this.state.userResource._rels.humanFactorsReportTemplate }, this.state.benzingerStats))),
	          _react2['default'].createElement('br', null),
	          _react2['default'].createElement(
	            'center',
	            null,
	            this.renderRow(_react2['default'].createElement(
	              'b',
	              null,
	              'XTNA'
	            ), _react2['default'].createElement(
	              'b',
	              null,
	              'Benzinger'
	            ))
	          ),
	          _react2['default'].createElement('br', null),
	          this.renderRow(this.renderResults('xtna'), this.renderResults('benzinger')),
	          _react2['default'].createElement(
	            'div',
	            { className: 'col-xs-10 col-xs-offset-1' },
	            _react2['default'].createElement(_xtnaTrabajoChartJsx2['default'], _extends({}, this.state.userResource.results.xtna, { id: 'xtna-trabajo-chart-' + this.state.userResource.id }))
	          )
	        ) : ''
	      );
	    }
	  }, {
	    key: 'renderResults',
	    value: function renderResults(type) {
	      var _this3 = this;
	
	      if (type === 'xtna') {
	        return _react2['default'].createElement(
	          'div',
	          null,
	          _react2['default'].createElement(
	            'center',
	            null,
	            _react2['default'].createElement(_xtnaChartJsx2['default'], _extends({ id: 'xtna-chart-' + this.state.userResource.id }, this.state.userResource.results.xtna)),
	            _react2['default'].createElement(_xtnaFormJsx2['default'], { editable: false, value: this.state.userResource.results.xtna })
	          ),
	          _react2['default'].createElement(_xtnaResultsJsx2['default'], this.state.userResource.results.xtna)
	        );
	      } else if (type === 'benzinger') {
	        return _react2['default'].createElement(
	          'div',
	          null,
	          _react2['default'].createElement(
	            'center',
	            null,
	            _react2['default'].createElement(_benzingerChartJsx2['default'], _extends({ id: 'benzinger-chart-' + this.state.userResource.id }, this.state.benzinger)),
	            _react2['default'].createElement(_benzingerFormJsx2['default'], { value: this.state.benzinger, stats: this.state.benzingerStats, onStatChange: function (stats) {
	                return _this3.setState({ benzingerStats: stats });
	              }, onChange: function (benzinger) {
	                return _this3.setState({ benzinger: benzinger });
	              } })
	          )
	        );
	      }
	    }
	  }, {
	    key: 'renderRow',
	    value: function renderRow(left, right) {
	      return _react2['default'].createElement(
	        'div',
	        { className: 'row', style: { margin: '5px' } },
	        _react2['default'].createElement(
	          'div',
	          { className: 'col-xs-10 col-xs-offset-1 col-md-4 col-md-offset-1' },
	          left
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'col-xs-10 col-xs-offset-1 col-md-4 col-md-offset-1' },
	          right
	        )
	      );
	    }
	  }]);
	
	  return UserDetails;
	})(_react2['default'].Component);
	
	exports['default'] = UserDetails;
	module.exports = exports['default'];

/***/ }),

/***/ 1020:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x2, _x3, _x4) { var _again = true; _function: while (_again) { var object = _x2, property = _x3, receiver = _x4; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x2 = parent; _x3 = property; _x4 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _ramda = __webpack_require__(27);
	
	var _ramda2 = _interopRequireDefault(_ramda);
	
	var _jquery = __webpack_require__(35);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bluebird = __webpack_require__(225);
	
	var _bluebird2 = _interopRequireDefault(_bluebird);
	
	var _reactBootstrapLibModal = __webpack_require__(413);
	
	var _reactBootstrapLibModal2 = _interopRequireDefault(_reactBootstrapLibModal);
	
	var _reactBootstrapLibAlert = __webpack_require__(252);
	
	var _reactBootstrapLibAlert2 = _interopRequireDefault(_reactBootstrapLibAlert);
	
	var _modulesAutoBind = __webpack_require__(29);
	
	var _modulesAutoBind2 = _interopRequireDefault(_modulesAutoBind);
	
	var _common = __webpack_require__(95);
	
	var _modulesSpinnerJsx = __webpack_require__(153);
	
	var _modulesSpinnerJsx2 = _interopRequireDefault(_modulesSpinnerJsx);
	
	var _TableJsx = __webpack_require__(663);
	
	var _TableJsx2 = _interopRequireDefault(_TableJsx);
	
	var _CreateUserFormJsx = __webpack_require__(2186);
	
	var _CreateUserFormJsx2 = _interopRequireDefault(_CreateUserFormJsx);
	
	var _EditUserFormJsx = __webpack_require__(2187);
	
	var _EditUserFormJsx2 = _interopRequireDefault(_EditUserFormJsx);
	
	var _UserDetailsJsx = __webpack_require__(1019);
	
	var _UserDetailsJsx2 = _interopRequireDefault(_UserDetailsJsx);
	
	var _reactBootstrapLibPagination = __webpack_require__(414);
	
	var _reactBootstrapLibPagination2 = _interopRequireDefault(_reactBootstrapLibPagination);
	
	var _FilterControlsJsx = __webpack_require__(2188);
	
	var _FilterControlsJsx2 = _interopRequireDefault(_FilterControlsJsx);
	
	var pageSize = 20;
	var columns = [{ id: 'id', label: 'ID', maxWidth: 1 }, { id: 'name', label: 'Nombre', maxWidth: 4 }, { id: 'company', label: 'Compañía', maxWidth: 4 }, { id: 'age', label: 'Edad', maxWidth: 1 }, { id: 'sex', label: 'Sexo', maxWidth: 1 }, { id: 'expiration', label: 'Fecha de Expiración', maxWidth: 2 }, { id: 'status', label: 'Estatus Cuestionarios', maxWidth: 2 }, { id: 'completionDate', label: 'Fecha de Respuesta', maxWidth: 2 }, { id: 'email', label: 'Email', maxWidth: 4 }, { id: 'consultant', label: 'Consultor', maxWidth: 3 }];
	
	var Users = (function (_React$Component) {
	  _inherits(Users, _React$Component);
	
	  function Users(props) {
	    _classCallCheck(this, Users);
	
	    _get(Object.getPrototypeOf(Users.prototype), 'constructor', this).call(this, props);
	
	    (0, _modulesAutoBind2['default'])(this);
	    this.state = {
	      creatingUser: false,
	      deletingUser: false,
	      editingUser: false,
	      filters: {
	        name: '',
	        company: '',
	        email: '',
	        sex: ''
	      },
	      sortColumn: 'id',
	      sortOrder: 'asc',
	      showingFilters: false,
	      selectedRow: null,
	      page: 0,
	      usersResource: null
	    };
	  }
	
	  _createClass(Users, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.fetchUsers(this.props.resourceUrl);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this = this;
	
	      if (!this.state.usersResource && this.state.loadingUsers) {
	        return _react2['default'].createElement(_modulesSpinnerJsx2['default'], null);
	      }
	      if (!this.state.usersResource && !this.state.loadingUsers) {
	        return _react2['default'].createElement(
	          'div',
	          null,
	          this.state.errorMessage
	        );
	      }
	
	      var resource = this.state.usersResource;
	      var numOfPages = Math.ceil(resource.total / pageSize);
	      var usersIndices = _ramda2['default'].range(this.state.page * pageSize, (this.state.page + 1) * pageSize);
	      var selectedIndex = this.state.selectedRow ? this.state.selectedRow.index : null;
	      var count = this.state.page * pageSize;
	      var data = this.state.loadingUsers ? [] : usersIndices.map(_ramda2['default'].compose(_ramda2['default'].prop(_ramda2['default'].__, resource._embedded))).filter(_ramda2['default'].identity).map(function (_ref) {
	        var id = _ref.id;
	        var name = _ref.name;
	        var company = _ref.company;
	        var age = _ref.age;
	        var sex = _ref.sex;
	        var questionnaire = _ref.questionnaire;
	        var email = _ref.email;
	        var consultant = _ref.consultant;
	        return { id: id, name: name, company: company, age: age, sex: sex, email: email, consultant: consultant,
	          expiration: questionnaire.expirationDate ? moment(questionnaire.expirationDate).format('DD/MM/YYYY') : '-',
	          completionDate: questionnaire.completionDate ? moment(questionnaire.completionDate).format('DD/MM/YYYY') : '-',
	          status: Users.getQuestionnaireStatus(questionnaire.stage)
	        };
	      });
	
	      return _react2['default'].createElement(
	        'div',
	        { style: this.state.loadingUsers ? { cursor: 'progress' } : {} },
	        _react2['default'].createElement(
	          'button',
	          { type: 'button', className: 'btn btn-success', style: { marginRight: '10px' }, onClick: this.handleOpenCreateUserModal },
	          'Crear Cliente'
	        ),
	        _react2['default'].createElement(
	          'button',
	          { className: 'btn btn-default', style: { marginRight: '10px' }, onClick: function () {
	              return _this.setState({ showingFilters: !_this.state.showingFilters });
	            } },
	          'Filtrar Clientes'
	        ),
	        this.state.selectedRow !== null ? _react2['default'].createElement(
	          'button',
	          { type: 'button', className: 'btn btn-info', style: { marginRight: '10px' }, onClick: function () {
	              return window.location.hash = '/clientes/' + _this.state.selectedRow.row.id;
	            } },
	          'Ver Detalles'
	        ) : '',
	        this.state.selectedRow !== null ? _react2['default'].createElement(
	          'button',
	          { type: 'button', className: 'btn btn-info', style: { marginRight: '10px' }, onClick: this.handleOpenEditUserModal },
	          'Editar Cliente'
	        ) : '',
	        this.state.selectedRow !== null && this.props.userType == 'admin' ? _react2['default'].createElement(
	          'button',
	          { type: 'button', className: 'btn btn-info', style: { marginRight: '10px' }, onClick: this.sendBenziger },
	          'Enviar Benziger'
	        ) : '',
	        _react2['default'].createElement(
	          'button',
	          { type: 'button', className: 'btn btn-info', style: { marginRight: '10px' }, onClick: this.exportUsers },
	          'Exportar Clientes'
	        ),
	        this.state.selectedRow !== null ? _react2['default'].createElement(
	          'button',
	          { type: 'button', className: 'btn btn-danger', style: { marginRight: '10px' }, onClick: this.handleOpenDeleteUserModal },
	          'Eliminar Cliente'
	        ) : '',
	        this.state.newUser ? this.renderCreateUserModal() : '',
	        this.state.editUser ? this.renderEditUserModal() : '',
	        this.state.deleteUser ? this.renderDeleteUserModal() : '',
	        this.state.showingFilters ? _react2['default'].createElement(_FilterControlsJsx2['default'], { onSubmit: this.handleFiltersChange }) : '',
	        resource.total > pageSize ? _react2['default'].createElement(
	          'center',
	          null,
	          _react2['default'].createElement(_reactBootstrapLibPagination2['default'], { prev: this.state.page !== 0, next: (this.state.page + 1) * pageSize <= resource.total, first: this.state.page !== 0, last: (this.state.page + 1) * pageSize <= resource.total, bsSize: 'medium', maxButtons: 10, items: Math.ceil(resource.total / pageSize), activePage: this.state.page + 1, onSelect: this.handlePageChange })
	        ) : '',
	        _react2['default'].createElement(_TableJsx2['default'], { columns: columns, sort: { column: this.state.sortColumn, order: this.state.sortOrder }, data: data, selectedIndex: selectedIndex, onSort: this.handleSortChange, onRowClick: function (event) {
	            return _this.setState({ selectedRow: event });
	          }, onRowDoubleClick: function (_ref2) {
	            var row = _ref2.row;
	            return window.location.hash = '/clientes/' + row.id;
	          } }),
	        this.state.loadingUsers ? _react2['default'].createElement(_modulesSpinnerJsx2['default'], null) : '',
	        resource ? _react2['default'].createElement(
	          'div',
	          null,
	          'Mostrando resultados ',
	          _react2['default'].createElement(
	            'b',
	            null,
	            Math.min(usersIndices[0] + 1, resource.total)
	          ),
	          '-',
	          _react2['default'].createElement(
	            'b',
	            null,
	            Math.min(usersIndices[usersIndices.length - 1] + 1, resource.total)
	          ),
	          ' de ',
	          _react2['default'].createElement(
	            'b',
	            null,
	            resource.total
	          ),
	          ' resultado',
	          resource.total !== 1 ? 's' : ''
	        ) : '',
	        resource.total > pageSize ? _react2['default'].createElement(
	          'center',
	          null,
	          _react2['default'].createElement(_reactBootstrapLibPagination2['default'], { prev: this.state.page !== 0, next: (this.state.page + 1) * pageSize <= resource.total, first: this.state.page !== 0, last: (this.state.page + 1) * pageSize <= resource.total, bsSize: 'medium', maxButtons: 10, items: Math.ceil(resource.total / pageSize), activePage: this.state.page + 1, onSelect: this.handlePageChange })
	        ) : ''
	      );
	    }
	  }, {
	    key: 'sendBenziger',
	    value: function sendBenziger() {
	      fetch(this.props.sendBenziger, {
	        method: 'post',
	        headers: { 'Content-Type': 'application/json' },
	        body: JSON.stringify({
	          username: this.props.user.user,
	          userType: this.props.user.userType,
	          id: this.state.selectedRow.row.id,
	          email: this.state.selectedRow.row.email,
	          name: this.state.selectedRow.row.name
	        }),
	        responseType: 'json'
	      }).then(function (response) {
	        return response.json();
	      }).then(function (response) {
	        if (response.code === 200) {
	          alert('El cuestionario fue enviado con exito.');
	        } else {
	          alert('Hubo un error, contacta al administrador.');
	        }
	      });
	    }
	  }, {
	    key: 'exportUsers',
	    value: function exportUsers() {
	      var filters = this.state.filters;
	      var url = this.state.usersResource._rels['export'].replace('{name}', filters.name || '').replace('{company}', filters.company || '').replace('{sex}', filters.sex || '').replace('{email}', filters.email || '').replace('{stage}', filters.stage || '');
	      _bluebird2['default'].resolve(_jquery2['default'].ajax({ url: url })).then(function (x) {
	        var a = (0, _jquery2['default'])("<a />", {
	          href: encodeURI('data:text/csv;charset=utf-8,' + x),
	          download: "clientes.csv",
	          id: 'download-element'
	        });
	        (0, _jquery2['default'])('body').append(a);
	        a[0].click();
	        (0, _jquery2['default'])('#download-element').remove();
	      })['catch'](function () {
	        return alert('Ocurrió un error al exportar los clientes.');
	      });
	    }
	  }, {
	    key: 'renderCreateUserModal',
	    value: function renderCreateUserModal() {
	      var _this2 = this;
	
	      var closeModal = function closeModal() {
	        return _this2.setState({ newUser: null, modalErrorMessage: null });
	      };
	      var userValidations = _ramda2['default'].pick(['email'], _common.validations);
	      var validUserForm = function validUserForm() {
	        return _ramda2['default'].is(Object, _this2.state.newUser) && _common.validations.validateObject(userValidations, _this2.state.newUser);
	      };
	      return _react2['default'].createElement(
	        _reactBootstrapLibModal2['default'],
	        { show: true, onHide: closeModal },
	        _react2['default'].createElement(
	          _reactBootstrapLibModal2['default'].Header,
	          { closeButton: true },
	          _react2['default'].createElement(
	            _reactBootstrapLibModal2['default'].Title,
	            null,
	            'Crear Cliente'
	          )
	        ),
	        _react2['default'].createElement(
	          _reactBootstrapLibModal2['default'].Body,
	          null,
	          this.state.modalErrorMessage ? _react2['default'].createElement(
	            _reactBootstrapLibAlert2['default'],
	            { bsStyle: 'danger', onDismiss: function () {
	                return _this2.setState({ modalErrorMessage: null });
	              } },
	            this.state.modalErrorMessage
	          ) : '',
	          _react2['default'].createElement(_CreateUserFormJsx2['default'], { value: this.state.newUser, onChange: function (newUser) {
	              return _this2.setState({ newUser: newUser });
	            } })
	        ),
	        _react2['default'].createElement(
	          _reactBootstrapLibModal2['default'].Footer,
	          null,
	          _react2['default'].createElement(
	            'button',
	            { type: 'button', className: 'btn btn-danger', onClick: closeModal },
	            'Cancelar'
	          ),
	          _react2['default'].createElement(
	            'button',
	            { type: 'submit', className: 'btn btn-success', onClick: this.handleCreateUser, disabled: !validUserForm() || this.state.creatingUser },
	            'Crear'
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderEditUserModal',
	    value: function renderEditUserModal() {
	      var _this3 = this;
	
	      var closeModal = function closeModal() {
	        return _this3.setState({ editUser: null });
	      };
	      var userValidations = _ramda2['default'].pick(['name', 'company', 'age', 'sex'], _common.validations);
	      var validationFields = ['name'];
	      if (this.state.editUser.company) validationFields.push('company');
	      if (this.state.editUser.age) validationFields.push('age');
	      if (this.state.editUser.sex) validationFields.push('sex');
	      var user = _ramda2['default'].clone(this.state.editUser);
	      if (user.age) user.age = parseInt(user.age, 10);
	      var validEditForm = function validEditForm() {
	        return _ramda2['default'].is(Object, _this3.state.editUser) && _common.validations.validateObject(_ramda2['default'].pick(validationFields, _common.validations), user);
	      };
	      return _react2['default'].createElement(
	        _reactBootstrapLibModal2['default'],
	        { show: true, onHide: closeModal },
	        _react2['default'].createElement(
	          _reactBootstrapLibModal2['default'].Header,
	          { closeButton: true },
	          _react2['default'].createElement(
	            _reactBootstrapLibModal2['default'].Title,
	            null,
	            'Editar Cliente'
	          )
	        ),
	        _react2['default'].createElement(
	          _reactBootstrapLibModal2['default'].Body,
	          null,
	          _react2['default'].createElement(_EditUserFormJsx2['default'], { value: this.state.editUser, onChange: function (editUser) {
	              return _this3.setState({ editUser: editUser });
	            } })
	        ),
	        _react2['default'].createElement(
	          _reactBootstrapLibModal2['default'].Footer,
	          null,
	          _react2['default'].createElement(
	            'button',
	            { type: 'button', className: 'btn btn-danger', onClick: closeModal },
	            'Cancelar'
	          ),
	          _react2['default'].createElement(
	            'button',
	            { type: 'submit', className: 'btn btn-success', onClick: this.handleEditUser, disabled: !validEditForm() || this.state.editingUser },
	            'Editar'
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderDeleteUserModal',
	    value: function renderDeleteUserModal() {
	      var _this4 = this;
	
	      var closeModal = function closeModal() {
	        return _this4.setState({ deleteUser: null });
	      };
	      return _react2['default'].createElement(
	        _reactBootstrapLibModal2['default'],
	        { show: true, onHide: closeModal },
	        _react2['default'].createElement(
	          _reactBootstrapLibModal2['default'].Header,
	          { closeButton: true },
	          _react2['default'].createElement(
	            _reactBootstrapLibModal2['default'].Title,
	            null,
	            'Eliminar Cliente'
	          )
	        ),
	        _react2['default'].createElement(
	          _reactBootstrapLibModal2['default'].Body,
	          null,
	          '¿Estás seguro de querer eliminar a ',
	          this.state.deleteUser.name,
	          '?'
	        ),
	        _react2['default'].createElement(
	          _reactBootstrapLibModal2['default'].Footer,
	          null,
	          _react2['default'].createElement(
	            'button',
	            { type: 'button', className: 'btn btn-danger', onClick: closeModal },
	            'Cancelar'
	          ),
	          _react2['default'].createElement(
	            'button',
	            { type: 'submit', className: 'btn btn-success', onClick: this.handleDeleteUser, disabled: this.state.deletingUser },
	            'Eliminar'
	          )
	        )
	      );
	    }
	  }, {
	    key: 'handleSortChange',
	    value: function handleSortChange(_ref3) {
	      var _this5 = this;
	
	      var column = _ref3.column;
	      var order = _ref3.order;
	
	      var prevColumn = this.state.sortColumn,
	          prevOrder = this.state.sortOrder;
	      this.setState({ sortColumn: column, sortOrder: order });
	      var url = this.state.usersResource._rels.sort.replace('{sort}', column === 'status' ? 'stage' : column).replace('{order}', order);
	      this.fetchUsers(url, this.state.page)['catch'](function () {
	        return _this5.setState({ sortColumn: prevColumn, sortOrder: prevOrder });
	      });
	    }
	  }, {
	    key: 'handleFiltersChange',
	    value: function handleFiltersChange(filters) {
	      this.setState({ filters: filters });
	      var url = this.state.usersResource._rels.search.replace('{name}', filters.name || '').replace('{company}', filters.company || '').replace('{sex}', filters.sex || '').replace('{email}', filters.email || '').replace('{stage}', filters.stage || '').replace('{consultant}', filters.consultant || '');
	      this.fetchUsers(url);
	    }
	  }, {
	    key: 'handlePageChange',
	    value: function handlePageChange(page) {
	      page--; // change to 0 based
	      this.fetchUsers(this.state.usersResource._rels.getPage.replace('{pageNum}', page), page);
	    }
	  }, {
	    key: 'fetchUsers',
	    value: function fetchUsers(url) {
	      var _this6 = this;
	
	      var page = arguments.length <= 1 || arguments[1] === undefined ? 0 : arguments[1];
	
	      if (this.state.loadingUsers) {
	        return _bluebird2['default'].reject('Already fetching users.');
	      }
	      var prevPage = this.state.page;
	      this.setState({ loadingUsers: true, selectedRow: null, page: page });
	      return _bluebird2['default'].resolve(_jquery2['default'].ajax({ url: url })).then(function (usersResource) {
	        return _this6.setState({ usersResource: usersResource });
	      })['catch'](function () {
	        return _this6.setState({ page: prevPage, errorMessage: 'Hubo un error al cargar los clientes.' });
	      })['finally'](function () {
	        return _this6.setState({ loadingUsers: false });
	      });
	    }
	  }, {
	    key: 'handleOpenCreateUserModal',
	    value: function handleOpenCreateUserModal() {
	      this.setState({ newUser: { name: '', email: '', expirationDays: 7, user: this.props.user } });
	    }
	  }, {
	    key: 'handleOpenEditUserModal',
	    value: function handleOpenEditUserModal() {
	      this.setState({ editUser: this.state.selectedRow.row });
	    }
	  }, {
	    key: 'handleOpenDeleteUserModal',
	    value: function handleOpenDeleteUserModal() {
	      this.setState({ deleteUser: this.state.selectedRow.row });
	    }
	  }, {
	    key: 'handleCreateUser',
	    value: function handleCreateUser(event) {
	      var _this7 = this;
	
	      event.preventDefault();
	      this.setState({ creatingUser: true });
	      return _bluebird2['default'].resolve(_jquery2['default'].ajax({
	        url: this.props.resourceUrl,
	        method: 'POST',
	        data: this.state.newUser
	      })).then(function () {
	        _this7.setState({ newUser: null, modalErrorMessage: null });
	        _this7.fetchUsers(_this7.state.usersResource._rels.self, _this7.state.page);
	      })['catch'](function () {
	        return _this7.setState({ modalErrorMessage: 'Hubo un error al crear el cliente.' });
	      })['finally'](function () {
	        return _this7.setState({ creatingUser: false });
	      });
	    }
	  }, {
	    key: 'handleDeleteUser',
	    value: function handleDeleteUser(event) {
	      var _this8 = this;
	
	      event.preventDefault();
	      this.setState({ deletingUser: true });
	
	      var url = this.state.usersResource._rels[this.state.selectedRow.index + pageSize * this.state.page];
	      return _bluebird2['default'].resolve(_jquery2['default'].ajax({
	        url: url,
	        method: 'DELETE'
	      })).then(function () {
	        _this8.setState({ deleteUser: null });
	        _this8.fetchUsers(_this8.state.usersResource._rels.self, _this8.state.page);
	      })['finally'](function () {
	        return _this8.setState({ deletingUser: false });
	      });
	    }
	  }, {
	    key: 'handleEditUser',
	    value: function handleEditUser(event) {
	      var _this9 = this;
	
	      event.preventDefault();
	      this.setState({ editingUser: true });
	      var url = this.state.usersResource._rels[this.state.selectedRow.index];
	      return _bluebird2['default'].resolve(_jquery2['default'].ajax({
	        url: url,
	        method: 'PUT',
	        data: this.state.editUser
	      })).then(function () {
	        _this9.setState({ editUser: null });
	        _this9.fetchUsers(_this9.state.usersResource._rels.self, _this9.state.page);
	      })['finally'](function () {
	        return _this9.setState({ editingUser: false });
	      });
	    }
	  }], [{
	    key: 'getQuestionnaireStatus',
	    value: function getQuestionnaireStatus(stage) {
	      return _ramda2['default'].prop(stage, ['No iniciado', 'Datos Personales', 'Cuestionario 1', 'Cuestionario 2', 'Completado']);
	    }
	  }]);
	
	  return Users;
	})(_react2['default'].Component);
	
	exports['default'] = Users;
	module.exports = exports['default'];

/***/ }),

/***/ 1021:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _ramda = __webpack_require__(27);
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _modulesAutoBind = __webpack_require__(29);
	
	var _modulesAutoBind2 = _interopRequireDefault(_modulesAutoBind);
	
	var _modulesNumberInputJsx = __webpack_require__(134);
	
	var _modulesNumberInputJsx2 = _interopRequireDefault(_modulesNumberInputJsx);
	
	var _XTNA = __webpack_require__(456);
	
	var _XTNA2 = _interopRequireDefault(_XTNA);
	
	var _ChartJsx = __webpack_require__(664);
	
	var _ChartJsx2 = _interopRequireDefault(_ChartJsx);
	
	__webpack_require__(440);
	
	var XTNAChartDataForm = (function (_React$Component) {
	  _inherits(XTNAChartDataForm, _React$Component);
	
	  function XTNAChartDataForm(props) {
	    _classCallCheck(this, XTNAChartDataForm);
	
	    _get(Object.getPrototypeOf(XTNAChartDataForm.prototype), 'constructor', this).call(this, props);
	    (0, _modulesAutoBind2['default'])(this);
	    this.state = {};
	  }
	
	  _createClass(XTNAChartDataForm, [{
	    key: 'render',
	    value: function render() {
	      var getPropNames = function getPropNames(type) {
	        return _XTNA2['default'].props().filter((0, _ramda.compose)((0, _ramda.equals)(type), _ramda.head));
	      };
	      var naturalProps = getPropNames('N');
	      var adaptedProps = getPropNames('A');
	
	      return _react2['default'].createElement(
	        'table',
	        { className: 'input-table', style: { marginBottom: '10px' } },
	        _react2['default'].createElement(
	          'thead',
	          null,
	          _react2['default'].createElement(
	            'tr',
	            null,
	            _react2['default'].createElement('td', null),
	            naturalProps.map((0, _ramda.compose)(function (prop) {
	              return _react2['default'].createElement(
	                'td',
	                { key: prop },
	                prop
	              );
	            }, _ramda.tail))
	          )
	        ),
	        _react2['default'].createElement(
	          'tbody',
	          null,
	          _react2['default'].createElement(
	            'tr',
	            null,
	            _react2['default'].createElement(
	              'td',
	              null,
	              _react2['default'].createElement(
	                'b',
	                null,
	                'Natural'
	              )
	            ),
	            naturalProps.map(this.renderField)
	          ),
	          _react2['default'].createElement(
	            'tr',
	            null,
	            _react2['default'].createElement(
	              'td',
	              null,
	              _react2['default'].createElement(
	                'b',
	                null,
	                'Adaptado'
	              )
	            ),
	            adaptedProps.map(this.renderField)
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderField',
	    value: function renderField(field) {
	      var cell = this.props.editable === false ? this.props.value[field] : _react2['default'].createElement(_modulesNumberInputJsx2['default'], { className: 'form-control', onChange: this.handleChange(field), value: this.props.value[field], min: '1', max: '9' });
	
	      return _react2['default'].createElement(
	        'td',
	        { key: field },
	        cell
	      );
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange(field) {
	      var _this = this;
	
	      return function (value) {
	        var _merge;
	
	        _this.props.onChange((0, _ramda.merge)(_this.props.value, (_merge = {}, _defineProperty(_merge, field, value), _defineProperty(_merge, 'valid', true), _merge)));
	      };
	    }
	  }]);
	
	  return XTNAChartDataForm;
	})(_react2['default'].Component);
	
	exports['default'] = XTNAChartDataForm;
	module.exports = exports['default'];

/***/ }),

/***/ 1022:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _ramda = __webpack_require__(27);
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _modulesAutoBind = __webpack_require__(29);
	
	var _modulesAutoBind2 = _interopRequireDefault(_modulesAutoBind);
	
	var _modulesUtils = __webpack_require__(349);
	
	var _modulesUtils2 = _interopRequireDefault(_modulesUtils);
	
	var _XTNA = __webpack_require__(456);
	
	var _XTNA2 = _interopRequireDefault(_XTNA);
	
	__webpack_require__(440);
	
	var XTNAResults = (function (_React$Component) {
	  _inherits(XTNAResults, _React$Component);
	
	  function XTNAResults(props) {
	    _classCallCheck(this, XTNAResults);
	
	    _get(Object.getPrototypeOf(XTNAResults.prototype), 'constructor', this).call(this, props);
	    (0, _modulesAutoBind2['default'])(this);
	  }
	
	  _createClass(XTNAResults, [{
	    key: 'render',
	    value: function render() {
	      var results = _XTNA2['default'].getResults((0, _ramda.pick)(_XTNA2['default'].props(), this.props));
	      var derivedProperties = (0, _ramda.toPairs)(results.derivedProperties);
	      var filterProps = function filterProps(type) {
	        return (0, _ramda.filter)((0, _ramda.compose)((0, _ramda.equals)(type), _ramda.head, _ramda.head), derivedProperties);
	      };
	
	      return _react2['default'].createElement(
	        'div',
	        { style: { marginBottom: '10px' } },
	        _react2['default'].createElement(
	          'center',
	          null,
	          _react2['default'].createElement(
	            'table',
	            { className: 'input-table', style: { marginBottom: '20px' } },
	            _react2['default'].createElement(
	              'thead',
	              null,
	              _react2['default'].createElement(
	                'tr',
	                null,
	                _react2['default'].createElement('td', null),
	                filterProps('N').map((0, _ramda.compose)(function (prop) {
	                  return _react2['default'].createElement(
	                    'td',
	                    { key: prop },
	                    prop
	                  );
	                }, _ramda.tail, _ramda.head))
	              )
	            ),
	            _react2['default'].createElement(
	              'tbody',
	              null,
	              _react2['default'].createElement(
	                'tr',
	                null,
	                _react2['default'].createElement(
	                  'td',
	                  null,
	                  _react2['default'].createElement(
	                    'b',
	                    null,
	                    'Natural'
	                  )
	                ),
	                filterProps('N').map(this.renderField)
	              ),
	              _react2['default'].createElement(
	                'tr',
	                null,
	                _react2['default'].createElement(
	                  'td',
	                  null,
	                  _react2['default'].createElement(
	                    'b',
	                    null,
	                    'Adaptado'
	                  )
	                ),
	                filterProps('A').map(this.renderField)
	              )
	            )
	          )
	        ),
	        _react2['default'].createElement(
	          'div',
	          null,
	          _react2['default'].createElement(
	            'div',
	            null,
	            _react2['default'].createElement(
	              'label',
	              null,
	              'Índice de Consistencia:'
	            ),
	            ' ',
	            _modulesUtils2['default'].formatPercentage(results.consistency)
	          ),
	          _react2['default'].createElement(
	            'div',
	            null,
	            _react2['default'].createElement(
	              'label',
	              null,
	              'Niveles de Cambio:'
	            ),
	            ' ',
	            results.change
	          ),
	          this.renderChanges(results.changes),
	          _react2['default'].createElement(
	            'div',
	            null,
	            _react2['default'].createElement(
	              'label',
	              null,
	              'Perfil Natural:'
	            )
	          ),
	          _react2['default'].createElement(
	            'div',
	            null,
	            results.NProfile.join(' - ')
	          ),
	          _react2['default'].createElement(
	            'div',
	            null,
	            _react2['default'].createElement(
	              'label',
	              null,
	              'Perfil Adaptado:'
	            )
	          ),
	          _react2['default'].createElement(
	            'div',
	            null,
	            results.AProfile.join(' - ')
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderField',
	    value: function renderField(field) {
	      return _react2['default'].createElement(
	        'td',
	        { key: (0, _ramda.head)(field) },
	        (0, _ramda.tail)(field)
	      );
	    }
	  }, {
	    key: 'renderChanges',
	    value: function renderChanges(changes) {
	      return (0, _ramda.toPairs)(changes).map(function (change) {
	        return _react2['default'].createElement(
	          'div',
	          { key: (0, _ramda.tail)((0, _ramda.head)(change)) },
	          _react2['default'].createElement(
	            'label',
	            null,
	            'Cambios en ',
	            (0, _ramda.tail)((0, _ramda.head)(change)),
	            ':'
	          ),
	          ' ',
	          (0, _ramda.tail)(change)
	        );
	      });
	    }
	  }]);
	
	  return XTNAResults;
	})(_react2['default'].Component);
	
	exports['default'] = XTNAResults;
	module.exports = exports['default'];

/***/ }),

/***/ 1023:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _ramda = __webpack_require__(27);
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(41);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _modulesAutoBind = __webpack_require__(29);
	
	var _modulesAutoBind2 = _interopRequireDefault(_modulesAutoBind);
	
	var _assetsXtnaTrabajoChartPng = __webpack_require__(2810);
	
	var _assetsXtnaTrabajoChartPng2 = _interopRequireDefault(_assetsXtnaTrabajoChartPng);
	
	var colors = {
	  red: 'rgb(255, 0, 0)',
	  blue: 'rgb(0, 0, 255)',
	  black: 'rgb(0, 0, 0)'
	};
	
	var XTNATrabajoChart = (function (_React$Component) {
	  _inherits(XTNATrabajoChart, _React$Component);
	
	  function XTNATrabajoChart(props) {
	    _classCallCheck(this, XTNATrabajoChart);
	
	    _get(Object.getPrototypeOf(XTNATrabajoChart.prototype), 'constructor', this).call(this, props);
	    (0, _modulesAutoBind2['default'])(this);
	    this.state = { canvas: null, backgroundLoaded: false };
	  }
	
	  _createClass(XTNATrabajoChart, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this = this;
	
	      var canvas = document.createElement('canvas');
	      canvas.setAttribute('style', 'width: 100%; height: 100%;');
	      canvas.setAttribute('width', canvas.offsetWidth);
	      canvas.setAttribute('height', canvas.offsetWidth);
	      canvas.setAttribute('id', this.props.id);
	      _reactDom2['default'].findDOMNode(this).appendChild(canvas);
	      var background = new Image();
	      background.src = _assetsXtnaTrabajoChartPng2['default'];
	      background.onload = function () {
	        return _this.setState({ backgroundLoaded: true });
	      };
	      this.setState({ canvas: canvas, background: background });
	      window.addEventListener('resize', this.handleResize);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('resize', this.handleResize);
	      _reactDom2['default'].findDOMNode(this).removeChild(this.state.canvas);
	    }
	  }, {
	    key: 'handleResize',
	    value: function handleResize() {
	      this.setState({ windowWidth: window.innerWidth });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.state.canvas && this.state.backgroundLoaded) {
	        this.renderCanvas(this.state.canvas);
	      }
	
	      return _react2['default'].createElement('div', { style: { marginBottom: '10px' } });
	    }
	  }, {
	    key: 'renderCanvas',
	    value: function renderCanvas(canvas) {
	      canvas.setAttribute('width', canvas.offsetWidth);
	      canvas.setAttribute('height', canvas.offsetWidth * .682);
	      var ctx = canvas.getContext("2d");
	      ctx.drawImage(this.state.background, 0, 0, canvas.offsetWidth, canvas.offsetHeight);
	
	      var width = (0, _ramda.multiply)(canvas.offsetWidth);
	      var height = (0, _ramda.multiply)(canvas.offsetWidth);
	
	      var yPositions = [.044, .214, .382, .545];
	      var xPositions = [.073, .193, .319, .45, .5, .55, .633, .763, .907];
	      var natural = ['NX', 'NT', 'NN', 'NA'];
	      var adapted = ['AX', 'AT', 'AN', 'AA'];
	
	      for (var j = 0; j < 4; j++) {
	        var xPosN = xPositions[9 - this.props[natural[j]]];
	        var xPosA = xPositions[9 - this.props[adapted[j]]];
	        var yPos = yPositions[j];
	
	        // draw circles
	        ctx.strokeStyle = colors.red;
	        ctx.lineWidth = 5;
	
	        ctx.beginPath();
	        ctx.arc(width(xPosN), height(yPos), width(.025), 0, 2 * Math.PI);
	        ctx.closePath();
	        ctx.stroke();
	
	        // draw triangles
	        ctx.strokeStyle = colors.blue;
	        ctx.beginPath();
	        ctx.moveTo(width(xPosA) - width(.023), height(yPos) + width(.018));
	        ctx.lineTo(width(xPosA) + width(.002), height(yPos) - width(.032));
	        ctx.lineTo(width(xPosA) + width(.0257), height(yPos) + width(.018));
	        ctx.lineTo(width(xPosA) + width(.002), height(yPos) + width(.018));
	        ctx.closePath();
	        ctx.stroke();
	
	        var xOffsetN = (xPosN < xPosA ? 1 : xPosN > xPosA ? -1 : 0) * .029;
	        var xOffsetA = (xPosN < xPosA ? -1 : xPosN > xPosA ? 1 : 0) * .017;
	
	        // draw lines
	        ctx.lineWidth = 4;
	        ctx.strokeStyle = colors.black;
	        ctx.dashedLine(width(xPosN + xOffsetN), height(yPos), width(xPosA + xOffsetA), height(yPos), 6);
	      }
	    }
	  }]);
	
	  return XTNATrabajoChart;
	})(_react2['default'].Component);
	
	exports['default'] = XTNATrabajoChart;
	module.exports = exports['default'];

/***/ }),

/***/ 1024:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _ramda = __webpack_require__(27);
	
	var _bluebird = __webpack_require__(225);
	
	var _jszip = __webpack_require__(398);
	
	var _jszip2 = _interopRequireDefault(_jszip);
	
	var getBinaryContent = null;
	if (typeof window !== 'undefined') {
	  var jszipUtils = __webpack_require__(1528);
	  getBinaryContent = (0, _bluebird.promisify)(jszipUtils.getBinaryContent.bind(jszipUtils));
	}
	
	exports['default'] = (0, _ramda.curry)(function (powerPointUrl, replaces, slideNums) {
	  if (typeof slideNums === 'number') {
	    slideNums = [slideNums];
	  }
	
	  replaces.swaps = replaces.swaps || {};
	
	  var zip = new _jszip2['default']();
	  return getBinaryContent(powerPointUrl).then(zip.loadAsync.bind(zip)).then(function (zip) {
	
	    var promises = slideNums.map(function (slideNum) {
	      return zip.folder('ppt').folder('slides').file('slide' + slideNum + '.xml').async('string').then(function (text) {
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	
	          for (var _iterator = Object.keys(replaces.text)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var key = _step.value;
	
	            text = text.replace('{{' + key + '}}', replaces.text[key]);
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator['return']) {
	              _iterator['return']();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	
	        zip.folder('ppt').folder('slides').file('slide' + slideNum + '.xml', text);
	      });
	    });
	
	    return Promise.all(promises).then(function () {
	      var mediaFolder = zip.folder('ppt').folder('media');
	      var _iteratorNormalCompletion2 = true;
	      var _didIteratorError2 = false;
	      var _iteratorError2 = undefined;
	
	      try {
	        for (var _iterator2 = Object.keys(replaces.images)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	          var key = _step2.value;
	
	          mediaFolder.file(key, replaces.images[key], { base64: true });
	        }
	      } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion2 && _iterator2['return']) {
	            _iterator2['return']();
	          }
	        } finally {
	          if (_didIteratorError2) {
	            throw _iteratorError2;
	          }
	        }
	      }
	
	      var pr = [];
	      var _iteratorNormalCompletion3 = true;
	      var _didIteratorError3 = false;
	      var _iteratorError3 = undefined;
	
	      try {
	        var _loop = function () {
	          var key = _step3.value;
	
	          pr.push(mediaFolder.file(replaces.swaps[key]).async('base64').then(function (data) {
	            mediaFolder.file(key, data, { base64: true });
	          }));
	        };
	
	        for (var _iterator3 = Object.keys(replaces.swaps)[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	          _loop();
	        }
	      } catch (err) {
	        _didIteratorError3 = true;
	        _iteratorError3 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion3 && _iterator3['return']) {
	            _iterator3['return']();
	          }
	        } finally {
	          if (_didIteratorError3) {
	            throw _iteratorError3;
	          }
	        }
	      }
	
	      return Promise.all(pr).then(function () {
	        return zip.generateAsync({ type: 'blob' });
	      });
	    });
	  });
	});
	module.exports = exports['default'];

/***/ }),

/***/ 1025:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _common = __webpack_require__(95);
	
	var settings = {
	  apiUrl: 'https://' + _common.servers.production.hostname + ':3000/'
	};
	
	if (false) {
	  var devSettings = {
	    apiUrl: 'http://127.0.0.1:3000/'
	  };
	
	  settings = R.merge(settings, devSettings);
	}
	
	exports['default'] = settings;
	module.exports = exports['default'];

/***/ }),

/***/ 2168:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _settings = __webpack_require__(1025);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	var _modulesAutoBind = __webpack_require__(29);
	
	var _modulesAutoBind2 = _interopRequireDefault(_modulesAutoBind);
	
	var _common = __webpack_require__(95);
	
	var _modulesSpinnerJsx = __webpack_require__(153);
	
	var _modulesSpinnerJsx2 = _interopRequireDefault(_modulesSpinnerJsx);
	
	var _authLoginJsx = __webpack_require__(2170);
	
	var _authLoginJsx2 = _interopRequireDefault(_authLoginJsx);
	
	var _NavbarJsx = __webpack_require__(2169);
	
	var _NavbarJsx2 = _interopRequireDefault(_NavbarJsx);
	
	var _reportsReportingToolJsx = __webpack_require__(2185);
	
	var _reportsReportingToolJsx2 = _interopRequireDefault(_reportsReportingToolJsx);
	
	var _usersUsersJsx = __webpack_require__(1020);
	
	var _usersUsersJsx2 = _interopRequireDefault(_usersUsersJsx);
	
	var _questionnairesQuestionnairesJsx = __webpack_require__(2182);
	
	var _questionnairesQuestionnairesJsx2 = _interopRequireDefault(_questionnairesQuestionnairesJsx);
	
	var _questionnairesQuestionnaireBenzigerJsx = __webpack_require__(2181);
	
	var _questionnairesQuestionnaireBenzigerJsx2 = _interopRequireDefault(_questionnairesQuestionnaireBenzigerJsx);
	
	var _usersUserDetailsJsx = __webpack_require__(1019);
	
	var _usersUserDetailsJsx2 = _interopRequireDefault(_usersUserDetailsJsx);
	
	var _consultantsConsultantsJsx = __webpack_require__(2172);
	
	var _consultantsConsultantsJsx2 = _interopRequireDefault(_consultantsConsultantsJsx);
	
	var _registrationRegistrationJsx = __webpack_require__(2183);
	
	var _registrationRegistrationJsx2 = _interopRequireDefault(_registrationRegistrationJsx);
	
	var _licensesLicensesJsx = __webpack_require__(1012);
	
	var _licensesLicensesJsx2 = _interopRequireDefault(_licensesLicensesJsx);
	
	var _licensesLicenseRequestsJsx = __webpack_require__(2177);
	
	var _licensesLicenseRequestsJsx2 = _interopRequireDefault(_licensesLicenseRequestsJsx);
	
	__webpack_require__(440);
	
	__webpack_require__(661);
	
	var apiLocation = _settings2['default'].apiUrl;
	
	var App = (function (_React$Component) {
	  _inherits(App, _React$Component);
	
	  function App(props) {
	    _classCallCheck(this, App);
	
	    _get(Object.getPrototypeOf(App.prototype), 'constructor', this).call(this, props);
	    (0, _modulesAutoBind2['default'])(this);
	    this.state = {
	      api: null,
	      route: window.location.hash.substr(1),
	      questionnaire: null
	    };
	
	    this.getApi();
	    __webpack_require__(133).locale('es');
	  }
	
	  _createClass(App, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this = this;
	
	      window.addEventListener('hashchange', function () {
	        _this.setState({ route: window.location.hash.substr(1) });
	      });
	    }
	  }, {
	    key: 'getApi',
	    value: function getApi() {
	      var _this2 = this;
	
	      $.ajax(apiLocation).success(function (api) {
	        return _this2.setState({ api: api, loggingOut: false });
	      }).fail(function () {
	        return _this2.setState({ errorMessage: 'Hubo un error al cargar la aplicación.' });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.state.loggingOut) {
	        return _react2['default'].createElement(
	          'div',
	          null,
	          'Saliendo...'
	        );
	      }
	
	      if (this.state.errorMessage) {
	        return _react2['default'].createElement(
	          'div',
	          null,
	          this.state.errorMessage
	        );
	      }
	
	      if (!this.state.api) {
	        return _react2['default'].createElement(
	          'center',
	          null,
	          _react2['default'].createElement(_modulesSpinnerJsx2['default'], null)
	        );
	      }
	
	      var routeParts = this.state.route.split('/');
	      if (this.state.api._rels.questionnaires && routeParts.length > 1 && routeParts[1] === 'cuestionarios') {
	        return _react2['default'].createElement(_questionnairesQuestionnairesJsx2['default'], { resourceUrl: this.state.api._rels.questionnaires.replace('{id}', routeParts[2]) });
	      }
	
	      if (this.state.api._rels.submitBenziger && routeParts.length > 2 && routeParts[1] === 'tomarBenziger') {
	        return _react2['default'].createElement(_questionnairesQuestionnaireBenzigerJsx2['default'], { benzigerProgress: this.state.api._rels.benzigerProgress, qId: routeParts[2], submitBenziger: this.state.api._rels.submitBenziger });
	      }
	
	      if (this.state.api._rels.registration && routeParts.length > 1 && routeParts[1] === 'registro') {
	        return _react2['default'].createElement(_registrationRegistrationJsx2['default'], { resourceUrl: this.state.api._rels.registration.replace('{id}', routeParts[2]) });
	      }
	
	      if (!this.state.api.user) {
	        if (this.state.api._rels.login) {
	          return _react2['default'].createElement(_authLoginJsx2['default'], { url: this.state.api._rels.login, onLogin: this.getApi });
	        }
	        return _react2['default'].createElement(
	          'div',
	          null,
	          'No se puede entrar por el momento.'
	        );
	      }
	
	      if (this.state.api.user) {
	        return _react2['default'].createElement(
	          'div',
	          null,
	          _react2['default'].createElement(_NavbarJsx2['default'], { user: this.state.api.user, onLogout: this.handleLogout, route: this.state.route }),
	          _react2['default'].createElement(
	            'div',
	            { className: 'container' },
	            this.getComponent(this.state.route)
	          )
	        );
	      }
	    }
	  }, {
	    key: 'handleLogout',
	    value: function handleLogout() {
	      window.location.hash = '/';
	      this.setState({ api: null, loggingOut: true });
	      this.getApi();
	    }
	  }, {
	    key: 'getComponent',
	    value: function getComponent() {
	      var _this3 = this;
	
	      var routes = {
	        reports: '/reportes',
	        users: '/clientes',
	        user: '/clientes/:id'
	      };
	
	      if (this.state.api.user.userType === 'admin') {
	        routes.consultants = '/consultores';
	        routes.licenseRequests = '/peticiones';
	      }
	
	      var routeHandlers = {
	        reports: function reports() {
	          return _react2['default'].createElement(_reportsReportingToolJsx2['default'], { numLicenses: 0, user: _this3.state.api.user, consumeLicense: _this3.state.api._rels.consumeLicense, xtnaReportTemplate: _this3.state.api._rels.xtnaReportTemplate, humanFactorsReportTemplate: _this3.state.api._rels.humanFactorsReportTemplate });
	        },
	        users: function users() {
	          return _react2['default'].createElement(_usersUsersJsx2['default'], { userType: _this3.state.api.user.userType, user: _this3.state.api.user.username, sendBenziger: _this3.state.api._rels.sendBenziger, resourceUrl: _this3.state.api._rels.users.replace('{usertype}', _this3.state.api.user.userType).replace('{username}', _this3.state.api.user.username) });
	        },
	        user: function user(_ref) {
	          var id = _ref.id;
	          return _react2['default'].createElement(_usersUserDetailsJsx2['default'], { user: _this3.state.api.user.username, userType: _this3.state.api.user.userType, exportBenziger: _this3.state.api._rels.benzigerAdultTemplate, resourceUrl: _this3.state.api._rels.getUserById.replace('{id}', id) });
	        },
	        consultants: function consultants() {
	          return _react2['default'].createElement(_consultantsConsultantsJsx2['default'], { resourceUrl: _this3.state.api._rels.consultants, consultantUrl: _this3.state.api._rels.getConsultantById });
	        },
	        licenses: function licenses() {
	          return _react2['default'].createElement(_licensesLicensesJsx2['default'], { resourceUrl: _this3['this'].state.api._rels.addLicenses });
	        },
	        licenseRequests: function licenseRequests() {
	          return _react2['default'].createElement(_licensesLicenseRequestsJsx2['default'], { resourceUrl: _this3.state.api._rels.licenseRequests });
	        }
	      };
	
	      var matchingRoute = this.getMatchingRoute(this.state.route, routes);
	
	      if (!matchingRoute.route) {
	        window.location.hash = '/reportes';
	        return routeHandlers.reports();
	      }
	
	      return routeHandlers[matchingRoute.route](matchingRoute.params);
	    }
	  }, {
	    key: 'getMatchingRoute',
	    value: function getMatchingRoute(route, routes) {
	      var forEachIndexed = R.addIndex(R.forEach);
	      var currentRouteParts = route.split('/');
	
	      var matchingRoute = null,
	          routeParams = null;
	      forEachIndexed(function (routeName, index) {
	        var parts = routes[routeName].split('/');
	
	        if (matchingRoute || parts.length !== currentRouteParts.length) {
	          return;
	        }
	
	        var params = {};
	        var matching = true;
	        forEachIndexed(function (part, partIndex) {
	          if (!matching) {
	            return;
	          }
	
	          var currentRoutePart = currentRouteParts[partIndex];
	          if (part[0] === ':') {
	            params[R.tail(part)] = currentRoutePart;
	          } else {
	            matching = currentRoutePart === part;
	          }
	        }, parts);
	
	        if (matching) {
	          matchingRoute = routeName;
	          routeParams = params;
	        }
	      }, Object.keys(routes));
	
	      return {
	        route: matchingRoute,
	        params: routeParams
	      };
	    }
	  }]);
	
	  return App;
	})(_react2['default'].Component);
	
	exports['default'] = App;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(35)))

/***/ }),

/***/ 2169:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _settings = __webpack_require__(1025);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	var _modulesAutoBind = __webpack_require__(29);
	
	var _modulesAutoBind2 = _interopRequireDefault(_modulesAutoBind);
	
	var _authTokenManager = __webpack_require__(661);
	
	var _authTokenManager2 = _interopRequireDefault(_authTokenManager);
	
	var _assetsLogoNoTextPng = __webpack_require__(2811);
	
	var _assetsLogoNoTextPng2 = _interopRequireDefault(_assetsLogoNoTextPng);
	
	var _licensesLicensesJsx = __webpack_require__(1012);
	
	var _licensesLicensesJsx2 = _interopRequireDefault(_licensesLicensesJsx);
	
	var apiLocation = _settings2['default'].apiUrl;
	
	var Navbar = (function (_React$Component) {
	  _inherits(Navbar, _React$Component);
	
	  function Navbar(props) {
	    _classCallCheck(this, Navbar);
	
	    _get(Object.getPrototypeOf(Navbar.prototype), 'constructor', this).call(this, props);
	    (0, _modulesAutoBind2['default'])(this);
	    this.state = {
	      api: null
	    };
	    this.getApi();
	  }
	
	  _createClass(Navbar, [{
	    key: 'handleLogout',
	    value: function handleLogout() {
	      _authTokenManager2['default'].clearToken();
	      this.props.onLogout();
	    }
	  }, {
	    key: 'getApi',
	    value: function getApi() {
	      var _this = this;
	
	      $.ajax(apiLocation).success(function (api) {
	        return _this.setState({ api: api, loggingOut: false });
	      }).fail(function () {
	        return _this.setState({ errorMessage: 'Hubo un error al cargar la aplicación.' });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var consultantsTab = { url: '#/consultores', label: 'Consultores' };
	      var requestsTab = { url: '#/peticiones', label: 'Peticiones' };
	      var tabs = [{ url: '#/reportes', label: 'Reportes' }, { url: '#/clientes', label: 'Clientes' }];
	
	      if (this.props.user.userType === 'admin') {
	        tabs.push(consultantsTab);
	        tabs.push(requestsTab);
	      }
	
	      if (!this.state.api) {
	        return null;
	      }
	
	      return _react2['default'].createElement(
	        'nav',
	        { className: 'navbar navbar-default', style: { marginBottom: '30px' } },
	        _react2['default'].createElement(
	          'div',
	          { className: 'container' },
	          _react2['default'].createElement(
	            'div',
	            { className: 'navbar-header' },
	            _react2['default'].createElement(
	              'button',
	              { onClick: function () {
	                  return _this2.forceUpdate();
	                }, type: 'button', className: 'navbar-toggle collapsed', 'data-toggle': 'collapse', 'data-target': '#navbar', 'aria-expanded': 'false', 'aria-controls': 'navbar' },
	              _react2['default'].createElement(
	                'span',
	                { className: 'sr-only' },
	                'Toggle navigation'
	              ),
	              _react2['default'].createElement('span', { className: 'icon-bar' }),
	              _react2['default'].createElement('span', { className: 'icon-bar' }),
	              _react2['default'].createElement('span', { className: 'icon-bar' })
	            ),
	            _react2['default'].createElement(
	              'a',
	              { style: { padding: '7px 20px' }, className: 'navbar-brand', href: '#' },
	              _react2['default'].createElement('img', { src: _assetsLogoNoTextPng2['default'], height: '36px' })
	            )
	          ),
	          _react2['default'].createElement(
	            'div',
	            { id: 'navbar', className: 'navbar-collapse collapse', 'aria-expanded': 'false' },
	            _react2['default'].createElement(
	              'ul',
	              { className: 'nav navbar-nav' },
	              tabs.map(this.renderTab)
	            ),
	            _react2['default'].createElement(
	              'ul',
	              { className: 'nav navbar-nav navbar-right' },
	              _react2['default'].createElement(
	                'li',
	                null,
	                _react2['default'].createElement(
	                  'a',
	                  null,
	                  this.props.user.username
	                )
	              ),
	              this.renderLicenses(),
	              _react2['default'].createElement(
	                'li',
	                null,
	                _react2['default'].createElement(
	                  'a',
	                  { href: '#', onClick: this.handleLogout },
	                  'Salir'
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderLicenses',
	    value: function renderLicenses() {
	      if (this.props.user.userType !== "admin") {
	        return _react2['default'].createElement(
	          'li',
	          null,
	          _react2['default'].createElement(
	            'a',
	            null,
	            _react2['default'].createElement(_licensesLicensesJsx2['default'], { user: this.props.user.username, resourceUrl: this.state.api._rels.licenses })
	          )
	        );
	      }
	    }
	  }, {
	    key: 'renderTab',
	    value: function renderTab(tab) {
	      var isActive = this.props.route.startsWith(tab.url.substring(1));
	      return _react2['default'].createElement(
	        'li',
	        { key: tab.label, className: isActive ? 'active' : '' },
	        _react2['default'].createElement(
	          'a',
	          { href: tab.url },
	          tab.label
	        )
	      );
	    }
	  }]);
	
	  return Navbar;
	})(_react2['default'].Component);
	
	exports['default'] = Navbar;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(35)))

/***/ }),

/***/ 2170:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _ramda = __webpack_require__(27);
	
	var _ramda2 = _interopRequireDefault(_ramda);
	
	var _jquery = __webpack_require__(35);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _common = __webpack_require__(95);
	
	var _modulesAutoBind = __webpack_require__(29);
	
	var _modulesAutoBind2 = _interopRequireDefault(_modulesAutoBind);
	
	var _TokenManager = __webpack_require__(661);
	
	var _TokenManager2 = _interopRequireDefault(_TokenManager);
	
	var _assetsLogoPng = __webpack_require__(744);
	
	var _assetsLogoPng2 = _interopRequireDefault(_assetsLogoPng);
	
	var Login = (function (_React$Component) {
	  _inherits(Login, _React$Component);
	
	  function Login(props) {
	    _classCallCheck(this, Login);
	
	    _get(Object.getPrototypeOf(Login.prototype), 'constructor', this).call(this, props);
	    (0, _modulesAutoBind2['default'])(this);
	    this.state = {
	      username: '',
	      password: '',
	      error: null
	    };
	
	    this.style = {
	      maxWidth: '500px',
	      padding: '15px',
	      margin: '0 auto'
	    };
	  }
	
	  _createClass(Login, [{
	    key: 'render',
	    value: function render() {
	      return _react2['default'].createElement(
	        'div',
	        { className: 'container-fluid' },
	        _react2['default'].createElement('img', { width: '370px', style: { padding: '30px' }, className: 'center-block', src: _assetsLogoPng2['default'] }),
	        _react2['default'].createElement(
	          'form',
	          { style: this.style },
	          _react2['default'].createElement(
	            'div',
	            { className: 'form-group' },
	            _react2['default'].createElement(
	              'label',
	              { className: 'control-label', htmlFor: 'username' },
	              'Usuario'
	            ),
	            _react2['default'].createElement('input', { className: 'form-control', type: 'text', value: this.state.username, id: 'username', onChange: this.handleUsernameChange })
	          ),
	          _react2['default'].createElement(
	            'div',
	            { className: 'form-group' },
	            _react2['default'].createElement(
	              'label',
	              { className: 'control-label', htmlFor: 'password' },
	              'Contraseña'
	            ),
	            _react2['default'].createElement('input', { className: 'form-control', type: 'password', value: this.state.password, id: 'password', onChange: this.handlePasswordChange })
	          ),
	          this.state.error ? _react2['default'].createElement(
	            'div',
	            { style: { color: 'red', marginBottom: '10px' } },
	            this.getErrorMessage()
	          ) : '',
	          _react2['default'].createElement('input', { type: 'submit', className: 'btn btn-lg btn-primary btn-block', onClick: this.handleLogin, value: 'Entrar', disabled: !this.validCredentials() })
	        )
	      );
	    }
	  }, {
	    key: 'validCredentials',
	    value: function validCredentials() {
	      return _common.validations.validateObject({ username: _ramda2['default'].either(_common.validations.username, _common.validations.email), password: _common.validations.password }, _ramda2['default'].pick(['username', 'password'], this.state));
	    }
	  }, {
	    key: 'getErrorMessage',
	    value: function getErrorMessage() {
	      switch (this.state.error) {
	        case 'Invalid username':
	          return 'Nombre de usuario incorrecto';
	        case 'Incorrect password':
	          return 'Contraseña incorrecta';
	          break;
	      }
	    }
	  }, {
	    key: 'handleUsernameChange',
	    value: function handleUsernameChange(event) {
	      this.setState({ username: event.target.value, error: null });
	    }
	  }, {
	    key: 'handlePasswordChange',
	    value: function handlePasswordChange(event) {
	      this.setState({ password: event.target.value, error: null });
	    }
	  }, {
	    key: 'handleLogin',
	    value: function handleLogin(event) {
	      var _this = this;
	
	      event.preventDefault();
	      _jquery2['default'].ajax({
	        url: this.props.url,
	        method: 'POST',
	        data: this.state
	      }).then(_ramda2['default'].compose(this.props.onLogin, _TokenManager2['default'].saveToken, _ramda2['default'].prop('token'))).fail(function (_ref) {
	        var responseJSON = _ref.responseJSON;
	
	        _this.setState({ error: responseJSON.message });
	      });
	    }
	  }]);
	
	  return Login;
	})(_react2['default'].Component);
	
	exports['default'] = Login;
	module.exports = exports['default'];

/***/ }),

/***/ 2171:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = {
	  IE: 11,
	  Chrome: 30,
	  Safari: 5,
	  Opera: 12,
	  Firefox: 27
	};
	module.exports = exports["default"];

/***/ }),

/***/ 2172:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x2, _x3, _x4) { var _again = true; _function: while (_again) { var object = _x2, property = _x3, receiver = _x4; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x2 = parent; _x3 = property; _x4 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _ramda = __webpack_require__(27);
	
	var _ramda2 = _interopRequireDefault(_ramda);
	
	var _jquery = __webpack_require__(35);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bluebird = __webpack_require__(225);
	
	var _bluebird2 = _interopRequireDefault(_bluebird);
	
	var _reactBootstrapLibModal = __webpack_require__(413);
	
	var _reactBootstrapLibModal2 = _interopRequireDefault(_reactBootstrapLibModal);
	
	var _reactBootstrapLibAlert = __webpack_require__(252);
	
	var _reactBootstrapLibAlert2 = _interopRequireDefault(_reactBootstrapLibAlert);
	
	var _modulesAutoBind = __webpack_require__(29);
	
	var _modulesAutoBind2 = _interopRequireDefault(_modulesAutoBind);
	
	var _common = __webpack_require__(95);
	
	var _modulesSpinnerJsx = __webpack_require__(153);
	
	var _modulesSpinnerJsx2 = _interopRequireDefault(_modulesSpinnerJsx);
	
	var _usersTableJsx = __webpack_require__(663);
	
	var _usersTableJsx2 = _interopRequireDefault(_usersTableJsx);
	
	var _CreateConsultantFormJsx = __webpack_require__(2173);
	
	var _CreateConsultantFormJsx2 = _interopRequireDefault(_CreateConsultantFormJsx);
	
	var _EditConsultantFormJsx = __webpack_require__(2174);
	
	var _EditConsultantFormJsx2 = _interopRequireDefault(_EditConsultantFormJsx);
	
	var _reactBootstrapLibPagination = __webpack_require__(414);
	
	var _reactBootstrapLibPagination2 = _interopRequireDefault(_reactBootstrapLibPagination);
	
	var pageSize = 20;
	var columns = [{ id: 'id', label: 'ID', maxWidth: 1 }, { id: 'name', label: 'Nombre', maxWidth: 4 }, { id: 'username', label: 'Correo', maxWidth: 4 }, { id: 'company', label: 'Compañía', maxWidth: 4 }, { id: 'jobposition', label: 'Puesto', maxWidth: 4 }, { id: 'totallicenses', label: 'Lic. Totales', maxWidth: 1 }, { id: 'usedlicenses', label: 'Lic. Usadas', maxWidth: 1 }, { id: 'availablelicenses', label: 'Lic. Disponibles', maxWidth: 1 }, { id: 'estatus', label: 'Estatus', maxWidth: 1 }];
	
	var Consultants = (function (_React$Component) {
	  _inherits(Consultants, _React$Component);
	
	  function Consultants(props) {
	    _classCallCheck(this, Consultants);
	
	    _get(Object.getPrototypeOf(Consultants.prototype), 'constructor', this).call(this, props);
	    (0, _modulesAutoBind2['default'])(this);
	    this.state = {
	      creatingConsultant: false,
	      editingConsultant: false,
	      sortColumn: 'id',
	      sortOrder: 'asc',
	      selectedRow: null,
	      toEditRow: null,
	      editInfo: null,
	      page: 0
	    };
	  }
	
	  _createClass(Consultants, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.fetchConsultants(this.props.resourceUrl);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this = this;
	
	      if (!this.state.consultantsResource && this.state.loadingConsultants) {
	        return _react2['default'].createElement(_modulesSpinnerJsx2['default'], null);
	      }
	
	      if (!this.state.consultantsResource && !this.state.loadingConsultants) {
	        return _react2['default'].createElement(
	          'div',
	          null,
	          this.state.errorMessage
	        );
	      }
	
	      var resource = this.state.consultantsResource;
	      var numOfPages = Math.ceil(resource.total / pageSize);
	      var consultantIndices = _ramda2['default'].range(this.state.page * pageSize, (this.state.page + 1) * pageSize);
	      var selectedIndex = this.state.selectedRow ? this.state.selectedRow.index : null;
	      var data = this.state.loadingConsultants ? [] : resource.consultants.map(function (consultant) {
	        return _ramda2['default'].merge(consultant, { estatus: consultant.archived ? 'Desactivado' : 'Activado' });
	      });
	
	      return _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement(
	          'button',
	          { type: 'button', className: 'btn btn-success', style: { marginRight: '10px' }, onClick: this.handleOpenCreateConsultantModal },
	          'Crear Consultor'
	        ),
	        this.state.selectedRow !== null ? _react2['default'].createElement(
	          'button',
	          { type: 'button', className: 'btn btn-info', style: { marginRight: '10px' }, onClick: function () {
	              return _this.setState({ toEditRow: _this.state.selectedRow });
	            } },
	          'Editar Consultor'
	        ) : '',
	        this.state.selectedRow !== null && data[selectedIndex].archived === false ? _react2['default'].createElement(
	          'button',
	          { type: 'button', className: 'btn btn-danger', style: { marginRight: '10px' }, onClick: this.handleOpenDeactivateUserModal },
	          'Desactivar Consultor'
	        ) : '',
	        this.state.selectedRow !== null && data[selectedIndex].archived === true ? _react2['default'].createElement(
	          'button',
	          { type: 'button', className: 'btn btn-success', style: { marginRight: '10px' }, onClick: this.handleOpenActivateUserModal },
	          'Activar Consultor'
	        ) : '',
	        this.state.newConsultant ? this.renderCreateConsultantModal() : '',
	        this.state.deleteUser ? this.renderDeleteUserModal() : '',
	        this.state.toEditRow !== null ? this.renderEditConsultantModal() : '',
	        _react2['default'].createElement(_usersTableJsx2['default'], {
	          columns: columns,
	          sort: { column: this.state.sortColumn, order: this.state.sortOrder },
	          data: data,
	          selectedIndex: selectedIndex,
	          onSort: this.handleSortChange,
	          onRowClick: function (event) {
	            return _this.setState({ selectedRow: event });
	          },
	          onRowDoubleClick: function (event) {
	            _this.setState({ toEditRow: event, editInfo: { totallicenses: 1 } });
	          }
	        }),
	        resource.total > pageSize ? _react2['default'].createElement(
	          'center',
	          null,
	          _react2['default'].createElement(_reactBootstrapLibPagination2['default'], {
	            prev: this.state.page !== 0,
	            next: (this.state.page + 1) * pageSize <= resource.total,
	            first: this.state.page !== 0,
	            last: (this.state.page + 1) * pageSize <= resource.total,
	            bsSize: 'medium',
	            maxButtons: 10,
	            items: Math.ceil(resource.total / pageSize),
	            activePage: this.state.page + 1,
	            onSelect: this.handlePageChange })
	        ) : ''
	      );
	    }
	  }, {
	    key: 'handleOpenDeactivateUserModal',
	    value: function handleOpenDeactivateUserModal() {
	      this.setState({ deleteUser: this.state.selectedRow.row, active: false });
	    }
	  }, {
	    key: 'handleOpenActivateUserModal',
	    value: function handleOpenActivateUserModal() {
	      this.setState({ deleteUser: this.state.selectedRow.row, active: true });
	    }
	  }, {
	    key: 'renderCreateConsultantModal',
	    value: function renderCreateConsultantModal() {
	      var _this2 = this;
	
	      var closeModal = function closeModal() {
	        return _this2.setState({ newConsultant: null, modalErrorMessage: null });
	      };
	      var consultantValidations = _ramda2['default'].pick(['name'], _common.validations);
	      var validConsultantForm = function validConsultantForm() {
	        return _ramda2['default'].is(Object, _this2.state.newConsultant) && _common.validations.validateObject(consultantValidations, _this2.state.newConsultant);
	      };
	
	      return _react2['default'].createElement(
	        _reactBootstrapLibModal2['default'],
	        { show: true, onHide: closeModal },
	        _react2['default'].createElement(
	          _reactBootstrapLibModal2['default'].Header,
	          { closeButton: true },
	          _react2['default'].createElement(
	            _reactBootstrapLibModal2['default'].Title,
	            null,
	            'Crear Consultor'
	          )
	        ),
	        _react2['default'].createElement(
	          _reactBootstrapLibModal2['default'].Body,
	          null,
	          this.state.modalErrorMessage ? _react2['default'].createElement(
	            _reactBootstrapLibAlert2['default'],
	            { bsStyle: 'danger', onDismiss: function () {
	                return _this2.setState({ modalErrorMessage: null });
	              } },
	            this.state.modalErrorMessage
	          ) : '',
	          _react2['default'].createElement(_CreateConsultantFormJsx2['default'], { value: this.state.newConsultant, onChange: function (newConsultant) {
	              return _this2.setState({ newConsultant: newConsultant });
	            } })
	        ),
	        _react2['default'].createElement(
	          _reactBootstrapLibModal2['default'].Footer,
	          null,
	          _react2['default'].createElement(
	            'button',
	            { type: 'button', className: 'btn btn-danger', onClick: closeModal },
	            'Cancelar'
	          ),
	          _react2['default'].createElement(
	            'button',
	            { type: 'submit', className: 'btn btn-success', onClick: this.handleCreateConsultant, disabled: !validConsultantForm() || this.state.creatingConsultant },
	            'Crear'
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderEditConsultantModal',
	    value: function renderEditConsultantModal() {
	      var _this3 = this;
	
	      var closeModal = function closeModal() {
	        return _this3.setState({ toEditRow: null, modalErrorMessage: null, editInfo: null });
	      };
	      var consultantValidations = _ramda2['default'].pick(['name'], _common.validations);
	      return _react2['default'].createElement(
	        _reactBootstrapLibModal2['default'],
	        { show: true, onHide: closeModal },
	        _react2['default'].createElement(
	          _reactBootstrapLibModal2['default'].Header,
	          { closeButton: true },
	          _react2['default'].createElement(
	            _reactBootstrapLibModal2['default'].Title,
	            null,
	            'Editar Licencias'
	          )
	        ),
	        _react2['default'].createElement(
	          _reactBootstrapLibModal2['default'].Body,
	          null,
	          this.state.modalErrorMessage ? _react2['default'].createElement(
	            _reactBootstrapLibAlert2['default'],
	            { bsStyle: 'danger', onDismiss: function () {
	                return _this3.setState({ modalErrorMessage: null });
	              } },
	            this.state.modalErrorMessage
	          ) : '',
	          _react2['default'].createElement(_EditConsultantFormJsx2['default'], { value: this.state.editInfo, resourceUrl: this.props.consultantUrl.replace('{username}', this.state.toEditRow.row.username), onChange: function (editInfo) {
	              return _this3.setState({ editInfo: editInfo });
	            } })
	        ),
	        _react2['default'].createElement(
	          _reactBootstrapLibModal2['default'].Footer,
	          null,
	          _react2['default'].createElement(
	            'button',
	            { type: 'button', className: 'btn btn-danger', onClick: closeModal },
	            'Cancelar'
	          ),
	          _react2['default'].createElement(
	            'button',
	            { type: 'submit', className: 'btn btn-success', onClick: this.handleEditConsultant, disabled: this.state.editingConsultant },
	            'Guardar'
	          )
	        )
	      );
	    }
	  }, {
	    key: 'handleSortChange',
	    value: function handleSortChange(_ref) {
	      var _this4 = this;
	
	      var column = _ref.column;
	      var order = _ref.order;
	
	      var prevColumn = this.state.sortColumn,
	          prevOrder = this.state.sortOrder;
	      this.setState({ sortColumn: column, sortOrder: order });
	      var url = this.state.consultantsResource._rels.sort.replace('{sort}', column).replace('{order}', order);
	      this.fetchConsultants(url, this.state.page)['catch'](function () {
	        return _this4.setState({ sortColumn: prevColumn, sortOrder: prevOrder });
	      });
	    }
	  }, {
	    key: 'handlePageChange',
	    value: function handlePageChange(eventKey) {
	      var page = eventKey - 1;
	      this.fetchConsultants(this.state.consultantsResource._rels.getPage.replace('{pageNum}', page), page);
	    }
	  }, {
	    key: 'fetchConsultants',
	    value: function fetchConsultants(url) {
	      var _this5 = this;
	
	      var page = arguments.length <= 1 || arguments[1] === undefined ? 0 : arguments[1];
	
	      if (this.state.loadingConsultants) {
	        return _bluebird2['default'].reject('Already fetching consultants.');
	      }
	      var prevPage = this.state.page;
	      this.setState({ loadingConsultants: true, selectedRow: null, page: page });
	
	      return _bluebird2['default'].resolve(_jquery2['default'].ajax({ url: url })).then(function (consultantsResource) {
	        return _this5.setState({ consultantsResource: consultantsResource });
	      })['catch'](function () {
	        return _this5.setState({ page: prevPage, errorMessage: 'Hubo un error al crear el consultor.' });
	      })['finally'](function () {
	        return _this5.setState({ loadingConsultants: false });
	      });
	    }
	  }, {
	    key: 'handleOpenCreateConsultantModal',
	    value: function handleOpenCreateConsultantModal() {
	      this.setState({ newConsultant: { name: '', username: '', totallicenses: 10 } });
	    }
	  }, {
	    key: 'handleCreateConsultant',
	    value: function handleCreateConsultant(event) {
	      var _this6 = this;
	
	      event.preventDefault();
	      this.setState({ creatingConsultant: true });
	      return _bluebird2['default'].resolve(_jquery2['default'].ajax({
	        url: this.props.resourceUrl,
	        method: 'POST',
	        data: this.state.newConsultant
	      })).then(function () {
	        _this6.setState({ newConsultant: null, modalErrorMessage: null });
	        _this6.fetchConsultants(_this6.state.consultantsResource._rels.self, _this6.state.page);
	      })['catch'](function () {
	        return _this6.setState({ modalErrorMessage: 'Ya existe un consultor con el mismo correo.' });
	      })['finally'](function () {
	        return _this6.setState({ creatingConsultant: false });
	      });
	    }
	  }, {
	    key: 'handleEditConsultant',
	    value: function handleEditConsultant(event) {
	      var _this7 = this;
	
	      event.preventDefault();
	      this.setState({ editingConsultant: true });
	      return _bluebird2['default'].resolve(_jquery2['default'].ajax({
	        url: this.props.consultantUrl.replace('{username}', this.state.toEditRow.row.username),
	        method: 'PUT',
	        data: this.state.editInfo
	      })).then(function () {
	        _this7.setState({ toEditRow: null, editInfo: null, modalErrorMessage: null });
	        _this7.fetchConsultants(_this7.state.consultantsResource._rels.self, _this7.state.page);
	      })['catch'](function () {
	        return _this7.setState({ modalErrorMessage: 'Hubo un error al crear el consultor.' });
	      })['finally'](function () {
	        return _this7.setState({ editingConsultant: false });
	      });
	    }
	  }, {
	    key: 'handleDeleteUser',
	    value: function handleDeleteUser(event) {
	      var _this8 = this;
	
	      event.preventDefault();
	      this.setState({ deletingUser: true });
	
	      var url = this.state.consultantsResource._rels[this.state.selectedRow.index] + '/active';
	      return _bluebird2['default'].resolve(_jquery2['default'].ajax({
	        url: url,
	        method: 'PATCH',
	        data: { active: this.state.active }
	      })).then(function () {
	        _this8.setState({ deleteUser: null });
	        _this8.fetchConsultants(_this8.state.consultantsResource._rels.self, _this8.state.page);
	      })['finally'](function () {
	        return _this8.setState({ deletingUser: false });
	      });
	    }
	  }, {
	    key: 'renderDeleteUserModal',
	    value: function renderDeleteUserModal() {
	      var _this9 = this;
	
	      var closeModal = function closeModal() {
	        return _this9.setState({ deleteUser: null });
	      };
	      return _react2['default'].createElement(
	        _reactBootstrapLibModal2['default'],
	        { show: true, onHide: closeModal },
	        _react2['default'].createElement(
	          _reactBootstrapLibModal2['default'].Header,
	          { closeButton: true },
	          this.state.active === true ? _react2['default'].createElement(
	            _reactBootstrapLibModal2['default'].Title,
	            null,
	            'Desactivar Consultor'
	          ) : '',
	          this.state.active === false ? _react2['default'].createElement(
	            _reactBootstrapLibModal2['default'].Title,
	            null,
	            'Activar Consultor'
	          ) : ''
	        ),
	        _react2['default'].createElement(
	          _reactBootstrapLibModal2['default'].Body,
	          null,
	          this.state.active === false ? _react2['default'].createElement(
	            'span',
	            null,
	            '¿Estás seguro de querer desactivar a ',
	            this.state.deleteUser.name,
	            '?'
	          ) : '',
	          this.state.active === true ? _react2['default'].createElement(
	            'span',
	            null,
	            '¿Estás seguro de querer activar a ',
	            this.state.deleteUser.name,
	            '?'
	          ) : ''
	        ),
	        _react2['default'].createElement(
	          _reactBootstrapLibModal2['default'].Footer,
	          null,
	          _react2['default'].createElement(
	            'button',
	            { type: 'button', className: 'btn btn-danger', onClick: closeModal },
	            'Cancelar'
	          ),
	          this.state.active === false ? _react2['default'].createElement(
	            'button',
	            { type: 'submit', className: 'btn btn-success', onClick: this.handleDeleteUser, disabled: this.state.deletingUser },
	            'Desactivar'
	          ) : '',
	          this.state.active === true ? _react2['default'].createElement(
	            'button',
	            { type: 'submit', className: 'btn btn-success', onClick: this.handleDeleteUser, disabled: this.state.deletingUser },
	            'Activar'
	          ) : ''
	        )
	      );
	    }
	  }]);
	
	  return Consultants;
	})(_react2['default'].Component);
	
	exports['default'] = Consultants;
	module.exports = exports['default'];

/***/ }),

/***/ 2173:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _ramda = __webpack_require__(27);
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _modulesAutoBind = __webpack_require__(29);
	
	var _modulesAutoBind2 = _interopRequireDefault(_modulesAutoBind);
	
	var _modulesNumberInputJsx = __webpack_require__(134);
	
	var _modulesNumberInputJsx2 = _interopRequireDefault(_modulesNumberInputJsx);
	
	var CreateConsultantForm = (function (_React$Component) {
	  _inherits(CreateConsultantForm, _React$Component);
	
	  function CreateConsultantForm(props) {
	    _classCallCheck(this, CreateConsultantForm);
	
	    _get(Object.getPrototypeOf(CreateConsultantForm.prototype), 'constructor', this).call(this, props);
	    (0, _modulesAutoBind2['default'])(this);
	  }
	
	  _createClass(CreateConsultantForm, [{
	    key: 'render',
	    value: function render() {
	      return _react2['default'].createElement(
	        'form',
	        null,
	        this.renderInput('Nombre', 'name'),
	        this.renderInput('Email', 'username'),
	        this.renderNumberInput('Licencias', 'totallicenses')
	      );
	    }
	  }, {
	    key: 'renderInput',
	    value: function renderInput(label, id) {
	      var input = _react2['default'].createElement('input', { type: 'text', value: this.props.value[id], onChange: this.handleChange(id, (0, _ramda.path)(['target', 'value'])) });
	      return this.renderRow(label, input);
	    }
	  }, {
	    key: 'renderNumberInput',
	    value: function renderNumberInput(label, id) {
	      var input = _react2['default'].createElement(_modulesNumberInputJsx2['default'], { value: this.props.value.totallicenses, onChange: this.handleChange('totallicenses', _ramda.identity), min: '0', max: '100' });
	      return this.renderRow(label, input);
	    }
	  }, {
	    key: 'renderRow',
	    value: function renderRow(label, input) {
	      return _react2['default'].createElement(
	        'div',
	        { className: 'row form-group' },
	        _react2['default'].createElement(
	          'label',
	          { className: 'col-xs-3 col-xs-offset-2', style: { textAlign: 'right' } },
	          label
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'col-xs-6' },
	          input
	        )
	      );
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange(field, getValue) {
	      var _this = this;
	
	      return function (event) {
	        var value = getValue(event);
	        _this.props.onChange((0, _ramda.merge)(_this.props.value, _defineProperty({}, field, value)));
	      };
	    }
	  }]);
	
	  return CreateConsultantForm;
	})(_react2['default'].Component);
	
	exports['default'] = CreateConsultantForm;
	module.exports = exports['default'];

/***/ }),

/***/ 2174:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _ramda = __webpack_require__(27);
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _modulesAutoBind = __webpack_require__(29);
	
	var _modulesAutoBind2 = _interopRequireDefault(_modulesAutoBind);
	
	var _modulesNumberInputJsx = __webpack_require__(134);
	
	var _modulesNumberInputJsx2 = _interopRequireDefault(_modulesNumberInputJsx);
	
	var _modulesSpinnerJsx = __webpack_require__(153);
	
	var _modulesSpinnerJsx2 = _interopRequireDefault(_modulesSpinnerJsx);
	
	var _reactBootstrapLibAlert = __webpack_require__(252);
	
	var _reactBootstrapLibAlert2 = _interopRequireDefault(_reactBootstrapLibAlert);
	
	var EditConsultantForm = (function (_React$Component) {
	  _inherits(EditConsultantForm, _React$Component);
	
	  function EditConsultantForm(props) {
	    _classCallCheck(this, EditConsultantForm);
	
	    _get(Object.getPrototypeOf(EditConsultantForm.prototype), 'constructor', this).call(this, props);
	    (0, _modulesAutoBind2['default'])(this);
	    this.state = {
	      errorMessage: null
	    };
	  }
	
	  _createClass(EditConsultantForm, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this = this;
	
	      $.ajax({
	        url: this.props.resourceUrl,
	        method: 'GET'
	      }).done(function (consultantResource) {
	        return _this.setState({ consultantResource: consultantResource });
	      }).fail(function () {
	        return _this.setState({ errorMessage: 'No se encontró el consultor.' });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      if (this.state.errorMessage) {
	        return _react2['default'].createElement(
	          _reactBootstrapLibAlert2['default'],
	          { bsStyle: 'danger', onDismiss: function () {
	              return _this2.setState({ errorMessage: null });
	            } },
	          this.state.errorMessage
	        );
	      }
	
	      if (!this.state.consultantResource) {
	        return _react2['default'].createElement(_modulesSpinnerJsx2['default'], null);
	      }
	
	      return _react2['default'].createElement(
	        'form',
	        null,
	        this.renderNumberInput('Licencias', 'totallicenses')
	      );
	    }
	  }, {
	    key: 'renderInput',
	    value: function renderInput(label, id) {
	      var input = _react2['default'].createElement('input', { type: 'text', value: this.state.consultantResource[id], onChange: this.handleChange(id, (0, _ramda.path)(['target', 'value'])) });
	      return this.renderRow(label, input);
	    }
	  }, {
	    key: 'renderNumberInput',
	    value: function renderNumberInput(label, id) {
	      var input = _react2['default'].createElement(_modulesNumberInputJsx2['default'], { value: this.state.consultantResource[id], onChange: this.handleChange('totallicenses', _ramda.identity), min: this.state.consultantResource.usedlicenses, max: '10000' });
	      return this.renderRow(label, input);
	    }
	  }, {
	    key: 'renderRow',
	    value: function renderRow(label, input) {
	      return _react2['default'].createElement(
	        'div',
	        { className: 'row form-group' },
	        _react2['default'].createElement(
	          'label',
	          { className: 'col-xs-3 col-xs-offset-2', style: { textAlign: 'right' } },
	          label
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'col-xs-6' },
	          input
	        )
	      );
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange(field, getValue) {
	      var _this3 = this;
	
	      return function (event) {
	        var value = getValue(event);
	        _this3.setState({ consultantResource: (0, _ramda.merge)(_this3.state.consultantResource, _defineProperty({}, field, value)) });
	        _this3.props.onChange((0, _ramda.mergeAll)([_this3.props.value, _this3.state.consultantResource, _defineProperty({}, field, value)]));
	      };
	    }
	  }]);
	
	  return EditConsultantForm;
	})(_react2['default'].Component);
	
	exports['default'] = EditConsultantForm;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(35)))

/***/ }),

/***/ 2175:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _ramda = __webpack_require__(27);
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _modulesAutoBind = __webpack_require__(29);
	
	var _modulesAutoBind2 = _interopRequireDefault(_modulesAutoBind);
	
	var _modulesNumberInputJsx = __webpack_require__(134);
	
	var _modulesNumberInputJsx2 = _interopRequireDefault(_modulesNumberInputJsx);
	
	var CreateLicenseRequestForm = (function (_React$Component) {
	  _inherits(CreateLicenseRequestForm, _React$Component);
	
	  function CreateLicenseRequestForm(props) {
	    _classCallCheck(this, CreateLicenseRequestForm);
	
	    _get(Object.getPrototypeOf(CreateLicenseRequestForm.prototype), 'constructor', this).call(this, props);
	    (0, _modulesAutoBind2['default'])(this);
	    this.state = {
	      licenseNum: 1
	    };
	  }
	
	  _createClass(CreateLicenseRequestForm, [{
	    key: 'render',
	    value: function render() {
	      return _react2['default'].createElement(
	        'form',
	        null,
	        this.renderInput('Usuario', 'username'),
	        this.renderInput('Licencias a agregar', 'licenseNum')
	      );
	    }
	  }, {
	    key: 'renderInput',
	    value: function renderInput(label, id) {
	      var input = _react2['default'].createElement('input', { type: 'text', value: this.props.value[id], onChange: this.handleChange(id, (0, _ramda.path)(['target', 'value'])) });
	      return this.renderRow(label, input);
	    }
	  }, {
	    key: 'renderRow',
	    value: function renderRow(label, input) {
	      return _react2['default'].createElement(
	        'div',
	        { className: 'row form-group' },
	        _react2['default'].createElement(
	          'label',
	          { className: 'col-xs-3 col-xs-offset-2', style: { textAlign: 'right' } },
	          label
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'col-xs-6' },
	          input
	        )
	      );
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange(field, getValue) {
	      var _this = this;
	
	      return function (event) {
	        var value = getValue(event);
	        _this.props.onChange((0, _ramda.merge)(_this.props.value, _defineProperty({}, field, value)));
	      };
	    }
	  }]);
	
	  return CreateLicenseRequestForm;
	})(_react2['default'].Component);
	
	exports['default'] = CreateLicenseRequestForm;
	module.exports = exports['default'];

/***/ }),

/***/ 2176:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _ramda = __webpack_require__(27);
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _modulesAutoBind = __webpack_require__(29);
	
	var _modulesAutoBind2 = _interopRequireDefault(_modulesAutoBind);
	
	var _modulesNumberInputJsx = __webpack_require__(134);
	
	var _modulesNumberInputJsx2 = _interopRequireDefault(_modulesNumberInputJsx);
	
	var EditLicenseRequestForm = (function (_React$Component) {
	  _inherits(EditLicenseRequestForm, _React$Component);
	
	  function EditLicenseRequestForm(props) {
	    _classCallCheck(this, EditLicenseRequestForm);
	
	    _get(Object.getPrototypeOf(EditLicenseRequestForm.prototype), 'constructor', this).call(this, props);
	    (0, _modulesAutoBind2['default'])(this);
	    this.state = {
	      licenseNum: 1
	    };
	  }
	
	  _createClass(EditLicenseRequestForm, [{
	    key: 'render',
	    value: function render() {
	      return _react2['default'].createElement(
	        'form',
	        null,
	        this.renderInput('Licencias a agregar', 'licenseRequest')
	      );
	    }
	  }, {
	    key: 'renderInput',
	    value: function renderInput(label, id) {
	      var input = _react2['default'].createElement('input', { type: 'text', value: this.props.value[id], onChange: this.handleChange(id, (0, _ramda.path)(['target', 'value'])) });
	      return this.renderRow(label, input);
	    }
	  }, {
	    key: 'renderRow',
	    value: function renderRow(label, input) {
	      return _react2['default'].createElement(
	        'div',
	        { className: 'row form-group' },
	        _react2['default'].createElement(
	          'label',
	          { className: 'col-xs-3 col-xs-offset-2', style: { textAlign: 'right' } },
	          label
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'col-xs-6' },
	          input
	        )
	      );
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange(field, getValue) {
	      var _this = this;
	
	      return function (event) {
	        var value = getValue(event);
	        _this.props.onChange((0, _ramda.merge)(_this.props.value, _defineProperty({}, field, value)));
	      };
	    }
	  }]);
	
	  return EditLicenseRequestForm;
	})(_react2['default'].Component);
	
	exports['default'] = EditLicenseRequestForm;
	module.exports = exports['default'];

/***/ }),

/***/ 2177:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x2, _x3, _x4) { var _again = true; _function: while (_again) { var object = _x2, property = _x3, receiver = _x4; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x2 = parent; _x3 = property; _x4 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _ramda = __webpack_require__(27);
	
	var _ramda2 = _interopRequireDefault(_ramda);
	
	var _jquery = __webpack_require__(35);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bluebird = __webpack_require__(225);
	
	var _bluebird2 = _interopRequireDefault(_bluebird);
	
	var _reactBootstrapLibModal = __webpack_require__(413);
	
	var _reactBootstrapLibModal2 = _interopRequireDefault(_reactBootstrapLibModal);
	
	var _reactBootstrapLibAlert = __webpack_require__(252);
	
	var _reactBootstrapLibAlert2 = _interopRequireDefault(_reactBootstrapLibAlert);
	
	var _modulesAutoBind = __webpack_require__(29);
	
	var _modulesAutoBind2 = _interopRequireDefault(_modulesAutoBind);
	
	var _common = __webpack_require__(95);
	
	var _modulesSpinnerJsx = __webpack_require__(153);
	
	var _modulesSpinnerJsx2 = _interopRequireDefault(_modulesSpinnerJsx);
	
	var _usersTableJsx = __webpack_require__(663);
	
	var _usersTableJsx2 = _interopRequireDefault(_usersTableJsx);
	
	var _CreateLicenseRequestFormJsx = __webpack_require__(2175);
	
	var _CreateLicenseRequestFormJsx2 = _interopRequireDefault(_CreateLicenseRequestFormJsx);
	
	var _EditLicenseRequestFormJsx = __webpack_require__(2176);
	
	var _EditLicenseRequestFormJsx2 = _interopRequireDefault(_EditLicenseRequestFormJsx);
	
	var _reactBootstrapLibPagination = __webpack_require__(414);
	
	var _reactBootstrapLibPagination2 = _interopRequireDefault(_reactBootstrapLibPagination);
	
	var pageSize = 20;
	var columns = [{ id: 'id', label: 'ID', maxWidth: 1 }, { id: 'name', label: 'Nombre', maxWidth: 4 }, { id: 'username', label: 'Correo', maxWidth: 4 }, { id: 'licenseRequest', label: 'Lic. Pedidas', maxWidth: 1 }];
	
	var LicenseRequests = (function (_React$Component) {
	  _inherits(LicenseRequests, _React$Component);
	
	  function LicenseRequests(props) {
	    _classCallCheck(this, LicenseRequests);
	
	    _get(Object.getPrototypeOf(LicenseRequests.prototype), 'constructor', this).call(this, props);
	    (0, _modulesAutoBind2['default'])(this);
	    this.state = {
	      creatingLicenseRequest: false,
	      edittingLicenseRequest: false,
	      sortColumn: 'id',
	      sortOrder: 'asc',
	      selectedRow: null,
	      page: 0
	    };
	  }
	
	  _createClass(LicenseRequests, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.fetchLicenseRequests(this.props.resourceUrl);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this = this;
	
	      if (!this.state.licenseRequestsResource && this.state.loadingLicenseRequests) {
	        return _react2['default'].createElement(_modulesSpinnerJsx2['default'], null);
	      }
	
	      if (!this.state.licenseRequestsResource && !this.state.loadingLicenseRequests) {
	        return _react2['default'].createElement(
	          'div',
	          null,
	          this.state.errorMessage
	        );
	      }
	
	      var resource = this.state.licenseRequestsResource;
	      var selectedIndex = this.state.selectedRow ? this.state.selectedRow.index : null;
	      var data = this.state.loadingLicenseRequests ? [] : resource.licenseRequests;
	
	      return _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement(
	          'button',
	          { type: 'button', className: 'btn btn-success', style: { display: 'none', marginRight: '10px' }, onClick: this.handleOpenCreateLicenseRequestModal },
	          'Crear Petición'
	        ),
	        this.state.selectedRow !== null ? _react2['default'].createElement(
	          'button',
	          { type: 'button', className: 'btn btn-info', style: { marginRight: '10px' }, onClick: this.handleOpenDeleteLicenseRequestModal },
	          'Eliminar Peticion'
	        ) : '',
	        this.state.selectedRow !== null ? _react2['default'].createElement(
	          'button',
	          { type: 'button', className: 'btn btn-info', style: { marginRight: '10px' }, onClick: this.handleOpenAcceptLicenseRequestModal },
	          'Aceptar Peticion'
	        ) : '',
	        this.state.selectedRow !== null ? _react2['default'].createElement(
	          'button',
	          { type: 'button', className: 'btn btn-info', style: { marginRight: '10px' }, onClick: this.handleOpenEditLicenseRequestModal },
	          'Editar y Aceptar Peticion'
	        ) : '',
	        this.state.licenseRequest ? this.renderCreateLicenseRequestModal() : '',
	        this.state.deleteLicenseRequest ? this.renderDeleteLicenseRequestModal() : '',
	        this.state.acceptLicenseRequest ? this.renderAcceptLicenseRequestModal() : '',
	        this.state.editLicenseRequest ? this.renderEditLicenseRequestModal() : '',
	        _react2['default'].createElement(_usersTableJsx2['default'], {
	          columns: columns,
	          sort: { column: this.state.sortColumn, order: this.state.sortOrder },
	          data: data,
	          selectedIndex: selectedIndex,
	          onSort: this.handleSortChange,
	          onRowClick: function (event) {
	            return _this.setState({ selectedRow: event });
	          },
	          onRowDoubleClick: function () {}
	        }),
	        resource.total > pageSize ? _react2['default'].createElement(
	          'center',
	          null,
	          _react2['default'].createElement(_reactBootstrapLibPagination2['default'], {
	            prev: this.state.page !== 0,
	            next: (this.state.page + 1) * pageSize <= resource.total,
	            first: this.state.page !== 0,
	            last: (this.state.page + 1) * pageSize <= resource.total,
	            bsSize: 'medium',
	            maxButtons: 10,
	            items: Math.ceil(resource.total / pageSize),
	            activePage: this.state.page + 1,
	            onSelect: this.handlePageChange })
	        ) : ''
	      );
	    }
	  }, {
	    key: 'handleSortChange',
	    value: function handleSortChange(_ref) {
	      var _this2 = this;
	
	      var column = _ref.column;
	      var order = _ref.order;
	
	      var prevColumn = this.state.sortColumn,
	          prevOrder = this.state.sortOrder;
	      this.setState({ sortColumn: column, sortOrder: order });
	      var url = this.state.licenseRequestsResource._rels.sort.replace('{sort}', column).replace('{order}', order);
	      this.fetchLicenseRequests(url, this.state.page)['catch'](function () {
	        return _this2.setState({ sortColumn: prevColumn, sortOrder: prevOrder });
	      });
	    }
	  }, {
	    key: 'handlePageChange',
	    value: function handlePageChange(eventKey) {
	      var page = eventKey - 1;
	      this.fetchLicenseRequests(this.state.licenseRequestsResource._rels.getPage.replace('{pageNum}', page), page);
	    }
	  }, {
	    key: 'fetchLicenseRequests',
	    value: function fetchLicenseRequests(url) {
	      var _this3 = this;
	
	      var page = arguments.length <= 1 || arguments[1] === undefined ? 0 : arguments[1];
	
	      if (this.state.loadingLicenseRequests) {
	        return _bluebird2['default'].reject('Already fetching licenseRequests.');
	      }
	      var prevPage = this.state.page;
	      this.setState({ loadingLicenseRequests: true, selectedRow: null, page: page });
	
	      return _bluebird2['default'].resolve(_jquery2['default'].ajax({ url: url })).then(function (licenseRequestsResource) {
	        return _this3.setState({ licenseRequestsResource: licenseRequestsResource });
	      })['catch'](function () {
	        return _this3.setState({ page: prevPage, errorMessage: 'Hubo un error al cargar las peticiones.' });
	      })['finally'](function () {
	        return _this3.setState({ loadingLicenseRequests: false });
	      });
	    }
	  }, {
	    key: 'handleOpenCreateLicenseRequestModal',
	    value: function handleOpenCreateLicenseRequestModal() {
	      this.setState({ licenseRequest: { username: '', licenseNum: 1 } });
	    }
	  }, {
	    key: 'handleOpenEditLicenseRequestModal',
	    value: function handleOpenEditLicenseRequestModal() {
	      this.setState({ editLicenseRequest: this.state.selectedRow.row });
	    }
	  }, {
	    key: 'handleOpenDeleteLicenseRequestModal',
	    value: function handleOpenDeleteLicenseRequestModal() {
	      this.setState({ deleteLicenseRequest: this.state.selectedRow.row });
	    }
	  }, {
	    key: 'handleOpenAcceptLicenseRequestModal',
	    value: function handleOpenAcceptLicenseRequestModal() {
	      this.setState({ acceptLicenseRequest: this.state.selectedRow.row });
	    }
	  }, {
	    key: 'handleAcceptLicenseRequest',
	    value: function handleAcceptLicenseRequest(event) {
	      var _this4 = this;
	
	      event.preventDefault();
	      this.setState({ acceptingLicenseRequest: true });
	      var url = this.props.resourceUrl + "/accept/";
	
	      return _bluebird2['default'].resolve(_jquery2['default'].ajax({
	        url: url,
	        data: this.state.acceptLicenseRequest,
	        method: 'POST'
	      })).then(function () {
	        _this4.setState({ acceptLicenseRequest: null });
	        _this4.fetchLicenseRequests(_this4.state.licenseRequestsResource._rels.self, _this4.state.page);
	      })['finally'](function () {
	        return _this4.setState({ acceptingLicenseRequest: false });
	      });
	    }
	  }, {
	    key: 'handleCreateLicenseRequest',
	    value: function handleCreateLicenseRequest(event) {
	      var _this5 = this;
	
	      event.preventDefault();
	      this.setState({ creatingLicenseRequest: true });
	
	      return _bluebird2['default'].resolve(_jquery2['default'].ajax({
	        url: this.props.resourceUrl,
	        method: 'POST',
	        data: this.state.licenseRequest
	      })).then(function () {
	        _this5.setState({ licenseRequest: null, modalErrorMessage: null });
	        _this5.fetchLicenseRequests(_this5.state.licenseRequestsResource._rels.self, _this5.state.page);
	      })['catch'](function () {
	        return _this5.setState({ modalErrorMessage: 'Hubo un error al crear la petición.' });
	      })['finally'](function () {
	        return _this5.setState({ creatingLicenseRequest: false });
	      });
	    }
	  }, {
	    key: 'handleEditLicenseRequest',
	    value: function handleEditLicenseRequest(event) {
	      var _this6 = this;
	
	      event.preventDefault();
	      this.setState({ edittingLicenseRequest: true });
	      var url = this.props.resourceUrl + "/accept/";
	
	      return _bluebird2['default'].resolve(_jquery2['default'].ajax({
	        url: url,
	        data: this.state.editLicenseRequest,
	        method: 'POST'
	      })).then(function () {
	        _this6.setState({ editLicenseRequest: null, modalErrorMessage: null });
	        _this6.fetchLicenseRequests(_this6.state.licenseRequestsResource._rels.self, _this6.state.page);
	      })['catch'](function () {
	        return _this6.setState({ modalErrorMessage: 'Hubo un error al crear la petición.' });
	      })['finally'](function () {
	        return _this6.setState({ edittingLicenseRequest: false });
	      });
	    }
	  }, {
	    key: 'handleDeleteLicenseRequest',
	    value: function handleDeleteLicenseRequest(event) {
	      var _this7 = this;
	
	      event.preventDefault();
	      this.setState({ deletingLicenseRequest: true });
	      var url = this.props.resourceUrl + "/delete/";
	
	      return _bluebird2['default'].resolve(_jquery2['default'].ajax({
	        url: url,
	        data: this.state.deleteLicenseRequest,
	        method: 'POST'
	      })).then(function () {
	        _this7.setState({ deleteLicenseRequest: null });
	        _this7.fetchLicenseRequests(_this7.state.licenseRequestsResource._rels.self, _this7.state.page);
	      })['finally'](function () {
	        return _this7.setState({ deletingLicenseRequest: false });
	      });
	    }
	  }, {
	    key: 'renderDeleteLicenseRequestModal',
	    value: function renderDeleteLicenseRequestModal() {
	      var _this8 = this;
	
	      var closeModal = function closeModal() {
	        return _this8.setState({ deleteLicenseRequest: null });
	      };
	
	      return _react2['default'].createElement(
	        _reactBootstrapLibModal2['default'],
	        { show: true, onHide: closeModal },
	        _react2['default'].createElement(
	          _reactBootstrapLibModal2['default'].Header,
	          { closeButton: true },
	          _react2['default'].createElement(
	            _reactBootstrapLibModal2['default'].Title,
	            null,
	            'Eliminar Petición'
	          )
	        ),
	        _react2['default'].createElement(
	          _reactBootstrapLibModal2['default'].Body,
	          null,
	          '¿Estás seguro de querer eliminar la petición de ',
	          this.state.deleteLicenseRequest.name,
	          '?'
	        ),
	        _react2['default'].createElement(
	          _reactBootstrapLibModal2['default'].Footer,
	          null,
	          _react2['default'].createElement(
	            'button',
	            { type: 'button', className: 'btn btn-danger', onClick: closeModal },
	            'Cancelar'
	          ),
	          _react2['default'].createElement(
	            'button',
	            { type: 'submit', className: 'btn btn-success', onClick: this.handleDeleteLicenseRequest, disabled: this.state.deletingLicenseRequest },
	            'Eliminar'
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderCreateLicenseRequestModal',
	    value: function renderCreateLicenseRequestModal() {
	      var _this9 = this;
	
	      var closeModal = function closeModal() {
	        return _this9.setState({ licenseRequest: null, modalErrorMessage: null });
	      };
	      var validLicenseRequestForm = function validLicenseRequestForm() {
	        return _ramda2['default'].is(Object, _this9.state.licenseRequest) && _common.validations.email(_this9.state.licenseRequest.username);
	      };
	
	      return _react2['default'].createElement(
	        _reactBootstrapLibModal2['default'],
	        { show: true, onHide: closeModal },
	        _react2['default'].createElement(
	          _reactBootstrapLibModal2['default'].Header,
	          { closeButton: true },
	          _react2['default'].createElement(
	            _reactBootstrapLibModal2['default'].Title,
	            null,
	            'Crear Petición'
	          )
	        ),
	        _react2['default'].createElement(
	          _reactBootstrapLibModal2['default'].Body,
	          null,
	          this.state.modalErrorMessage ? _react2['default'].createElement(
	            _reactBootstrapLibAlert2['default'],
	            { bsStyle: 'danger', onDismiss: function () {
	                return _this9.setState({ modalErrorMessage: null });
	              } },
	            this.state.modalErrorMessage
	          ) : '',
	          _react2['default'].createElement(_CreateLicenseRequestFormJsx2['default'], { value: this.state.licenseRequest, onChange: function (formChange) {
	              return _this9.setState({ licenseRequest: formChange });
	            } })
	        ),
	        _react2['default'].createElement(
	          _reactBootstrapLibModal2['default'].Footer,
	          null,
	          _react2['default'].createElement(
	            'button',
	            { type: 'button', className: 'btn btn-danger', onClick: closeModal },
	            'Cancelar'
	          ),
	          _react2['default'].createElement(
	            'button',
	            { type: 'submit', className: 'btn btn-success', onClick: this.handleCreateLicenseRequest, disabled: !validLicenseRequestForm() || this.state.creatingLicenseRequest },
	            'Crear'
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderAcceptLicenseRequestModal',
	    value: function renderAcceptLicenseRequestModal() {
	      var _this10 = this;
	
	      var closeModal = function closeModal() {
	        return _this10.setState({ acceptLicenseRequest: null });
	      };
	
	      return _react2['default'].createElement(
	        _reactBootstrapLibModal2['default'],
	        { show: true, onHide: closeModal },
	        _react2['default'].createElement(
	          _reactBootstrapLibModal2['default'].Header,
	          { closeButton: true },
	          _react2['default'].createElement(
	            _reactBootstrapLibModal2['default'].Title,
	            null,
	            'Aceptar Petición'
	          )
	        ),
	        _react2['default'].createElement(
	          _reactBootstrapLibModal2['default'].Body,
	          null,
	          '¿Estás seguro de querer aceptar la petición de ',
	          this.state.acceptLicenseRequest.name,
	          '?'
	        ),
	        _react2['default'].createElement(
	          _reactBootstrapLibModal2['default'].Footer,
	          null,
	          _react2['default'].createElement(
	            'button',
	            { type: 'button', className: 'btn btn-danger', onClick: closeModal },
	            'Cancelar'
	          ),
	          _react2['default'].createElement(
	            'button',
	            { type: 'submit', className: 'btn btn-success', onClick: this.handleAcceptLicenseRequest, disabled: this.state.acceptingLicenseRequest },
	            'Aceptar'
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderEditLicenseRequestModal',
	    value: function renderEditLicenseRequestModal() {
	      var _this11 = this;
	
	      var closeModal = function closeModal() {
	        return _this11.setState({ editLicenseRequest: null, modalErrorMessage: null });
	      };
	      var validLicenseRequestForm = function validLicenseRequestForm() {
	        return _ramda2['default'].is(Object, _this11.state.editLicenseRequest) && _common.validations.email(_this11.state.editLicenseRequest.username);
	      };
	
	      return _react2['default'].createElement(
	        _reactBootstrapLibModal2['default'],
	        { show: true, onHide: closeModal },
	        _react2['default'].createElement(
	          _reactBootstrapLibModal2['default'].Header,
	          { closeButton: true },
	          _react2['default'].createElement(
	            _reactBootstrapLibModal2['default'].Title,
	            null,
	            'Editar y Acpetar Petición'
	          )
	        ),
	        _react2['default'].createElement(
	          _reactBootstrapLibModal2['default'].Body,
	          null,
	          this.state.modalErrorMessage ? _react2['default'].createElement(
	            _reactBootstrapLibAlert2['default'],
	            { bsStyle: 'danger', onDismiss: function () {
	                return _this11.setState({ modalErrorMessage: null });
	              } },
	            this.state.modalErrorMessage
	          ) : '',
	          _react2['default'].createElement(_EditLicenseRequestFormJsx2['default'], { value: this.state.editLicenseRequest, onChange: function (formChange) {
	              return _this11.setState({ editLicenseRequest: formChange });
	            } })
	        ),
	        _react2['default'].createElement(
	          _reactBootstrapLibModal2['default'].Footer,
	          null,
	          _react2['default'].createElement(
	            'button',
	            { type: 'button', className: 'btn btn-danger', onClick: closeModal },
	            'Cancelar'
	          ),
	          _react2['default'].createElement(
	            'button',
	            { type: 'submit', className: 'btn btn-success', onClick: this.handleEditLicenseRequest, disabled: !validLicenseRequestForm() || this.state.edittingLicenseRequest },
	            'Aceptar'
	          )
	        )
	      );
	    }
	  }]);
	
	  return LicenseRequests;
	})(_react2['default'].Component);
	
	exports['default'] = LicenseRequests;
	module.exports = exports['default'];

/***/ }),

/***/ 2178:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _ramda = __webpack_require__(27);
	
	var _ramda2 = _interopRequireDefault(_ramda);
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _modulesAutoBind = __webpack_require__(29);
	
	var _modulesAutoBind2 = _interopRequireDefault(_modulesAutoBind);
	
	var OrderedSelect = (function (_React$Component) {
	  _inherits(OrderedSelect, _React$Component);
	
	  function OrderedSelect(props) {
	    _classCallCheck(this, OrderedSelect);
	
	    _get(Object.getPrototypeOf(OrderedSelect.prototype), 'constructor', this).call(this, props);
	    (0, _modulesAutoBind2['default'])(this);
	    this.state = {};
	  }
	
	  _createClass(OrderedSelect, [{
	    key: 'render',
	    value: function render() {
	      var _this = this;
	
	      var getClasses = function getClasses(index) {
	        return ['btn', 'btn-default'].concat(_toConsumableArray(_ramda2['default'].contains(index + 1, _this.props.selections) ? ['active'] : []), _toConsumableArray(_this.props.editable ? [] : ['disabled'])).join(' ');
	      };
	      var getBgColor = function getBgColor(index) {
	        return ['#FFFFFF', '#5BC0DE', '#FF0000'][_this.props.selections.indexOf(index + 1) + 1];
	      };
	      return _react2['default'].createElement(
	        'div',
	        { style: { margin: '30px 20px', backgroundColor: '#EEEEEE', padding: '20px 30px', borderRadius: '10px' } },
	        _react2['default'].createElement(
	          'b',
	          { style: { margin: '5px' } },
	          this.props.text
	        ),
	        _react2['default'].createElement(
	          'center',
	          null,
	          this.props.options.map(function (option, index) {
	            return _react2['default'].createElement(
	              'span',
	              { key: index, className: getClasses(index), onKeyPress: this.handleKeyPress(index), style: { cursor: this.props.editable ? 'pointer' : '', backgroundColor: getBgColor(index), margin: '5px 0px', width: '100%' }, onClick: this.props.editable && this.handleClick(index), tabIndex: '0' },
	              option
	            );
	          }, this)
	        )
	      );
	    }
	  }, {
	    key: 'handleKeyPress',
	    value: function handleKeyPress(index) {
	      var _this2 = this;
	
	      return function (event) {
	        if (event.keyCode === 0 || event.keyCode === 32) {
	          event.preventDefault();
	          _this2.handleClick(index)();
	        }
	      };
	    }
	  }, {
	    key: 'handleClick',
	    value: function handleClick(index) {
	      var _this3 = this;
	
	      return function () {
	        var newSelections = undefined;
	        if (index + 1 === _this3.props.selections[0]) {
	          newSelections = [0, 0];
	        } else if (index + 1 === _this3.props.selections[1]) {
	          newSelections = [_this3.props.selections[0], 0];
	        } else if (_this3.props.selections.filter(_ramda2['default'].identity).length === 2) {
	          newSelections = [_this3.props.selections[0], index + 1];
	        } else {
	          newSelections = [].concat(_toConsumableArray(_this3.props.selections.filter(_ramda2['default'].identity)), [index + 1]);
	          if (newSelections.length === 1) {
	            newSelections.push(0);
	          }
	        }
	
	        _this3.props.onChange(newSelections);
	      };
	    }
	  }]);
	
	  return OrderedSelect;
	})(_react2['default'].Component);
	
	exports['default'] = OrderedSelect;
	module.exports = exports['default'];

/***/ }),

/***/ 2179:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _ramda = __webpack_require__(27);
	
	var _ramda2 = _interopRequireDefault(_ramda);
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _modulesAutoBind = __webpack_require__(29);
	
	var _modulesAutoBind2 = _interopRequireDefault(_modulesAutoBind);
	
	var _modulesNumberInputJsx = __webpack_require__(134);
	
	var _modulesNumberInputJsx2 = _interopRequireDefault(_modulesNumberInputJsx);
	
	var _common = __webpack_require__(95);
	
	var PersonalDataForm = (function (_React$Component) {
	  _inherits(PersonalDataForm, _React$Component);
	
	  function PersonalDataForm(props) {
	    _classCallCheck(this, PersonalDataForm);
	
	    _get(Object.getPrototypeOf(PersonalDataForm.prototype), 'constructor', this).call(this, props);
	    (0, _modulesAutoBind2['default'])(this);
	    this.editable = this.props.editable !== false;
	    this.state = {};
	    this.enableLeaveMessage();
	  }
	
	  _createClass(PersonalDataForm, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.enableLeaveMessage();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.onbeforeunload = null;
	    }
	  }, {
	    key: 'enableLeaveMessage',
	    value: function enableLeaveMessage() {
	      if (this.props.canSave) {
	        window.onbeforeunload = function (event) {
	          return (event || window.event).returnValue = 'Tienes cambios sin guardar.';
	        };
	      } else {
	        window.onbeforeunload = null;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this = this;
	
	      var complete = _common.validations.validateObject(_ramda2['default'].pick(['name', 'company', 'age'], _common.validations), this.props.value);
	      var incompleteError = function incompleteError() {
	        return alert('Faltan campos de llenar.');
	      };
	      var continueClasses = 'btn btn-lg btn-success';
	      if (!complete) {
	        continueClasses += ' disabled';
	      }
	
	      return _react2['default'].createElement(
	        'form',
	        { style: { marginTop: '50px' } },
	        _react2['default'].createElement(
	          'div',
	          { className: 'row', style: { margin: '25px' } },
	          _react2['default'].createElement(
	            'div',
	            { className: 'col-xs-10 col-xs-offset-1' },
	            _react2['default'].createElement(
	              'h3',
	              null,
	              'Completa tus datos personales'
	            )
	          )
	        ),
	        this.renderRow(_react2['default'].createElement(
	          'label',
	          null,
	          'Nombre'
	        ), _react2['default'].createElement('input', { type: 'text', value: this.props.value.name || "", onChange: function (e) {
	            return _this.props.onChange(_ramda2['default'].merge(_this.props.value, { name: e.target.value }));
	          } })),
	        this.renderRow(_react2['default'].createElement(
	          'label',
	          null,
	          'Edad'
	        ), _react2['default'].createElement(_modulesNumberInputJsx2['default'], { value: this.props.value.age, onChange: function (age) {
	            return _this.props.onChange(_ramda2['default'].merge(_this.props.value, { age: age }));
	          }, min: '0', max: '125' })),
	        this.renderRow(_react2['default'].createElement(
	          'label',
	          null,
	          'Sexo'
	        ), this.renderSexRadioButton()),
	        this.renderRow(_react2['default'].createElement(
	          'label',
	          null,
	          'Empresa'
	        ), _react2['default'].createElement('input', { type: 'text', value: this.props.value.company || "", onChange: function (e) {
	            return _this.props.onChange(_ramda2['default'].merge(_this.props.value, { company: e.target.value }));
	          } })),
	        this.editable ? _react2['default'].createElement(
	          'div',
	          { style: { textAlign: 'right' } },
	          _react2['default'].createElement(
	            'button',
	            { type: 'button', style: { display: 'inline-block', margin: '0px 10px' }, className: 'btn btn-lg btn-info', disabled: !this.props.canSave, onClick: this.props.onSave },
	            this.props.canSave ? 'Guardar' : 'Guardado'
	          ),
	          _react2['default'].createElement(
	            'button',
	            { type: 'button', style: { display: 'inline-block', margin: '0px 10px' }, className: continueClasses, onClick: complete ? this.props.onSubmit : incompleteError },
	            'Continuar'
	          )
	        ) : ''
	      );
	    }
	  }, {
	    key: 'renderSexRadioButton',
	    value: function renderSexRadioButton() {
	      var _this2 = this;
	
	      return _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement(
	          'div',
	          null,
	          _react2['default'].createElement('input', { type: 'radio', name: 'sex', value: 'Masculino', checked: this.props.value.sex === 'M', onChange: function () {
	              return _this2.props.onChange(_ramda2['default'].merge(_this2.props.value, { sex: 'M' }));
	            } }),
	          ' Masculino'
	        ),
	        _react2['default'].createElement(
	          'div',
	          null,
	          _react2['default'].createElement('input', { type: 'radio', name: 'sex', value: 'Femenino', checked: this.props.value.sex === 'F', onChange: function () {
	              _this2.props.onChange(_ramda2['default'].merge(_this2.props.value, { sex: 'F' }));
	            } }),
	          ' Femenino'
	        )
	      );
	    }
	  }, {
	    key: 'renderRow',
	    value: function renderRow(left, right) {
	      return _react2['default'].createElement(
	        'div',
	        { className: 'row', style: { margin: '25px' } },
	        _react2['default'].createElement(
	          'div',
	          { className: 'col-xs-10 col-xs-offset-1 col-md-4 col-md-offset-1' },
	          left
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'col-xs-10 col-xs-offset-1 col-md-4 col-md-offset-1' },
	          right
	        )
	      );
	    }
	  }]);
	
	  return PersonalDataForm;
	})(_react2['default'].Component);
	
	exports['default'] = PersonalDataForm;
	module.exports = exports['default'];

/***/ }),

/***/ 2180:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	exports['default'] = _react2['default'].createElement(
	  'div',
	  { style: { margin: '10px' } },
	  _react2['default'].createElement(
	    'h1',
	    null,
	    'Política de Privacidad'
	  ),
	  _react2['default'].createElement('br', null),
	  _react2['default'].createElement(
	    'p',
	    null,
	    _react2['default'].createElement(
	      'strong',
	      null,
	      'Le damos la bienvenida a la Política de privacidad de '
	    )
	  ),
	  _react2['default'].createElement(
	    'p',
	    null,
	    _react2['default'].createElement(
	      'strong',
	      null,
	      'Whitewater The Teaming Company'
	    )
	  ),
	  _react2['default'].createElement(
	    'p',
	    null,
	    'Cuando utiliza los servicios de Whitewater TTC, nos confía su información personal.'
	  ),
	  _react2['default'].createElement(
	    'p',
	    null,
	    'El objetivo de esta Política de privacidad es informarle sobre los datos que recolectamos y lo que hacemos con ellos. Para contestar los formularios es necesario que Usted esté de acuerdo con la presente política y marque el recuadro de “Aceptar” que se encuentra al final.'
	  ),
	  _react2['default'].createElement(
	    'p',
	    null,
	    'Su privacidad es importante para Whitewater TTC y si requiere mayor información puede ponerse en contacto con el consultor que lo está atendiendo.'
	  ),
	  _react2['default'].createElement('br', null),
	  _react2['default'].createElement(
	    'p',
	    null,
	    _react2['default'].createElement(
	      'strong',
	      null,
	      'Política de Privacidad'
	    )
	  ),
	  _react2['default'].createElement(
	    'p',
	    null,
	    'Cuando comparte su información personal con nosotros podemos identificar y mejorar los servicios que le brindamos.'
	  ),
	  _react2['default'].createElement(
	    'p',
	    null,
	    'Su información personal será utilizada para alguna de las siguientes finalidades: capacitación y desarrollo, coaching, reclutamiento y selección, apreciación de perfiles de personalidad.'
	  ),
	  _react2['default'].createElement(
	    'p',
	    null,
	    'La presente Política de privacidad describe:'
	  ),
	  _react2['default'].createElement(
	    'p',
	    null,
	    _react2['default'].createElement(
	      'ul',
	      null,
	      _react2['default'].createElement(
	        'li',
	        null,
	        'Qué datos recolectamos'
	      ),
	      _react2['default'].createElement(
	        'li',
	        null,
	        'Cómo utilizamos esos datos'
	      )
	    )
	  ),
	  _react2['default'].createElement('br', null),
	  _react2['default'].createElement(
	    'p',
	    null,
	    _react2['default'].createElement(
	      'strong',
	      null,
	      'Datos recolectados por Whitewater'
	    )
	  ),
	  _react2['default'].createElement(
	    'p',
	    null,
	    'Recopilamos información para ofrecer mejores servicios a todos nuestros usuarios: desde información básica, como su edad, hasta información de sus opiniones personales sobre temas de personalidad o negocio.'
	  ),
	  _react2['default'].createElement(
	    'p',
	    null,
	    'Recolectamos la siguiente información para identificar su Perfil de Personalidad XTNA®, Perfil de Personalidad Five Factors® y Perfil Motivacional APM®'
	  ),
	  _react2['default'].createElement(
	    'ul',
	    null,
	    _react2['default'].createElement(
	      'li',
	      null,
	      'Nombre completo.'
	    ),
	    _react2['default'].createElement(
	      'li',
	      null,
	      'Correo electrónico.'
	    ),
	    _react2['default'].createElement(
	      'li',
	      null,
	      'Edad.'
	    ),
	    _react2['default'].createElement(
	      'li',
	      null,
	      'Sexo.'
	    ),
	    _react2['default'].createElement(
	      'li',
	      null,
	      'Empresa u organización en donde trabaja o institución educativa en la que estudia.'
	    ),
	    _react2['default'].createElement(
	      'li',
	      null,
	      'Ciudad, estado y país en donde vive.'
	    )
	  ),
	  _react2['default'].createElement(
	    'p',
	    null,
	    'Esta información se asocia a su perfil de personalidad y para obtener este perfil solicitamos sus respuestas personales respeto a su estilo de conducta o su forma de pensar. Respecto al uso que hacemos con sus datos y respuestas por favor lea la siguiente sección “Cómo utilizamos los datos recolectados”.'
	  ),
	  _react2['default'].createElement(
	    'p',
	    null,
	    'Recolectamos la siguiente información para identificar el perfil de su equipo de trabajo u organización Team Profile Assessment®:'
	  ),
	  _react2['default'].createElement(
	    'ul',
	    null,
	    _react2['default'].createElement(
	      'li',
	      null,
	      'Nombre de la empresa u organización.'
	    ),
	    _react2['default'].createElement(
	      'li',
	      null,
	      'Equipo al que pertenece.'
	    ),
	    _react2['default'].createElement(
	      'li',
	      null,
	      'Puesto que desempeña.'
	    ),
	    _react2['default'].createElement(
	      'li',
	      null,
	      'Antigüedad en el puesto y/u organización.'
	    ),
	    _react2['default'].createElement(
	      'li',
	      null,
	      'Sexo.'
	    )
	  ),
	  _react2['default'].createElement(
	    'p',
	    null,
	    'Como podrá notar, para obtener los resultados de Team Profile Assessment® no solicitamos su nombre ni edad. Respecto al uso que hacemos con sus datos y respuestas por favor lea la siguiente sección “Cómo utilizamos los datos recolectados”.'
	  ),
	  _react2['default'].createElement('br', null),
	  _react2['default'].createElement(
	    'p',
	    null,
	    _react2['default'].createElement(
	      'strong',
	      null,
	      'Cómo utilizamos los datos recolectados'
	    )
	  ),
	  _react2['default'].createElement(
	    'p',
	    null,
	    'Utilizamos sus datos y respuestas personales para generar los perfiles de personalidad o el perfil de Equipo al que pertenece.'
	  ),
	  _react2['default'].createElement(
	    'p',
	    null,
	    'Sus respuestas particulares respecto a su conducta o sus opiniones sobre el equipo de trabajo en el que participa NO se comparte ni con los consultores que lo atienden, tampoco se comparte con personal de la empresa con la que trabaja (jefes o personal de recursos humanos).'
	  ),
	  _react2['default'].createElement(
	    'p',
	    null,
	    'También usamos la información para efectos estadísticos necesarios para la actualización de los baremos de personalidad como:'
	  ),
	  _react2['default'].createElement(
	    'ul',
	    null,
	    _react2['default'].createElement(
	      'li',
	      null,
	      'Perfil de personalidad de hombres mayores de 30 años.'
	    ),
	    _react2['default'].createElement(
	      'li',
	      null,
	      'Perfil de personalidad de mujeres en puestos ejecutivos.'
	    ),
	    _react2['default'].createElement(
	      'li',
	      null,
	      'Perfil de quipos de trabajo en plantas de producción de países determinados.'
	    ),
	    _react2['default'].createElement(
	      'li',
	      null,
	      'Similitudes y diferencias entre equipos comerciales y equipos de tecnología.'
	    )
	  ),
	  _react2['default'].createElement('br', null),
	  _react2['default'].createElement(
	    'p',
	    null,
	    _react2['default'].createElement(
	      'strong',
	      null,
	      'Seguridad de los datos'
	    )
	  ),
	  _react2['default'].createElement(
	    'p',
	    null,
	    'Whitewater lleva a cabo el tratamiento de los datos y respuestas personales en sus servidores, que están ubicados en Estados Unidos.'
	  ),
	  _react2['default'].createElement(
	    'p',
	    null,
	    'Nos esforzamos por proteger a Whitewater TTC y a nuestros usuarios frente a cualquier modificación, divulgación o destrucción no autorizada de los datos que conservamos o frente al acceso no autorizado a los mismos. En particular:'
	  ),
	  _react2['default'].createElement(
	    'p',
	    null,
	    _react2['default'].createElement(
	      'ul',
	      null,
	      _react2['default'].createElement(
	        'li',
	        null,
	        'Encriptamos muchos de nuestros servicios ',
	        _react2['default'].createElement(
	          'a',
	          { href: 'https://support.google.com/websearch/answer/173733?hl=es' },
	          'mediante el protocolo SSL'
	        ),
	        '.'
	      ),
	      _react2['default'].createElement(
	        'li',
	        null,
	        'Posibilitamos la seguridad de acceso mediante un único código de seguridad generado de forma exclusiva para Usted.'
	      ),
	      _react2['default'].createElement(
	        'li',
	        null,
	        'Revisamos nuestra política en materia de recogida, almacenamiento y tratamiento de datos, incluyendo las medidas de seguridad físicas, para impedir el acceso no autorizado a nuestros sistemas.'
	      ),
	      _react2['default'].createElement(
	        'li',
	        null,
	        'Limitamos el acceso de los consultores y empleados de Whitewater TTC a la información personal que deben procesar para obtener los reportes correspondientes de personalidad y nos aseguramos de que cumplan las estrictas obligaciones de confidencialidad contractuales y de que estén sujetos a las condiciones disciplinarias pertinentes o al despido si no cumplen dichas obligaciones.'
	      ),
	      _react2['default'].createElement(
	        'li',
	        null,
	        'Nuestra Política de Privacidad no regula las actividades de tratamiento de datos de otras empresas y organizaciones que anuncien nuestros servicios y puedan emplear cookies, contadores de visitas y otras tecnologías para publicar y ofrecer anuncios relevantes.'
	      )
	    )
	  ),
	  _react2['default'].createElement('br', null),
	  _react2['default'].createElement(
	    'p',
	    null,
	    _react2['default'].createElement(
	      'strong',
	      null,
	      'Mantenemos la privacidad y la seguridad de tu información personal, sobre la que tienes todo el control.'
	    )
	  ),
	  _react2['default'].createElement(
	    'p',
	    null,
	    _react2['default'].createElement('strong', null)
	  ),
	  _react2['default'].createElement('br', null),
	  _react2['default'].createElement('br', null),
	  _react2['default'].createElement(
	    'p',
	    null,
	    '© 2015 Whitewater The Teaming Company'
	  ),
	  _react2['default'].createElement(
	    'p',
	    null,
	    '© 2015 Los Expertos Entrenamiento Especializado, S.C.'
	  )
	);
	module.exports = exports['default'];

/***/ }),

/***/ 2181:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _ramda = __webpack_require__(27);
	
	var _ramda2 = _interopRequireDefault(_ramda);
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _modulesAutoBind = __webpack_require__(29);
	
	var _modulesAutoBind2 = _interopRequireDefault(_modulesAutoBind);
	
	var _QuestionnairesData = __webpack_require__(455);
	
	var _assetsModelo1Png = __webpack_require__(2812);
	
	var _assetsModelo1Png2 = _interopRequireDefault(_assetsModelo1Png);
	
	var _assetsModelo2Png = __webpack_require__(2813);
	
	var _assetsModelo2Png2 = _interopRequireDefault(_assetsModelo2Png);
	
	var _assetsModelo3Png = __webpack_require__(2814);
	
	var _assetsModelo3Png2 = _interopRequireDefault(_assetsModelo3Png);
	
	var _assetsModelo4Png = __webpack_require__(2815);
	
	var _assetsModelo4Png2 = _interopRequireDefault(_assetsModelo4Png);
	
	var _reactBootstrap = __webpack_require__(1675);
	
	var _reactCheckboxGroup = __webpack_require__(1690);
	
	var _reactRadioGroup = __webpack_require__(1735);
	
	var _modulesFooterJs = __webpack_require__(2190);
	
	var _modulesFooterJs2 = _interopRequireDefault(_modulesFooterJs);
	
	var FileSaver = __webpack_require__(745);
	
	var QuestionnaireBenziger = (function (_React$Component) {
	  _inherits(QuestionnaireBenziger, _React$Component);
	
	  function QuestionnaireBenziger(props) {
	    _classCallCheck(this, QuestionnaireBenziger);
	
	    _get(Object.getPrototypeOf(QuestionnaireBenziger.prototype), 'constructor', this).call(this, props);
	    (0, _modulesAutoBind2['default'])(this);
	    this.state = { q3Questions: _QuestionnairesData.q3Questions, q3Answers: _QuestionnairesData.q3Answers, answers: Array(90).fill(null), aux: Array(90).fill(null) };
	    this.loadAnswers();
	    this.editable = this.props.editable !== false;
	  }
	
	  _createClass(QuestionnaireBenziger, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.enableLeaveMessage();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.onbeforeunload = null;
	    }
	  }, {
	    key: 'enableLeaveMessage',
	    value: function enableLeaveMessage() {
	      if (this.props.canSave) {
	        window.onbeforeunload = function (event) {
	          return (event || window.event).returnValue = 'Tienes cambios sin guardar.';
	        };
	      } else {
	        window.onbeforeunload = null;
	      }
	    }
	  }, {
	    key: 'loadAnswers',
	    value: function loadAnswers() {
	      var _this = this;
	
	      var validAnswers;
	      fetch(this.props.benzigerProgress, {
	        method: 'post',
	        headers: { 'Content-Type': 'application/json' },
	        body: JSON.stringify({
	          qId: this.props.qId
	        }),
	        responseType: 'json'
	      }).then(function (response) {
	        return response.json();
	      }).then(function (response) {
	        if (response.code === 200) {
	          validAnswers = response.answers.slice();
	          validAnswers.forEach(function (value, i) {
	            if (value === "" || value === -1) {
	              validAnswers[i] = null;
	            }
	          });
	          _this.setState({ answers: validAnswers });
	        }
	      });
	    }
	  }, {
	    key: 'validateSubmit',
	    value: function validateSubmit() {
	      var valid = true;
	      for (var i = 0; i < 71; i++) {
	        if (this.state.answers[i] == null) {
	          valid = false;
	        }
	      }
	      if (valid) {
	        this.submitBenziger();
	      } else {
	        alert('Faltan campos de llenar.');
	      }
	    }
	  }, {
	    key: 'submitBenziger',
	    value: function submitBenziger() {
	      var validAnswers = this.state.answers.slice();
	      validAnswers.forEach(function (value, i) {
	        if (value === null) {
	          validAnswers[i] = "";
	        }
	      });
	      fetch(this.props.submitBenziger, {
	        method: 'post',
	        headers: { 'Content-Type': 'application/json' },
	        body: JSON.stringify({
	          answers: validAnswers,
	          qId: this.props.qId
	        }),
	        responseType: 'json'
	      }).then(function (response) {
	        return response.json();
	      }).then(function (response) {
	        if (response.code === 200) {
	          alert('El cuestionario fue guardado con exito!');
	        } else {
	          alert('Hubo un error, contacta al administrador.');
	        }
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var complete = false;
	      var incompleteError = function incompleteError() {
	        return alert('Faltan campos de llenar.');
	      };
	      var continueClasses = 'btn btn-lg btn-success';
	      var exportClass = 'btn btn-lg btn-success';
	      if (!complete) {
	        continueClasses += ' disabled';
	      }
	
	      return _react2['default'].createElement(
	        'form',
	        { style: { paddingRight: '20px', paddingLeft: '20px' } },
	        _react2['default'].createElement(
	          'h1',
	          null,
	          'Cuestionario Benziger Thinking Style Assessment'
	        ),
	        'El perfil Benziger Thinking Style está diseñado para identificar sus patrones de pensamiento para captar, procesar y explicar información.',
	        _react2['default'].createElement(
	          'ul',
	          null,
	          _react2['default'].createElement(
	            'li',
	            null,
	            'Está desarrollado a partir de la neurociencia e identica cuatro cuadrantes de pensamiento.'
	          ),
	          _react2['default'].createElement(
	            'li',
	            null,
	            'Las respuestas que usted brinde ayudan a identificar su cuadrante dominante y por lo tanto NO hay respuestas buenas ni malas.'
	          ),
	          _react2['default'].createElement(
	            'li',
	            null,
	            'Las respuestas que usted brinda son totalmente confidenciales.'
	          )
	        ),
	        _ramda2['default'].addIndex(_ramda2['default'].map)(this.renderSection, _ramda2['default'].zip(this.state.q3Questions, this.state.q3Answers)),
	        _react2['default'].createElement(
	          _modulesFooterJs2['default'],
	          null,
	          _react2['default'].createElement(
	            'button',
	            { type: 'button', style: { display: 'inline-block', margin: '0px 10px' }, className: 'btn btn-lg btn-info', onClick: this.submitBenziger },
	            'Guardar'
	          ),
	          _react2['default'].createElement(
	            'button',
	            { type: 'button', style: { display: 'inline-block', margin: '0px 10px' }, className: 'btn btn-lg btn-success', onClick: this.validateSubmit },
	            'Enviar'
	          ),
	          _react2['default'].createElement('br', null)
	        )
	      );
	    }
	  }, {
	    key: 'renderSection',
	    value: function renderSection(section, index) {
	      var questions = section[0];
	      var answers = section[1];
	      var style = "default";
	      switch (index) {
	        case 0:
	          style = "info";
	          break;
	        case 1:
	          style = "info";
	          break;
	        case 2:
	          style = "info";
	          break;
	        case 3:
	          style = "info";
	          break;
	        case 4:
	          style = "info";
	          break;
	        case 5:
	          style = "info";
	          break;
	        case 6:
	          style = "info";
	          break;
	        case 7:
	          style = "info";
	          break;
	      }
	      if (index == 7) {
	        return _react2['default'].createElement(
	          'div',
	          null,
	          _react2['default'].createElement('br', null),
	          _react2['default'].createElement(
	            _reactBootstrap.Panel,
	            { header: this.renderSectionName(index), bsStyle: style },
	            this.renderInstructions(index),
	            _ramda2['default'].addIndex(_ramda2['default'].map)(this.renderQuestionLast, _ramda2['default'].zip(questions, answers))
	          )
	        );
	      } else {
	        return _react2['default'].createElement(
	          'div',
	          null,
	          _react2['default'].createElement('br', null),
	          _react2['default'].createElement(
	            _reactBootstrap.Panel,
	            { header: this.renderSectionName(index), bsStyle: style },
	            this.renderInstructions(index),
	            _ramda2['default'].addIndex(_ramda2['default'].map)(this.renderQuestion, _ramda2['default'].zip(questions, answers))
	          )
	        );
	      }
	    }
	  }, {
	    key: 'renderSectionName',
	    value: function renderSectionName(section) {
	      if (section === 0) return _react2['default'].createElement(
	        'h1',
	        null,
	        'Datos Personales'
	      );
	      if (section === 1) return _react2['default'].createElement(
	        'h1',
	        null,
	        'Sección I. Información general'
	      );
	      if (section === 2) return _react2['default'].createElement(
	        'h1',
	        null,
	        'Sección II. Usted de niño'
	      );
	      if (section === 3) return _react2['default'].createElement(
	        'h1',
	        null,
	        'Sección III. Labores'
	      );
	      if (section === 4) return _react2['default'].createElement(
	        'h1',
	        null,
	        'Sección IV. Su vida de hogar y tiempo libre'
	      );
	      if (section === 5) return _react2['default'].createElement(
	        'h1',
	        null,
	        'Sección V. Percepción general de mí mismo'
	      );
	      if (section === 6) return _react2['default'].createElement(
	        'h1',
	        null,
	        'Sección VI. Estado emocional'
	      );
	      if (section === 7) return _react2['default'].createElement(
	        'h1',
	        null,
	        '72) Nivel de estrés'
	      );
	    }
	  }, {
	    key: 'renderInstructions',
	    value: function renderInstructions(section) {
	      if (section === 1) return _react2['default'].createElement('div', null);
	      if (section === 2) return _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement(
	          'p',
	          null,
	          'Instrucciones para responder las preguntas 13 a 21.'
	        ),
	        _react2['default'].createElement(
	          'ul',
	          null,
	          _react2['default'].createElement(
	            'li',
	            null,
	            'Seleccione las 3 respuestas que mejor lo describen.'
	          ),
	          _react2['default'].createElement(
	            'li',
	            null,
	            'Primero seleccione la respuesta que lo describe en primer lugar.'
	          ),
	          _react2['default'].createElement(
	            'li',
	            null,
	            'Despues, seleccione la respuesta que lo describe en segundo lugar.'
	          ),
	          _react2['default'].createElement(
	            'li',
	            null,
	            'Por ultimo, seleccione la respuesta que lo describe en tercer lugar.'
	          )
	        )
	      );
	      if (section === 3) return _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement(
	          'p',
	          null,
	          'Instrucciones para responder las preguntas 25 a 40.'
	        ),
	        _react2['default'].createElement(
	          'ul',
	          null,
	          _react2['default'].createElement(
	            'li',
	            null,
	            'Seleccione las 3 respuestas que mejor lo describen.'
	          ),
	          _react2['default'].createElement(
	            'li',
	            null,
	            'Primero seleccione la respuesta que lo describe en primer lugar.'
	          ),
	          _react2['default'].createElement(
	            'li',
	            null,
	            'Despues, seleccione la respuesta que lo describe en segundo lugar.'
	          ),
	          _react2['default'].createElement(
	            'li',
	            null,
	            'Por ultimo, seleccione la respuesta que lo describe en tercer lugar.'
	          )
	        )
	      );
	      if (section === 4) return _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement(
	          'p',
	          null,
	          'Instrucciones para responder las preguntas 41 a 49.'
	        ),
	        _react2['default'].createElement(
	          'ul',
	          null,
	          _react2['default'].createElement(
	            'li',
	            null,
	            'Seleccione las 3 respuestas que mejor lo describen.'
	          ),
	          _react2['default'].createElement(
	            'li',
	            null,
	            'Primero seleccione la respuesta que lo describe en primer lugar.'
	          ),
	          _react2['default'].createElement(
	            'li',
	            null,
	            'Despues, seleccione la respuesta que lo describe en segundo lugar.'
	          ),
	          _react2['default'].createElement(
	            'li',
	            null,
	            'Por ultimo, seleccione la respuesta que lo describe en tercer lugar.'
	          )
	        )
	      );
	      if (section === 5) return _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement(
	          'p',
	          null,
	          'Instrucciones para responder las preguntas 51 a 61.'
	        ),
	        _react2['default'].createElement(
	          'ul',
	          null,
	          _react2['default'].createElement(
	            'li',
	            null,
	            'Seleccione las 3 respuestas que mejor lo describen.'
	          ),
	          _react2['default'].createElement(
	            'li',
	            null,
	            'Primero seleccione la respuesta que lo describe en primer lugar.'
	          ),
	          _react2['default'].createElement(
	            'li',
	            null,
	            'Despues, seleccione la respuesta que lo describe en segundo lugar.'
	          ),
	          _react2['default'].createElement(
	            'li',
	            null,
	            'Por ultimo, seleccione la respuesta que lo describe en tercer lugar.'
	          )
	        )
	      );
	      if (section === 6) return _react2['default'].createElement('div', null);
	      if (section === 7) return _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement(
	          'p',
	          null,
	          'Instrucciones para responder a la pregunta 72.'
	        ),
	        _react2['default'].createElement(
	          'ul',
	          null,
	          _react2['default'].createElement(
	            'li',
	            null,
	            'Indique cuál de los siguientes acontecimientos importantes ha ocurrido en su vida durante los 12 meses pasados.'
	          ),
	          _react2['default'].createElement(
	            'li',
	            null,
	            'Indique el numero de veces en su respuesta.'
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderQuestion',
	    value: function renderQuestion(question, index) {
	      var questionStmt = question[0];
	      var options = question[1];
	      var questionNumber = options[1];
	      var title = _react2['default'].createElement(
	        'h4',
	        null,
	        questionStmt
	      );
	
	      return _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement(
	          _reactBootstrap.Panel,
	          { header: title },
	          this.renderOptions(options, index)
	        )
	      );
	    }
	  }, {
	    key: 'renderQuestionLast',
	    value: function renderQuestionLast(question, index) {
	      var questionStmt = question[0];
	      var options = question[1];
	      var title = questionStmt;
	      var questionNumber = options[1];
	
	      var divStyle = {
	        width: '400px'
	      };
	      return _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement(
	          _reactBootstrap.FormGroup,
	          null,
	          _react2['default'].createElement(
	            _reactBootstrap.InputGroup,
	            null,
	            _react2['default'].createElement(
	              _reactBootstrap.InputGroup.Addon,
	              { style: divStyle },
	              title
	            ),
	            this.renderOptions(options, index)
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderOptions',
	    value: function renderOptions(options, index) {
	      var inputType = options[0];
	      var questionNumber = options[1];
	      options = options.slice(2);
	      var optionsSelect = [];
	      var len = options.length;
	      var noticeM = '';
	      var noticeN = '';
	      var notices = [];
	      notices[0] = '';
	      notices[1] = '';
	      notices[2] = '';
	      var noticeL = '';
	      var modelosV = [_assetsModelo1Png2['default'], _assetsModelo2Png2['default'], _assetsModelo3Png2['default'], _assetsModelo4Png2['default']];
	      var lenAux = 0;
	      var optionsCheckboxAux;
	      var optionsCheckbox = [];
	      var lenModels = modelosV.length;
	      var lenAnswers = 0;
	
	      if (this.state.aux[questionNumber - 1] !== null) {
	        lenAux = this.state.aux[questionNumber - 1].length;
	      }
	      for (var i = 0; i < len; i++) {
	        if (this.state.aux[questionNumber - 1] !== null) {
	          for (var j = 0; j < lenAux; j++) {
	            if (this.state.aux[questionNumber - 1][j].type == 3) {
	              if (this.state.aux[questionNumber - 1][j].value == i) {
	                if (j == 0) {
	                  notices[0] = this.state.aux[questionNumber - 1][j].label;
	                } else if (j == 1) {
	                  notices[1] = this.state.aux[questionNumber - 1][j].label;
	                } else {
	                  notices[2] = this.state.aux[questionNumber - 1][j].label;
	                }
	              }
	            }
	          }
	        }
	        optionsSelect.push({
	          value: i,
	          label: options[i]
	        });
	      }
	      if (inputType === 0) return _react2['default'].createElement(
	        _reactBootstrap.FormGroup,
	        null,
	        _react2['default'].createElement(_reactBootstrap.FormControl, {
	          type: 'text',
	          value: this.state.answers[questionNumber - 1] || '',
	          placeholder: '',
	          onChange: this.handleInputChange.bind(this, questionNumber)
	        })
	      );else if (inputType === 1) return _react2['default'].createElement(
	        _reactBootstrap.FormGroup,
	        null,
	        _react2['default'].createElement(_reactBootstrap.FormControl, {
	          type: 'number',
	          value: this.state.answers[questionNumber - 1] || "",
	          placeholder: '',
	          onChange: this.handleNumChange.bind(this, questionNumber),
	          min: '0'
	        })
	      );else if (inputType === 2) {
	        optionsCheckbox = [];
	        var radioName = "question" + questionNumber;
	        for (var i = 0; i < len; i++) {
	          optionsCheckboxAux = _react2['default'].createElement(
	            'label',
	            null,
	            _react2['default'].createElement(_reactRadioGroup.Radio, { value: i }),
	            ' ',
	            options[i],
	            '  '
	          );
	          optionsCheckbox.push(optionsCheckboxAux);
	        }
	        return _react2['default'].createElement(
	          _reactRadioGroup.RadioGroup,
	          { name: radioName, selectedValue: this.state.answers[questionNumber - 1], onChange: this.handleRadioChange.bind(this, questionNumber) },
	          optionsCheckbox
	        );
	      } else if (inputType === 3) {
	        if (this.state.answers[questionNumber - 1] != null) {
	          lenAnswers = this.state.answers[questionNumber - 1].length;
	        }
	        notices[0] = '';
	        notices[1] = '';
	        notices[2] = '';
	        for (var i = 0; i < lenAnswers; i++) {
	          notices[i] = this.state.answers[questionNumber - 1][i];
	        }
	        for (var i = 0; i < lenModels; i++) {
	          optionsCheckboxAux = _react2['default'].createElement(
	            'label',
	            null,
	            _react2['default'].createElement(_reactCheckboxGroup.Checkbox, { value: i }),
	            _react2['default'].createElement('img', { width: '100px', src: modelosV[i] }),
	            '           '
	          );
	          optionsCheckbox.push(optionsCheckboxAux);
	        }
	        return _react2['default'].createElement(
	          'div',
	          null,
	          _react2['default'].createElement(
	            _reactBootstrap.ListGroup,
	            null,
	            _react2['default'].createElement(
	              _reactBootstrap.ListGroupItem,
	              { bsStyle: 'success' },
	              'MEJOR me describe: ',
	              _react2['default'].createElement('img', { width: '50px', src: modelosV[notices[0]], alt: '' })
	            ),
	            _react2['default'].createElement(
	              _reactBootstrap.ListGroupItem,
	              { bsStyle: 'danger' },
	              'NADA me describe:  ',
	              _react2['default'].createElement('img', { width: '50px', src: modelosV[notices[1]], alt: '' })
	            )
	          ),
	          _react2['default'].createElement(
	            _reactCheckboxGroup.CheckboxGroup,
	            {
	              name: 'form-field-6',
	              value: this.state.answers[questionNumber - 1],
	              onChange: this.handleCheckboxChange2.bind(this, questionNumber) },
	            optionsCheckbox
	          )
	        );
	      } else if (inputType === 4) {
	        if (this.state.answers[questionNumber - 1] != null) {
	          lenAnswers = this.state.answers[questionNumber - 1].length;
	        }
	        notices[0] = '';
	        notices[1] = '';
	        notices[2] = '';
	        for (var i = 0; i < lenAnswers; i++) {
	          notices[i] = this.state.answers[questionNumber - 1][i];
	        }
	        optionsCheckbox = [];
	        for (var i = 0; i < len; i++) {
	          optionsCheckboxAux = _react2['default'].createElement(
	            'label',
	            null,
	            _react2['default'].createElement(_reactCheckboxGroup.Checkbox, { value: options[i] }),
	            ' ',
	            options[i],
	            '  '
	          );
	          optionsCheckbox.push(optionsCheckboxAux);
	        }
	        return _react2['default'].createElement(
	          'div',
	          null,
	          _react2['default'].createElement(
	            _reactBootstrap.ListGroup,
	            null,
	            _react2['default'].createElement(
	              _reactBootstrap.ListGroupItem,
	              { bsStyle: 'success' },
	              'a) Lo primero que me describe es:   ',
	              _react2['default'].createElement(
	                'b',
	                null,
	                notices[0] || ''
	              )
	            ),
	            _react2['default'].createElement(
	              _reactBootstrap.ListGroupItem,
	              { bsStyle: 'warning' },
	              'b) Lo segundo que me describe es:  ',
	              _react2['default'].createElement(
	                'b',
	                null,
	                notices[1] || ''
	              )
	            ),
	            _react2['default'].createElement(
	              _reactBootstrap.ListGroupItem,
	              { bsStyle: 'danger' },
	              'c) Lo tercero que me describe es:   ',
	              _react2['default'].createElement(
	                'b',
	                null,
	                notices[2] || ''
	              )
	            )
	          ),
	          _react2['default'].createElement(
	            'p',
	            null,
	            'Seleccione tres opciones del siguiente menu'
	          ),
	          _react2['default'].createElement(
	            _reactCheckboxGroup.CheckboxGroup,
	            {
	              name: 'form-field-6',
	              value: this.state.answers[questionNumber - 1],
	              onChange: this.handleCheckboxChange3.bind(this, questionNumber) },
	            optionsCheckbox
	          )
	        );
	      } else if (inputType === 5) {
	        optionsCheckbox = [];
	        for (var i = 0; i < len; i++) {
	          optionsCheckboxAux = _react2['default'].createElement(
	            'label',
	            null,
	            _react2['default'].createElement(_reactCheckboxGroup.Checkbox, { value: i }),
	            ' ',
	            options[i],
	            '  '
	          );
	          optionsCheckbox.push(optionsCheckboxAux);
	        }
	        return _react2['default'].createElement(
	          _reactCheckboxGroup.CheckboxGroup,
	          {
	            name: 'form-field-6',
	            value: this.state.answers[questionNumber - 1],
	            onChange: this.handleCheckboxChange.bind(this, questionNumber) },
	          optionsCheckbox
	        );
	      } else if (inputType === 6) {
	        optionsCheckbox = [];
	        for (var i = 0; i < len; i++) {
	          optionsCheckboxAux = _react2['default'].createElement(
	            'label',
	            null,
	            _react2['default'].createElement(_reactCheckboxGroup.Checkbox, { value: options[i] }),
	            ' ',
	            options[i],
	            '  '
	          );
	          optionsCheckbox.push(optionsCheckboxAux);
	        }
	        return _react2['default'].createElement(
	          _reactCheckboxGroup.CheckboxGroup,
	          {
	            name: 'form-field-6',
	            value: this.state.answers[questionNumber - 1],
	            onChange: this.handleCheckboxChange6.bind(this, questionNumber) },
	          optionsCheckbox
	        );
	      } else if (inputType === 7) return _react2['default'].createElement(_reactBootstrap.FormControl, { type: 'text', value: this.state.answers[questionNumber - 1] || '0', placeholder: '', onChange: this.handleNumChange.bind(this, questionNumber), min: '0' });else if (inputType === 8) {
	        optionsCheckbox = [];
	        var radioName = "question" + questionNumber;
	        if (this.state.answers[questionNumber - 2] !== null) {
	          len = this.state.answers[questionNumber - 2].length;
	          for (var i = 0; i < len; i++) {
	            optionsCheckboxAux = _react2['default'].createElement(
	              'label',
	              null,
	              _react2['default'].createElement(_reactRadioGroup.Radio, { value: this.state.answers[questionNumber - 2][i] }),
	              ' ',
	              this.state.answers[questionNumber - 2][i],
	              '  '
	            );
	            optionsCheckbox.push(optionsCheckboxAux);
	          }
	        }
	        return _react2['default'].createElement(
	          _reactRadioGroup.RadioGroup,
	          { name: radioName, selectedValue: this.state.answers[questionNumber - 1], onChange: this.handleRadioChange.bind(this, questionNumber) },
	          optionsCheckbox
	        );
	      } else if (inputType === 9) {
	        optionsCheckbox = [];
	        var radioName = "question" + questionNumber;
	        for (var i = 55; i < questionNumber; i++) {
	          if (this.state.answers[i - 1] !== null) {
	            len = this.state.answers[i - 1].length;
	            if (len > 0) {
	              optionsCheckboxAux = _react2['default'].createElement(
	                'label',
	                null,
	                _react2['default'].createElement(_reactRadioGroup.Radio, { value: this.state.answers[i - 1][0] }),
	                ' ',
	                this.state.answers[i - 1][0],
	                '  '
	              );
	              optionsCheckbox.push(optionsCheckboxAux);
	            }
	          }
	        }
	        return _react2['default'].createElement(
	          _reactRadioGroup.RadioGroup,
	          { name: radioName, selectedValue: this.state.answers[questionNumber - 1], onChange: this.handleRadioChange.bind(this, questionNumber) },
	          optionsCheckbox
	        );
	      }
	    }
	  }, {
	    key: 'handleInputChange',
	    value: function handleInputChange(questionNumber, input) {
	      var answersUpdated = this.state.answers.slice();
	      answersUpdated[questionNumber - 1] = input.target.value;
	      this.setState({ answers: answersUpdated });
	    }
	  }, {
	    key: 'handleNumChange',
	    value: function handleNumChange(questionNumber, input) {
	      var answersUpdated = this.state.answers.slice();
	      var answer = Math.max(input.target.value, 0);
	      answersUpdated[questionNumber - 1] = answer;
	      this.setState({ answers: answersUpdated });
	      if (questionNumber == 3 && answer >= 18) {
	        this.setState({ q3Questions: _QuestionnairesData.q3Questions });
	      } else {
	        this.setState({ q3Questions: _QuestionnairesData.q3QuestionsTeen });
	      }
	    }
	  }, {
	    key: 'handleRadioChange',
	    value: function handleRadioChange(questionNumber, select) {
	      var answersUpdated = this.state.answers.slice();
	      answersUpdated[questionNumber - 1] = select;
	      this.setState({ answers: answersUpdated });
	    }
	  }, {
	    key: 'handleCheckboxChange',
	    value: function handleCheckboxChange(questionNumber, select) {
	      var answersUpdated = this.state.answers.slice();
	      answersUpdated[questionNumber - 1] = select;
	      this.setState({ answers: answersUpdated });
	    }
	  }, {
	    key: 'handleCheckboxChange6',
	    value: function handleCheckboxChange6(questionNumber, select) {
	      var answersUpdated = this.state.answers.slice();
	      answersUpdated[questionNumber - 1] = select;
	      if (select.length <= 6) {
	        this.setState({ answers: answersUpdated });
	      } else {
	        alert("Máximo 6 opciones");
	      }
	    }
	  }, {
	    key: 'handleCheckboxChange2',
	    value: function handleCheckboxChange2(questionNumber, select) {
	      var answersUpdated = this.state.answers.slice();
	      answersUpdated[questionNumber - 1] = select;
	      if (select.length <= 2) {
	        this.setState({ answers: answersUpdated });
	      } else {
	        alert("Máximo 2 opciones");
	      }
	    }
	  }, {
	    key: 'handleCheckboxChange3',
	    value: function handleCheckboxChange3(questionNumber, select) {
	      var answersUpdated = this.state.answers.slice();
	      answersUpdated[questionNumber - 1] = select;
	      if (select.length <= 3) {
	        this.setState({ answers: answersUpdated });
	      } else {
	        alert("Máximo 3 opciones");
	      }
	    }
	  }]);
	
	  return QuestionnaireBenziger;
	})(_react2['default'].Component);
	
	exports['default'] = QuestionnaireBenziger;
	module.exports = exports['default'];

/***/ }),

/***/ 2182:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _ramda = __webpack_require__(27);
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(35);
	
	var _modulesAutoBind = __webpack_require__(29);
	
	var _modulesAutoBind2 = _interopRequireDefault(_modulesAutoBind);
	
	var _modulesSpinnerJsx = __webpack_require__(153);
	
	var _modulesSpinnerJsx2 = _interopRequireDefault(_modulesSpinnerJsx);
	
	var _modulesNumberInputJsx = __webpack_require__(134);
	
	var _modulesNumberInputJsx2 = _interopRequireDefault(_modulesNumberInputJsx);
	
	var _PersonalDataFormJsx = __webpack_require__(2179);
	
	var _PersonalDataFormJsx2 = _interopRequireDefault(_PersonalDataFormJsx);
	
	var _Questionnaire1Jsx = __webpack_require__(1013);
	
	var _Questionnaire1Jsx2 = _interopRequireDefault(_Questionnaire1Jsx);
	
	var _Questionnaire2Jsx = __webpack_require__(1014);
	
	var _Questionnaire2Jsx2 = _interopRequireDefault(_Questionnaire2Jsx);
	
	var _assetsLogoPng = __webpack_require__(744);
	
	var _assetsLogoPng2 = _interopRequireDefault(_assetsLogoPng);
	
	var _PrivacyPolicyJsx = __webpack_require__(2180);
	
	var _PrivacyPolicyJsx2 = _interopRequireDefault(_PrivacyPolicyJsx);
	
	var Questionnaires = (function (_React$Component) {
	  _inherits(Questionnaires, _React$Component);
	
	  function Questionnaires(props) {
	    _classCallCheck(this, Questionnaires);
	
	    _get(Object.getPrototypeOf(Questionnaires.prototype), 'constructor', this).call(this, props);
	    (0, _modulesAutoBind2['default'])(this);
	    this.state = {
	      windowWidth: window.innerWidth,
	      savedAnswers: null,
	      savedPersonalData: null,
	      resource: null,
	      age: 0,
	      identityValidated: false
	    };
	
	    this.handleChange = (0, _ramda.curryN)(2, this.handleChange);
	  }
	
	  _createClass(Questionnaires, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.fetchQuestionnaire(this.props.resourceUrl);
	      window.addEventListener('resize', this.handleResize);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.fetchQuestionnaire(nextProps.resourceUrl);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('resize', this.handleResize);
	    }
	  }, {
	    key: 'handleResize',
	    value: function handleResize() {
	      this.setState({ windowWidth: window.innerWidth });
	    }
	  }, {
	    key: 'handleLeave',
	    value: function handleLeave(event) {
	      if (this.s) return 'Tienes cambios sin guardar.';
	    }
	  }, {
	    key: 'fetchQuestionnaire',
	    value: function fetchQuestionnaire(url) {
	      var _this = this;
	
	      (0, _jquery.ajax)(url).success(function (resource) {
	        return _this.setState({ resource: resource, savedAnswers: (0, _ramda.clone)(resource._embedded ? resource._embedded.answers : null), savedPersonalData: (0, _ramda.clone)(resource._embedded ? resource._embedded.personalData : null) });
	      }).fail(function () {
	        return _this.setState({ resource: 'not found' });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2['default'].createElement(
	        'div',
	        { className: 'container', style: { padding: '30px 0px' } },
	        this.getContent()
	      );
	    }
	  }, {
	    key: 'getContent',
	    value: function getContent() {
	      if (this.state.resource === null) {
	        return _react2['default'].createElement(_modulesSpinnerJsx2['default'], null);
	      }
	
	      if (this.state.resource === 'not found') {
	        return _react2['default'].createElement(
	          'div',
	          null,
	          'No se encontró el cuestionario...'
	        );
	      }
	
	      if (this.state.resource.expired) {
	        return _react2['default'].createElement(
	          'div',
	          null,
	          'El cuestionario ha expirado.'
	        );
	      }
	
	      return _react2['default'].createElement(
	        'div',
	        null,
	        this.state.resource.expiration && this.state.resource.stage < 3 ? _react2['default'].createElement(
	          'div',
	          null,
	          _react2['default'].createElement('img', { width: '120px', src: _assetsLogoPng2['default'] }),
	          _react2['default'].createElement(
	            'div',
	            { className: 'pull-right' },
	            'Fecha Límite: ',
	            _react2['default'].createElement(
	              'b',
	              null,
	              moment(this.state.resource.expiration).format('DD/MM/YYYY')
	            )
	          )
	        ) : '',
	        this.renderQuestionnaire()
	      );
	    }
	  }, {
	    key: 'renderQuestionnaire',
	    value: function renderQuestionnaire() {
	      var _this2 = this;
	
	      var smallScreen = this.state.windowWidth < 1200;
	      var answers = this.state.resource._embedded.answers;
	      var personalData = this.state.resource._embedded.personalData;
	      var representative = this.state.resource._embedded.personalData.representative;
	
	      var name = personalData.name;
	      if (this.state.resource.stage === 0) {
	        if (this.state.identityValidated === false) {
	          return _react2['default'].createElement(
	            'div',
	            null,
	            _react2['default'].createElement(
	              'center',
	              null,
	              _react2['default'].createElement(
	                'p',
	                null,
	                'Buen día'
	              ),
	              _react2['default'].createElement(
	                'h1',
	                null,
	                _react2['default'].createElement(
	                  'b',
	                  null,
	                  _react2['default'].createElement(
	                    'u',
	                    null,
	                    name.toUpperCase()
	                  )
	                )
	              ),
	              _react2['default'].createElement(
	                'p',
	                null,
	                'Bienvenido(a) a'
	              ),
	              _react2['default'].createElement(
	                'p',
	                null,
	                _react2['default'].createElement(
	                  'b',
	                  null,
	                  'Whitewater Teaming Tools'
	                )
	              ),
	              _react2['default'].createElement(
	                'p',
	                null,
	                'Usted recibió la liga de acceso a esta plataforma'
	              ),
	              _react2['default'].createElement(
	                'p',
	                null,
	                'por instrucciones de ',
	                representative
	              ),
	              _react2['default'].createElement('br', null),
	              _react2['default'].createElement(
	                'p',
	                null,
	                'Por favor elija una de las siguiente opciones:'
	              ),
	              _react2['default'].createElement('br', null),
	              _react2['default'].createElement(
	                'div',
	                { className: 'row' },
	                _react2['default'].createElement(
	                  'div',
	                  { className: 'col-xs-3 col-xs-offset-1', style: { textAlign: 'right' } },
	                  _react2['default'].createElement(
	                    'button',
	                    { onClick: function () {
	                        return _this2.setState({ identityValidated: 1 });
	                      }, style: { margin: '5px' }, className: 'btn btn-success' },
	                    _react2['default'].createElement(
	                      'span',
	                      { style: { visibility: 'hidden' } },
	                      'X'
	                    )
	                  )
	                ),
	                _react2['default'].createElement(
	                  'div',
	                  { className: 'col-xs-5', style: { textAlign: 'left' } },
	                  _react2['default'].createElement(
	                    'span',
	                    null,
	                    _react2['default'].createElement(
	                      'b',
	                      null,
	                      'Sí soy ',
	                      name
	                    )
	                  ),
	                  _react2['default'].createElement(
	                    'div',
	                    null,
	                    'Al señalar esta opción continuará con el cuestionario.'
	                  )
	                )
	              ),
	              _react2['default'].createElement('br', null),
	              _react2['default'].createElement(
	                'div',
	                { className: 'row' },
	                _react2['default'].createElement(
	                  'div',
	                  { className: 'col-xs-3 col-xs-offset-1', style: { textAlign: 'right' } },
	                  _react2['default'].createElement(
	                    'button',
	                    { onClick: function () {
	                        return _this2.setState({ identityValidated: 2 });
	                      }, style: { margin: '5px' }, className: 'btn btn-info' },
	                    _react2['default'].createElement(
	                      'span',
	                      { style: { visibility: 'hidden' } },
	                      'X'
	                    )
	                  )
	                ),
	                _react2['default'].createElement(
	                  'div',
	                  { className: 'col-xs-5', style: { textAlign: 'left' } },
	                  _react2['default'].createElement(
	                    'span',
	                    null,
	                    _react2['default'].createElement(
	                      'b',
	                      null,
	                      'Sí soy ',
	                      name,
	                      ', pero no sé de qué se trata esto.'
	                    )
	                  ),
	                  _react2['default'].createElement(
	                    'div',
	                    null,
	                    'Al señalar esta opción usted saldrá del sistema y recibirá un correo de ',
	                    representative,
	                    ' explicándole por qué recibió esta invitación.'
	                  )
	                )
	              ),
	              _react2['default'].createElement('br', null),
	              _react2['default'].createElement(
	                'div',
	                { className: 'row' },
	                _react2['default'].createElement(
	                  'div',
	                  { className: 'col-xs-3 col-xs-offset-1', style: { textAlign: 'right' } },
	                  _react2['default'].createElement(
	                    'button',
	                    { onClick: function () {
	                        return _this2.setState({ identityValidated: 3 });
	                      }, style: { margin: '5px' }, className: 'btn btn-danger' },
	                    _react2['default'].createElement(
	                      'span',
	                      { style: { visibility: 'hidden' } },
	                      'X'
	                    )
	                  )
	                ),
	                _react2['default'].createElement(
	                  'div',
	                  { className: 'col-xs-5', style: { textAlign: 'left' } },
	                  _react2['default'].createElement(
	                    'span',
	                    null,
	                    _react2['default'].createElement(
	                      'b',
	                      null,
	                      'NO soy ',
	                      name
	                    )
	                  ),
	                  _react2['default'].createElement(
	                    'div',
	                    null,
	                    'Al señalar esta opción saldrá del sistema y enviará una notificación a ',
	                    representative,
	                    '.'
	                  )
	                )
	              )
	            )
	          );
	        } else if (this.state.identityValidated === 3) {
	          return _react2['default'].createElement(
	            'div',
	            null,
	            'Se ha enviado una notificación al administrador. Disculpe las molestias.'
	          );
	        } else if (this.state.identityValidated === 2) {
	          return _react2['default'].createElement(
	            'div',
	            null,
	            'Se ha enviado una notificación al administrador. Usted recibirá un correo explicando el motivo del cuestionario.'
	          );
	        } else if (this.state.identityValidated === 1) {
	          return _react2['default'].createElement(
	            'div',
	            { className: 'privacy-policy' },
	            _PrivacyPolicyJsx2['default'],
	            _react2['default'].createElement(
	              'div',
	              null,
	              _react2['default'].createElement(
	                'button',
	                { type: 'button', className: 'btn btn-success btn-lg pull-right', onClick: this.handleSubmit(0) },
	                'Aceptar'
	              )
	            )
	          );
	        }
	      }
	
	      if (this.state.resource.stage === 1) {
	        return _react2['default'].createElement(_PersonalDataFormJsx2['default'], { canSave: !(0, _ramda.equals)(this.state.savedPersonalData, personalData), onSave: this.handlePersonalDataSave, value: personalData, onSubmit: this.handlePersonalDataSubmit, onChange: function (data) {
	            _this2.state.resource._embedded.personalData = data;
	            _this2.setState({ resource: _this2.state.resource });
	          } });
	      }
	
	      if (this.state.resource.stage === 2) {
	        return _react2['default'].createElement(_Questionnaire1Jsx2['default'], { smallScreen: smallScreen, value: answers[0], canSave: !(0, _ramda.equals)(this.state.savedAnswers[0], answers[0]), onChange: this.handleChange(0), onSave: this.handleSave(0), onSubmit: this.handleSubmit(0) });
	      }
	
	      if (this.state.resource.stage === 3) {
	        return _react2['default'].createElement(_Questionnaire2Jsx2['default'], { value: answers[1], canSave: !(0, _ramda.equals)(this.state.savedAnswers[1], answers[1]), onChange: this.handleChange(1), onSave: this.handleSave(1), onSubmit: this.handleSubmit(1) });
	      }
	
	      if (this.state.resource.stage === 4) {
	        return _react2['default'].createElement(
	          'center',
	          null,
	          _react2['default'].createElement(
	            'h3',
	            null,
	            _react2['default'].createElement('br', null),
	            _react2['default'].createElement('br', null),
	            _react2['default'].createElement('br', null),
	            _react2['default'].createElement('br', null),
	            _react2['default'].createElement('br', null),
	            _react2['default'].createElement('br', null),
	            _react2['default'].createElement('span', { className: 'glyphicon glyphicon-ok', style: { color: 'green' } }),
	            ' Los cuestionarios han sido completados.'
	          )
	        );
	      }
	    }
	  }, {
	    key: 'putPersonalData',
	    value: function putPersonalData(saveOnly) {
	      return (0, _jquery.ajax)({ url: this.state.resource._rels.personalData, method: 'PUT', data: { personalData: this.state.resource._embedded.personalData, save: saveOnly } });
	    }
	  }, {
	    key: 'handlePersonalDataSave',
	    value: function handlePersonalDataSave() {
	      var _this3 = this;
	
	      this.putPersonalData(true).success(function () {
	        _this3.state.savedPersonalData = (0, _ramda.clone)(_this3.state.resource._embedded.personalData);
	        _this3.setState({ savedPersonalData: _this3.state.savedPersonalData });
	      }).fail(function () {
	        alert('Ocurrió un error al guardar las respuestas.');
	      });
	    }
	  }, {
	    key: 'handlePersonalDataSubmit',
	    value: function handlePersonalDataSubmit() {
	      var _this4 = this;
	
	      this.putPersonalData(false).success(function () {
	        _this4.state.resource.stage++;
	        _this4.setState({ resource: _this4.state.resource });
	      }).fail(function () {
	        alert('Hubo un error al guardar las respuestas.');
	      });
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange(qId, answers) {
	      this.state.resource._embedded.answers[qId] = answers;
	      this.setState({ resource: this.state.resource });
	    }
	  }, {
	    key: 'putAnswers',
	    value: function putAnswers(qId, saveOnly) {
	      return (0, _jquery.ajax)({ url: this.state.resource._rels.answers, method: 'PUT', data: JSON.stringify({ answers: this.state.resource._embedded.answers, save: saveOnly }), headers: { 'Content-Type': 'application/json' } });
	    }
	  }, {
	    key: 'handleSave',
	    value: function handleSave(qId) {
	      var _this5 = this;
	
	      return function () {
	        _this5.putAnswers(qId, true).success(function () {
	          _this5.state.savedAnswers[qId] = (0, _ramda.clone)(_this5.state.resource._embedded.answers[qId]);
	          _this5.setState({ savedAnswers: _this5.state.savedAnswers });
	        }).fail(function () {
	          alert('No se pudieron guardar las respuestas.');
	        });
	      };
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit(qId) {
	      var _this6 = this;
	
	      return function () {
	        _this6.putAnswers(qId, false).success(function () {
	          _this6.state.resource.stage++;
	          _this6.setState({ resource: _this6.state.resource });
	          window.scrollTo(0, 0);
	        }).fail(function () {
	          alert('Hubo un error al guardar las respuestas.');
	        });
	      };
	    }
	  }]);
	
	  return Questionnaires;
	})(_react2['default'].Component);
	
	exports['default'] = Questionnaires;
	module.exports = exports['default'];

/***/ }),

/***/ 2183:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _ramda = __webpack_require__(27);
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(35);
	
	var _modulesAutoBind = __webpack_require__(29);
	
	var _modulesAutoBind2 = _interopRequireDefault(_modulesAutoBind);
	
	var _modulesSpinnerJsx = __webpack_require__(153);
	
	var _modulesSpinnerJsx2 = _interopRequireDefault(_modulesSpinnerJsx);
	
	var _assetsLogoPng = __webpack_require__(744);
	
	var _assetsLogoPng2 = _interopRequireDefault(_assetsLogoPng);
	
	var _common = __webpack_require__(95);
	
	var Registration = (function (_React$Component) {
	  _inherits(Registration, _React$Component);
	
	  function Registration(props) {
	    _classCallCheck(this, Registration);
	
	    _get(Object.getPrototypeOf(Registration.prototype), 'constructor', this).call(this, props);
	    (0, _modulesAutoBind2['default'])(this);
	    this.state = {
	      windowWidth: window.innerWidth,
	      resource: null,
	      newData: {
	        name: null,
	        company: null,
	        password: null
	      }
	    };
	  }
	
	  _createClass(Registration, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.fetchConsultant(this.props.resourceUrl);
	      window.addEventListener('resize', this.handleResize);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('resize', this.handleResize);
	    }
	  }, {
	    key: 'handleResize',
	    value: function handleResize() {
	      this.setState({ windowWidth: window.innerWidth });
	    }
	  }, {
	    key: 'fetchConsultant',
	    value: function fetchConsultant(url) {
	      var _this = this;
	
	      (0, _jquery.ajax)(url).success(function (resource) {
	        var newData = _this.state.newData;
	        newData.name = resource.name;
	        _this.setState({ resource: resource, newData: newData });
	      }).fail(function () {
	        return _this.setState({ resource: 'not found' });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2['default'].createElement(
	        'div',
	        { className: 'container', style: { padding: '30px 0px' } },
	        this.getContent()
	      );
	    }
	  }, {
	    key: 'getContent',
	    value: function getContent() {
	      var _this2 = this;
	
	      if (this.state.resource === null) {
	        return _react2['default'].createElement(_modulesSpinnerJsx2['default'], null);
	      }
	
	      if (this.state.resource === 'not found') {
	        return _react2['default'].createElement(
	          'div',
	          null,
	          'No se encontró el consultor...'
	        );
	      }
	
	      return _react2['default'].createElement(
	        'form',
	        { style: { marginTop: '50px' } },
	        this.renderRow(_react2['default'].createElement(
	          'label',
	          null,
	          'Nombre'
	        ), _react2['default'].createElement('input', { type: 'text', onChange: function (e) {
	            return _this2.state.newData.name = e.target.value;
	          } })),
	        this.renderRow(_react2['default'].createElement(
	          'label',
	          null,
	          'Cliente'
	        ), _react2['default'].createElement(
	          'label',
	          null,
	          this.state.resource.username
	        )),
	        this.renderRow(_react2['default'].createElement(
	          'label',
	          null,
	          'Empresa'
	        ), _react2['default'].createElement('input', { type: 'text', onChange: function (e) {
	            return _this2.state.newData.company = e.target.value;
	          } })),
	        this.renderRow(_react2['default'].createElement(
	          'label',
	          null,
	          'Contraseña'
	        ), _react2['default'].createElement('input', { type: 'password' })),
	        this.renderRow(_react2['default'].createElement(
	          'label',
	          null,
	          'Confirmar contraseña'
	        ), _react2['default'].createElement('input', { type: 'password', onChange: function (e) {
	            return _this2.state.newData.password = e.target.value;
	          } })),
	        _react2['default'].createElement(
	          'div',
	          { style: { textAlign: 'center' } },
	          _react2['default'].createElement(
	            'button',
	            { type: 'button', style: { display: 'inline-block', margin: '0px 10px' }, className: 'btn btn-lg btn-success', onClick: this.handleConsultantDataSubmit },
	            'Guardar'
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderRow',
	    value: function renderRow(left, right) {
	      return _react2['default'].createElement(
	        'div',
	        { className: 'row', style: { margin: '25px' } },
	        _react2['default'].createElement(
	          'div',
	          { className: 'col-xs-10 col-xs-offset-1 col-md-4 col-md-offset-1' },
	          left
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'col-xs-10 col-xs-offset-1 col-md-4 col-md-offset-1' },
	          right
	        )
	      );
	    }
	  }, {
	    key: 'handleConsultantDataSubmit',
	    value: function handleConsultantDataSubmit() {
	      var bad_format = false;
	      $("input").each(function (index, val) {
	        if ($(this).val() === "") {
	          alert("Faltan campos de llenar.");
	          bad_format = true;
	          return false;
	        }
	      });
	
	      if (!bad_format && $("input:eq(2)").val() !== $("input:eq(3)").val()) {
	        alert("Las contraseñas nos coinciden.");
	        bad_format = true;
	      }
	
	      if (bad_format) {
	        return false;
	      }
	
	      (0, _jquery.ajax)({
	        url: this.state.resource._rels.self,
	        method: 'PUT',
	        data: this.state.newData
	      }).success(function () {
	        window.location = '/';
	      }).fail(function () {
	        alert('Hubo un error al guardar las respuestas.');
	      });
	    }
	  }]);
	
	  return Registration;
	})(_react2['default'].Component);
	
	exports['default'] = Registration;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(35)))

/***/ }),

/***/ 2184:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _ramda = __webpack_require__(27);
	
	var _ramda2 = _interopRequireDefault(_ramda);
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _modulesAutoBind = __webpack_require__(29);
	
	var _modulesAutoBind2 = _interopRequireDefault(_modulesAutoBind);
	
	var _modulesReadExcel = __webpack_require__(2193);
	
	var _modulesReadExcel2 = _interopRequireDefault(_modulesReadExcel);
	
	var _xtna = __webpack_require__(457);
	
	var _PersonalDataFormJsx = __webpack_require__(1017);
	
	var _PersonalDataFormJsx2 = _interopRequireDefault(_PersonalDataFormJsx);
	
	var excelSchema = {
	  sheetNum: 5,
	  cells: {
	    name: 'BC4', company: 'BC5', date: 'BC6', age: 'BC7',
	    NX: 'BA11', NT: 'BB11', NN: 'BC11', NA: 'BD11', AX: 'BA12', AT: 'BB12', AN: 'BC12', AA: 'BD12'
	  }
	};
	
	var ExcelDataExtractor = (function (_React$Component) {
	  _inherits(ExcelDataExtractor, _React$Component);
	
	  function ExcelDataExtractor(props) {
	    _classCallCheck(this, ExcelDataExtractor);
	
	    _get(Object.getPrototypeOf(ExcelDataExtractor.prototype), 'constructor', this).call(this, props);
	    (0, _modulesAutoBind2['default'])(this);
	    this.state = {
	      errorMessage: ''
	    };
	  }
	
	  _createClass(ExcelDataExtractor, [{
	    key: 'render',
	    value: function render() {
	      return _react2['default'].createElement(
	        'div',
	        { className: 'form-inline', style: { marginBottom: '10px' } },
	        _react2['default'].createElement(
	          'label',
	          null,
	          'Cargar datos de Excel:'
	        ),
	        _react2['default'].createElement('input', { ref: 'fileInput', type: 'file', accept: '.xlsx', onChange: this.handleExcelSubmission }),
	        _react2['default'].createElement(
	          'span',
	          { style: { color: 'red' } },
	          this.state.errorMessage
	        )
	      );
	    }
	  }, {
	    key: 'handleExcelSubmission',
	    value: function handleExcelSubmission() {
	      var _this = this;
	
	      this.setState({ errorMessage: '' });
	      var files = this.refs.fileInput.getDOMNode().files;
	
	      if (files.length === 0) {
	        return;
	      }
	
	      var file = files[0];
	      var cells = _ramda2['default'].toPairs(excelSchema.cells).map(_ramda2['default'].tail);
	      (0, _modulesReadExcel2['default'])(cells, excelSchema.sheetNum, file).then(function (data) {
	        if (_ramda2['default'].any(_ramda2['default'].isNil, _ramda2['default'].toPairs(data).map(_ramda2['default'].compose(_ramda2['default'].head, _ramda2['default'].tail)))) {
	          return _this.setState({ errorMessage: 'Archivo inválido.' });
	        }
	
	        var formattedData = _ramda2['default'].compose(_ramda2['default'].fromPairs, _ramda2['default'].map(function (pair) {
	          return [_ramda2['default'].head(pair), data[_ramda2['default'].head(_ramda2['default'].tail(pair))]];
	        }), _ramda2['default'].toPairs)(excelSchema.cells);
	
	        formattedData.date = moment.unix((parseInt(formattedData.date) - 25568) * 60 * 60 * 24 - 19 * 60 * 60);
	        [].concat(_toConsumableArray(_xtna.XTNA.props()), ['age']).forEach(function (prop) {
	          return formattedData[prop] = parseInt(formattedData[prop]);
	        });
	
	        var xtna = _ramda2['default'].pick(_xtna.XTNA.props(), formattedData);
	        var personal = _ramda2['default'].pick(['name', 'company', 'date', 'age'], formattedData);
	
	        _this.props.onChange({
	          xtna: _ramda2['default'].merge(xtna, { valid: _xtna.XTNA.validForm(xtna) }),
	          personal: _ramda2['default'].merge(personal, { valid: _PersonalDataFormJsx2['default'].validForm(personal) })
	        });
	      }, function () {
	        return _this.setState({ errorMessage: 'Archivo inválido.' });
	      });
	    }
	  }]);
	
	  return ExcelDataExtractor;
	})(_react2['default'].Component);
	
	exports['default'] = ExcelDataExtractor;
	module.exports = exports['default'];

/***/ }),

/***/ 2185:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _ramda = __webpack_require__(27);
	
	var _moment = __webpack_require__(133);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _modulesAutoBind = __webpack_require__(29);
	
	var _modulesAutoBind2 = _interopRequireDefault(_modulesAutoBind);
	
	var _xtna = __webpack_require__(457);
	
	var _xtnaTrabajo = __webpack_require__(2189);
	
	var _benzinger = __webpack_require__(1011);
	
	var _ExcelDataExtractorJsx = __webpack_require__(2184);
	
	var _ExcelDataExtractorJsx2 = _interopRequireDefault(_ExcelDataExtractorJsx);
	
	var _XTNAReportGeneratorJsx = __webpack_require__(1018);
	
	var _XTNAReportGeneratorJsx2 = _interopRequireDefault(_XTNAReportGeneratorJsx);
	
	var _HumanFactorsReportGeneratorJsx = __webpack_require__(1016);
	
	var _HumanFactorsReportGeneratorJsx2 = _interopRequireDefault(_HumanFactorsReportGeneratorJsx);
	
	var _PersonalDataFormJsx = __webpack_require__(1017);
	
	var _PersonalDataFormJsx2 = _interopRequireDefault(_PersonalDataFormJsx);
	
	var ReportingTool = (function (_React$Component) {
	  _inherits(ReportingTool, _React$Component);
	
	  function ReportingTool(props) {
	    _classCallCheck(this, ReportingTool);
	
	    _get(Object.getPrototypeOf(ReportingTool.prototype), 'constructor', this).call(this, props);
	    (0, _modulesAutoBind2['default'])(this);
	    this.state = {
	      xtna: (0, _ramda.merge)({ valid: true }, _xtna.XTNA['default']()),
	      benzinger: (0, _ramda.merge)({ valid: true }, _benzinger.Benzinger['default']()),
	      benzingerStats: { i1: 0, i2: 0, e1: 0, e2: 0 },
	      personal: { name: '', company: '', age: 0, date: (0, _moment2['default'])(), valid: false },
	      benzinger: { L1: 0, A1: 0, V1: 0, I1: 0, L2: 0, A2: 0, V2: 0, I2: 0, valid: true,
	        adultoStats: {
	          AT: [0, 0, 0, 0],
	          ATL: [0, 0, 0, 0],
	          AA: [0, 0, 0, 0]
	        },
	        jovenStats: [0, 0, 0, 0],
	        adjetivo: '',
	        totalExIn: [0, 0],
	        adultoExIn: [0, 0],
	        jovenExIn: [0, 0],
	        posDetNegEst: [0, 0, 0, 0],
	        imagen: ['0', '0', '0', '0']
	      }
	    };
	  }
	
	  _createClass(ReportingTool, [{
	    key: 'render',
	    value: function render() {
	      var _this = this;
	
	      var canGenerateXTNAReport = this.state.xtna.valid && this.state.personal.valid && this.props.xtnaReportTemplate && this.props.numLicenses >= 0;
	      var canGenerateHumanFactorsReport = this.state.benzinger.valid && this.state.personal.valid && this.props.humanFactorsReportTemplate && this.props.numLicenses >= 0;
	
	      return _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement(
	          'div',
	          { className: 'col-xs-10 col-xs-offset-1 col-md-offset-0 col-md-4', style: { margin: '20px 0px' } },
	          _react2['default'].createElement(_PersonalDataFormJsx2['default'], { value: this.state.personal, onChange: function (value) {
	              return _this.setState({ personal: value });
	            } }),
	          _react2['default'].createElement(_ExcelDataExtractorJsx2['default'], { onChange: (0, _ramda.bind)(this.setState, this) }),
	          _react2['default'].createElement(_XTNAReportGeneratorJsx2['default'], {
	            user: this.props.user,
	            licenseConsumed: function () {
	              return 0;
	            },
	            consumeLicense: this.props.consumeLicense,
	            personalData: this.state.personal,
	            xtna: this.state.xtna,
	            valid: canGenerateXTNAReport,
	            chartsIds: { xtna: 'xtna-chart', xtnaTrabajo: 'xtna-trabajo-chart' },
	            reportTemplateUrl: this.props.xtnaReportTemplate }),
	          _react2['default'].createElement(_HumanFactorsReportGeneratorJsx2['default'], _extends({ user: this.props.user, licenseConsumed: function () {
	              return 0;
	            }, consumeLicense: this.props.consumeLicense, personalData: this.state.personal, xtna: this.state.xtna, benzinger: this.state.benzinger, valid: canGenerateHumanFactorsReport, chartsIds: { xtna: 'xtna-chart', benzinger: 'benzinger-chart', xtnaTrabajo: 'xtna-trabajo-chart' }, reportTemplateUrl: this.props.humanFactorsReportTemplate }, this.state.benzingerStats))
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'col-xs-10 col-xs-offset-1 col-md-offset-0 col-md-4', style: { margin: '20px 0px' } },
	          _react2['default'].createElement(_xtna.XTNAChart, _extends({}, this.state.xtna, { id: 'xtna-chart' })),
	          _react2['default'].createElement(
	            'center',
	            null,
	            _react2['default'].createElement(_xtna.XTNAForm, { value: this.state.xtna, onChange: function (value) {
	                return _this.setState({ xtna: value });
	              } })
	          ),
	          _react2['default'].createElement(_xtna.XTNAResults, this.state.xtna)
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'col-xs-10 col-xs-offset-1 col-md-offset-0 col-md-4', style: { margin: '20px 0px' } },
	          _react2['default'].createElement(_benzinger.BenzingerChart, _extends({}, this.state.benzinger, { id: 'benzinger-chart' })),
	          _react2['default'].createElement(
	            'center',
	            null,
	            _react2['default'].createElement(_benzinger.BenzingerForm, { value: this.state.benzinger, stats: this.state.benzingerStats, onStatChange: function (stats) {
	                return _this.setState({ benzingerStats: stats });
	              }, onChange: function (value) {
	                return _this.setState({ benzinger: value });
	              } })
	          )
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'col-xs-10 col-xs-offset-1', style: { margin: '20px 0px' } },
	          _react2['default'].createElement(_xtnaTrabajo.XTNATrabajoChart, _extends({}, this.state.xtna, { id: 'xtna-trabajo-chart' }))
	        )
	      );
	    }
	  }]);
	
	  return ReportingTool;
	})(_react2['default'].Component);
	
	exports['default'] = ReportingTool;
	module.exports = exports['default'];

/***/ }),

/***/ 2186:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _ramda = __webpack_require__(27);
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _modulesAutoBind = __webpack_require__(29);
	
	var _modulesAutoBind2 = _interopRequireDefault(_modulesAutoBind);
	
	var _modulesNumberInputJsx = __webpack_require__(134);
	
	var _modulesNumberInputJsx2 = _interopRequireDefault(_modulesNumberInputJsx);
	
	var CreateUserForm = (function (_React$Component) {
	  _inherits(CreateUserForm, _React$Component);
	
	  function CreateUserForm(props) {
	    _classCallCheck(this, CreateUserForm);
	
	    _get(Object.getPrototypeOf(CreateUserForm.prototype), 'constructor', this).call(this, props);
	    (0, _modulesAutoBind2['default'])(this);
	    this.state = {
	      lastExpirationValue: 1,
	      lastRepresentativeValue: '',
	      hasRepresentative: true
	    };
	  }
	
	  _createClass(CreateUserForm, [{
	    key: 'render',
	    value: function render() {
	      var expirationTextbox = this.props.value.expirationDays === -1 ? '' : _react2['default'].createElement(_modulesNumberInputJsx2['default'], { value: this.props.value.expirationDays, onChange: this.handleChange('expirationDays', _ramda.identity), min: '1', max: '100' });
	
	      var expirationInput = _react2['default'].createElement(
	        'span',
	        null,
	        expirationTextbox,
	        _react2['default'].createElement('input', { type: 'checkbox',
	          style: { margin: '0px 5px' },
	          checked: this.props.value.expirationDays === -1,
	          onChange: this.handleChange('expirationDays', (0, _ramda.compose)(this.handleCheckboxClick, (0, _ramda.path)(['target', 'checked']))) }),
	        'Ilimitado'
	      );
	
	      var representativeTextbox = this.state.hasRepresentative === false ? '' : _react2['default'].createElement('input', { type: 'text', value: this.props.value.representative, onChange: this.handleChange('representative', (0, _ramda.path)(['target', 'value'])) });
	
	      var representativeInput = _react2['default'].createElement(
	        'span',
	        null,
	        representativeTextbox,
	        _react2['default'].createElement('br', null),
	        _react2['default'].createElement('input', { type: 'checkbox',
	          style: { margin: '0px 5px' },
	          checked: this.state.hasRepresentative === false,
	          onChange: this.handleChange('representative', (0, _ramda.compose)(this.handleRepresentativeCheckboxClick, (0, _ramda.path)(['target', 'checked']))) }),
	        'Usar nombre de consultor'
	      );
	
	      return _react2['default'].createElement(
	        'form',
	        null,
	        this.renderInput('Nombre', 'name'),
	        this.renderInput('Email', 'email'),
	        this.renderRow('Solicitante', representativeInput),
	        this.renderRow('Vigencia (días)', expirationInput)
	      );
	    }
	  }, {
	    key: 'handleRepresentativeCheckboxClick',
	    value: function handleRepresentativeCheckboxClick(checked) {
	      if (checked) {
	        this.setState({
	          lastRepresentativeValue: this.props.value.representative,
	          hasRepresentative: false
	        });
	
	        return '';
	      }
	
	      this.setState({
	        hasRepresentative: true
	      });
	
	      return this.state.lastRepresentativeValue;
	    }
	  }, {
	    key: 'handleCheckboxClick',
	    value: function handleCheckboxClick(checked) {
	      if (checked) {
	        this.setState({
	          lastExpirationValue: this.props.value.expirationDays
	        });
	        return -1;
	      }
	
	      return this.state.lastExpirationValue;
	    }
	  }, {
	    key: 'renderInput',
	    value: function renderInput(label, id) {
	      var input = _react2['default'].createElement('input', { type: 'text', value: this.props.value[id], onChange: this.handleChange(id, (0, _ramda.path)(['target', 'value'])) });
	      return this.renderRow(label, input);
	    }
	  }, {
	    key: 'renderRow',
	    value: function renderRow(label, input) {
	      return _react2['default'].createElement(
	        'div',
	        { className: 'row form-group' },
	        _react2['default'].createElement(
	          'label',
	          { className: 'col-xs-3 col-xs-offset-2', style: { textAlign: 'right' } },
	          label
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'col-xs-6' },
	          input
	        )
	      );
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange(field, getValue) {
	      var _this = this;
	
	      return function (event) {
	        var value = getValue(event);
	        _this.props.onChange((0, _ramda.merge)(_this.props.value, _defineProperty({}, field, value)));
	      };
	    }
	  }]);
	
	  return CreateUserForm;
	})(_react2['default'].Component);
	
	exports['default'] = CreateUserForm;
	module.exports = exports['default'];

/***/ }),

/***/ 2187:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _ramda = __webpack_require__(27);
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _modulesAutoBind = __webpack_require__(29);
	
	var _modulesAutoBind2 = _interopRequireDefault(_modulesAutoBind);
	
	var EditUserForm = (function (_React$Component) {
	  _inherits(EditUserForm, _React$Component);
	
	  function EditUserForm(props) {
	    _classCallCheck(this, EditUserForm);
	
	    _get(Object.getPrototypeOf(EditUserForm.prototype), 'constructor', this).call(this, props);
	    (0, _modulesAutoBind2['default'])(this);
	  }
	
	  _createClass(EditUserForm, [{
	    key: 'render',
	    value: function render() {
	      return _react2['default'].createElement(
	        'form',
	        null,
	        this.renderInput('Nombre', 'name'),
	        this.renderInput('Compañía', 'company'),
	        this.renderInput('Edad', 'age'),
	        this.renderRow('Sexo', this.renderSexRadioButton())
	      );
	    }
	  }, {
	    key: 'renderInput',
	    value: function renderInput(label, id) {
	      var value = this.props.value[id] ? this.props.value[id] : undefined;
	      var input = _react2['default'].createElement('input', { type: 'text', defaultValue: value, onChange: this.handleChange(id, (0, _ramda.path)(['target', 'value'])) });
	      return this.renderRow(label, input);
	    }
	  }, {
	    key: 'renderRow',
	    value: function renderRow(label, input) {
	      return _react2['default'].createElement(
	        'div',
	        { className: 'row form-group' },
	        _react2['default'].createElement(
	          'label',
	          { className: 'col-xs-3 col-xs-offset-2', style: { textAlign: 'right' } },
	          label
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: 'col-xs-6' },
	          input
	        )
	      );
	    }
	  }, {
	    key: 'renderSexRadioButton',
	    value: function renderSexRadioButton() {
	      var _this = this;
	
	      return _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement(
	          'div',
	          null,
	          _react2['default'].createElement('input', { type: 'radio', name: 'sex', value: 'Masculino', checked: this.props.value.sex === 'M', onChange: function () {
	              return _this.props.onChange(R.merge(_this.props.value, { sex: 'M' }));
	            } }),
	          ' Masculino'
	        ),
	        _react2['default'].createElement(
	          'div',
	          null,
	          _react2['default'].createElement('input', { type: 'radio', name: 'sex', value: 'Femenino', checked: this.props.value.sex === 'F', onChange: function () {
	              _this.props.onChange(R.merge(_this.props.value, { sex: 'F' }));
	            } }),
	          ' Femenino'
	        )
	      );
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange(field, getValue) {
	      var _this2 = this;
	
	      return function (event) {
	        var value = getValue(event);
	        _this2.props.onChange((0, _ramda.merge)(_this2.props.value, _defineProperty({}, field, value)));
	      };
	    }
	  }]);
	
	  return EditUserForm;
	})(_react2['default'].Component);
	
	exports['default'] = EditUserForm;
	module.exports = exports['default'];

/***/ }),

/***/ 2188:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _ramda = __webpack_require__(27);
	
	var _ramda2 = _interopRequireDefault(_ramda);
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _modulesAutoBind = __webpack_require__(29);
	
	var _modulesAutoBind2 = _interopRequireDefault(_modulesAutoBind);
	
	var _common = __webpack_require__(95);
	
	var style = {
	  margin: '10px'
	};
	
	var FilterControls = (function (_React$Component) {
	  _inherits(FilterControls, _React$Component);
	
	  function FilterControls(props) {
	    _classCallCheck(this, FilterControls);
	
	    _get(Object.getPrototypeOf(FilterControls.prototype), 'constructor', this).call(this, props);
	    (0, _modulesAutoBind2['default'])(this);
	    this.state = {
	      name: '',
	      company: '',
	      email: '',
	      stage: '',
	      sexo: ''
	    };
	  }
	
	  _createClass(FilterControls, [{
	    key: 'render',
	    value: function render() {
	      var _this = this;
	
	      return _react2['default'].createElement(
	        'form',
	        { className: 'form form-inline', style: { border: '1px solid black', margin: '10px' } },
	        _react2['default'].createElement(
	          'h2',
	          { style: { margin: '10px' } },
	          'Filtrar'
	        ),
	        _react2['default'].createElement('input', { className: 'form-control', style: style, type: 'text', placeholder: 'Nombre', value: this.state.name, onChange: this.handleTextboxChange('name') }),
	        _react2['default'].createElement('input', { className: 'form-control', style: style, type: 'text', placeholder: 'Empresa', value: this.state.company, onChange: this.handleTextboxChange('company') }),
	        _react2['default'].createElement('input', { className: 'form-control', style: style, type: 'text', placeholder: 'Email', value: this.state.email, onChange: this.handleTextboxChange('email') }),
	        _react2['default'].createElement('input', { className: 'form-control', style: style, type: 'text', placeholder: 'Consultor', value: this.state.consultor, onChange: this.handleTextboxChange('consultant') }),
	        _react2['default'].createElement(
	          'select',
	          { className: 'form-control', style: style, onChange: function (e) {
	              return _this.setState({ sex: e.target.value });
	            } },
	          _react2['default'].createElement(
	            'option',
	            { value: '' },
	            'Sexo'
	          ),
	          _react2['default'].createElement(
	            'option',
	            { value: 'M' },
	            'Masculino'
	          ),
	          _react2['default'].createElement(
	            'option',
	            { value: 'F' },
	            'Femenino'
	          )
	        ),
	        _react2['default'].createElement(
	          'select',
	          { className: 'form-control', style: style, onChange: function (e) {
	              return _this.setState({ stage: e.target.value });
	            } },
	          _react2['default'].createElement(
	            'option',
	            { value: '' },
	            'Estatus'
	          ),
	          _react2['default'].createElement(
	            'option',
	            { value: '0' },
	            'No Iniciado'
	          ),
	          _react2['default'].createElement(
	            'option',
	            { value: '1' },
	            'Cuestionario 1'
	          ),
	          _react2['default'].createElement(
	            'option',
	            { value: '2' },
	            'Cuestionario 2'
	          ),
	          _react2['default'].createElement(
	            'option',
	            { value: '3' },
	            'Completado'
	          )
	        ),
	        _react2['default'].createElement(
	          'div',
	          null,
	          _react2['default'].createElement(
	            'button',
	            { type: 'submit', style: style, className: 'btn btn-default', disabled: !this.valid(), onClick: this.handleSubmit },
	            'Filtrar'
	          )
	        )
	      );
	    }
	  }, {
	    key: 'handleTextboxChange',
	    value: function handleTextboxChange(propName) {
	      var _this2 = this;
	
	      return function (event) {
	        _this2.setState(_defineProperty({}, propName, event.target.value));
	      };
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit(event) {
	      event.preventDefault();
	      this.props.onSubmit(this.state);
	    }
	  }, {
	    key: 'valid',
	    value: function valid() {
	      var formValidations = {
	        name: _ramda2['default'].either(_common.validations.name, _ramda2['default'].isEmpty),
	        company: _ramda2['default'].either(_common.validations.company, _ramda2['default'].isEmpty),
	        email: _ramda2['default'].either(_common.validations.email, _ramda2['default'].isEmpty)
	      };
	
	      return _common.validations.validateObject(formValidations, this.state);
	    }
	  }]);
	
	  return FilterControls;
	})(_react2['default'].Component);
	
	exports['default'] = FilterControls;
	module.exports = exports['default'];

/***/ }),

/***/ 2189:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _ChartJsx = __webpack_require__(1023);
	
	var _ChartJsx2 = _interopRequireDefault(_ChartJsx);
	
	exports['default'] = {
	  XTNATrabajoChart: _ChartJsx2['default']
	};
	module.exports = exports['default'];

/***/ }),

/***/ 2190:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var style = {
	    backgroundColor: "#F8F8F8",
	    borderTop: "1px solid #E7E7E7",
	    textAlign: "right",
	    padding: "20px",
	    position: "fixed",
	    left: "0",
	    bottom: "0",
	    height: "80px",
	    width: "100%",
	    zIndex: "3"
	};
	
	var phantom = {
	    display: 'block',
	    padding: '20px',
	    height: '60px',
	    width: '100%'
	};
	
	function Footer(_ref) {
	    var children = _ref.children;
	
	    return _react2["default"].createElement(
	        "div",
	        null,
	        _react2["default"].createElement("div", { style: phantom }),
	        _react2["default"].createElement(
	            "div",
	            { style: style },
	            children
	        )
	    );
	}
	
	exports["default"] = Footer;
	module.exports = exports["default"];

/***/ }),

/***/ 2191:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	exports['default'] = function () {
	    var ua = navigator.userAgent,
	        tem,
	        M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
	    if (/trident/i.test(M[1])) {
	        tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
	        return { name: 'IE', version: tem[1] || '' };
	    }
	    if (M[1] === 'Chrome') {
	        tem = ua.match(/\bOPR\/(\d+)/);
	        if (tem != null) {
	            return { name: 'Opera', version: tem[1] };
	        }
	    }
	    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
	    if ((tem = ua.match(/version\/(\d+)/i)) != null) {
	        M.splice(1, 1, tem[1]);
	    }
	    return {
	        name: M[0],
	        version: M[1]
	    };
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 2192:
/***/ (function(module, exports) {

	'use strict';
	
	if (typeof window !== 'undefined') {
	  CanvasRenderingContext2D.prototype.dashedLine = function (x1, y1, x2, y2, dashLen) {
	    this.beginPath();
	    dashLen = dashLen || 1;
	
	    this.moveTo(x1, y1);
	
	    var dX = x2 - x1;
	    var dY = y2 - y1;
	    var dashes = Math.floor(Math.sqrt(dX * dX + dY * dY) / dashLen);
	    var dashX = dX / dashes;
	    var dashY = dY / dashes;
	
	    var q = 0;
	    while (q++ < dashes) {
	      x1 += dashX;
	      y1 += dashY;
	      this[q % 2 == 0 ? 'moveTo' : 'lineTo'](x1, y1);
	    }
	    this[q % 2 == 0 ? 'moveTo' : 'lineTo'](x2, y2);
	    this.stroke();
	  };
	}

/***/ }),

/***/ 2193:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _ramda = __webpack_require__(27);
	
	var _bluebird = __webpack_require__(225);
	
	var _bluebird2 = _interopRequireDefault(_bluebird);
	
	var _jquery = __webpack_require__(35);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _jszip = __webpack_require__(398);
	
	var _jszip2 = _interopRequireDefault(_jszip);
	
	var readExcelFile = function readExcelFile(cells, sheetNum, zip) {
	  var invalidFile = function invalidFile() {
	    throw new Error('Invalid File');
	  };
	
	  var sheetName = 'xl/worksheets/sheet' + sheetNum + '.xml';
	  if (typeof zip.files[sheetName] === 'undefined') {
	    return invalidFile();
	  }
	
	  var xmlData = zip.folder('xl').folder('worksheets').file('sheet' + sheetNum + '.xml').asText();
	  var $xml = (0, _jquery2['default'])(_jquery2['default'].parseXML(xmlData));
	
	  var getCell = function getCell(cellId) {
	    var cells = $xml.find('c[r=\'' + cellId + '\']');
	    return [cellId, cells.length ? (0, _jquery2['default'])(cells[0]).children('v')[0].innerHTML : null];
	  };
	
	  return (0, _ramda.fromPairs)((0, _ramda.map)(getCell, cells));
	};
	
	exports['default'] = function (cells, sheetNum, file) {
	  var reader = new FileReader();
	
	  var dataPromise = new _bluebird2['default'](function (resolve, reject) {
	    reader.onload = function (event) {
	      try {
	        resolve(readExcelFile(cells, sheetNum, new _jszip2['default'](event.target.result)));
	      } catch (e) {
	        reject(e);
	      }
	    };
	  });
	
	  reader.readAsArrayBuffer(file);
	  return dataPromise;
	};
	
	;
	module.exports = exports['default'];

/***/ }),

/***/ 2484:
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(283)();
	// imports
	
	
	// module
	exports.push([module.id, ".react-date-field{position:relative;overflow:visible;vertical-align:middle}.react-date-field,.react-date-field *,.react-date-field :after,.react-date-field :before{box-sizing:border-box}.react-date-field>.react-date-field__picker{min-width:100%;position:absolute;z-index:100;left:-1px;background:#fff}.react-date-field--picker-position-bottom>.react-date-field__picker{top:100%}.react-date-field--picker-position-top>.react-date-field__picker{bottom:100%}.react-date-field__input{width:100%;-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;padding:5px;border:none;outline:none}.react-date-field__calendar-icon{border:3px solid gray;border-top-width:5px;border-radius:2px;padding:5px 7px;margin:2px 4px 0 2px;position:relative}.react-date-field__clear-icon{color:gray;fill:gray;margin:0 2px;cursor:pointer}.react-date-field__clear-icon svg{vertical-align:middle}.react-date-field__clear-icon:hover{color:#4d4d4d;fill:#4d4d4d}.react-date-field__calendar-icon:after,.react-date-field__calendar-icon:before{content:\"\";width:3px;height:6px;border-radius:10px;left:1px;top:-6px;position:absolute;background:gray}.react-date-field__calendar-icon:after{left:auto;right:0}.react-date-field__calendar-icon-inner{background:gray;position:absolute;border-radius:1px;top:2px;left:2px;width:4px;height:4px}.react-date-picker__clock{box-sizing:border-box;display:inline-block;border:5px solid gray;border-radius:50%;position:relative}.react-date-picker__clock *,.react-date-picker__clock :after,.react-date-picker__clock :before{box-sizing:border-box}.react-date-picker__clock-center,.react-date-picker__clock-overlay{border-radius:50%;position:absolute;-webkit-transform:translate3d(-50%,-50%,0);transform:translate3d(-50%,-50%,0);top:50%;left:50%}.react-date-picker__clock-hand,.react-date-picker__clock-tick{position:absolute;left:50%;top:50%;width:1px;background:gray}.react-date-picker__date-format-spinner,.react-date-picker__date-format-spinner *,.react-date-picker__date-format-spinner :after,.react-date-picker__date-format-spinner :before,.react-date-picker__time-picker,.react-date-picker__time-picker *,.react-date-picker__time-picker :after,.react-date-picker__time-picker :before{box-sizing:border-box}.react-date-picker__time-picker-input{margin-top:10px}.react-date-picker__year-view{box-sizing:border-box;outline:none}.react-date-picker__year-view *,.react-date-picker__year-view :after,.react-date-picker__year-view :before{box-sizing:border-box}.react-date-picker__year-view-month{text-align:center}.react-date-picker__decade-view{box-sizing:border-box;outline:none}.react-date-picker__decade-view *,.react-date-picker__decade-view :after,.react-date-picker__decade-view :before{box-sizing:border-box}.react-date-picker__decade-view-year{text-align:center}.react-date-picker__history-view{box-sizing:border-box;outline:none}.react-date-picker__history-view *,.react-date-picker__history-view :after,.react-date-picker__history-view :before{box-sizing:border-box}.react-date-picker__nav-bar{box-sizing:border-box;outline:none;position:relative}.react-date-picker__nav-bar *,.react-date-picker__nav-bar :after,.react-date-picker__nav-bar :before{box-sizing:border-box}.react-date-picker__nav-bar-arrow{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:pointer;position:relative}.react-date-picker__nav-bar-arrow--disabled{fill:#bfbfbf;cursor:default}.react-date-picker__nav-bar-date{text-overflow:ellipsis;white-space:nowrap;overflow:hidden}.react-date-picker__nav-bar svg{vertical-align:middle}.react-date-picker__nav-bar-history-view{z-index:100;position:absolute;margin:auto;left:3px;right:3px;top:100%}.react-date-picker,.react-date-picker *,.react-date-picker :after,.react-date-picker :before,.react-date-picker__basic-month-view,.react-date-picker__basic-month-view *,.react-date-picker__basic-month-view :after,.react-date-picker__basic-month-view :before,.react-date-picker__calendar,.react-date-picker__calendar *,.react-date-picker__calendar :after,.react-date-picker__calendar :before{box-sizing:border-box}.react-date-picker__transition-month-view{position:relative;overflow:hidden}.react-date-picker__prev{-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0)}.react-date-picker__next{-webkit-transform:translate3d(100%,0,0);transform:translate3d(100%,0,0)}.react-date-picker--transition-left{-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0)}.react-date-picker--transition-left.react-date-picker__next{-webkit-transform:translateZ(0);transform:translateZ(0)}.react-date-picker--transition-right{z-index:1111;-webkit-transform:translate3d(100%,0,0);transform:translate3d(100%,0,0)}.react-date-picker--transition-right.react-date-picker__prev{-webkit-transform:translateZ(0);transform:translateZ(0)}.react-date-picker__center{z-index:10}.react-date-picker__center.react-date-picker--transition,.react-date-picker__next.react-date-picker--transition,.react-date-picker__prev.react-date-picker--transition{transition-property:-webkit-transform;transition-property:transform;transition-property:transform,-webkit-transform}.react-date-picker__next,.react-date-picker__prev{top:0;left:0;height:100%;width:100%;position:absolute!important}.react-date-picker__basic-month-view,.react-date-picker__month-view{position:relative;outline:none}.react-date-picker__basic-month-view-week-day-name,.react-date-picker__month-view-week-day-name{padding:5px 0}.react-date-picker__basic-month-view-day--hidden,.react-date-picker__month-view-day--hidden{visibility:hidden}.react-date-picker__basic-month-view-day--disabled,.react-date-picker__month-view-day--disabled{color:#bfbfbf}.react-date-picker__basic-month-view-cell,.react-date-picker__month-view-cell{-webkit-box-flex:1;-ms-flex:1 0 auto;flex:1 0 auto;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-flow:row;flex-flow:row;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.react-date-picker__basic-month-view-row,.react-date-picker__month-view-row{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-flow:row;flex-flow:row;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-ms-flex-negative:0;flex-shrink:0;-ms-flex-preferred-size:auto;flex-basis:auto}.react-date-picker__basic-month-view-week-day-names,.react-date-picker__month-view-week-day-names{-webkit-box-flex:0;-ms-flex:none;flex:none}.react-flex-v2{display:-webkit-box;display:-ms-flexbox;display:flex}.react-flex-v2--inline{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex}.react-flex-v2--display-flex{display:-webkit-box;display:-ms-flexbox;display:flex}.react-flex-v2--display-inline-flex{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex}.react-flex-v2--align-items-center{-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;-ms-grid-row-align:center;align-items:center}.react-flex-v2--align-items-stretch{-webkit-box-align:stretch;-webkit-align-items:stretch;-ms-flex-align:stretch;-ms-grid-row-align:stretch;align-items:stretch}.react-flex-v2--align-items-baseline{-webkit-box-align:baseline;-webkit-align-items:baseline;-ms-flex-align:baseline;-ms-grid-row-align:baseline;align-items:baseline}.react-flex-v2--align-items-end,.react-flex-v2--align-items-flex-end{-webkit-box-align:end;-webkit-align-items:flex-end;-ms-flex-align:end;-ms-grid-row-align:flex-end;align-items:flex-end}.react-flex-v2--align-items-flex-start,.react-flex-v2--align-items-start{-webkit-box-align:start;-webkit-align-items:flex-start;-ms-flex-align:start;-ms-grid-row-align:flex-start;align-items:flex-start}.react-flex-v2--align-self-center{-webkit-align-self:center;-ms-flex-item-align:center;align-self:center}.react-flex-v2--align-self-stretch{-webkit-align-self:stretch;-ms-flex-item-align:stretch;align-self:stretch}.react-flex-v2--align-self-baseline{-webkit-align-self:baseline;-ms-flex-item-align:baseline;align-self:baseline}.react-flex-v2--align-self-auto{-webkit-align-self:auto;-ms-flex-item-align:auto;align-self:auto}.react-flex-v2--align-self-end,.react-flex-v2--align-self-flex-end{-webkit-align-self:flex-end;-ms-flex-item-align:end;align-self:flex-end}.react-flex-v2--align-self-flex-start,.react-flex-v2--align-self-start{-webkit-align-self:flex-start;-ms-flex-item-align:start;align-self:flex-start}.react-flex-v2--align-content-center{-ms-flex-line-pack:center;align-content:center}.react-flex-v2--align-content-stretch{-ms-flex-line-pack:stretch;align-content:stretch}.react-flex-v2--align-content-around,.react-flex-v2--align-content-space-around{-ms-flex-line-pack:distribute;align-content:space-around}.react-flex-v2--align-content-between,.react-flex-v2--align-content-space-between{-ms-flex-line-pack:justify;align-content:space-between}.react-flex-v2--align-content-end,.react-flex-v2--align-content-flex-end{-ms-flex-line-pack:end;align-content:flex-end}.react-flex-v2--align-content-flex-start,.react-flex-v2--align-content-start{-ms-flex-line-pack:start;align-content:flex-start}.react-flex-v2--justify-content-flex-start,.react-flex-v2--justify-content-start{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.react-flex-v2--justify-content-end,.react-flex-v2--justify-content-flex-end{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}.react-flex-v2--justify-content-center{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.react-flex-v2--justify-content-space-around{-ms-flex-pack:distribute;justify-content:space-around}.react-flex-v2--justify-content-space-between{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.react-flex-v2--wrap{-ms-flex-wrap:wrap;flex-wrap:wrap}.react-flex-v2--column{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.react-flex-v2--column-reverse{-webkit-box-orient:vertical;-webkit-box-direction:reverse;-ms-flex-direction:column-reverse;flex-direction:column-reverse}.react-flex-v2--row{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}.react-flex-v2--row-reverse{-webkit-box-orient:horizontal;-webkit-box-direction:reverse;-ms-flex-direction:row-reverse;flex-direction:row-reverse}.react-flex-v2--flex-basis-auto{-ms-flex-preferred-size:auto;flex-basis:auto}.react-flex-v2--flex-basis-0,.react-flex-v2--flex-basis-none{-ms-flex-preferred-size:0px;flex-basis:0px}.react-flex-v2--flex-basis-fill{-ms-flex-preferred-size:fill;flex-basis:fill}.react-flex-v2--flex-basis-content{-ms-flex-preferred-size:content;flex-basis:content}.react-flex-v2--flex-basis-fit-content{-ms-flex-preferred-size:fit-content;flex-basis:fit-content}.react-flex-v2--flex-basis-min-content{-ms-flex-preferred-size:min-content;flex-basis:min-content}.react-flex-v2--flex-basis-max-content{-ms-flex-preferred-size:max-content;flex-basis:max-content}.react-flex-v2--flex-0,.react-flex-v2--flex-none{-webkit-box-flex:0;-ms-flex:none;flex:none}.react-flex-v2--flex-1{-webkit-box-flex:1;-ms-flex:1;flex:1}.react-flex-v2--flex-2{-webkit-box-flex:2;-ms-flex:2;flex:2}.react-flex-v2--flex-3{-webkit-box-flex:3;-ms-flex:3;flex:3}.react-flex-v2--flex-4{-webkit-box-flex:4;-ms-flex:4;flex:4}.react-flex-v2--flex-5{-webkit-box-flex:5;-ms-flex:5;flex:5}.react-flex-v2--flex-6{-webkit-box-flex:6;-ms-flex:6;flex:6}.react-flex-v2--flex-7{-webkit-box-flex:7;-ms-flex:7;flex:7}.react-flex-v2--flex-8{-webkit-box-flex:8;-ms-flex:8;flex:8}.react-flex-v2--flex-9{-webkit-box-flex:9;-ms-flex:9;flex:9}.react-flex-v2--flex-10{-webkit-box-flex:10;-ms-flex:10;flex:10}.react-flex-v2--flex-11{-webkit-box-flex:11;-ms-flex:11;flex:11}.react-flex-v2--flex-12{-webkit-box-flex:12;-ms-flex:12;flex:12}.react-flex-v2--flex-13{-webkit-box-flex:13;-ms-flex:13;flex:13}.react-flex-v2--flex-14{-webkit-box-flex:14;-ms-flex:14;flex:14}.react-flex-v2--flex-15{-webkit-box-flex:15;-ms-flex:15;flex:15}.react-flex-v2--flex-16{-webkit-box-flex:16;-ms-flex:16;flex:16}.react-flex-v2--flex-17{-webkit-box-flex:17;-ms-flex:17;flex:17}.react-flex-v2--flex-18{-webkit-box-flex:18;-ms-flex:18;flex:18}.react-flex-v2--flex-19{-webkit-box-flex:19;-ms-flex:19;flex:19}.react-flex-v2--flex-20{-webkit-box-flex:20;-ms-flex:20;flex:20}.react-flex-v2--flex-21{-webkit-box-flex:21;-ms-flex:21;flex:21}.react-flex-v2--flex-22{-webkit-box-flex:22;-ms-flex:22;flex:22}.react-flex-v2--flex-23{-webkit-box-flex:23;-ms-flex:23;flex:23}.react-flex-v2--flex-24{-webkit-box-flex:24;-ms-flex:24;flex:24}.react-flex-v2--flex-25{-webkit-box-flex:25;-ms-flex:25;flex:25}.react-flex-v2--flex-26{-webkit-box-flex:26;-ms-flex:26;flex:26}.react-flex-v2--flex-27{-webkit-box-flex:27;-ms-flex:27;flex:27}.react-flex-v2--flex-28{-webkit-box-flex:28;-ms-flex:28;flex:28}.react-flex-v2--flex-29{-webkit-box-flex:29;-ms-flex:29;flex:29}.react-flex-v2--flex-30{-webkit-box-flex:30;-ms-flex:30;flex:30}.react-flex-v2--flex-31{-webkit-box-flex:31;-ms-flex:31;flex:31}.react-flex-v2--flex-32{-webkit-box-flex:32;-ms-flex:32;flex:32}.react-flex-v2--flex-33{-webkit-box-flex:33;-ms-flex:33;flex:33}.react-flex-v2--flex-34{-webkit-box-flex:34;-ms-flex:34;flex:34}.react-flex-v2--flex-35{-webkit-box-flex:35;-ms-flex:35;flex:35}.react-flex-v2--flex-36{-webkit-box-flex:36;-ms-flex:36;flex:36}.react-flex-v2--flex-37{-webkit-box-flex:37;-ms-flex:37;flex:37}.react-flex-v2--flex-38{-webkit-box-flex:38;-ms-flex:38;flex:38}.react-flex-v2--flex-39{-webkit-box-flex:39;-ms-flex:39;flex:39}.react-flex-v2--flex-40{-webkit-box-flex:40;-ms-flex:40;flex:40}.react-flex-v2--flex-41{-webkit-box-flex:41;-ms-flex:41;flex:41}.react-flex-v2--flex-42{-webkit-box-flex:42;-ms-flex:42;flex:42}.react-flex-v2--flex-43{-webkit-box-flex:43;-ms-flex:43;flex:43}.react-flex-v2--flex-44{-webkit-box-flex:44;-ms-flex:44;flex:44}.react-flex-v2--flex-45{-webkit-box-flex:45;-ms-flex:45;flex:45}.react-flex-v2--flex-46{-webkit-box-flex:46;-ms-flex:46;flex:46}.react-flex-v2--flex-47{-webkit-box-flex:47;-ms-flex:47;flex:47}.react-flex-v2--flex-48{-webkit-box-flex:48;-ms-flex:48;flex:48}.react-flex-v2--flex-49{-webkit-box-flex:49;-ms-flex:49;flex:49}.react-flex-v2--flex-50{-webkit-box-flex:50;-ms-flex:50;flex:50}.react-flex-v2--flex-51{-webkit-box-flex:51;-ms-flex:51;flex:51}.react-flex-v2--flex-52{-webkit-box-flex:52;-ms-flex:52;flex:52}.react-flex-v2--flex-53{-webkit-box-flex:53;-ms-flex:53;flex:53}.react-flex-v2--flex-54{-webkit-box-flex:54;-ms-flex:54;flex:54}.react-flex-v2--flex-55{-webkit-box-flex:55;-ms-flex:55;flex:55}.react-flex-v2--flex-56{-webkit-box-flex:56;-ms-flex:56;flex:56}.react-flex-v2--flex-57{-webkit-box-flex:57;-ms-flex:57;flex:57}.react-flex-v2--flex-58{-webkit-box-flex:58;-ms-flex:58;flex:58}.react-flex-v2--flex-59{-webkit-box-flex:59;-ms-flex:59;flex:59}.react-flex-v2--flex-60{-webkit-box-flex:60;-ms-flex:60;flex:60}.react-flex-v2--flex-61{-webkit-box-flex:61;-ms-flex:61;flex:61}.react-flex-v2--flex-62{-webkit-box-flex:62;-ms-flex:62;flex:62}.react-flex-v2--flex-63{-webkit-box-flex:63;-ms-flex:63;flex:63}.react-flex-v2--flex-64{-webkit-box-flex:64;-ms-flex:64;flex:64}.react-flex-v2--flex-65{-webkit-box-flex:65;-ms-flex:65;flex:65}.react-flex-v2--flex-66{-webkit-box-flex:66;-ms-flex:66;flex:66}.react-flex-v2--flex-67{-webkit-box-flex:67;-ms-flex:67;flex:67}.react-flex-v2--flex-68{-webkit-box-flex:68;-ms-flex:68;flex:68}.react-flex-v2--flex-69{-webkit-box-flex:69;-ms-flex:69;flex:69}.react-flex-v2--flex-70{-webkit-box-flex:70;-ms-flex:70;flex:70}.react-flex-v2--flex-71{-webkit-box-flex:71;-ms-flex:71;flex:71}.react-flex-v2--flex-72{-webkit-box-flex:72;-ms-flex:72;flex:72}.react-flex-v2--flex-73{-webkit-box-flex:73;-ms-flex:73;flex:73}.react-flex-v2--flex-74{-webkit-box-flex:74;-ms-flex:74;flex:74}.react-flex-v2--flex-75{-webkit-box-flex:75;-ms-flex:75;flex:75}.react-flex-v2--flex-76{-webkit-box-flex:76;-ms-flex:76;flex:76}.react-flex-v2--flex-77{-webkit-box-flex:77;-ms-flex:77;flex:77}.react-flex-v2--flex-78{-webkit-box-flex:78;-ms-flex:78;flex:78}.react-flex-v2--flex-79{-webkit-box-flex:79;-ms-flex:79;flex:79}.react-flex-v2--flex-80{-webkit-box-flex:80;-ms-flex:80;flex:80}.react-flex-v2--flex-81{-webkit-box-flex:81;-ms-flex:81;flex:81}.react-flex-v2--flex-82{-webkit-box-flex:82;-ms-flex:82;flex:82}.react-flex-v2--flex-83{-webkit-box-flex:83;-ms-flex:83;flex:83}.react-flex-v2--flex-84{-webkit-box-flex:84;-ms-flex:84;flex:84}.react-flex-v2--flex-85{-webkit-box-flex:85;-ms-flex:85;flex:85}.react-flex-v2--flex-86{-webkit-box-flex:86;-ms-flex:86;flex:86}.react-flex-v2--flex-87{-webkit-box-flex:87;-ms-flex:87;flex:87}.react-flex-v2--flex-88{-webkit-box-flex:88;-ms-flex:88;flex:88}.react-flex-v2--flex-89{-webkit-box-flex:89;-ms-flex:89;flex:89}.react-flex-v2--flex-90{-webkit-box-flex:90;-ms-flex:90;flex:90}.react-flex-v2--flex-91{-webkit-box-flex:91;-ms-flex:91;flex:91}.react-flex-v2--flex-92{-webkit-box-flex:92;-ms-flex:92;flex:92}.react-flex-v2--flex-93{-webkit-box-flex:93;-ms-flex:93;flex:93}.react-flex-v2--flex-94{-webkit-box-flex:94;-ms-flex:94;flex:94}.react-flex-v2--flex-95{-webkit-box-flex:95;-ms-flex:95;flex:95}.react-flex-v2--flex-96{-webkit-box-flex:96;-ms-flex:96;flex:96}.react-flex-v2--flex-97{-webkit-box-flex:97;-ms-flex:97;flex:97}.react-flex-v2--flex-98{-webkit-box-flex:98;-ms-flex:98;flex:98}.react-flex-v2--flex-99{-webkit-box-flex:99;-ms-flex:99;flex:99}.react-flex-v2--flex-100{-webkit-box-flex:100;-ms-flex:100;flex:100}.react-flex-v2--flex-grow-0{-webkit-box-flex:0;-ms-flex-positive:0;flex-grow:0}.react-flex-v2--flex-grow-1{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}.react-flex-v2--flex-grow-2{-webkit-box-flex:2;-ms-flex-positive:2;flex-grow:2}.react-flex-v2--flex-grow-3{-webkit-box-flex:3;-ms-flex-positive:3;flex-grow:3}.react-flex-v2--flex-grow-4{-webkit-box-flex:4;-ms-flex-positive:4;flex-grow:4}.react-flex-v2--flex-grow-5{-webkit-box-flex:5;-ms-flex-positive:5;flex-grow:5}.react-flex-v2--flex-grow-6{-webkit-box-flex:6;-ms-flex-positive:6;flex-grow:6}.react-flex-v2--flex-grow-7{-webkit-box-flex:7;-ms-flex-positive:7;flex-grow:7}.react-flex-v2--flex-grow-8{-webkit-box-flex:8;-ms-flex-positive:8;flex-grow:8}.react-flex-v2--flex-grow-9{-webkit-box-flex:9;-ms-flex-positive:9;flex-grow:9}.react-flex-v2--flex-grow-10{-webkit-box-flex:10;-ms-flex-positive:10;flex-grow:10}.react-flex-v2--flex-grow-11{-webkit-box-flex:11;-ms-flex-positive:11;flex-grow:11}.react-flex-v2--flex-grow-12{-webkit-box-flex:12;-ms-flex-positive:12;flex-grow:12}.react-flex-v2--flex-grow-13{-webkit-box-flex:13;-ms-flex-positive:13;flex-grow:13}.react-flex-v2--flex-grow-14{-webkit-box-flex:14;-ms-flex-positive:14;flex-grow:14}.react-flex-v2--flex-grow-15{-webkit-box-flex:15;-ms-flex-positive:15;flex-grow:15}.react-flex-v2--flex-grow-16{-webkit-box-flex:16;-ms-flex-positive:16;flex-grow:16}.react-flex-v2--flex-grow-17{-webkit-box-flex:17;-ms-flex-positive:17;flex-grow:17}.react-flex-v2--flex-grow-18{-webkit-box-flex:18;-ms-flex-positive:18;flex-grow:18}.react-flex-v2--flex-grow-19{-webkit-box-flex:19;-ms-flex-positive:19;flex-grow:19}.react-flex-v2--flex-grow-20{-webkit-box-flex:20;-ms-flex-positive:20;flex-grow:20}.react-flex-v2--flex-grow-21{-webkit-box-flex:21;-ms-flex-positive:21;flex-grow:21}.react-flex-v2--flex-grow-22{-webkit-box-flex:22;-ms-flex-positive:22;flex-grow:22}.react-flex-v2--flex-grow-23{-webkit-box-flex:23;-ms-flex-positive:23;flex-grow:23}.react-flex-v2--flex-grow-24{-webkit-box-flex:24;-ms-flex-positive:24;flex-grow:24}.react-flex-v2--flex-grow-25{-webkit-box-flex:25;-ms-flex-positive:25;flex-grow:25}.react-flex-v2--flex-grow-26{-webkit-box-flex:26;-ms-flex-positive:26;flex-grow:26}.react-flex-v2--flex-grow-27{-webkit-box-flex:27;-ms-flex-positive:27;flex-grow:27}.react-flex-v2--flex-grow-28{-webkit-box-flex:28;-ms-flex-positive:28;flex-grow:28}.react-flex-v2--flex-grow-29{-webkit-box-flex:29;-ms-flex-positive:29;flex-grow:29}.react-flex-v2--flex-grow-30{-webkit-box-flex:30;-ms-flex-positive:30;flex-grow:30}.react-flex-v2--flex-grow-31{-webkit-box-flex:31;-ms-flex-positive:31;flex-grow:31}.react-flex-v2--flex-grow-32{-webkit-box-flex:32;-ms-flex-positive:32;flex-grow:32}.react-flex-v2--flex-grow-33{-webkit-box-flex:33;-ms-flex-positive:33;flex-grow:33}.react-flex-v2--flex-grow-34{-webkit-box-flex:34;-ms-flex-positive:34;flex-grow:34}.react-flex-v2--flex-grow-35{-webkit-box-flex:35;-ms-flex-positive:35;flex-grow:35}.react-flex-v2--flex-grow-36{-webkit-box-flex:36;-ms-flex-positive:36;flex-grow:36}.react-flex-v2--flex-grow-37{-webkit-box-flex:37;-ms-flex-positive:37;flex-grow:37}.react-flex-v2--flex-grow-38{-webkit-box-flex:38;-ms-flex-positive:38;flex-grow:38}.react-flex-v2--flex-grow-39{-webkit-box-flex:39;-ms-flex-positive:39;flex-grow:39}.react-flex-v2--flex-grow-40{-webkit-box-flex:40;-ms-flex-positive:40;flex-grow:40}.react-flex-v2--flex-grow-41{-webkit-box-flex:41;-ms-flex-positive:41;flex-grow:41}.react-flex-v2--flex-grow-42{-webkit-box-flex:42;-ms-flex-positive:42;flex-grow:42}.react-flex-v2--flex-grow-43{-webkit-box-flex:43;-ms-flex-positive:43;flex-grow:43}.react-flex-v2--flex-grow-44{-webkit-box-flex:44;-ms-flex-positive:44;flex-grow:44}.react-flex-v2--flex-grow-45{-webkit-box-flex:45;-ms-flex-positive:45;flex-grow:45}.react-flex-v2--flex-grow-46{-webkit-box-flex:46;-ms-flex-positive:46;flex-grow:46}.react-flex-v2--flex-grow-47{-webkit-box-flex:47;-ms-flex-positive:47;flex-grow:47}.react-flex-v2--flex-grow-48{-webkit-box-flex:48;-ms-flex-positive:48;flex-grow:48}.react-flex-v2--flex-grow-49{-webkit-box-flex:49;-ms-flex-positive:49;flex-grow:49}.react-flex-v2--flex-grow-50{-webkit-box-flex:50;-ms-flex-positive:50;flex-grow:50}.react-flex-v2--flex-grow-51{-webkit-box-flex:51;-ms-flex-positive:51;flex-grow:51}.react-flex-v2--flex-grow-52{-webkit-box-flex:52;-ms-flex-positive:52;flex-grow:52}.react-flex-v2--flex-grow-53{-webkit-box-flex:53;-ms-flex-positive:53;flex-grow:53}.react-flex-v2--flex-grow-54{-webkit-box-flex:54;-ms-flex-positive:54;flex-grow:54}.react-flex-v2--flex-grow-55{-webkit-box-flex:55;-ms-flex-positive:55;flex-grow:55}.react-flex-v2--flex-grow-56{-webkit-box-flex:56;-ms-flex-positive:56;flex-grow:56}.react-flex-v2--flex-grow-57{-webkit-box-flex:57;-ms-flex-positive:57;flex-grow:57}.react-flex-v2--flex-grow-58{-webkit-box-flex:58;-ms-flex-positive:58;flex-grow:58}.react-flex-v2--flex-grow-59{-webkit-box-flex:59;-ms-flex-positive:59;flex-grow:59}.react-flex-v2--flex-grow-60{-webkit-box-flex:60;-ms-flex-positive:60;flex-grow:60}.react-flex-v2--flex-grow-61{-webkit-box-flex:61;-ms-flex-positive:61;flex-grow:61}.react-flex-v2--flex-grow-62{-webkit-box-flex:62;-ms-flex-positive:62;flex-grow:62}.react-flex-v2--flex-grow-63{-webkit-box-flex:63;-ms-flex-positive:63;flex-grow:63}.react-flex-v2--flex-grow-64{-webkit-box-flex:64;-ms-flex-positive:64;flex-grow:64}.react-flex-v2--flex-grow-65{-webkit-box-flex:65;-ms-flex-positive:65;flex-grow:65}.react-flex-v2--flex-grow-66{-webkit-box-flex:66;-ms-flex-positive:66;flex-grow:66}.react-flex-v2--flex-grow-67{-webkit-box-flex:67;-ms-flex-positive:67;flex-grow:67}.react-flex-v2--flex-grow-68{-webkit-box-flex:68;-ms-flex-positive:68;flex-grow:68}.react-flex-v2--flex-grow-69{-webkit-box-flex:69;-ms-flex-positive:69;flex-grow:69}.react-flex-v2--flex-grow-70{-webkit-box-flex:70;-ms-flex-positive:70;flex-grow:70}.react-flex-v2--flex-grow-71{-webkit-box-flex:71;-ms-flex-positive:71;flex-grow:71}.react-flex-v2--flex-grow-72{-webkit-box-flex:72;-ms-flex-positive:72;flex-grow:72}.react-flex-v2--flex-grow-73{-webkit-box-flex:73;-ms-flex-positive:73;flex-grow:73}.react-flex-v2--flex-grow-74{-webkit-box-flex:74;-ms-flex-positive:74;flex-grow:74}.react-flex-v2--flex-grow-75{-webkit-box-flex:75;-ms-flex-positive:75;flex-grow:75}.react-flex-v2--flex-grow-76{-webkit-box-flex:76;-ms-flex-positive:76;flex-grow:76}.react-flex-v2--flex-grow-77{-webkit-box-flex:77;-ms-flex-positive:77;flex-grow:77}.react-flex-v2--flex-grow-78{-webkit-box-flex:78;-ms-flex-positive:78;flex-grow:78}.react-flex-v2--flex-grow-79{-webkit-box-flex:79;-ms-flex-positive:79;flex-grow:79}.react-flex-v2--flex-grow-80{-webkit-box-flex:80;-ms-flex-positive:80;flex-grow:80}.react-flex-v2--flex-grow-81{-webkit-box-flex:81;-ms-flex-positive:81;flex-grow:81}.react-flex-v2--flex-grow-82{-webkit-box-flex:82;-ms-flex-positive:82;flex-grow:82}.react-flex-v2--flex-grow-83{-webkit-box-flex:83;-ms-flex-positive:83;flex-grow:83}.react-flex-v2--flex-grow-84{-webkit-box-flex:84;-ms-flex-positive:84;flex-grow:84}.react-flex-v2--flex-grow-85{-webkit-box-flex:85;-ms-flex-positive:85;flex-grow:85}.react-flex-v2--flex-grow-86{-webkit-box-flex:86;-ms-flex-positive:86;flex-grow:86}.react-flex-v2--flex-grow-87{-webkit-box-flex:87;-ms-flex-positive:87;flex-grow:87}.react-flex-v2--flex-grow-88{-webkit-box-flex:88;-ms-flex-positive:88;flex-grow:88}.react-flex-v2--flex-grow-89{-webkit-box-flex:89;-ms-flex-positive:89;flex-grow:89}.react-flex-v2--flex-grow-90{-webkit-box-flex:90;-ms-flex-positive:90;flex-grow:90}.react-flex-v2--flex-grow-91{-webkit-box-flex:91;-ms-flex-positive:91;flex-grow:91}.react-flex-v2--flex-grow-92{-webkit-box-flex:92;-ms-flex-positive:92;flex-grow:92}.react-flex-v2--flex-grow-93{-webkit-box-flex:93;-ms-flex-positive:93;flex-grow:93}.react-flex-v2--flex-grow-94{-webkit-box-flex:94;-ms-flex-positive:94;flex-grow:94}.react-flex-v2--flex-grow-95{-webkit-box-flex:95;-ms-flex-positive:95;flex-grow:95}.react-flex-v2--flex-grow-96{-webkit-box-flex:96;-ms-flex-positive:96;flex-grow:96}.react-flex-v2--flex-grow-97{-webkit-box-flex:97;-ms-flex-positive:97;flex-grow:97}.react-flex-v2--flex-grow-98{-webkit-box-flex:98;-ms-flex-positive:98;flex-grow:98}.react-flex-v2--flex-grow-99{-webkit-box-flex:99;-ms-flex-positive:99;flex-grow:99}.react-flex-v2--flex-grow-100{-webkit-box-flex:100;-ms-flex-positive:100;flex-grow:100}.react-flex-v2--flex-shrink-0{-ms-flex-negative:0;flex-shrink:0}.react-flex-v2--flex-shrink-1{-ms-flex-negative:1;flex-shrink:1}.react-flex-v2--flex-shrink-2{-ms-flex-negative:2;flex-shrink:2}.react-flex-v2--flex-shrink-3{-ms-flex-negative:3;flex-shrink:3}.react-flex-v2--flex-shrink-4{-ms-flex-negative:4;flex-shrink:4}.react-flex-v2--flex-shrink-5{-ms-flex-negative:5;flex-shrink:5}.react-flex-v2--flex-shrink-6{-ms-flex-negative:6;flex-shrink:6}.react-flex-v2--flex-shrink-7{-ms-flex-negative:7;flex-shrink:7}.react-flex-v2--flex-shrink-8{-ms-flex-negative:8;flex-shrink:8}.react-flex-v2--flex-shrink-9{-ms-flex-negative:9;flex-shrink:9}.react-flex-v2--flex-shrink-10{-ms-flex-negative:10;flex-shrink:10}.react-flex-v2--flex-shrink-11{-ms-flex-negative:11;flex-shrink:11}.react-flex-v2--flex-shrink-12{-ms-flex-negative:12;flex-shrink:12}.react-flex-v2--flex-shrink-13{-ms-flex-negative:13;flex-shrink:13}.react-flex-v2--flex-shrink-14{-ms-flex-negative:14;flex-shrink:14}.react-flex-v2--flex-shrink-15{-ms-flex-negative:15;flex-shrink:15}.react-flex-v2--flex-shrink-16{-ms-flex-negative:16;flex-shrink:16}.react-flex-v2--flex-shrink-17{-ms-flex-negative:17;flex-shrink:17}.react-flex-v2--flex-shrink-18{-ms-flex-negative:18;flex-shrink:18}.react-flex-v2--flex-shrink-19{-ms-flex-negative:19;flex-shrink:19}.react-flex-v2--flex-shrink-20{-ms-flex-negative:20;flex-shrink:20}.react-flex-v2--flex-shrink-21{-ms-flex-negative:21;flex-shrink:21}.react-flex-v2--flex-shrink-22{-ms-flex-negative:22;flex-shrink:22}.react-flex-v2--flex-shrink-23{-ms-flex-negative:23;flex-shrink:23}.react-flex-v2--flex-shrink-24{-ms-flex-negative:24;flex-shrink:24}.react-flex-v2--flex-shrink-25{-ms-flex-negative:25;flex-shrink:25}.react-flex-v2--flex-shrink-26{-ms-flex-negative:26;flex-shrink:26}.react-flex-v2--flex-shrink-27{-ms-flex-negative:27;flex-shrink:27}.react-flex-v2--flex-shrink-28{-ms-flex-negative:28;flex-shrink:28}.react-flex-v2--flex-shrink-29{-ms-flex-negative:29;flex-shrink:29}.react-flex-v2--flex-shrink-30{-ms-flex-negative:30;flex-shrink:30}.react-flex-v2--flex-shrink-31{-ms-flex-negative:31;flex-shrink:31}.react-flex-v2--flex-shrink-32{-ms-flex-negative:32;flex-shrink:32}.react-flex-v2--flex-shrink-33{-ms-flex-negative:33;flex-shrink:33}.react-flex-v2--flex-shrink-34{-ms-flex-negative:34;flex-shrink:34}.react-flex-v2--flex-shrink-35{-ms-flex-negative:35;flex-shrink:35}.react-flex-v2--flex-shrink-36{-ms-flex-negative:36;flex-shrink:36}.react-flex-v2--flex-shrink-37{-ms-flex-negative:37;flex-shrink:37}.react-flex-v2--flex-shrink-38{-ms-flex-negative:38;flex-shrink:38}.react-flex-v2--flex-shrink-39{-ms-flex-negative:39;flex-shrink:39}.react-flex-v2--flex-shrink-40{-ms-flex-negative:40;flex-shrink:40}.react-flex-v2--flex-shrink-41{-ms-flex-negative:41;flex-shrink:41}.react-flex-v2--flex-shrink-42{-ms-flex-negative:42;flex-shrink:42}.react-flex-v2--flex-shrink-43{-ms-flex-negative:43;flex-shrink:43}.react-flex-v2--flex-shrink-44{-ms-flex-negative:44;flex-shrink:44}.react-flex-v2--flex-shrink-45{-ms-flex-negative:45;flex-shrink:45}.react-flex-v2--flex-shrink-46{-ms-flex-negative:46;flex-shrink:46}.react-flex-v2--flex-shrink-47{-ms-flex-negative:47;flex-shrink:47}.react-flex-v2--flex-shrink-48{-ms-flex-negative:48;flex-shrink:48}.react-flex-v2--flex-shrink-49{-ms-flex-negative:49;flex-shrink:49}.react-flex-v2--flex-shrink-50{-ms-flex-negative:50;flex-shrink:50}.react-flex-v2--flex-shrink-51{-ms-flex-negative:51;flex-shrink:51}.react-flex-v2--flex-shrink-52{-ms-flex-negative:52;flex-shrink:52}.react-flex-v2--flex-shrink-53{-ms-flex-negative:53;flex-shrink:53}.react-flex-v2--flex-shrink-54{-ms-flex-negative:54;flex-shrink:54}.react-flex-v2--flex-shrink-55{-ms-flex-negative:55;flex-shrink:55}.react-flex-v2--flex-shrink-56{-ms-flex-negative:56;flex-shrink:56}.react-flex-v2--flex-shrink-57{-ms-flex-negative:57;flex-shrink:57}.react-flex-v2--flex-shrink-58{-ms-flex-negative:58;flex-shrink:58}.react-flex-v2--flex-shrink-59{-ms-flex-negative:59;flex-shrink:59}.react-flex-v2--flex-shrink-60{-ms-flex-negative:60;flex-shrink:60}.react-flex-v2--flex-shrink-61{-ms-flex-negative:61;flex-shrink:61}.react-flex-v2--flex-shrink-62{-ms-flex-negative:62;flex-shrink:62}.react-flex-v2--flex-shrink-63{-ms-flex-negative:63;flex-shrink:63}.react-flex-v2--flex-shrink-64{-ms-flex-negative:64;flex-shrink:64}.react-flex-v2--flex-shrink-65{-ms-flex-negative:65;flex-shrink:65}.react-flex-v2--flex-shrink-66{-ms-flex-negative:66;flex-shrink:66}.react-flex-v2--flex-shrink-67{-ms-flex-negative:67;flex-shrink:67}.react-flex-v2--flex-shrink-68{-ms-flex-negative:68;flex-shrink:68}.react-flex-v2--flex-shrink-69{-ms-flex-negative:69;flex-shrink:69}.react-flex-v2--flex-shrink-70{-ms-flex-negative:70;flex-shrink:70}.react-flex-v2--flex-shrink-71{-ms-flex-negative:71;flex-shrink:71}.react-flex-v2--flex-shrink-72{-ms-flex-negative:72;flex-shrink:72}.react-flex-v2--flex-shrink-73{-ms-flex-negative:73;flex-shrink:73}.react-flex-v2--flex-shrink-74{-ms-flex-negative:74;flex-shrink:74}.react-flex-v2--flex-shrink-75{-ms-flex-negative:75;flex-shrink:75}.react-flex-v2--flex-shrink-76{-ms-flex-negative:76;flex-shrink:76}.react-flex-v2--flex-shrink-77{-ms-flex-negative:77;flex-shrink:77}.react-flex-v2--flex-shrink-78{-ms-flex-negative:78;flex-shrink:78}.react-flex-v2--flex-shrink-79{-ms-flex-negative:79;flex-shrink:79}.react-flex-v2--flex-shrink-80{-ms-flex-negative:80;flex-shrink:80}.react-flex-v2--flex-shrink-81{-ms-flex-negative:81;flex-shrink:81}.react-flex-v2--flex-shrink-82{-ms-flex-negative:82;flex-shrink:82}.react-flex-v2--flex-shrink-83{-ms-flex-negative:83;flex-shrink:83}.react-flex-v2--flex-shrink-84{-ms-flex-negative:84;flex-shrink:84}.react-flex-v2--flex-shrink-85{-ms-flex-negative:85;flex-shrink:85}.react-flex-v2--flex-shrink-86{-ms-flex-negative:86;flex-shrink:86}.react-flex-v2--flex-shrink-87{-ms-flex-negative:87;flex-shrink:87}.react-flex-v2--flex-shrink-88{-ms-flex-negative:88;flex-shrink:88}.react-flex-v2--flex-shrink-89{-ms-flex-negative:89;flex-shrink:89}.react-flex-v2--flex-shrink-90{-ms-flex-negative:90;flex-shrink:90}.react-flex-v2--flex-shrink-91{-ms-flex-negative:91;flex-shrink:91}.react-flex-v2--flex-shrink-92{-ms-flex-negative:92;flex-shrink:92}.react-flex-v2--flex-shrink-93{-ms-flex-negative:93;flex-shrink:93}.react-flex-v2--flex-shrink-94{-ms-flex-negative:94;flex-shrink:94}.react-flex-v2--flex-shrink-95{-ms-flex-negative:95;flex-shrink:95}.react-flex-v2--flex-shrink-96{-ms-flex-negative:96;flex-shrink:96}.react-flex-v2--flex-shrink-97{-ms-flex-negative:97;flex-shrink:97}.react-flex-v2--flex-shrink-98{-ms-flex-negative:98;flex-shrink:98}.react-flex-v2--flex-shrink-99{-ms-flex-negative:99;flex-shrink:99}.react-flex-v2--flex-shrink-100{-ms-flex-negative:100;flex-shrink:100}.react-date-field--theme-default{border:1px solid gray}.react-date-field--theme-default.react-date-field--focused{border:1px solid #349aef}.react-date-field--theme-default>.react-date-field__picker{box-shadow:0 2px 12px rgba(0,0,0,.34375);border:1px solid #349aef}.react-date-field--theme-default .react-date-field__calendar-icon{border:2px solid gray}.react-date-field--theme-default .react-date-field__calendar-icon:after,.react-date-field--theme-default .react-date-field__calendar-icon:before{width:2px;height:5px;top:-5px}.react-date-field--theme-default .react-date-field__calendar-icon:before{left:2px}.react-date-field--theme-default .react-date-field__calendar-icon:after{right:1px;left:auto}.react-date-field--theme-default .react-date-field__clear-icon{color:gray;fill:gray}.react-date-field--theme-default .react-date-field__clear-icon:hover{color:#4d4d4d;fill:#4d4d4d}.react-date-field--theme-default.react-date-field--focused .react-date-field__clear-icon{color:#349aef;fill:#349aef}.react-date-field--theme-default:not(.react-date-field--disabled) .react-date-field__calendar-icon:hover{border-color:#4d4d4d;cursor:pointer}.react-date-field--theme-default:not(.react-date-field--disabled) .react-date-field__calendar-icon:hover .react-date-field__calendar-icon-inner,.react-date-field--theme-default:not(.react-date-field--disabled) .react-date-field__calendar-icon:hover:after,.react-date-field--theme-default:not(.react-date-field--disabled) .react-date-field__calendar-icon:hover:before{background:#4d4d4d}.react-date-field--theme-default .react-date-field__calendar-icon-inner,.react-date-field--theme-default .react-date-field__calendar-icon:after,.react-date-field--theme-default .react-date-field__calendar-icon:before{background:gray}.react-date-field--theme-default.react-date-field--focused .react-date-field__calendar-icon,.react-date-field--theme-default.react-date-field--focused .react-date-field__calendar-icon:active,.react-date-field--theme-default.react-date-field--focused .react-date-field__calendar-icon:hover,.react-date-field--theme-default:not(.react-date-field--disabled) .react-date-field__calendar-icon:active{border-color:#349aef}.react-date-field--theme-default.react-date-field--focused .react-date-field__calendar-icon .react-date-field__calendar-icon-inner,.react-date-field--theme-default.react-date-field--focused .react-date-field__calendar-icon:active .react-date-field__calendar-icon-inner,.react-date-field--theme-default.react-date-field--focused .react-date-field__calendar-icon:active:after,.react-date-field--theme-default.react-date-field--focused .react-date-field__calendar-icon:active:before,.react-date-field--theme-default.react-date-field--focused .react-date-field__calendar-icon:after,.react-date-field--theme-default.react-date-field--focused .react-date-field__calendar-icon:before,.react-date-field--theme-default.react-date-field--focused .react-date-field__calendar-icon:hover .react-date-field__calendar-icon-inner,.react-date-field--theme-default.react-date-field--focused .react-date-field__calendar-icon:hover:after,.react-date-field--theme-default.react-date-field--focused .react-date-field__calendar-icon:hover:before,.react-date-field--theme-default:not(.react-date-field--disabled) .react-date-field__calendar-icon:active .react-date-field__calendar-icon-inner,.react-date-field--theme-default:not(.react-date-field--disabled) .react-date-field__calendar-icon:active:after,.react-date-field--theme-default:not(.react-date-field--disabled) .react-date-field__calendar-icon:active:before{background:#349aef}.react-date-picker__clock--theme-default .react-date-picker__clock-hand-second{background:red}.react-date-picker__clock--theme-default .react-date-picker__clock-center{background:#e6e6e6}.react-date-picker__clock--theme-default .react-date-picker__clock-overlay{background:#fff;border-style:solid;border-color:gray}.react-date-picker__footer--theme-default{padding:5px}.react-date-picker__footer--theme-default .react-date-picker__footer-button{padding:3px 4px;outline:none;position:relative;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;border:1px solid gray;background:#fff;font-size:.9em}.react-date-picker__footer--theme-default .react-date-picker__footer-button:active{top:1px}.react-date-picker__footer--theme-default .react-date-picker__footer-button:not(.react-date-picker__footer-button--disabled){cursor:pointer}.react-date-picker__footer--theme-default .react-date-picker__footer-button:not(.react-date-picker__footer-button--disabled):hover{background:#349aef;border-color:#349aef;color:#fff}.react-date-picker__footer--theme-default .react-date-picker__footer-button+.react-date-picker__footer-button{margin-left:3px}.react-date-picker__date-format-spinner--theme-default{border:1px solid gray}.react-date-picker__date-format-spinner--theme-default input{padding:5px;border:none;outline:none}.react-date-picker__date-format-spinner--theme-default:not([disabled]).react-date-picker__date-format-spinner--focused{border:1px solid #349aef}.react-date-picker__date-format-spinner--theme-default:not([disabled]) .react-date-picker__date-format-spinner-arrow{position:relative;cursor:pointer}.react-date-picker__date-format-spinner--theme-default:not([disabled]) .react-date-picker__date-format-spinner-arrow:active{fill:#349aef;top:1px}.react-date-picker__year-view--theme-default{border:1px solid gray;padding:2px}.react-date-picker__year-view--theme-default .react-date-picker__year-view-month{padding:5px;cursor:pointer;border:2px solid transparent}.react-date-picker__year-view--theme-default .react-date-picker__year-view-month--disabled{color:#d8d8d8}.react-date-picker__year-view--theme-default .react-date-picker__year-view-month--active{border:2px solid #349aef}.react-date-picker__year-view--theme-default .react-date-picker__year-view-month--value{color:#fff;background:#349aef padding-box;border:2px solid #349aef}.react-date-picker__year-view--theme-default .react-date-picker__year-view-month--active.react-date-picker__year-view-month--value{background:#4ca6f1 padding-box}.react-date-picker__decade-view--theme-default{border:1px solid gray;padding:2px}.react-date-picker__decade-view--theme-default .react-date-picker__decade-view-arrow{cursor:pointer;position:relative;fill:#676767;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.react-date-picker__decade-view--theme-default .react-date-picker__decade-view-arrow--disabled{fill:#c5c5c5}.react-date-picker__decade-view--theme-default .react-date-picker__decade-view-arrow:not(.react-date-picker__decade-view-arrow--disabled):active{left:1px}.react-date-picker__decade-view--theme-default .react-date-picker__decade-view-year{padding:5px;cursor:pointer;border:2px solid transparent}.react-date-picker__decade-view--theme-default .react-date-picker__decade-view-year--disabled{color:#d8d8d8}.react-date-picker__decade-view--theme-default .react-date-picker__decade-view-year--active{border:2px solid #349aef}.react-date-picker__decade-view--theme-default .react-date-picker__decade-view-year--value{color:#fff;background:#349aef padding-box;border:2px solid #349aef}.react-date-picker__decade-view--theme-default .react-date-picker__decade-view-year--active.react-date-picker__decade-view-year--value{background:#4ca6f1 padding-box}.react-date-picker__history-view--theme-default{border:1px solid gray;padding:2px}.react-date-picker__history-view--theme-default .react-date-picker__decade-view--theme-default,.react-date-picker__history-view--theme-default .react-date-picker__year-view--theme-default{border:none}.react-date-picker__nav-bar .react-date-picker__history-view--theme-default{font-size:.833em}.react-date-picker__nav-bar--theme-default{padding-top:5px;padding-bottom:5px;font-size:1.2rem}.react-date-picker__nav-bar--theme-default .react-date-picker__nav-bar-secondary-arrow{margin-right:7px}.react-date-picker__nav-bar--theme-default .react-date-picker__nav-bar-history-view{background:#fff}.react-date-picker__nav-bar--theme-default.react-date-picker__nav-bar--with-history-view .react-date-picker__nav-bar-date{cursor:pointer}.react-date-picker__nav-bar--theme-default .react-date-picker__nav-bar-arrow{position:relative;fill:#676767}.react-date-picker__nav-bar--theme-default .react-date-picker__nav-bar-arrow--disabled{fill:#c5c5c5}.react-date-picker__nav-bar--theme-default .react-date-picker__nav-bar-arrow:not(.react-date-picker__nav-bar-arrow--disabled):hover{fill:#9a9a9a}.react-date-picker__nav-bar--theme-default .react-date-picker__nav-bar-arrow:not(.react-date-picker__nav-bar-arrow--disabled):active{top:1px}.react-date-picker__calendar--theme-default{border:1px solid gray}.react-date-picker__calendar--theme-default .react-date-picker__month-view--theme-default{border:none}.react-date-picker__calendar--theme-default .react-date-picker__clock{margin:10px}.react-date-picker__calendar--theme-default,.react-date-picker__date-field--theme-default,.react-date-picker__month-view--theme-default,.react-date-picker__transition-month-view--theme-default{font-size:16px;font-size:1em}.react-date-picker__transition-month-view--theme-default{border:1px solid gray}.react-date-picker__transition-month-view--theme-default .react-date-picker__calendar--theme-default,.react-date-picker__transition-month-view--theme-default .react-date-picker__month-view--theme-default,.react-date-picker__transition-month-view--theme-default .react-date-picker__multi-month-view--theme-default{border:none}.react-date-picker__navigation-view--theme-default{border:1px solid gray}.react-date-picker__navigation-view--theme-default .react-date-picker__month-view,.react-date-picker__navigation-view--theme-default .react-date-picker__multi-month-view{border:none}.react-date-picker__month-view--theme-default{background:#fff;position:relative;border:1px solid gray;overflow:hidden}.react-date-picker__month-view--theme-default .react-date-picker__month-view-week-day-names{text-transform:uppercase}.react-date-picker__month-view--theme-default .react-date-picker__month-view-week-number{color:#b1b1b1;font-size:.8em}.react-date-picker__month-view--theme-default .react-date-picker__month-view-cell{min-width:40px}.react-date-picker__month-view--theme-default .react-date-picker__month-view-day{z-index:10}.react-date-picker__month-view--theme-default .react-date-picker__month-view-day .react-date-picker__month-view-day-text{border:2px solid transparent;border-radius:50%;cursor:pointer;text-align:center;min-width:40px;min-height:40px;max-width:40px;max-height:40px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.react-date-picker__month-view--theme-default .react-date-picker__month-view-day .react-date-picker__month-view-day-text:hover{background:#d8edff padding-box}.react-date-picker__month-view--theme-default .react-date-picker__month-view-day--in-hover-range,.react-date-picker__month-view--theme-default .react-date-picker__month-view-day--in-range{overflow:hidden}.react-date-picker__month-view--theme-default .react-date-picker__month-view-day--in-hover-range .react-date-picker__month-view-day-text,.react-date-picker__month-view--theme-default .react-date-picker__month-view-day--in-range .react-date-picker__month-view-day-text{position:relative}.react-date-picker__month-view--theme-default .react-date-picker__month-view-day--in-hover-range .react-date-picker__month-view-day-text:after,.react-date-picker__month-view--theme-default .react-date-picker__month-view-day--in-hover-range .react-date-picker__month-view-day-text:before,.react-date-picker__month-view--theme-default .react-date-picker__month-view-day--in-range .react-date-picker__month-view-day-text:after,.react-date-picker__month-view--theme-default .react-date-picker__month-view-day--in-range .react-date-picker__month-view-day-text:before{position:absolute;height:100%;top:0;bottom:0;width:500%;background:#349aef;z-index:-1;content:\"\"}.react-date-picker__month-view--theme-default .react-date-picker__month-view-day--in-hover-range .react-date-picker__month-view-day-text:before,.react-date-picker__month-view--theme-default .react-date-picker__month-view-day--in-range .react-date-picker__month-view-day-text:before{right:50%}.react-date-picker__month-view--theme-default .react-date-picker__month-view-day--in-hover-range .react-date-picker__month-view-day-text:after,.react-date-picker__month-view--theme-default .react-date-picker__month-view-day--in-range .react-date-picker__month-view-day-text:after{left:50%}.react-date-picker__month-view--theme-default .react-date-picker__month-view-day--in-hover-range.react-date-picker__month-view-day--hover-range-end .react-date-picker__month-view-day-text:after,.react-date-picker__month-view--theme-default .react-date-picker__month-view-day--in-hover-range.react-date-picker__month-view-day--hover-range-start .react-date-picker__month-view-day-text:before,.react-date-picker__month-view--theme-default .react-date-picker__month-view-day--in-hover-range.react-date-picker__month-view-day--range-end:not(.react-date-picker__month-view-day--in-hover-range) .react-date-picker__month-view-day-text:after,.react-date-picker__month-view--theme-default .react-date-picker__month-view-day--in-hover-range.react-date-picker__month-view-day--range-start:not(.react-date-picker__month-view-day--in-hover-range) .react-date-picker__month-view-day-text:before,.react-date-picker__month-view--theme-default .react-date-picker__month-view-day--in-range.react-date-picker__month-view-day--hover-range-end .react-date-picker__month-view-day-text:after,.react-date-picker__month-view--theme-default .react-date-picker__month-view-day--in-range.react-date-picker__month-view-day--hover-range-start .react-date-picker__month-view-day-text:before,.react-date-picker__month-view--theme-default .react-date-picker__month-view-day--in-range.react-date-picker__month-view-day--range-end:not(.react-date-picker__month-view-day--in-hover-range) .react-date-picker__month-view-day-text:after,.react-date-picker__month-view--theme-default .react-date-picker__month-view-day--in-range.react-date-picker__month-view-day--range-start:not(.react-date-picker__month-view-day--in-hover-range) .react-date-picker__month-view-day-text:before{display:none}.react-date-picker__month-view--theme-default .react-date-picker__month-view-day--in-hover-range.react-date-picker__month-view-day--hover-range-end:not(.react-date-picker__month-view-day--hover-range-start) .react-date-picker__month-view-day-text:before,.react-date-picker__month-view--theme-default .react-date-picker__month-view-day--in-hover-range.react-date-picker__month-view-day--hover-range-start:not(.react-date-picker__month-view-day--hover-range-end) .react-date-picker__month-view-day-text:after,.react-date-picker__month-view--theme-default .react-date-picker__month-view-day--in-range.react-date-picker__month-view-day--hover-range-end:not(.react-date-picker__month-view-day--hover-range-start) .react-date-picker__month-view-day-text:before,.react-date-picker__month-view--theme-default .react-date-picker__month-view-day--in-range.react-date-picker__month-view-day--hover-range-start:not(.react-date-picker__month-view-day--hover-range-end) .react-date-picker__month-view-day-text:after{display:inherit}.react-date-picker__month-view--theme-default .react-date-picker__month-view-day--in-hover-range.react-date-picker__month-view-day--active:not(.react-date-picker__month-view-day--range-start):not(.react-date-picker__month-view-day--range-end):not(.react-date-picker__month-view-day--hover-range-start):not(.react-date-picker__month-view-day--hover-range-end) .react-date-picker__month-view-day-text,.react-date-picker__month-view--theme-default .react-date-picker__month-view-day--in-hover-range.react-date-picker__month-view-day--active:not(.react-date-picker__month-view-day--range-start):not(.react-date-picker__month-view-day--range-end):not(.react-date-picker__month-view-day--hover-range-start):not(.react-date-picker__month-view-day--hover-range-end) .react-date-picker__month-view-day-text:hover,.react-date-picker__month-view--theme-default .react-date-picker__month-view-day--in-range.react-date-picker__month-view-day--active:not(.react-date-picker__month-view-day--range-start):not(.react-date-picker__month-view-day--range-end):not(.react-date-picker__month-view-day--hover-range-start):not(.react-date-picker__month-view-day--hover-range-end) .react-date-picker__month-view-day-text,.react-date-picker__month-view--theme-default .react-date-picker__month-view-day--in-range.react-date-picker__month-view-day--active:not(.react-date-picker__month-view-day--range-start):not(.react-date-picker__month-view-day--range-end):not(.react-date-picker__month-view-day--hover-range-start):not(.react-date-picker__month-view-day--hover-range-end) .react-date-picker__month-view-day-text:hover{background:#93c9f6 padding-box}.react-date-picker__month-view--theme-default .react-date-picker__month-view-day--in-hover-range .react-date-picker__month-view-day-text,.react-date-picker__month-view--theme-default .react-date-picker__month-view-day--in-range .react-date-picker__month-view-day-text,.react-date-picker__month-view--theme-default .react-date-picker__month-view-day--value .react-date-picker__month-view-day-text{border:2px solid transparent;background:#349aef padding-box;color:#fff}.react-date-picker__month-view--theme-default .react-date-picker__month-view-day--in-hover-range .react-date-picker__month-view-day-text:hover,.react-date-picker__month-view--theme-default .react-date-picker__month-view-day--in-range .react-date-picker__month-view-day-text:hover,.react-date-picker__month-view--theme-default .react-date-picker__month-view-day--value .react-date-picker__month-view-day-text:hover{background:#349aef padding-box}.react-date-picker__month-view--theme-default .react-date-picker__month-view-day--in-hover-range.react-date-picker__month-view-day--today-highlight .react-date-picker__month-view-day-text,.react-date-picker__month-view--theme-default .react-date-picker__month-view-day--in-range.react-date-picker__month-view-day--today-highlight .react-date-picker__month-view-day-text,.react-date-picker__month-view--theme-default .react-date-picker__month-view-day--value.react-date-picker__month-view-day--today-highlight .react-date-picker__month-view-day-text{color:#fcf}.react-date-picker__month-view--theme-default .react-date-picker__month-view-day--in-hover-range .react-date-picker__month-view-day-text{background:#d9ecfc padding-box}.react-date-picker__month-view--theme-default .react-date-picker__month-view-day--in-hover-range .react-date-picker__month-view-day-text:after,.react-date-picker__month-view--theme-default .react-date-picker__month-view-day--in-hover-range .react-date-picker__month-view-day-text:before{background:#d9ecfc}.react-date-picker__month-view--theme-default .react-date-picker__month-view-day--hover-range-end .react-date-picker__month-view-day-text,.react-date-picker__month-view--theme-default .react-date-picker__month-view-day--hover-range-end .react-date-picker__month-view-day-text:hover,.react-date-picker__month-view--theme-default .react-date-picker__month-view-day--hover-range-start .react-date-picker__month-view-day-text,.react-date-picker__month-view--theme-default .react-date-picker__month-view-day--hover-range-start .react-date-picker__month-view-day-text:hover,.react-date-picker__month-view--theme-default .react-date-picker__month-view-day--range-end .react-date-picker__month-view-day-text,.react-date-picker__month-view--theme-default .react-date-picker__month-view-day--range-end .react-date-picker__month-view-day-text:hover,.react-date-picker__month-view--theme-default .react-date-picker__month-view-day--range-start .react-date-picker__month-view-day-text,.react-date-picker__month-view--theme-default .react-date-picker__month-view-day--range-start .react-date-picker__month-view-day-text:hover{background:#63b2f3 padding-box}.react-date-picker__month-view--theme-default .react-date-picker__month-view-day--active .react-date-picker__month-view-day-text{border:2px solid #349aef}.react-date-picker__month-view--theme-default .react-date-picker__month-view-day--next-month,.react-date-picker__month-view--theme-default .react-date-picker__month-view-day--prev-month{color:#b3b3b3}.react-date-picker__month-view--theme-default .react-date-picker__month-view-day--weekend-highlight{color:red}.react-date-picker__month-view--theme-default .react-date-picker__month-view-day--weekend-highlight.react-date-picker__month-view-day--next-month,.react-date-picker__month-view--theme-default .react-date-picker__month-view-day--weekend-highlight.react-date-picker__month-view-day--prev-month{color:#d68e8e}.react-date-picker__month-view--theme-default .react-date-picker__month-view-day--today-highlight{color:#f0f}.react-date-picker__month-view--theme-default .react-date-picker__month-view-day--today-highlight.react-date-picker__month-view-day--next-month,.react-date-picker__month-view--theme-default .react-date-picker__month-view-day--today-highlight.react-date-picker__month-view-day--prev-month{color:#f6f}.react-date-picker__month-view--theme-default .react-date-picker__month-view-day--disabled{color:#d8d8d8}.react-date-picker__month-view--theme-default .react-date-picker__month-view-day--disabled .react-date-picker__month-view-day-text{cursor:default}.react-date-picker__month-view--theme-default .react-date-picker__month-view-day--disabled .react-date-picker__month-view-day-text:hover{background:none}.react-date-picker__month-view--theme-default .react-date-picker__month-view-day--disabled.react-date-picker__month-view-day--next-month,.react-date-picker__month-view--theme-default .react-date-picker__month-view-day--disabled.react-date-picker__month-view-day--prev-month{color:#d8d8d8}.react-date-picker__multi-month-view{border:1px solid gray}.react-date-picker__multi-month-view .react-date-picker__month-view{border:none}", "", {"version":3,"sources":["/../../../../../../react-date-picker/index.css"],"names":[],"mappings":"AAAA,kBAEE,kBAAmB,AACnB,iBAAkB,AAClB,qBAAuB,CAAE,AACzB,yFAJA,qBAAuB,CAOI,AAC3B,4CACE,eAAgB,AAChB,kBAAmB,AACnB,YAAa,AACb,UAAW,AACX,eAAkB,CAAE,AAExB,oEACE,QAAU,CAAE,AAEd,iEACE,WAAa,CAAE,AAEjB,yBACE,WAAY,AACZ,mBAAoB,AAEhB,kBAAmB,AACf,cAAe,AACvB,YAAa,AACb,YAAa,AACb,YAAc,CAAE,AAElB,iCACE,sBAAuB,AACvB,qBAAsB,AACtB,kBAAmB,AACnB,gBAAiB,AACjB,qBAAwB,AACxB,iBAAmB,CAAE,AAEvB,8BACE,WAAY,AACZ,UAAW,AACX,aAAgB,AAChB,cAAgB,CAAE,AAClB,kCACE,qBAAuB,CAAE,AAE7B,oCACE,cAAe,AACf,YAAc,CAAE,AAElB,+EAEE,WAAY,AACZ,UAAW,AACX,WAAY,AACZ,mBAAoB,AACpB,SAAU,AACV,SAAU,AACV,kBAAmB,AACnB,eAAiB,CAAE,AAErB,uCACE,UAAW,AACX,OAAW,CAAE,AAEf,uCACE,gBAAiB,AACjB,kBAAmB,AACnB,kBAAmB,AACnB,QAAS,AACT,SAAU,AACV,UAAW,AACX,UAAY,CAAE,AAEhB,0BACE,sBAAuB,AACvB,qBAAsB,AACtB,sBAAuB,AACvB,kBAAmB,AACnB,iBAAmB,CAAE,AACrB,+FAGE,qBAAuB,CAAE,AAE7B,mEAEE,kBAAmB,AACnB,kBAAmB,AACnB,2CAA8C,AACtC,mCAAsC,AAC9C,QAAS,AACT,QAAU,CAAE,AAEd,8DAEE,kBAAmB,AACnB,SAAU,AACV,QAAS,AACT,UAAW,AACX,eAAiB,CAAE,AAWnB,kUAGE,qBAAuB,CAAE,AAE7B,sCACE,eAAiB,CAAE,AAErB,8BACE,sBAAuB,AACvB,YAAc,CAAE,AAChB,2GAGE,qBAAuB,CAAE,AAC3B,oCACE,iBAAmB,CAAE,AAEzB,gCACE,sBAAuB,AACvB,YAAc,CAAE,AAChB,iHAGE,qBAAuB,CAAE,AAC3B,qCACE,iBAAmB,CAAE,AAEzB,iCACE,sBAAuB,AACvB,YAAc,CAAE,AAChB,oHAGE,qBAAuB,CAAE,AAE7B,4BACE,sBAAuB,AACvB,aAAc,AACd,iBAAmB,CAAE,AACrB,qGAGE,qBAAuB,CAAE,AAC3B,kCACE,yBAA0B,AACvB,sBAAuB,AACtB,qBAAsB,AAClB,iBAAkB,AAC1B,eAAgB,AAChB,iBAAmB,CAAE,AACrB,4CACE,aAAc,AACd,cAAgB,CAAE,AACtB,iCACE,uBAAwB,AACxB,mBAAoB,AACpB,eAAiB,CAAE,AACrB,gCACE,qBAAuB,CAAE,AAC3B,yCACE,YAAa,AACb,kBAAmB,AACnB,YAAa,AACb,SAAU,AACV,UAAW,AACX,QAAU,CAAE,AAMd,uYASE,qBAAuB,CAAE,AAE7B,0CACE,kBAAmB,AACnB,eAAiB,CAAE,AAErB,yBACE,yCAAgD,AACxC,gCAAwC,CAAE,AAEpD,yBACE,wCAA+C,AACvC,+BAAuC,CAAE,AAEnD,oCACE,yCAAgD,AACxC,gCAAwC,CAAE,AAClD,4DACE,gCAA6C,AACrC,uBAAqC,CAAE,AAEnD,qCACE,aAAc,AACd,wCAA+C,AACvC,+BAAuC,CAAE,AACjD,6DACE,gCAA6C,AACrC,uBAAqC,CAAE,AAEnD,2BACE,UAAY,CAAE,AAEhB,uKAIE,sCAAuC,AACvC,8BAA+B,AAC/B,+CAAkD,CAAE,AAEtD,kDAEE,MAAS,AACT,OAAU,AACV,YAAa,AACb,WAAY,AACZ,2BAA8B,CAAE,AAElC,oEAEE,kBAAmB,AACnB,YAAc,CAAE,AAChB,gGAEE,aAAiB,CAAE,AACrB,4FAEE,iBAAmB,CAAE,AACvB,gGAEE,aAAe,CAAE,AACnB,8EAEE,mBAAoB,AAEhB,kBAAmB,AACf,cAAe,AACvB,oBAAqB,AAErB,oBAAqB,AACrB,aAAc,AAEV,kBAAmB,AACf,cAAe,AACvB,yBAA0B,AAEtB,sBAAuB,AACnB,mBAAoB,AAC5B,wBAAyB,AAErB,qBAAsB,AAClB,sBAAwB,CAAE,AACpC,4EAEE,oBAAqB,AAErB,oBAAqB,AACrB,aAAc,AAEV,kBAAmB,AACf,cAAe,AACvB,mBAAoB,AAEhB,oBAAqB,AACjB,YAAa,AAEjB,oBAAqB,AACjB,cAAe,AAEnB,6BAA8B,AAC1B,eAAiB,CAAE,AAC7B,kGAEE,mBAAoB,AAEhB,cAAe,AACX,SAAW,CAAE,AAEzB,eACE,oBAAqB,AAErB,oBAAqB,AACrB,YAAc,CAAE,AAElB,uBACE,2BAA4B,AAE5B,2BAA4B,AAC5B,mBAAqB,CAAE,AAEzB,6BACE,oBAAqB,AAErB,oBAAqB,AACrB,YAAc,CAAE,AAElB,oCACE,2BAA4B,AAE5B,2BAA4B,AAC5B,mBAAqB,CAAE,AAGzB,mCACE,yBAA0B,AAC1B,2BAA4B,AACxB,sBAAuB,AACf,0BAA2B,AAC/B,kBAAoB,CAAE,AAEhC,oCACE,0BAA2B,AAC3B,4BAA6B,AACzB,uBAAwB,AAChB,2BAA4B,AAChC,mBAAqB,CAAE,AAEjC,qCACE,2BAA4B,AAC5B,6BAA8B,AAC1B,wBAAyB,AACjB,4BAA6B,AACjC,oBAAsB,CAAE,AAElC,qEAEE,sBAAuB,AACvB,6BAA8B,AAC1B,mBAAoB,AACZ,4BAA6B,AACjC,oBAAsB,CAAE,AAElC,yEAEE,wBAAyB,AACzB,+BAAgC,AAC5B,qBAAsB,AACd,8BAA+B,AACnC,sBAAwB,CAAE,AAGpC,kCACE,0BAA2B,AACvB,2BAA4B,AACxB,iBAAmB,CAAE,AAE/B,mCACE,2BAA4B,AACxB,4BAA6B,AACzB,kBAAoB,CAAE,AAEhC,oCACE,4BAA6B,AACzB,6BAA8B,AAC1B,mBAAqB,CAAE,AAEjC,gCACE,wBAAyB,AACrB,yBAA0B,AACtB,eAAiB,CAAE,AAE7B,mEAEE,4BAA6B,AACzB,wBAAyB,AACrB,mBAAqB,CAAE,AAEjC,uEAEE,8BAA+B,AAC3B,0BAA2B,AACvB,qBAAuB,CAAE,AAGnC,qCAEM,0BAA2B,AACvB,oBAAsB,CAAE,AAElC,sCAEM,2BAA4B,AACxB,qBAAuB,CAAE,AAEnC,gFAGM,8BAA+B,AAC3B,0BAA4B,CAAE,AAExC,kFAGM,2BAA4B,AACxB,2BAA6B,CAAE,AAEzC,yEAGM,uBAAwB,AACpB,sBAAwB,CAAE,AAEpC,6EAGM,yBAA0B,AACtB,wBAA0B,CAAE,AAGtC,iFAEE,uBAAwB,AAEpB,oBAAqB,AACjB,0BAA4B,CAAE,AAExC,6EAEE,qBAAsB,AAElB,kBAAmB,AACf,wBAA0B,CAAE,AAEtC,uCACE,wBAAyB,AAErB,qBAAsB,AAClB,sBAAwB,CAAE,AAEpC,6CAEM,yBAA0B,AACtB,4BAA8B,CAAE,AAE1C,8CACE,yBAA0B,AAEtB,sBAAuB,AACnB,6BAA+B,CAAE,AAG3C,qBAEM,mBAAoB,AAChB,cAAgB,CAAE,AAG5B,uBACE,4BAA6B,AAC7B,6BAA8B,AAE1B,0BAA2B,AACvB,qBAAuB,CAAE,AAEnC,+BACE,4BAA6B,AAC7B,8BAA+B,AAE3B,kCAAmC,AAC/B,6BAA+B,CAAE,AAG3C,oBACE,8BAA+B,AAC/B,6BAA8B,AAE1B,uBAAwB,AACpB,kBAAoB,CAAE,AAEhC,4BACE,8BAA+B,AAC/B,8BAA+B,AAE3B,+BAAgC,AAC5B,0BAA4B,CAAE,AAGxC,gCAEM,6BAA8B,AAC1B,eAAiB,CAAE,AAE7B,6DAGM,4BAA6B,AACzB,cAAgB,CAAE,AAE5B,gCAEM,6BAA8B,AAC1B,eAAiB,CAAE,AAE7B,mCAEM,gCAAiC,AAC7B,kBAAoB,CAAE,AAEhC,uCAEM,oCAAqC,AACjC,sBAAwB,CAAE,AAEpC,uCAEM,oCAAqC,AACjC,sBAAwB,CAAE,AAEpC,uCAEM,oCAAqC,AACjC,sBAAwB,CAAE,AAGpC,iDAEE,mBAAoB,AAEhB,cAAe,AACX,SAAW,CAAE,AAEvB,uBACE,mBAAoB,AAEhB,WAAY,AACR,MAAQ,CAAE,AAEpB,uBACE,mBAAoB,AAEhB,WAAY,AACR,MAAQ,CAAE,AAEpB,uBACE,mBAAoB,AAEhB,WAAY,AACR,MAAQ,CAAE,AAEpB,uBACE,mBAAoB,AAEhB,WAAY,AACR,MAAQ,CAAE,AAEpB,uBACE,mBAAoB,AAEhB,WAAY,AACR,MAAQ,CAAE,AAEpB,uBACE,mBAAoB,AAEhB,WAAY,AACR,MAAQ,CAAE,AAEpB,uBACE,mBAAoB,AAEhB,WAAY,AACR,MAAQ,CAAE,AAEpB,uBACE,mBAAoB,AAEhB,WAAY,AACR,MAAQ,CAAE,AAEpB,uBACE,mBAAoB,AAEhB,WAAY,AACR,MAAQ,CAAE,AAEpB,wBACE,oBAAqB,AAEjB,YAAa,AACT,OAAS,CAAE,AAErB,wBACE,oBAAqB,AAEjB,YAAa,AACT,OAAS,CAAE,AAErB,wBACE,oBAAqB,AAEjB,YAAa,AACT,OAAS,CAAE,AAErB,wBACE,oBAAqB,AAEjB,YAAa,AACT,OAAS,CAAE,AAErB,wBACE,oBAAqB,AAEjB,YAAa,AACT,OAAS,CAAE,AAErB,wBACE,oBAAqB,AAEjB,YAAa,AACT,OAAS,CAAE,AAErB,wBACE,oBAAqB,AAEjB,YAAa,AACT,OAAS,CAAE,AAErB,wBACE,oBAAqB,AAEjB,YAAa,AACT,OAAS,CAAE,AAErB,wBACE,oBAAqB,AAEjB,YAAa,AACT,OAAS,CAAE,AAErB,wBACE,oBAAqB,AAEjB,YAAa,AACT,OAAS,CAAE,AAErB,wBACE,oBAAqB,AAEjB,YAAa,AACT,OAAS,CAAE,AAErB,wBACE,oBAAqB,AAEjB,YAAa,AACT,OAAS,CAAE,AAErB,wBACE,oBAAqB,AAEjB,YAAa,AACT,OAAS,CAAE,AAErB,wBACE,oBAAqB,AAEjB,YAAa,AACT,OAAS,CAAE,AAErB,wBACE,oBAAqB,AAEjB,YAAa,AACT,OAAS,CAAE,AAErB,wBACE,oBAAqB,AAEjB,YAAa,AACT,OAAS,CAAE,AAErB,wBACE,oBAAqB,AAEjB,YAAa,AACT,OAAS,CAAE,AAErB,wBACE,oBAAqB,AAEjB,YAAa,AACT,OAAS,CAAE,AAErB,wBACE,oBAAqB,AAEjB,YAAa,AACT,OAAS,CAAE,AAErB,wBACE,oBAAqB,AAEjB,YAAa,AACT,OAAS,CAAE,AAErB,wBACE,oBAAqB,AAEjB,YAAa,AACT,OAAS,CAAE,AAErB,wBACE,oBAAqB,AAEjB,YAAa,AACT,OAAS,CAAE,AAErB,wBACE,oBAAqB,AAEjB,YAAa,AACT,OAAS,CAAE,AAErB,wBACE,oBAAqB,AAEjB,YAAa,AACT,OAAS,CAAE,AAErB,wBACE,oBAAqB,AAEjB,YAAa,AACT,OAAS,CAAE,AAErB,wBACE,oBAAqB,AAEjB,YAAa,AACT,OAAS,CAAE,AAErB,wBACE,oBAAqB,AAEjB,YAAa,AACT,OAAS,CAAE,AAErB,wBACE,oBAAqB,AAEjB,YAAa,AACT,OAAS,CAAE,AAErB,wBACE,oBAAqB,AAEjB,YAAa,AACT,OAAS,CAAE,AAErB,wBACE,oBAAqB,AAEjB,YAAa,AACT,OAAS,CAAE,AAErB,wBACE,oBAAqB,AAEjB,YAAa,AACT,OAAS,CAAE,AAErB,wBACE,oBAAqB,AAEjB,YAAa,AACT,OAAS,CAAE,AAErB,wBACE,oBAAqB,AAEjB,YAAa,AACT,OAAS,CAAE,AAErB,wBACE,oBAAqB,AAEjB,YAAa,AACT,OAAS,CAAE,AAErB,wBACE,oBAAqB,AAEjB,YAAa,AACT,OAAS,CAAE,AAErB,wBACE,oBAAqB,AAEjB,YAAa,AACT,OAAS,CAAE,AAErB,wBACE,oBAAqB,AAEjB,YAAa,AACT,OAAS,CAAE,AAErB,wBACE,oBAAqB,AAEjB,YAAa,AACT,OAAS,CAAE,AAErB,wBACE,oBAAqB,AAEjB,YAAa,AACT,OAAS,CAAE,AAErB,wBACE,oBAAqB,AAEjB,YAAa,AACT,OAAS,CAAE,AAErB,wBACE,oBAAqB,AAEjB,YAAa,AACT,OAAS,CAAE,AAErB,wBACE,oBAAqB,AAEjB,YAAa,AACT,OAAS,CAAE,AAErB,wBACE,oBAAqB,AAEjB,YAAa,AACT,OAAS,CAAE,AAErB,wBACE,oBAAqB,AAEjB,YAAa,AACT,OAAS,CAAE,AAErB,wBACE,oBAAqB,AAEjB,YAAa,AACT,OAAS,CAAE,AAErB,wBACE,oBAAqB,AAEjB,YAAa,AACT,OAAS,CAAE,AAErB,wBACE,oBAAqB,AAEjB,YAAa,AACT,OAAS,CAAE,AAErB,wBACE,oBAAqB,AAEjB,YAAa,AACT,OAAS,CAAE,AAErB,wBACE,oBAAqB,AAEjB,YAAa,AACT,OAAS,CAAE,AAErB,wBACE,oBAAqB,AAEjB,YAAa,AACT,OAAS,CAAE,AAErB,wBACE,oBAAqB,AAEjB,YAAa,AACT,OAAS,CAAE,AAErB,wBACE,oBAAqB,AAEjB,YAAa,AACT,OAAS,CAAE,AAErB,wBACE,oBAAqB,AAEjB,YAAa,AACT,OAAS,CAAE,AAErB,wBACE,oBAAqB,AAEjB,YAAa,AACT,OAAS,CAAE,AAErB,wBACE,oBAAqB,AAEjB,YAAa,AACT,OAAS,CAAE,AAErB,wBACE,oBAAqB,AAEjB,YAAa,AACT,OAAS,CAAE,AAErB,wBACE,oBAAqB,AAEjB,YAAa,AACT,OAAS,CAAE,AAErB,wBACE,oBAAqB,AAEjB,YAAa,AACT,OAAS,CAAE,AAErB,wBACE,oBAAqB,AAEjB,YAAa,AACT,OAAS,CAAE,AAErB,wBACE,oBAAqB,AAEjB,YAAa,AACT,OAAS,CAAE,AAErB,wBACE,oBAAqB,AAEjB,YAAa,AACT,OAAS,CAAE,AAErB,wBACE,oBAAqB,AAEjB,YAAa,AACT,OAAS,CAAE,AAErB,wBACE,oBAAqB,AAEjB,YAAa,AACT,OAAS,CAAE,AAErB,wBACE,oBAAqB,AAEjB,YAAa,AACT,OAAS,CAAE,AAErB,wBACE,oBAAqB,AAEjB,YAAa,AACT,OAAS,CAAE,AAErB,wBACE,oBAAqB,AAEjB,YAAa,AACT,OAAS,CAAE,AAErB,wBACE,oBAAqB,AAEjB,YAAa,AACT,OAAS,CAAE,AAErB,wBACE,oBAAqB,AAEjB,YAAa,AACT,OAAS,CAAE,AAErB,wBACE,oBAAqB,AAEjB,YAAa,AACT,OAAS,CAAE,AAErB,wBACE,oBAAqB,AAEjB,YAAa,AACT,OAAS,CAAE,AAErB,wBACE,oBAAqB,AAEjB,YAAa,AACT,OAAS,CAAE,AAErB,wBACE,oBAAqB,AAEjB,YAAa,AACT,OAAS,CAAE,AAErB,wBACE,oBAAqB,AAEjB,YAAa,AACT,OAAS,CAAE,AAErB,wBACE,oBAAqB,AAEjB,YAAa,AACT,OAAS,CAAE,AAErB,wBACE,oBAAqB,AAEjB,YAAa,AACT,OAAS,CAAE,AAErB,wBACE,oBAAqB,AAEjB,YAAa,AACT,OAAS,CAAE,AAErB,wBACE,oBAAqB,AAEjB,YAAa,AACT,OAAS,CAAE,AAErB,wBACE,oBAAqB,AAEjB,YAAa,AACT,OAAS,CAAE,AAErB,wBACE,oBAAqB,AAEjB,YAAa,AACT,OAAS,CAAE,AAErB,wBACE,oBAAqB,AAEjB,YAAa,AACT,OAAS,CAAE,AAErB,wBACE,oBAAqB,AAEjB,YAAa,AACT,OAAS,CAAE,AAErB,wBACE,oBAAqB,AAEjB,YAAa,AACT,OAAS,CAAE,AAErB,wBACE,oBAAqB,AAEjB,YAAa,AACT,OAAS,CAAE,AAErB,wBACE,oBAAqB,AAEjB,YAAa,AACT,OAAS,CAAE,AAErB,wBACE,oBAAqB,AAEjB,YAAa,AACT,OAAS,CAAE,AAErB,wBACE,oBAAqB,AAEjB,YAAa,AACT,OAAS,CAAE,AAErB,wBACE,oBAAqB,AAEjB,YAAa,AACT,OAAS,CAAE,AAErB,wBACE,oBAAqB,AAEjB,YAAa,AACT,OAAS,CAAE,AAErB,wBACE,oBAAqB,AAEjB,YAAa,AACT,OAAS,CAAE,AAErB,wBACE,oBAAqB,AAEjB,YAAa,AACT,OAAS,CAAE,AAErB,yBACE,qBAAsB,AAElB,aAAc,AACV,QAAU,CAAE,AAGtB,4BACE,mBAAoB,AAEhB,oBAAqB,AACjB,WAAa,CAAE,AAEzB,4BACE,mBAAoB,AAEhB,oBAAqB,AACjB,WAAa,CAAE,AAEzB,4BACE,mBAAoB,AAEhB,oBAAqB,AACjB,WAAa,CAAE,AAEzB,4BACE,mBAAoB,AAEhB,oBAAqB,AACjB,WAAa,CAAE,AAEzB,4BACE,mBAAoB,AAEhB,oBAAqB,AACjB,WAAa,CAAE,AAEzB,4BACE,mBAAoB,AAEhB,oBAAqB,AACjB,WAAa,CAAE,AAEzB,4BACE,mBAAoB,AAEhB,oBAAqB,AACjB,WAAa,CAAE,AAEzB,4BACE,mBAAoB,AAEhB,oBAAqB,AACjB,WAAa,CAAE,AAEzB,4BACE,mBAAoB,AAEhB,oBAAqB,AACjB,WAAa,CAAE,AAEzB,4BACE,mBAAoB,AAEhB,oBAAqB,AACjB,WAAa,CAAE,AAEzB,6BACE,oBAAqB,AAEjB,qBAAsB,AAClB,YAAc,CAAE,AAE1B,6BACE,oBAAqB,AAEjB,qBAAsB,AAClB,YAAc,CAAE,AAE1B,6BACE,oBAAqB,AAEjB,qBAAsB,AAClB,YAAc,CAAE,AAE1B,6BACE,oBAAqB,AAEjB,qBAAsB,AAClB,YAAc,CAAE,AAE1B,6BACE,oBAAqB,AAEjB,qBAAsB,AAClB,YAAc,CAAE,AAE1B,6BACE,oBAAqB,AAEjB,qBAAsB,AAClB,YAAc,CAAE,AAE1B,6BACE,oBAAqB,AAEjB,qBAAsB,AAClB,YAAc,CAAE,AAE1B,6BACE,oBAAqB,AAEjB,qBAAsB,AAClB,YAAc,CAAE,AAE1B,6BACE,oBAAqB,AAEjB,qBAAsB,AAClB,YAAc,CAAE,AAE1B,6BACE,oBAAqB,AAEjB,qBAAsB,AAClB,YAAc,CAAE,AAE1B,6BACE,oBAAqB,AAEjB,qBAAsB,AAClB,YAAc,CAAE,AAE1B,6BACE,oBAAqB,AAEjB,qBAAsB,AAClB,YAAc,CAAE,AAE1B,6BACE,oBAAqB,AAEjB,qBAAsB,AAClB,YAAc,CAAE,AAE1B,6BACE,oBAAqB,AAEjB,qBAAsB,AAClB,YAAc,CAAE,AAE1B,6BACE,oBAAqB,AAEjB,qBAAsB,AAClB,YAAc,CAAE,AAE1B,6BACE,oBAAqB,AAEjB,qBAAsB,AAClB,YAAc,CAAE,AAE1B,6BACE,oBAAqB,AAEjB,qBAAsB,AAClB,YAAc,CAAE,AAE1B,6BACE,oBAAqB,AAEjB,qBAAsB,AAClB,YAAc,CAAE,AAE1B,6BACE,oBAAqB,AAEjB,qBAAsB,AAClB,YAAc,CAAE,AAE1B,6BACE,oBAAqB,AAEjB,qBAAsB,AAClB,YAAc,CAAE,AAE1B,6BACE,oBAAqB,AAEjB,qBAAsB,AAClB,YAAc,CAAE,AAE1B,6BACE,oBAAqB,AAEjB,qBAAsB,AAClB,YAAc,CAAE,AAE1B,6BACE,oBAAqB,AAEjB,qBAAsB,AAClB,YAAc,CAAE,AAE1B,6BACE,oBAAqB,AAEjB,qBAAsB,AAClB,YAAc,CAAE,AAE1B,6BACE,oBAAqB,AAEjB,qBAAsB,AAClB,YAAc,CAAE,AAE1B,6BACE,oBAAqB,AAEjB,qBAAsB,AAClB,YAAc,CAAE,AAE1B,6BACE,oBAAqB,AAEjB,qBAAsB,AAClB,YAAc,CAAE,AAE1B,6BACE,oBAAqB,AAEjB,qBAAsB,AAClB,YAAc,CAAE,AAE1B,6BACE,oBAAqB,AAEjB,qBAAsB,AAClB,YAAc,CAAE,AAE1B,6BACE,oBAAqB,AAEjB,qBAAsB,AAClB,YAAc,CAAE,AAE1B,6BACE,oBAAqB,AAEjB,qBAAsB,AAClB,YAAc,CAAE,AAE1B,6BACE,oBAAqB,AAEjB,qBAAsB,AAClB,YAAc,CAAE,AAE1B,6BACE,oBAAqB,AAEjB,qBAAsB,AAClB,YAAc,CAAE,AAE1B,6BACE,oBAAqB,AAEjB,qBAAsB,AAClB,YAAc,CAAE,AAE1B,6BACE,oBAAqB,AAEjB,qBAAsB,AAClB,YAAc,CAAE,AAE1B,6BACE,oBAAqB,AAEjB,qBAAsB,AAClB,YAAc,CAAE,AAE1B,6BACE,oBAAqB,AAEjB,qBAAsB,AAClB,YAAc,CAAE,AAE1B,6BACE,oBAAqB,AAEjB,qBAAsB,AAClB,YAAc,CAAE,AAE1B,6BACE,oBAAqB,AAEjB,qBAAsB,AAClB,YAAc,CAAE,AAE1B,6BACE,oBAAqB,AAEjB,qBAAsB,AAClB,YAAc,CAAE,AAE1B,6BACE,oBAAqB,AAEjB,qBAAsB,AAClB,YAAc,CAAE,AAE1B,6BACE,oBAAqB,AAEjB,qBAAsB,AAClB,YAAc,CAAE,AAE1B,6BACE,oBAAqB,AAEjB,qBAAsB,AAClB,YAAc,CAAE,AAE1B,6BACE,oBAAqB,AAEjB,qBAAsB,AAClB,YAAc,CAAE,AAE1B,6BACE,oBAAqB,AAEjB,qBAAsB,AAClB,YAAc,CAAE,AAE1B,6BACE,oBAAqB,AAEjB,qBAAsB,AAClB,YAAc,CAAE,AAE1B,6BACE,oBAAqB,AAEjB,qBAAsB,AAClB,YAAc,CAAE,AAE1B,6BACE,oBAAqB,AAEjB,qBAAsB,AAClB,YAAc,CAAE,AAE1B,6BACE,oBAAqB,AAEjB,qBAAsB,AAClB,YAAc,CAAE,AAE1B,6BACE,oBAAqB,AAEjB,qBAAsB,AAClB,YAAc,CAAE,AAE1B,6BACE,oBAAqB,AAEjB,qBAAsB,AAClB,YAAc,CAAE,AAE1B,6BACE,oBAAqB,AAEjB,qBAAsB,AAClB,YAAc,CAAE,AAE1B,6BACE,oBAAqB,AAEjB,qBAAsB,AAClB,YAAc,CAAE,AAE1B,6BACE,oBAAqB,AAEjB,qBAAsB,AAClB,YAAc,CAAE,AAE1B,6BACE,oBAAqB,AAEjB,qBAAsB,AAClB,YAAc,CAAE,AAE1B,6BACE,oBAAqB,AAEjB,qBAAsB,AAClB,YAAc,CAAE,AAE1B,6BACE,oBAAqB,AAEjB,qBAAsB,AAClB,YAAc,CAAE,AAE1B,6BACE,oBAAqB,AAEjB,qBAAsB,AAClB,YAAc,CAAE,AAE1B,6BACE,oBAAqB,AAEjB,qBAAsB,AAClB,YAAc,CAAE,AAE1B,6BACE,oBAAqB,AAEjB,qBAAsB,AAClB,YAAc,CAAE,AAE1B,6BACE,oBAAqB,AAEjB,qBAAsB,AAClB,YAAc,CAAE,AAE1B,6BACE,oBAAqB,AAEjB,qBAAsB,AAClB,YAAc,CAAE,AAE1B,6BACE,oBAAqB,AAEjB,qBAAsB,AAClB,YAAc,CAAE,AAE1B,6BACE,oBAAqB,AAEjB,qBAAsB,AAClB,YAAc,CAAE,AAE1B,6BACE,oBAAqB,AAEjB,qBAAsB,AAClB,YAAc,CAAE,AAE1B,6BACE,oBAAqB,AAEjB,qBAAsB,AAClB,YAAc,CAAE,AAE1B,6BACE,oBAAqB,AAEjB,qBAAsB,AAClB,YAAc,CAAE,AAE1B,6BACE,oBAAqB,AAEjB,qBAAsB,AAClB,YAAc,CAAE,AAE1B,6BACE,oBAAqB,AAEjB,qBAAsB,AAClB,YAAc,CAAE,AAE1B,6BACE,oBAAqB,AAEjB,qBAAsB,AAClB,YAAc,CAAE,AAE1B,6BACE,oBAAqB,AAEjB,qBAAsB,AAClB,YAAc,CAAE,AAE1B,6BACE,oBAAqB,AAEjB,qBAAsB,AAClB,YAAc,CAAE,AAE1B,6BACE,oBAAqB,AAEjB,qBAAsB,AAClB,YAAc,CAAE,AAE1B,6BACE,oBAAqB,AAEjB,qBAAsB,AAClB,YAAc,CAAE,AAE1B,6BACE,oBAAqB,AAEjB,qBAAsB,AAClB,YAAc,CAAE,AAE1B,6BACE,oBAAqB,AAEjB,qBAAsB,AAClB,YAAc,CAAE,AAE1B,6BACE,oBAAqB,AAEjB,qBAAsB,AAClB,YAAc,CAAE,AAE1B,6BACE,oBAAqB,AAEjB,qBAAsB,AAClB,YAAc,CAAE,AAE1B,6BACE,oBAAqB,AAEjB,qBAAsB,AAClB,YAAc,CAAE,AAE1B,6BACE,oBAAqB,AAEjB,qBAAsB,AAClB,YAAc,CAAE,AAE1B,6BACE,oBAAqB,AAEjB,qBAAsB,AAClB,YAAc,CAAE,AAE1B,6BACE,oBAAqB,AAEjB,qBAAsB,AAClB,YAAc,CAAE,AAE1B,6BACE,oBAAqB,AAEjB,qBAAsB,AAClB,YAAc,CAAE,AAE1B,6BACE,oBAAqB,AAEjB,qBAAsB,AAClB,YAAc,CAAE,AAE1B,6BACE,oBAAqB,AAEjB,qBAAsB,AAClB,YAAc,CAAE,AAE1B,6BACE,oBAAqB,AAEjB,qBAAsB,AAClB,YAAc,CAAE,AAE1B,6BACE,oBAAqB,AAEjB,qBAAsB,AAClB,YAAc,CAAE,AAE1B,6BACE,oBAAqB,AAEjB,qBAAsB,AAClB,YAAc,CAAE,AAE1B,6BACE,oBAAqB,AAEjB,qBAAsB,AAClB,YAAc,CAAE,AAE1B,6BACE,oBAAqB,AAEjB,qBAAsB,AAClB,YAAc,CAAE,AAE1B,8BACE,qBAAsB,AAElB,sBAAuB,AACnB,aAAe,CAAE,AAG3B,8BAEM,oBAAqB,AACjB,aAAe,CAAE,AAE3B,8BAEM,oBAAqB,AACjB,aAAe,CAAE,AAE3B,8BAEM,oBAAqB,AACjB,aAAe,CAAE,AAE3B,8BAEM,oBAAqB,AACjB,aAAe,CAAE,AAE3B,8BAEM,oBAAqB,AACjB,aAAe,CAAE,AAE3B,8BAEM,oBAAqB,AACjB,aAAe,CAAE,AAE3B,8BAEM,oBAAqB,AACjB,aAAe,CAAE,AAE3B,8BAEM,oBAAqB,AACjB,aAAe,CAAE,AAE3B,8BAEM,oBAAqB,AACjB,aAAe,CAAE,AAE3B,8BAEM,oBAAqB,AACjB,aAAe,CAAE,AAE3B,+BAEM,qBAAsB,AAClB,cAAgB,CAAE,AAE5B,+BAEM,qBAAsB,AAClB,cAAgB,CAAE,AAE5B,+BAEM,qBAAsB,AAClB,cAAgB,CAAE,AAE5B,+BAEM,qBAAsB,AAClB,cAAgB,CAAE,AAE5B,+BAEM,qBAAsB,AAClB,cAAgB,CAAE,AAE5B,+BAEM,qBAAsB,AAClB,cAAgB,CAAE,AAE5B,+BAEM,qBAAsB,AAClB,cAAgB,CAAE,AAE5B,+BAEM,qBAAsB,AAClB,cAAgB,CAAE,AAE5B,+BAEM,qBAAsB,AAClB,cAAgB,CAAE,AAE5B,+BAEM,qBAAsB,AAClB,cAAgB,CAAE,AAE5B,+BAEM,qBAAsB,AAClB,cAAgB,CAAE,AAE5B,+BAEM,qBAAsB,AAClB,cAAgB,CAAE,AAE5B,+BAEM,qBAAsB,AAClB,cAAgB,CAAE,AAE5B,+BAEM,qBAAsB,AAClB,cAAgB,CAAE,AAE5B,+BAEM,qBAAsB,AAClB,cAAgB,CAAE,AAE5B,+BAEM,qBAAsB,AAClB,cAAgB,CAAE,AAE5B,+BAEM,qBAAsB,AAClB,cAAgB,CAAE,AAE5B,+BAEM,qBAAsB,AAClB,cAAgB,CAAE,AAE5B,+BAEM,qBAAsB,AAClB,cAAgB,CAAE,AAE5B,+BAEM,qBAAsB,AAClB,cAAgB,CAAE,AAE5B,+BAEM,qBAAsB,AAClB,cAAgB,CAAE,AAE5B,+BAEM,qBAAsB,AAClB,cAAgB,CAAE,AAE5B,+BAEM,qBAAsB,AAClB,cAAgB,CAAE,AAE5B,+BAEM,qBAAsB,AAClB,cAAgB,CAAE,AAE5B,+BAEM,qBAAsB,AAClB,cAAgB,CAAE,AAE5B,+BAEM,qBAAsB,AAClB,cAAgB,CAAE,AAE5B,+BAEM,qBAAsB,AAClB,cAAgB,CAAE,AAE5B,+BAEM,qBAAsB,AAClB,cAAgB,CAAE,AAE5B,+BAEM,qBAAsB,AAClB,cAAgB,CAAE,AAE5B,+BAEM,qBAAsB,AAClB,cAAgB,CAAE,AAE5B,+BAEM,qBAAsB,AAClB,cAAgB,CAAE,AAE5B,+BAEM,qBAAsB,AAClB,cAAgB,CAAE,AAE5B,+BAEM,qBAAsB,AAClB,cAAgB,CAAE,AAE5B,+BAEM,qBAAsB,AAClB,cAAgB,CAAE,AAE5B,+BAEM,qBAAsB,AAClB,cAAgB,CAAE,AAE5B,+BAEM,qBAAsB,AAClB,cAAgB,CAAE,AAE5B,+BAEM,qBAAsB,AAClB,cAAgB,CAAE,AAE5B,+BAEM,qBAAsB,AAClB,cAAgB,CAAE,AAE5B,+BAEM,qBAAsB,AAClB,cAAgB,CAAE,AAE5B,+BAEM,qBAAsB,AAClB,cAAgB,CAAE,AAE5B,+BAEM,qBAAsB,AAClB,cAAgB,CAAE,AAE5B,+BAEM,qBAAsB,AAClB,cAAgB,CAAE,AAE5B,+BAEM,qBAAsB,AAClB,cAAgB,CAAE,AAE5B,+BAEM,qBAAsB,AAClB,cAAgB,CAAE,AAE5B,+BAEM,qBAAsB,AAClB,cAAgB,CAAE,AAE5B,+BAEM,qBAAsB,AAClB,cAAgB,CAAE,AAE5B,+BAEM,qBAAsB,AAClB,cAAgB,CAAE,AAE5B,+BAEM,qBAAsB,AAClB,cAAgB,CAAE,AAE5B,+BAEM,qBAAsB,AAClB,cAAgB,CAAE,AAE5B,+BAEM,qBAAsB,AAClB,cAAgB,CAAE,AAE5B,+BAEM,qBAAsB,AAClB,cAAgB,CAAE,AAE5B,+BAEM,qBAAsB,AAClB,cAAgB,CAAE,AAE5B,+BAEM,qBAAsB,AAClB,cAAgB,CAAE,AAE5B,+BAEM,qBAAsB,AAClB,cAAgB,CAAE,AAE5B,+BAEM,qBAAsB,AAClB,cAAgB,CAAE,AAE5B,+BAEM,qBAAsB,AAClB,cAAgB,CAAE,AAE5B,+BAEM,qBAAsB,AAClB,cAAgB,CAAE,AAE5B,+BAEM,qBAAsB,AAClB,cAAgB,CAAE,AAE5B,+BAEM,qBAAsB,AAClB,cAAgB,CAAE,AAE5B,+BAEM,qBAAsB,AAClB,cAAgB,CAAE,AAE5B,+BAEM,qBAAsB,AAClB,cAAgB,CAAE,AAE5B,+BAEM,qBAAsB,AAClB,cAAgB,CAAE,AAE5B,+BAEM,qBAAsB,AAClB,cAAgB,CAAE,AAE5B,+BAEM,qBAAsB,AAClB,cAAgB,CAAE,AAE5B,+BAEM,qBAAsB,AAClB,cAAgB,CAAE,AAE5B,+BAEM,qBAAsB,AAClB,cAAgB,CAAE,AAE5B,+BAEM,qBAAsB,AAClB,cAAgB,CAAE,AAE5B,+BAEM,qBAAsB,AAClB,cAAgB,CAAE,AAE5B,+BAEM,qBAAsB,AAClB,cAAgB,CAAE,AAE5B,+BAEM,qBAAsB,AAClB,cAAgB,CAAE,AAE5B,+BAEM,qBAAsB,AAClB,cAAgB,CAAE,AAE5B,+BAEM,qBAAsB,AAClB,cAAgB,CAAE,AAE5B,+BAEM,qBAAsB,AAClB,cAAgB,CAAE,AAE5B,+BAEM,qBAAsB,AAClB,cAAgB,CAAE,AAE5B,+BAEM,qBAAsB,AAClB,cAAgB,CAAE,AAE5B,+BAEM,qBAAsB,AAClB,cAAgB,CAAE,AAE5B,+BAEM,qBAAsB,AAClB,cAAgB,CAAE,AAE5B,+BAEM,qBAAsB,AAClB,cAAgB,CAAE,AAE5B,+BAEM,qBAAsB,AAClB,cAAgB,CAAE,AAE5B,+BAEM,qBAAsB,AAClB,cAAgB,CAAE,AAE5B,+BAEM,qBAAsB,AAClB,cAAgB,CAAE,AAE5B,+BAEM,qBAAsB,AAClB,cAAgB,CAAE,AAE5B,+BAEM,qBAAsB,AAClB,cAAgB,CAAE,AAE5B,+BAEM,qBAAsB,AAClB,cAAgB,CAAE,AAE5B,+BAEM,qBAAsB,AAClB,cAAgB,CAAE,AAE5B,+BAEM,qBAAsB,AAClB,cAAgB,CAAE,AAE5B,+BAEM,qBAAsB,AAClB,cAAgB,CAAE,AAE5B,+BAEM,qBAAsB,AAClB,cAAgB,CAAE,AAE5B,+BAEM,qBAAsB,AAClB,cAAgB,CAAE,AAE5B,+BAEM,qBAAsB,AAClB,cAAgB,CAAE,AAE5B,gCAEM,sBAAuB,AACnB,eAAiB,CAAE,AAE7B,iCACE,qBAAuB,CAAE,AACzB,2DACE,wBAA0B,CAAE,AAC9B,2DACE,yCAA8C,AAC9C,wBAA0B,CAAE,AAC9B,kEACE,qBAAuB,CAAE,AACzB,iJACE,UAAW,AACX,WAAY,AACZ,QAAU,CAAE,AACd,yEACE,QAAU,CAAE,AACd,wEACE,UAAW,AACX,SAAW,CAAE,AACjB,+DACE,WAAY,AACZ,SAAW,CAAE,AACf,qEACE,cAAe,AACf,YAAc,CAAE,AAClB,yFACE,cAAe,AACf,YAAc,CAAE,AAClB,yGACE,qBAAsB,AACtB,cAAgB,CAAE,AAClB,+WAEE,kBAAoB,CAAE,AAI1B,yNACE,eAAiB,CAAE,AACrB,2YAIE,oBAAsB,CAAE,AACxB,i3CAWE,kBAAoB,CAAE,AAE5B,+EACE,cAAgB,CAAE,AAEpB,0EACE,kBAAoB,CAAE,AAExB,2EACE,gBAAkB,AAClB,mBAAoB,AACpB,iBAAmB,CAAE,AAEvB,0CACE,WAAa,CAAE,AACf,4EACE,gBAAiB,AACjB,aAAc,AACd,kBAAmB,AACnB,yBAA0B,AACvB,sBAAuB,AACtB,qBAAsB,AAClB,iBAAkB,AAC1B,sBAAuB,AACvB,gBAAkB,AAClB,cAAiB,CAAE,AACnB,mFACE,OAAS,CAAE,AACb,6HACE,cAAgB,CAAE,AAClB,mIACE,mBAAoB,AACpB,qBAAsB,AACtB,UAAa,CAAE,AACrB,8GACE,eAAiB,CAAE,AAEvB,uDACE,qBAAuB,CAAE,AACzB,6DACE,YAAa,AACb,YAAa,AACb,YAAc,CAAE,AAClB,uHACE,wBAA0B,CAAE,AAC9B,qHACE,kBAAmB,AACnB,cAAgB,CAAE,AAClB,4HACE,aAAc,AACd,OAAS,CAAE,AAEjB,6CACE,sBAAuB,AACvB,WAAa,CAAE,AACf,iFACE,YAAa,AACb,eAAgB,AAChB,4BAA8B,CAAE,AAChC,2FACE,aAAe,CAAE,AACrB,yFACE,wBAA0B,CAAE,AAC9B,wFACE,WAAa,AACb,+BAAgC,AAChC,wBAA0B,CAAE,AAC9B,mIACE,8BAAgC,CAAE,AAEtC,+CACE,sBAAuB,AACvB,WAAa,CAAE,AACf,qFACE,eAAgB,AAChB,kBAAmB,AACnB,aAAc,AACd,yBAA0B,AACvB,sBAAuB,AACtB,qBAAsB,AAClB,gBAAkB,CAAE,AAC5B,+FACE,YAAc,CAAE,AAClB,iJACE,QAAU,CAAE,AAChB,oFACE,YAAa,AACb,eAAgB,AAChB,4BAA8B,CAAE,AAChC,8FACE,aAAe,CAAE,AACrB,4FACE,wBAA0B,CAAE,AAC9B,2FACE,WAAa,AACb,+BAAgC,AAChC,wBAA0B,CAAE,AAC9B,uIACE,8BAAgC,CAAE,AAEtC,gDACE,sBAAuB,AACvB,WAAa,CAAE,AACf,4LAEE,WAAa,CAAE,AAEnB,4EACE,gBAAmB,CAAE,AAEvB,2CACE,gBAAiB,AACjB,mBAAoB,AACpB,gBAAkB,CAAE,AACpB,uFACE,gBAAkB,CAAE,AACtB,oFACE,eAAkB,CAAE,AACtB,0HACE,cAAgB,CAAE,AACpB,6EACE,kBAAmB,AACnB,YAAc,CAAE,AAChB,uFACE,YAAc,CAAE,AAClB,oIACE,YAAc,CAAE,AAClB,qIACE,OAAS,CAAE,AAEjB,4CACE,qBAAuB,CAAE,AACzB,0FACE,WAAa,CAAE,AACjB,sEACE,WAAa,CAAE,AAEnB,iMAIE,eAAgB,AAChB,aAAe,CAAE,AAEnB,yDACE,qBAAuB,CAAE,AACzB,yTAGE,WAAa,CAAE,AAEnB,mDACE,qBAAuB,CAAE,AACzB,0KAEE,WAAa,CAAE,AAEnB,8CACE,gBAAkB,AAClB,kBAAmB,AACnB,sBAAuB,AACvB,eAAiB,CAAE,AACnB,4FACE,wBAA0B,CAAE,AAC9B,yFACE,cAAe,AACf,cAAiB,CAAE,AACrB,kFACE,cAAgB,CAAE,AACpB,iFACE,UAAY,CAAE,AACd,yHACE,6BAA8B,AAC9B,kBAAmB,AACnB,eAAgB,AAChB,kBAAmB,AACnB,eAAgB,AAChB,gBAAiB,AACjB,eAAgB,AAChB,gBAAiB,AACjB,oBAAqB,AAErB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AAEtB,sBAAuB,AACnB,mBAAoB,AAC5B,wBAAyB,AAErB,qBAAsB,AAClB,sBAAwB,CAAE,AAClC,+HACE,8BAAgC,CAAE,AACtC,4LACE,eAAiB,CAAE,AACnB,4QACE,iBAAmB,CAAE,AACrB,kjBACE,kBAAmB,AACnB,YAAa,AACb,MAAS,AACT,SAAY,AACZ,WAAY,AACZ,mBAAoB,AACpB,WAAY,AACZ,UAAY,CAAE,AAChB,0RACE,SAAW,CAAE,AACf,wRACE,QAAU,CAAE,AAGhB,4sDACE,YAAc,CAAE,AAGlB,0+BACE,eAAiB,CAAE,AAGnB,4jDACE,8BAAgC,CAAE,AACxC,4YACE,6BAA8B,AAC9B,+BAAgC,AAChC,UAAa,CAAE,AACf,8ZACE,8BAAgC,CAAE,AACtC,qiBACE,UAAe,CAAE,AACnB,yIACE,8BAAgC,CAAE,AAClC,+RACE,kBAAoB,CAAE,AAGxB,wlCACE,8BAAgC,CAAE,AACtC,iIACE,wBAA0B,CAAE,AAChC,0LAEE,aAAe,CAAE,AACnB,oGACE,SAAW,CAAE,AACb,oSACE,aAAe,CAAE,AACrB,kGACE,UAAe,CAAE,AACjB,gSACE,UAAe,CAAE,AACrB,2FACE,aAAe,CAAE,AACjB,mIACE,cAAgB,CAAE,AAClB,yIACE,eAAiB,CAAE,AACvB,kRACE,aAAe,CAAE,AAEvB,qCACE,qBAAuB,CAAE,AACzB,oEACE,WAAa,CAAE","file":"index.css","sourcesContent":[".react-date-field {\n  box-sizing: border-box;\n  position: relative;\n  overflow: visible;\n  vertical-align: middle; }\n  .react-date-field *,\n  .react-date-field *:before,\n  .react-date-field *:after {\n    box-sizing: border-box; }\n  .react-date-field > .react-date-field__picker {\n    min-width: 100%;\n    position: absolute;\n    z-index: 100;\n    left: -1px;\n    background: white; }\n\n.react-date-field--picker-position-bottom > .react-date-field__picker {\n  top: 100%; }\n\n.react-date-field--picker-position-top > .react-date-field__picker {\n  bottom: 100%; }\n\n.react-date-field__input {\n  width: 100%;\n  -webkit-box-flex: 1;\n  -webkit-flex: 1 1 auto;\n      -ms-flex: 1 1 auto;\n          flex: 1 1 auto;\n  padding: 5px;\n  border: none;\n  outline: none; }\n\n.react-date-field__calendar-icon {\n  border: 3px solid gray;\n  border-top-width: 5px;\n  border-radius: 2px;\n  padding: 5px 7px;\n  margin: 2px 4px 0px 2px;\n  position: relative; }\n\n.react-date-field__clear-icon {\n  color: gray;\n  fill: gray;\n  margin: 0px 2px;\n  cursor: pointer; }\n  .react-date-field__clear-icon svg {\n    vertical-align: middle; }\n\n.react-date-field__clear-icon:hover {\n  color: #4d4d4d;\n  fill: #4d4d4d; }\n\n.react-date-field__calendar-icon:after,\n.react-date-field__calendar-icon:before {\n  content: '';\n  width: 3px;\n  height: 6px;\n  border-radius: 10px;\n  left: 1px;\n  top: -6px;\n  position: absolute;\n  background: gray; }\n\n.react-date-field__calendar-icon:after {\n  left: auto;\n  right: 0px; }\n\n.react-date-field__calendar-icon-inner {\n  background: gray;\n  position: absolute;\n  border-radius: 1px;\n  top: 2px;\n  left: 2px;\n  width: 4px;\n  height: 4px; }\n\n.react-date-picker__clock {\n  box-sizing: border-box;\n  display: inline-block;\n  border: 5px solid gray;\n  border-radius: 50%;\n  position: relative; }\n  .react-date-picker__clock *,\n  .react-date-picker__clock *:before,\n  .react-date-picker__clock *:after {\n    box-sizing: border-box; }\n\n.react-date-picker__clock-overlay,\n.react-date-picker__clock-center {\n  border-radius: 50%;\n  position: absolute;\n  -webkit-transform: translate3d(-50%, -50%, 0);\n          transform: translate3d(-50%, -50%, 0);\n  top: 50%;\n  left: 50%; }\n\n.react-date-picker__clock-hand,\n.react-date-picker__clock-tick {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  width: 1px;\n  background: gray; }\n\n.react-date-picker__date-format-spinner {\n  box-sizing: border-box; }\n  .react-date-picker__date-format-spinner *,\n  .react-date-picker__date-format-spinner *:before,\n  .react-date-picker__date-format-spinner *:after {\n    box-sizing: border-box; }\n\n.react-date-picker__time-picker {\n  box-sizing: border-box; }\n  .react-date-picker__time-picker *,\n  .react-date-picker__time-picker *:before,\n  .react-date-picker__time-picker *:after {\n    box-sizing: border-box; }\n\n.react-date-picker__time-picker-input {\n  margin-top: 10px; }\n\n.react-date-picker__year-view {\n  box-sizing: border-box;\n  outline: none; }\n  .react-date-picker__year-view *,\n  .react-date-picker__year-view *:before,\n  .react-date-picker__year-view *:after {\n    box-sizing: border-box; }\n  .react-date-picker__year-view-month {\n    text-align: center; }\n\n.react-date-picker__decade-view {\n  box-sizing: border-box;\n  outline: none; }\n  .react-date-picker__decade-view *,\n  .react-date-picker__decade-view *:before,\n  .react-date-picker__decade-view *:after {\n    box-sizing: border-box; }\n  .react-date-picker__decade-view-year {\n    text-align: center; }\n\n.react-date-picker__history-view {\n  box-sizing: border-box;\n  outline: none; }\n  .react-date-picker__history-view *,\n  .react-date-picker__history-view *:before,\n  .react-date-picker__history-view *:after {\n    box-sizing: border-box; }\n\n.react-date-picker__nav-bar {\n  box-sizing: border-box;\n  outline: none;\n  position: relative; }\n  .react-date-picker__nav-bar *,\n  .react-date-picker__nav-bar *:before,\n  .react-date-picker__nav-bar *:after {\n    box-sizing: border-box; }\n  .react-date-picker__nav-bar-arrow {\n    -webkit-user-select: none;\n       -moz-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n    cursor: pointer;\n    position: relative; }\n    .react-date-picker__nav-bar-arrow--disabled {\n      fill: #BFBFBF;\n      cursor: default; }\n  .react-date-picker__nav-bar-date {\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    overflow: hidden; }\n  .react-date-picker__nav-bar svg {\n    vertical-align: middle; }\n  .react-date-picker__nav-bar-history-view {\n    z-index: 100;\n    position: absolute;\n    margin: auto;\n    left: 3px;\n    right: 3px;\n    top: 100%; }\n\n.react-date-picker,\n.react-date-picker__calendar,\n.react-date-picker__basic-month-view {\n  box-sizing: border-box; }\n  .react-date-picker *,\n  .react-date-picker *:before,\n  .react-date-picker *:after,\n  .react-date-picker__calendar *,\n  .react-date-picker__calendar *:before,\n  .react-date-picker__calendar *:after,\n  .react-date-picker__basic-month-view *,\n  .react-date-picker__basic-month-view *:before,\n  .react-date-picker__basic-month-view *:after {\n    box-sizing: border-box; }\n\n.react-date-picker__transition-month-view {\n  position: relative;\n  overflow: hidden; }\n\n.react-date-picker__prev {\n  -webkit-transform: translate3d(-100%, 0px, 0px);\n          transform: translate3d(-100%, 0px, 0px); }\n\n.react-date-picker__next {\n  -webkit-transform: translate3d(100%, 0px, 0px);\n          transform: translate3d(100%, 0px, 0px); }\n\n.react-date-picker--transition-left {\n  -webkit-transform: translate3d(-100%, 0px, 0px);\n          transform: translate3d(-100%, 0px, 0px); }\n  .react-date-picker--transition-left.react-date-picker__next {\n    -webkit-transform: translate3d(0%, 0px, 0px);\n            transform: translate3d(0%, 0px, 0px); }\n\n.react-date-picker--transition-right {\n  z-index: 1111;\n  -webkit-transform: translate3d(100%, 0px, 0px);\n          transform: translate3d(100%, 0px, 0px); }\n  .react-date-picker--transition-right.react-date-picker__prev {\n    -webkit-transform: translate3d(0%, 0px, 0px);\n            transform: translate3d(0%, 0px, 0px); }\n\n.react-date-picker__center {\n  z-index: 10; }\n\n.react-date-picker__prev.react-date-picker--transition,\n.react-date-picker__center.react-date-picker--transition,\n.react-date-picker__next.react-date-picker--transition {\n  -webkit-transition-property: -webkit-transform;\n  transition-property: -webkit-transform;\n  transition-property: transform;\n  transition-property: transform, -webkit-transform; }\n\n.react-date-picker__prev,\n.react-date-picker__next {\n  top: 0px;\n  left: 0px;\n  height: 100%;\n  width: 100%;\n  position: absolute !important; }\n\n.react-date-picker__month-view,\n.react-date-picker__basic-month-view {\n  position: relative;\n  outline: none; }\n  .react-date-picker__month-view-week-day-name,\n  .react-date-picker__basic-month-view-week-day-name {\n    padding: 5px 0px; }\n  .react-date-picker__month-view-day--hidden,\n  .react-date-picker__basic-month-view-day--hidden {\n    visibility: hidden; }\n  .react-date-picker__month-view-day--disabled,\n  .react-date-picker__basic-month-view-day--disabled {\n    color: #BFBFBF; }\n  .react-date-picker__month-view-cell,\n  .react-date-picker__basic-month-view-cell {\n    -webkit-box-flex: 1;\n    -webkit-flex: 1 0 auto;\n        -ms-flex: 1 0 auto;\n            flex: 1 0 auto;\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-flex-flow: row;\n        -ms-flex-flow: row;\n            flex-flow: row;\n    -webkit-box-align: center;\n    -webkit-align-items: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -webkit-box-pack: center;\n    -webkit-justify-content: center;\n        -ms-flex-pack: center;\n            justify-content: center; }\n  .react-date-picker__month-view-row,\n  .react-date-picker__basic-month-view-row {\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-flex-flow: row;\n        -ms-flex-flow: row;\n            flex-flow: row;\n    -webkit-box-flex: 1;\n    -webkit-flex-grow: 1;\n        -ms-flex-positive: 1;\n            flex-grow: 1;\n    -webkit-flex-shrink: 0;\n        -ms-flex-negative: 0;\n            flex-shrink: 0;\n    -webkit-flex-basis: auto;\n        -ms-flex-preferred-size: auto;\n            flex-basis: auto; }\n  .react-date-picker__month-view-week-day-names,\n  .react-date-picker__basic-month-view-week-day-names {\n    -webkit-box-flex: 0;\n    -webkit-flex: none;\n        -ms-flex: none;\n            flex: none; }\n\n.react-flex-v2 {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex; }\n\n.react-flex-v2--inline {\n  display: -webkit-inline-box;\n  display: -webkit-inline-flex;\n  display: -ms-inline-flexbox;\n  display: inline-flex; }\n\n.react-flex-v2--display-flex {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex; }\n\n.react-flex-v2--display-inline-flex {\n  display: -webkit-inline-box;\n  display: -webkit-inline-flex;\n  display: -ms-inline-flexbox;\n  display: inline-flex; }\n\n/* ALIGN-ITEMS */\n.react-flex-v2--align-items-center {\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n      -ms-flex-align: center;\n              -ms-grid-row-align: center;\n          align-items: center; }\n\n.react-flex-v2--align-items-stretch {\n  -webkit-box-align: stretch;\n  -webkit-align-items: stretch;\n      -ms-flex-align: stretch;\n              -ms-grid-row-align: stretch;\n          align-items: stretch; }\n\n.react-flex-v2--align-items-baseline {\n  -webkit-box-align: baseline;\n  -webkit-align-items: baseline;\n      -ms-flex-align: baseline;\n              -ms-grid-row-align: baseline;\n          align-items: baseline; }\n\n.react-flex-v2--align-items-end,\n.react-flex-v2--align-items-flex-end {\n  -webkit-box-align: end;\n  -webkit-align-items: flex-end;\n      -ms-flex-align: end;\n              -ms-grid-row-align: flex-end;\n          align-items: flex-end; }\n\n.react-flex-v2--align-items-start,\n.react-flex-v2--align-items-flex-start {\n  -webkit-box-align: start;\n  -webkit-align-items: flex-start;\n      -ms-flex-align: start;\n              -ms-grid-row-align: flex-start;\n          align-items: flex-start; }\n\n/* ALIGN-SELF */\n.react-flex-v2--align-self-center {\n  -webkit-align-self: center;\n      -ms-flex-item-align: center;\n          align-self: center; }\n\n.react-flex-v2--align-self-stretch {\n  -webkit-align-self: stretch;\n      -ms-flex-item-align: stretch;\n          align-self: stretch; }\n\n.react-flex-v2--align-self-baseline {\n  -webkit-align-self: baseline;\n      -ms-flex-item-align: baseline;\n          align-self: baseline; }\n\n.react-flex-v2--align-self-auto {\n  -webkit-align-self: auto;\n      -ms-flex-item-align: auto;\n          align-self: auto; }\n\n.react-flex-v2--align-self-end,\n.react-flex-v2--align-self-flex-end {\n  -webkit-align-self: flex-end;\n      -ms-flex-item-align: end;\n          align-self: flex-end; }\n\n.react-flex-v2--align-self-start,\n.react-flex-v2--align-self-flex-start {\n  -webkit-align-self: flex-start;\n      -ms-flex-item-align: start;\n          align-self: flex-start; }\n\n/* ALIGN-CONTENT */\n.react-flex-v2--align-content-center {\n  -webkit-align-content: center;\n      -ms-flex-line-pack: center;\n          align-content: center; }\n\n.react-flex-v2--align-content-stretch {\n  -webkit-align-content: stretch;\n      -ms-flex-line-pack: stretch;\n          align-content: stretch; }\n\n.react-flex-v2--align-content-around,\n.react-flex-v2--align-content-space-around {\n  -webkit-align-content: space-around;\n      -ms-flex-line-pack: distribute;\n          align-content: space-around; }\n\n.react-flex-v2--align-content-between,\n.react-flex-v2--align-content-space-between {\n  -webkit-align-content: space-between;\n      -ms-flex-line-pack: justify;\n          align-content: space-between; }\n\n.react-flex-v2--align-content-end,\n.react-flex-v2--align-content-flex-end {\n  -webkit-align-content: flex-end;\n      -ms-flex-line-pack: end;\n          align-content: flex-end; }\n\n.react-flex-v2--align-content-start,\n.react-flex-v2--align-content-flex-start {\n  -webkit-align-content: flex-start;\n      -ms-flex-line-pack: start;\n          align-content: flex-start; }\n\n/* JUSTIFY-CONTENT */\n.react-flex-v2--justify-content-start,\n.react-flex-v2--justify-content-flex-start {\n  -webkit-box-pack: start;\n  -webkit-justify-content: flex-start;\n      -ms-flex-pack: start;\n          justify-content: flex-start; }\n\n.react-flex-v2--justify-content-end,\n.react-flex-v2--justify-content-flex-end {\n  -webkit-box-pack: end;\n  -webkit-justify-content: flex-end;\n      -ms-flex-pack: end;\n          justify-content: flex-end; }\n\n.react-flex-v2--justify-content-center {\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n      -ms-flex-pack: center;\n          justify-content: center; }\n\n.react-flex-v2--justify-content-space-around {\n  -webkit-justify-content: space-around;\n      -ms-flex-pack: distribute;\n          justify-content: space-around; }\n\n.react-flex-v2--justify-content-space-between {\n  -webkit-box-pack: justify;\n  -webkit-justify-content: space-between;\n      -ms-flex-pack: justify;\n          justify-content: space-between; }\n\n/* WRAP */\n.react-flex-v2--wrap {\n  -webkit-flex-wrap: wrap;\n      -ms-flex-wrap: wrap;\n          flex-wrap: wrap; }\n\n/* COLUMN */\n.react-flex-v2--column {\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n      -ms-flex-direction: column;\n          flex-direction: column; }\n\n.react-flex-v2--column-reverse {\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: reverse;\n  -webkit-flex-direction: column-reverse;\n      -ms-flex-direction: column-reverse;\n          flex-direction: column-reverse; }\n\n/* ROW */\n.react-flex-v2--row {\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: row;\n      -ms-flex-direction: row;\n          flex-direction: row; }\n\n.react-flex-v2--row-reverse {\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: reverse;\n  -webkit-flex-direction: row-reverse;\n      -ms-flex-direction: row-reverse;\n          flex-direction: row-reverse; }\n\n/* FLEX-BASIS */\n.react-flex-v2--flex-basis-auto {\n  -webkit-flex-basis: auto;\n      -ms-flex-preferred-size: auto;\n          flex-basis: auto; }\n\n.react-flex-v2--flex-basis-none,\n.react-flex-v2--flex-basis-0 {\n  -webkit-flex-basis: 0px;\n      -ms-flex-preferred-size: 0px;\n          flex-basis: 0px; }\n\n.react-flex-v2--flex-basis-fill {\n  -webkit-flex-basis: fill;\n      -ms-flex-preferred-size: fill;\n          flex-basis: fill; }\n\n.react-flex-v2--flex-basis-content {\n  -webkit-flex-basis: content;\n      -ms-flex-preferred-size: content;\n          flex-basis: content; }\n\n.react-flex-v2--flex-basis-fit-content {\n  -webkit-flex-basis: fit-content;\n      -ms-flex-preferred-size: fit-content;\n          flex-basis: fit-content; }\n\n.react-flex-v2--flex-basis-min-content {\n  -webkit-flex-basis: min-content;\n      -ms-flex-preferred-size: min-content;\n          flex-basis: min-content; }\n\n.react-flex-v2--flex-basis-max-content {\n  -webkit-flex-basis: max-content;\n      -ms-flex-preferred-size: max-content;\n          flex-basis: max-content; }\n\n/* FLEX */\n.react-flex-v2--flex-none,\n.react-flex-v2--flex-0 {\n  -webkit-box-flex: 0;\n  -webkit-flex: none;\n      -ms-flex: none;\n          flex: none; }\n\n.react-flex-v2--flex-1 {\n  -webkit-box-flex: 1;\n  -webkit-flex: 1;\n      -ms-flex: 1;\n          flex: 1; }\n\n.react-flex-v2--flex-2 {\n  -webkit-box-flex: 2;\n  -webkit-flex: 2;\n      -ms-flex: 2;\n          flex: 2; }\n\n.react-flex-v2--flex-3 {\n  -webkit-box-flex: 3;\n  -webkit-flex: 3;\n      -ms-flex: 3;\n          flex: 3; }\n\n.react-flex-v2--flex-4 {\n  -webkit-box-flex: 4;\n  -webkit-flex: 4;\n      -ms-flex: 4;\n          flex: 4; }\n\n.react-flex-v2--flex-5 {\n  -webkit-box-flex: 5;\n  -webkit-flex: 5;\n      -ms-flex: 5;\n          flex: 5; }\n\n.react-flex-v2--flex-6 {\n  -webkit-box-flex: 6;\n  -webkit-flex: 6;\n      -ms-flex: 6;\n          flex: 6; }\n\n.react-flex-v2--flex-7 {\n  -webkit-box-flex: 7;\n  -webkit-flex: 7;\n      -ms-flex: 7;\n          flex: 7; }\n\n.react-flex-v2--flex-8 {\n  -webkit-box-flex: 8;\n  -webkit-flex: 8;\n      -ms-flex: 8;\n          flex: 8; }\n\n.react-flex-v2--flex-9 {\n  -webkit-box-flex: 9;\n  -webkit-flex: 9;\n      -ms-flex: 9;\n          flex: 9; }\n\n.react-flex-v2--flex-10 {\n  -webkit-box-flex: 10;\n  -webkit-flex: 10;\n      -ms-flex: 10;\n          flex: 10; }\n\n.react-flex-v2--flex-11 {\n  -webkit-box-flex: 11;\n  -webkit-flex: 11;\n      -ms-flex: 11;\n          flex: 11; }\n\n.react-flex-v2--flex-12 {\n  -webkit-box-flex: 12;\n  -webkit-flex: 12;\n      -ms-flex: 12;\n          flex: 12; }\n\n.react-flex-v2--flex-13 {\n  -webkit-box-flex: 13;\n  -webkit-flex: 13;\n      -ms-flex: 13;\n          flex: 13; }\n\n.react-flex-v2--flex-14 {\n  -webkit-box-flex: 14;\n  -webkit-flex: 14;\n      -ms-flex: 14;\n          flex: 14; }\n\n.react-flex-v2--flex-15 {\n  -webkit-box-flex: 15;\n  -webkit-flex: 15;\n      -ms-flex: 15;\n          flex: 15; }\n\n.react-flex-v2--flex-16 {\n  -webkit-box-flex: 16;\n  -webkit-flex: 16;\n      -ms-flex: 16;\n          flex: 16; }\n\n.react-flex-v2--flex-17 {\n  -webkit-box-flex: 17;\n  -webkit-flex: 17;\n      -ms-flex: 17;\n          flex: 17; }\n\n.react-flex-v2--flex-18 {\n  -webkit-box-flex: 18;\n  -webkit-flex: 18;\n      -ms-flex: 18;\n          flex: 18; }\n\n.react-flex-v2--flex-19 {\n  -webkit-box-flex: 19;\n  -webkit-flex: 19;\n      -ms-flex: 19;\n          flex: 19; }\n\n.react-flex-v2--flex-20 {\n  -webkit-box-flex: 20;\n  -webkit-flex: 20;\n      -ms-flex: 20;\n          flex: 20; }\n\n.react-flex-v2--flex-21 {\n  -webkit-box-flex: 21;\n  -webkit-flex: 21;\n      -ms-flex: 21;\n          flex: 21; }\n\n.react-flex-v2--flex-22 {\n  -webkit-box-flex: 22;\n  -webkit-flex: 22;\n      -ms-flex: 22;\n          flex: 22; }\n\n.react-flex-v2--flex-23 {\n  -webkit-box-flex: 23;\n  -webkit-flex: 23;\n      -ms-flex: 23;\n          flex: 23; }\n\n.react-flex-v2--flex-24 {\n  -webkit-box-flex: 24;\n  -webkit-flex: 24;\n      -ms-flex: 24;\n          flex: 24; }\n\n.react-flex-v2--flex-25 {\n  -webkit-box-flex: 25;\n  -webkit-flex: 25;\n      -ms-flex: 25;\n          flex: 25; }\n\n.react-flex-v2--flex-26 {\n  -webkit-box-flex: 26;\n  -webkit-flex: 26;\n      -ms-flex: 26;\n          flex: 26; }\n\n.react-flex-v2--flex-27 {\n  -webkit-box-flex: 27;\n  -webkit-flex: 27;\n      -ms-flex: 27;\n          flex: 27; }\n\n.react-flex-v2--flex-28 {\n  -webkit-box-flex: 28;\n  -webkit-flex: 28;\n      -ms-flex: 28;\n          flex: 28; }\n\n.react-flex-v2--flex-29 {\n  -webkit-box-flex: 29;\n  -webkit-flex: 29;\n      -ms-flex: 29;\n          flex: 29; }\n\n.react-flex-v2--flex-30 {\n  -webkit-box-flex: 30;\n  -webkit-flex: 30;\n      -ms-flex: 30;\n          flex: 30; }\n\n.react-flex-v2--flex-31 {\n  -webkit-box-flex: 31;\n  -webkit-flex: 31;\n      -ms-flex: 31;\n          flex: 31; }\n\n.react-flex-v2--flex-32 {\n  -webkit-box-flex: 32;\n  -webkit-flex: 32;\n      -ms-flex: 32;\n          flex: 32; }\n\n.react-flex-v2--flex-33 {\n  -webkit-box-flex: 33;\n  -webkit-flex: 33;\n      -ms-flex: 33;\n          flex: 33; }\n\n.react-flex-v2--flex-34 {\n  -webkit-box-flex: 34;\n  -webkit-flex: 34;\n      -ms-flex: 34;\n          flex: 34; }\n\n.react-flex-v2--flex-35 {\n  -webkit-box-flex: 35;\n  -webkit-flex: 35;\n      -ms-flex: 35;\n          flex: 35; }\n\n.react-flex-v2--flex-36 {\n  -webkit-box-flex: 36;\n  -webkit-flex: 36;\n      -ms-flex: 36;\n          flex: 36; }\n\n.react-flex-v2--flex-37 {\n  -webkit-box-flex: 37;\n  -webkit-flex: 37;\n      -ms-flex: 37;\n          flex: 37; }\n\n.react-flex-v2--flex-38 {\n  -webkit-box-flex: 38;\n  -webkit-flex: 38;\n      -ms-flex: 38;\n          flex: 38; }\n\n.react-flex-v2--flex-39 {\n  -webkit-box-flex: 39;\n  -webkit-flex: 39;\n      -ms-flex: 39;\n          flex: 39; }\n\n.react-flex-v2--flex-40 {\n  -webkit-box-flex: 40;\n  -webkit-flex: 40;\n      -ms-flex: 40;\n          flex: 40; }\n\n.react-flex-v2--flex-41 {\n  -webkit-box-flex: 41;\n  -webkit-flex: 41;\n      -ms-flex: 41;\n          flex: 41; }\n\n.react-flex-v2--flex-42 {\n  -webkit-box-flex: 42;\n  -webkit-flex: 42;\n      -ms-flex: 42;\n          flex: 42; }\n\n.react-flex-v2--flex-43 {\n  -webkit-box-flex: 43;\n  -webkit-flex: 43;\n      -ms-flex: 43;\n          flex: 43; }\n\n.react-flex-v2--flex-44 {\n  -webkit-box-flex: 44;\n  -webkit-flex: 44;\n      -ms-flex: 44;\n          flex: 44; }\n\n.react-flex-v2--flex-45 {\n  -webkit-box-flex: 45;\n  -webkit-flex: 45;\n      -ms-flex: 45;\n          flex: 45; }\n\n.react-flex-v2--flex-46 {\n  -webkit-box-flex: 46;\n  -webkit-flex: 46;\n      -ms-flex: 46;\n          flex: 46; }\n\n.react-flex-v2--flex-47 {\n  -webkit-box-flex: 47;\n  -webkit-flex: 47;\n      -ms-flex: 47;\n          flex: 47; }\n\n.react-flex-v2--flex-48 {\n  -webkit-box-flex: 48;\n  -webkit-flex: 48;\n      -ms-flex: 48;\n          flex: 48; }\n\n.react-flex-v2--flex-49 {\n  -webkit-box-flex: 49;\n  -webkit-flex: 49;\n      -ms-flex: 49;\n          flex: 49; }\n\n.react-flex-v2--flex-50 {\n  -webkit-box-flex: 50;\n  -webkit-flex: 50;\n      -ms-flex: 50;\n          flex: 50; }\n\n.react-flex-v2--flex-51 {\n  -webkit-box-flex: 51;\n  -webkit-flex: 51;\n      -ms-flex: 51;\n          flex: 51; }\n\n.react-flex-v2--flex-52 {\n  -webkit-box-flex: 52;\n  -webkit-flex: 52;\n      -ms-flex: 52;\n          flex: 52; }\n\n.react-flex-v2--flex-53 {\n  -webkit-box-flex: 53;\n  -webkit-flex: 53;\n      -ms-flex: 53;\n          flex: 53; }\n\n.react-flex-v2--flex-54 {\n  -webkit-box-flex: 54;\n  -webkit-flex: 54;\n      -ms-flex: 54;\n          flex: 54; }\n\n.react-flex-v2--flex-55 {\n  -webkit-box-flex: 55;\n  -webkit-flex: 55;\n      -ms-flex: 55;\n          flex: 55; }\n\n.react-flex-v2--flex-56 {\n  -webkit-box-flex: 56;\n  -webkit-flex: 56;\n      -ms-flex: 56;\n          flex: 56; }\n\n.react-flex-v2--flex-57 {\n  -webkit-box-flex: 57;\n  -webkit-flex: 57;\n      -ms-flex: 57;\n          flex: 57; }\n\n.react-flex-v2--flex-58 {\n  -webkit-box-flex: 58;\n  -webkit-flex: 58;\n      -ms-flex: 58;\n          flex: 58; }\n\n.react-flex-v2--flex-59 {\n  -webkit-box-flex: 59;\n  -webkit-flex: 59;\n      -ms-flex: 59;\n          flex: 59; }\n\n.react-flex-v2--flex-60 {\n  -webkit-box-flex: 60;\n  -webkit-flex: 60;\n      -ms-flex: 60;\n          flex: 60; }\n\n.react-flex-v2--flex-61 {\n  -webkit-box-flex: 61;\n  -webkit-flex: 61;\n      -ms-flex: 61;\n          flex: 61; }\n\n.react-flex-v2--flex-62 {\n  -webkit-box-flex: 62;\n  -webkit-flex: 62;\n      -ms-flex: 62;\n          flex: 62; }\n\n.react-flex-v2--flex-63 {\n  -webkit-box-flex: 63;\n  -webkit-flex: 63;\n      -ms-flex: 63;\n          flex: 63; }\n\n.react-flex-v2--flex-64 {\n  -webkit-box-flex: 64;\n  -webkit-flex: 64;\n      -ms-flex: 64;\n          flex: 64; }\n\n.react-flex-v2--flex-65 {\n  -webkit-box-flex: 65;\n  -webkit-flex: 65;\n      -ms-flex: 65;\n          flex: 65; }\n\n.react-flex-v2--flex-66 {\n  -webkit-box-flex: 66;\n  -webkit-flex: 66;\n      -ms-flex: 66;\n          flex: 66; }\n\n.react-flex-v2--flex-67 {\n  -webkit-box-flex: 67;\n  -webkit-flex: 67;\n      -ms-flex: 67;\n          flex: 67; }\n\n.react-flex-v2--flex-68 {\n  -webkit-box-flex: 68;\n  -webkit-flex: 68;\n      -ms-flex: 68;\n          flex: 68; }\n\n.react-flex-v2--flex-69 {\n  -webkit-box-flex: 69;\n  -webkit-flex: 69;\n      -ms-flex: 69;\n          flex: 69; }\n\n.react-flex-v2--flex-70 {\n  -webkit-box-flex: 70;\n  -webkit-flex: 70;\n      -ms-flex: 70;\n          flex: 70; }\n\n.react-flex-v2--flex-71 {\n  -webkit-box-flex: 71;\n  -webkit-flex: 71;\n      -ms-flex: 71;\n          flex: 71; }\n\n.react-flex-v2--flex-72 {\n  -webkit-box-flex: 72;\n  -webkit-flex: 72;\n      -ms-flex: 72;\n          flex: 72; }\n\n.react-flex-v2--flex-73 {\n  -webkit-box-flex: 73;\n  -webkit-flex: 73;\n      -ms-flex: 73;\n          flex: 73; }\n\n.react-flex-v2--flex-74 {\n  -webkit-box-flex: 74;\n  -webkit-flex: 74;\n      -ms-flex: 74;\n          flex: 74; }\n\n.react-flex-v2--flex-75 {\n  -webkit-box-flex: 75;\n  -webkit-flex: 75;\n      -ms-flex: 75;\n          flex: 75; }\n\n.react-flex-v2--flex-76 {\n  -webkit-box-flex: 76;\n  -webkit-flex: 76;\n      -ms-flex: 76;\n          flex: 76; }\n\n.react-flex-v2--flex-77 {\n  -webkit-box-flex: 77;\n  -webkit-flex: 77;\n      -ms-flex: 77;\n          flex: 77; }\n\n.react-flex-v2--flex-78 {\n  -webkit-box-flex: 78;\n  -webkit-flex: 78;\n      -ms-flex: 78;\n          flex: 78; }\n\n.react-flex-v2--flex-79 {\n  -webkit-box-flex: 79;\n  -webkit-flex: 79;\n      -ms-flex: 79;\n          flex: 79; }\n\n.react-flex-v2--flex-80 {\n  -webkit-box-flex: 80;\n  -webkit-flex: 80;\n      -ms-flex: 80;\n          flex: 80; }\n\n.react-flex-v2--flex-81 {\n  -webkit-box-flex: 81;\n  -webkit-flex: 81;\n      -ms-flex: 81;\n          flex: 81; }\n\n.react-flex-v2--flex-82 {\n  -webkit-box-flex: 82;\n  -webkit-flex: 82;\n      -ms-flex: 82;\n          flex: 82; }\n\n.react-flex-v2--flex-83 {\n  -webkit-box-flex: 83;\n  -webkit-flex: 83;\n      -ms-flex: 83;\n          flex: 83; }\n\n.react-flex-v2--flex-84 {\n  -webkit-box-flex: 84;\n  -webkit-flex: 84;\n      -ms-flex: 84;\n          flex: 84; }\n\n.react-flex-v2--flex-85 {\n  -webkit-box-flex: 85;\n  -webkit-flex: 85;\n      -ms-flex: 85;\n          flex: 85; }\n\n.react-flex-v2--flex-86 {\n  -webkit-box-flex: 86;\n  -webkit-flex: 86;\n      -ms-flex: 86;\n          flex: 86; }\n\n.react-flex-v2--flex-87 {\n  -webkit-box-flex: 87;\n  -webkit-flex: 87;\n      -ms-flex: 87;\n          flex: 87; }\n\n.react-flex-v2--flex-88 {\n  -webkit-box-flex: 88;\n  -webkit-flex: 88;\n      -ms-flex: 88;\n          flex: 88; }\n\n.react-flex-v2--flex-89 {\n  -webkit-box-flex: 89;\n  -webkit-flex: 89;\n      -ms-flex: 89;\n          flex: 89; }\n\n.react-flex-v2--flex-90 {\n  -webkit-box-flex: 90;\n  -webkit-flex: 90;\n      -ms-flex: 90;\n          flex: 90; }\n\n.react-flex-v2--flex-91 {\n  -webkit-box-flex: 91;\n  -webkit-flex: 91;\n      -ms-flex: 91;\n          flex: 91; }\n\n.react-flex-v2--flex-92 {\n  -webkit-box-flex: 92;\n  -webkit-flex: 92;\n      -ms-flex: 92;\n          flex: 92; }\n\n.react-flex-v2--flex-93 {\n  -webkit-box-flex: 93;\n  -webkit-flex: 93;\n      -ms-flex: 93;\n          flex: 93; }\n\n.react-flex-v2--flex-94 {\n  -webkit-box-flex: 94;\n  -webkit-flex: 94;\n      -ms-flex: 94;\n          flex: 94; }\n\n.react-flex-v2--flex-95 {\n  -webkit-box-flex: 95;\n  -webkit-flex: 95;\n      -ms-flex: 95;\n          flex: 95; }\n\n.react-flex-v2--flex-96 {\n  -webkit-box-flex: 96;\n  -webkit-flex: 96;\n      -ms-flex: 96;\n          flex: 96; }\n\n.react-flex-v2--flex-97 {\n  -webkit-box-flex: 97;\n  -webkit-flex: 97;\n      -ms-flex: 97;\n          flex: 97; }\n\n.react-flex-v2--flex-98 {\n  -webkit-box-flex: 98;\n  -webkit-flex: 98;\n      -ms-flex: 98;\n          flex: 98; }\n\n.react-flex-v2--flex-99 {\n  -webkit-box-flex: 99;\n  -webkit-flex: 99;\n      -ms-flex: 99;\n          flex: 99; }\n\n.react-flex-v2--flex-100 {\n  -webkit-box-flex: 100;\n  -webkit-flex: 100;\n      -ms-flex: 100;\n          flex: 100; }\n\n/* FLEX-GROW */\n.react-flex-v2--flex-grow-0 {\n  -webkit-box-flex: 0;\n  -webkit-flex-grow: 0;\n      -ms-flex-positive: 0;\n          flex-grow: 0; }\n\n.react-flex-v2--flex-grow-1 {\n  -webkit-box-flex: 1;\n  -webkit-flex-grow: 1;\n      -ms-flex-positive: 1;\n          flex-grow: 1; }\n\n.react-flex-v2--flex-grow-2 {\n  -webkit-box-flex: 2;\n  -webkit-flex-grow: 2;\n      -ms-flex-positive: 2;\n          flex-grow: 2; }\n\n.react-flex-v2--flex-grow-3 {\n  -webkit-box-flex: 3;\n  -webkit-flex-grow: 3;\n      -ms-flex-positive: 3;\n          flex-grow: 3; }\n\n.react-flex-v2--flex-grow-4 {\n  -webkit-box-flex: 4;\n  -webkit-flex-grow: 4;\n      -ms-flex-positive: 4;\n          flex-grow: 4; }\n\n.react-flex-v2--flex-grow-5 {\n  -webkit-box-flex: 5;\n  -webkit-flex-grow: 5;\n      -ms-flex-positive: 5;\n          flex-grow: 5; }\n\n.react-flex-v2--flex-grow-6 {\n  -webkit-box-flex: 6;\n  -webkit-flex-grow: 6;\n      -ms-flex-positive: 6;\n          flex-grow: 6; }\n\n.react-flex-v2--flex-grow-7 {\n  -webkit-box-flex: 7;\n  -webkit-flex-grow: 7;\n      -ms-flex-positive: 7;\n          flex-grow: 7; }\n\n.react-flex-v2--flex-grow-8 {\n  -webkit-box-flex: 8;\n  -webkit-flex-grow: 8;\n      -ms-flex-positive: 8;\n          flex-grow: 8; }\n\n.react-flex-v2--flex-grow-9 {\n  -webkit-box-flex: 9;\n  -webkit-flex-grow: 9;\n      -ms-flex-positive: 9;\n          flex-grow: 9; }\n\n.react-flex-v2--flex-grow-10 {\n  -webkit-box-flex: 10;\n  -webkit-flex-grow: 10;\n      -ms-flex-positive: 10;\n          flex-grow: 10; }\n\n.react-flex-v2--flex-grow-11 {\n  -webkit-box-flex: 11;\n  -webkit-flex-grow: 11;\n      -ms-flex-positive: 11;\n          flex-grow: 11; }\n\n.react-flex-v2--flex-grow-12 {\n  -webkit-box-flex: 12;\n  -webkit-flex-grow: 12;\n      -ms-flex-positive: 12;\n          flex-grow: 12; }\n\n.react-flex-v2--flex-grow-13 {\n  -webkit-box-flex: 13;\n  -webkit-flex-grow: 13;\n      -ms-flex-positive: 13;\n          flex-grow: 13; }\n\n.react-flex-v2--flex-grow-14 {\n  -webkit-box-flex: 14;\n  -webkit-flex-grow: 14;\n      -ms-flex-positive: 14;\n          flex-grow: 14; }\n\n.react-flex-v2--flex-grow-15 {\n  -webkit-box-flex: 15;\n  -webkit-flex-grow: 15;\n      -ms-flex-positive: 15;\n          flex-grow: 15; }\n\n.react-flex-v2--flex-grow-16 {\n  -webkit-box-flex: 16;\n  -webkit-flex-grow: 16;\n      -ms-flex-positive: 16;\n          flex-grow: 16; }\n\n.react-flex-v2--flex-grow-17 {\n  -webkit-box-flex: 17;\n  -webkit-flex-grow: 17;\n      -ms-flex-positive: 17;\n          flex-grow: 17; }\n\n.react-flex-v2--flex-grow-18 {\n  -webkit-box-flex: 18;\n  -webkit-flex-grow: 18;\n      -ms-flex-positive: 18;\n          flex-grow: 18; }\n\n.react-flex-v2--flex-grow-19 {\n  -webkit-box-flex: 19;\n  -webkit-flex-grow: 19;\n      -ms-flex-positive: 19;\n          flex-grow: 19; }\n\n.react-flex-v2--flex-grow-20 {\n  -webkit-box-flex: 20;\n  -webkit-flex-grow: 20;\n      -ms-flex-positive: 20;\n          flex-grow: 20; }\n\n.react-flex-v2--flex-grow-21 {\n  -webkit-box-flex: 21;\n  -webkit-flex-grow: 21;\n      -ms-flex-positive: 21;\n          flex-grow: 21; }\n\n.react-flex-v2--flex-grow-22 {\n  -webkit-box-flex: 22;\n  -webkit-flex-grow: 22;\n      -ms-flex-positive: 22;\n          flex-grow: 22; }\n\n.react-flex-v2--flex-grow-23 {\n  -webkit-box-flex: 23;\n  -webkit-flex-grow: 23;\n      -ms-flex-positive: 23;\n          flex-grow: 23; }\n\n.react-flex-v2--flex-grow-24 {\n  -webkit-box-flex: 24;\n  -webkit-flex-grow: 24;\n      -ms-flex-positive: 24;\n          flex-grow: 24; }\n\n.react-flex-v2--flex-grow-25 {\n  -webkit-box-flex: 25;\n  -webkit-flex-grow: 25;\n      -ms-flex-positive: 25;\n          flex-grow: 25; }\n\n.react-flex-v2--flex-grow-26 {\n  -webkit-box-flex: 26;\n  -webkit-flex-grow: 26;\n      -ms-flex-positive: 26;\n          flex-grow: 26; }\n\n.react-flex-v2--flex-grow-27 {\n  -webkit-box-flex: 27;\n  -webkit-flex-grow: 27;\n      -ms-flex-positive: 27;\n          flex-grow: 27; }\n\n.react-flex-v2--flex-grow-28 {\n  -webkit-box-flex: 28;\n  -webkit-flex-grow: 28;\n      -ms-flex-positive: 28;\n          flex-grow: 28; }\n\n.react-flex-v2--flex-grow-29 {\n  -webkit-box-flex: 29;\n  -webkit-flex-grow: 29;\n      -ms-flex-positive: 29;\n          flex-grow: 29; }\n\n.react-flex-v2--flex-grow-30 {\n  -webkit-box-flex: 30;\n  -webkit-flex-grow: 30;\n      -ms-flex-positive: 30;\n          flex-grow: 30; }\n\n.react-flex-v2--flex-grow-31 {\n  -webkit-box-flex: 31;\n  -webkit-flex-grow: 31;\n      -ms-flex-positive: 31;\n          flex-grow: 31; }\n\n.react-flex-v2--flex-grow-32 {\n  -webkit-box-flex: 32;\n  -webkit-flex-grow: 32;\n      -ms-flex-positive: 32;\n          flex-grow: 32; }\n\n.react-flex-v2--flex-grow-33 {\n  -webkit-box-flex: 33;\n  -webkit-flex-grow: 33;\n      -ms-flex-positive: 33;\n          flex-grow: 33; }\n\n.react-flex-v2--flex-grow-34 {\n  -webkit-box-flex: 34;\n  -webkit-flex-grow: 34;\n      -ms-flex-positive: 34;\n          flex-grow: 34; }\n\n.react-flex-v2--flex-grow-35 {\n  -webkit-box-flex: 35;\n  -webkit-flex-grow: 35;\n      -ms-flex-positive: 35;\n          flex-grow: 35; }\n\n.react-flex-v2--flex-grow-36 {\n  -webkit-box-flex: 36;\n  -webkit-flex-grow: 36;\n      -ms-flex-positive: 36;\n          flex-grow: 36; }\n\n.react-flex-v2--flex-grow-37 {\n  -webkit-box-flex: 37;\n  -webkit-flex-grow: 37;\n      -ms-flex-positive: 37;\n          flex-grow: 37; }\n\n.react-flex-v2--flex-grow-38 {\n  -webkit-box-flex: 38;\n  -webkit-flex-grow: 38;\n      -ms-flex-positive: 38;\n          flex-grow: 38; }\n\n.react-flex-v2--flex-grow-39 {\n  -webkit-box-flex: 39;\n  -webkit-flex-grow: 39;\n      -ms-flex-positive: 39;\n          flex-grow: 39; }\n\n.react-flex-v2--flex-grow-40 {\n  -webkit-box-flex: 40;\n  -webkit-flex-grow: 40;\n      -ms-flex-positive: 40;\n          flex-grow: 40; }\n\n.react-flex-v2--flex-grow-41 {\n  -webkit-box-flex: 41;\n  -webkit-flex-grow: 41;\n      -ms-flex-positive: 41;\n          flex-grow: 41; }\n\n.react-flex-v2--flex-grow-42 {\n  -webkit-box-flex: 42;\n  -webkit-flex-grow: 42;\n      -ms-flex-positive: 42;\n          flex-grow: 42; }\n\n.react-flex-v2--flex-grow-43 {\n  -webkit-box-flex: 43;\n  -webkit-flex-grow: 43;\n      -ms-flex-positive: 43;\n          flex-grow: 43; }\n\n.react-flex-v2--flex-grow-44 {\n  -webkit-box-flex: 44;\n  -webkit-flex-grow: 44;\n      -ms-flex-positive: 44;\n          flex-grow: 44; }\n\n.react-flex-v2--flex-grow-45 {\n  -webkit-box-flex: 45;\n  -webkit-flex-grow: 45;\n      -ms-flex-positive: 45;\n          flex-grow: 45; }\n\n.react-flex-v2--flex-grow-46 {\n  -webkit-box-flex: 46;\n  -webkit-flex-grow: 46;\n      -ms-flex-positive: 46;\n          flex-grow: 46; }\n\n.react-flex-v2--flex-grow-47 {\n  -webkit-box-flex: 47;\n  -webkit-flex-grow: 47;\n      -ms-flex-positive: 47;\n          flex-grow: 47; }\n\n.react-flex-v2--flex-grow-48 {\n  -webkit-box-flex: 48;\n  -webkit-flex-grow: 48;\n      -ms-flex-positive: 48;\n          flex-grow: 48; }\n\n.react-flex-v2--flex-grow-49 {\n  -webkit-box-flex: 49;\n  -webkit-flex-grow: 49;\n      -ms-flex-positive: 49;\n          flex-grow: 49; }\n\n.react-flex-v2--flex-grow-50 {\n  -webkit-box-flex: 50;\n  -webkit-flex-grow: 50;\n      -ms-flex-positive: 50;\n          flex-grow: 50; }\n\n.react-flex-v2--flex-grow-51 {\n  -webkit-box-flex: 51;\n  -webkit-flex-grow: 51;\n      -ms-flex-positive: 51;\n          flex-grow: 51; }\n\n.react-flex-v2--flex-grow-52 {\n  -webkit-box-flex: 52;\n  -webkit-flex-grow: 52;\n      -ms-flex-positive: 52;\n          flex-grow: 52; }\n\n.react-flex-v2--flex-grow-53 {\n  -webkit-box-flex: 53;\n  -webkit-flex-grow: 53;\n      -ms-flex-positive: 53;\n          flex-grow: 53; }\n\n.react-flex-v2--flex-grow-54 {\n  -webkit-box-flex: 54;\n  -webkit-flex-grow: 54;\n      -ms-flex-positive: 54;\n          flex-grow: 54; }\n\n.react-flex-v2--flex-grow-55 {\n  -webkit-box-flex: 55;\n  -webkit-flex-grow: 55;\n      -ms-flex-positive: 55;\n          flex-grow: 55; }\n\n.react-flex-v2--flex-grow-56 {\n  -webkit-box-flex: 56;\n  -webkit-flex-grow: 56;\n      -ms-flex-positive: 56;\n          flex-grow: 56; }\n\n.react-flex-v2--flex-grow-57 {\n  -webkit-box-flex: 57;\n  -webkit-flex-grow: 57;\n      -ms-flex-positive: 57;\n          flex-grow: 57; }\n\n.react-flex-v2--flex-grow-58 {\n  -webkit-box-flex: 58;\n  -webkit-flex-grow: 58;\n      -ms-flex-positive: 58;\n          flex-grow: 58; }\n\n.react-flex-v2--flex-grow-59 {\n  -webkit-box-flex: 59;\n  -webkit-flex-grow: 59;\n      -ms-flex-positive: 59;\n          flex-grow: 59; }\n\n.react-flex-v2--flex-grow-60 {\n  -webkit-box-flex: 60;\n  -webkit-flex-grow: 60;\n      -ms-flex-positive: 60;\n          flex-grow: 60; }\n\n.react-flex-v2--flex-grow-61 {\n  -webkit-box-flex: 61;\n  -webkit-flex-grow: 61;\n      -ms-flex-positive: 61;\n          flex-grow: 61; }\n\n.react-flex-v2--flex-grow-62 {\n  -webkit-box-flex: 62;\n  -webkit-flex-grow: 62;\n      -ms-flex-positive: 62;\n          flex-grow: 62; }\n\n.react-flex-v2--flex-grow-63 {\n  -webkit-box-flex: 63;\n  -webkit-flex-grow: 63;\n      -ms-flex-positive: 63;\n          flex-grow: 63; }\n\n.react-flex-v2--flex-grow-64 {\n  -webkit-box-flex: 64;\n  -webkit-flex-grow: 64;\n      -ms-flex-positive: 64;\n          flex-grow: 64; }\n\n.react-flex-v2--flex-grow-65 {\n  -webkit-box-flex: 65;\n  -webkit-flex-grow: 65;\n      -ms-flex-positive: 65;\n          flex-grow: 65; }\n\n.react-flex-v2--flex-grow-66 {\n  -webkit-box-flex: 66;\n  -webkit-flex-grow: 66;\n      -ms-flex-positive: 66;\n          flex-grow: 66; }\n\n.react-flex-v2--flex-grow-67 {\n  -webkit-box-flex: 67;\n  -webkit-flex-grow: 67;\n      -ms-flex-positive: 67;\n          flex-grow: 67; }\n\n.react-flex-v2--flex-grow-68 {\n  -webkit-box-flex: 68;\n  -webkit-flex-grow: 68;\n      -ms-flex-positive: 68;\n          flex-grow: 68; }\n\n.react-flex-v2--flex-grow-69 {\n  -webkit-box-flex: 69;\n  -webkit-flex-grow: 69;\n      -ms-flex-positive: 69;\n          flex-grow: 69; }\n\n.react-flex-v2--flex-grow-70 {\n  -webkit-box-flex: 70;\n  -webkit-flex-grow: 70;\n      -ms-flex-positive: 70;\n          flex-grow: 70; }\n\n.react-flex-v2--flex-grow-71 {\n  -webkit-box-flex: 71;\n  -webkit-flex-grow: 71;\n      -ms-flex-positive: 71;\n          flex-grow: 71; }\n\n.react-flex-v2--flex-grow-72 {\n  -webkit-box-flex: 72;\n  -webkit-flex-grow: 72;\n      -ms-flex-positive: 72;\n          flex-grow: 72; }\n\n.react-flex-v2--flex-grow-73 {\n  -webkit-box-flex: 73;\n  -webkit-flex-grow: 73;\n      -ms-flex-positive: 73;\n          flex-grow: 73; }\n\n.react-flex-v2--flex-grow-74 {\n  -webkit-box-flex: 74;\n  -webkit-flex-grow: 74;\n      -ms-flex-positive: 74;\n          flex-grow: 74; }\n\n.react-flex-v2--flex-grow-75 {\n  -webkit-box-flex: 75;\n  -webkit-flex-grow: 75;\n      -ms-flex-positive: 75;\n          flex-grow: 75; }\n\n.react-flex-v2--flex-grow-76 {\n  -webkit-box-flex: 76;\n  -webkit-flex-grow: 76;\n      -ms-flex-positive: 76;\n          flex-grow: 76; }\n\n.react-flex-v2--flex-grow-77 {\n  -webkit-box-flex: 77;\n  -webkit-flex-grow: 77;\n      -ms-flex-positive: 77;\n          flex-grow: 77; }\n\n.react-flex-v2--flex-grow-78 {\n  -webkit-box-flex: 78;\n  -webkit-flex-grow: 78;\n      -ms-flex-positive: 78;\n          flex-grow: 78; }\n\n.react-flex-v2--flex-grow-79 {\n  -webkit-box-flex: 79;\n  -webkit-flex-grow: 79;\n      -ms-flex-positive: 79;\n          flex-grow: 79; }\n\n.react-flex-v2--flex-grow-80 {\n  -webkit-box-flex: 80;\n  -webkit-flex-grow: 80;\n      -ms-flex-positive: 80;\n          flex-grow: 80; }\n\n.react-flex-v2--flex-grow-81 {\n  -webkit-box-flex: 81;\n  -webkit-flex-grow: 81;\n      -ms-flex-positive: 81;\n          flex-grow: 81; }\n\n.react-flex-v2--flex-grow-82 {\n  -webkit-box-flex: 82;\n  -webkit-flex-grow: 82;\n      -ms-flex-positive: 82;\n          flex-grow: 82; }\n\n.react-flex-v2--flex-grow-83 {\n  -webkit-box-flex: 83;\n  -webkit-flex-grow: 83;\n      -ms-flex-positive: 83;\n          flex-grow: 83; }\n\n.react-flex-v2--flex-grow-84 {\n  -webkit-box-flex: 84;\n  -webkit-flex-grow: 84;\n      -ms-flex-positive: 84;\n          flex-grow: 84; }\n\n.react-flex-v2--flex-grow-85 {\n  -webkit-box-flex: 85;\n  -webkit-flex-grow: 85;\n      -ms-flex-positive: 85;\n          flex-grow: 85; }\n\n.react-flex-v2--flex-grow-86 {\n  -webkit-box-flex: 86;\n  -webkit-flex-grow: 86;\n      -ms-flex-positive: 86;\n          flex-grow: 86; }\n\n.react-flex-v2--flex-grow-87 {\n  -webkit-box-flex: 87;\n  -webkit-flex-grow: 87;\n      -ms-flex-positive: 87;\n          flex-grow: 87; }\n\n.react-flex-v2--flex-grow-88 {\n  -webkit-box-flex: 88;\n  -webkit-flex-grow: 88;\n      -ms-flex-positive: 88;\n          flex-grow: 88; }\n\n.react-flex-v2--flex-grow-89 {\n  -webkit-box-flex: 89;\n  -webkit-flex-grow: 89;\n      -ms-flex-positive: 89;\n          flex-grow: 89; }\n\n.react-flex-v2--flex-grow-90 {\n  -webkit-box-flex: 90;\n  -webkit-flex-grow: 90;\n      -ms-flex-positive: 90;\n          flex-grow: 90; }\n\n.react-flex-v2--flex-grow-91 {\n  -webkit-box-flex: 91;\n  -webkit-flex-grow: 91;\n      -ms-flex-positive: 91;\n          flex-grow: 91; }\n\n.react-flex-v2--flex-grow-92 {\n  -webkit-box-flex: 92;\n  -webkit-flex-grow: 92;\n      -ms-flex-positive: 92;\n          flex-grow: 92; }\n\n.react-flex-v2--flex-grow-93 {\n  -webkit-box-flex: 93;\n  -webkit-flex-grow: 93;\n      -ms-flex-positive: 93;\n          flex-grow: 93; }\n\n.react-flex-v2--flex-grow-94 {\n  -webkit-box-flex: 94;\n  -webkit-flex-grow: 94;\n      -ms-flex-positive: 94;\n          flex-grow: 94; }\n\n.react-flex-v2--flex-grow-95 {\n  -webkit-box-flex: 95;\n  -webkit-flex-grow: 95;\n      -ms-flex-positive: 95;\n          flex-grow: 95; }\n\n.react-flex-v2--flex-grow-96 {\n  -webkit-box-flex: 96;\n  -webkit-flex-grow: 96;\n      -ms-flex-positive: 96;\n          flex-grow: 96; }\n\n.react-flex-v2--flex-grow-97 {\n  -webkit-box-flex: 97;\n  -webkit-flex-grow: 97;\n      -ms-flex-positive: 97;\n          flex-grow: 97; }\n\n.react-flex-v2--flex-grow-98 {\n  -webkit-box-flex: 98;\n  -webkit-flex-grow: 98;\n      -ms-flex-positive: 98;\n          flex-grow: 98; }\n\n.react-flex-v2--flex-grow-99 {\n  -webkit-box-flex: 99;\n  -webkit-flex-grow: 99;\n      -ms-flex-positive: 99;\n          flex-grow: 99; }\n\n.react-flex-v2--flex-grow-100 {\n  -webkit-box-flex: 100;\n  -webkit-flex-grow: 100;\n      -ms-flex-positive: 100;\n          flex-grow: 100; }\n\n/* FLEX-SHRINK */\n.react-flex-v2--flex-shrink-0 {\n  -webkit-flex-shrink: 0;\n      -ms-flex-negative: 0;\n          flex-shrink: 0; }\n\n.react-flex-v2--flex-shrink-1 {\n  -webkit-flex-shrink: 1;\n      -ms-flex-negative: 1;\n          flex-shrink: 1; }\n\n.react-flex-v2--flex-shrink-2 {\n  -webkit-flex-shrink: 2;\n      -ms-flex-negative: 2;\n          flex-shrink: 2; }\n\n.react-flex-v2--flex-shrink-3 {\n  -webkit-flex-shrink: 3;\n      -ms-flex-negative: 3;\n          flex-shrink: 3; }\n\n.react-flex-v2--flex-shrink-4 {\n  -webkit-flex-shrink: 4;\n      -ms-flex-negative: 4;\n          flex-shrink: 4; }\n\n.react-flex-v2--flex-shrink-5 {\n  -webkit-flex-shrink: 5;\n      -ms-flex-negative: 5;\n          flex-shrink: 5; }\n\n.react-flex-v2--flex-shrink-6 {\n  -webkit-flex-shrink: 6;\n      -ms-flex-negative: 6;\n          flex-shrink: 6; }\n\n.react-flex-v2--flex-shrink-7 {\n  -webkit-flex-shrink: 7;\n      -ms-flex-negative: 7;\n          flex-shrink: 7; }\n\n.react-flex-v2--flex-shrink-8 {\n  -webkit-flex-shrink: 8;\n      -ms-flex-negative: 8;\n          flex-shrink: 8; }\n\n.react-flex-v2--flex-shrink-9 {\n  -webkit-flex-shrink: 9;\n      -ms-flex-negative: 9;\n          flex-shrink: 9; }\n\n.react-flex-v2--flex-shrink-10 {\n  -webkit-flex-shrink: 10;\n      -ms-flex-negative: 10;\n          flex-shrink: 10; }\n\n.react-flex-v2--flex-shrink-11 {\n  -webkit-flex-shrink: 11;\n      -ms-flex-negative: 11;\n          flex-shrink: 11; }\n\n.react-flex-v2--flex-shrink-12 {\n  -webkit-flex-shrink: 12;\n      -ms-flex-negative: 12;\n          flex-shrink: 12; }\n\n.react-flex-v2--flex-shrink-13 {\n  -webkit-flex-shrink: 13;\n      -ms-flex-negative: 13;\n          flex-shrink: 13; }\n\n.react-flex-v2--flex-shrink-14 {\n  -webkit-flex-shrink: 14;\n      -ms-flex-negative: 14;\n          flex-shrink: 14; }\n\n.react-flex-v2--flex-shrink-15 {\n  -webkit-flex-shrink: 15;\n      -ms-flex-negative: 15;\n          flex-shrink: 15; }\n\n.react-flex-v2--flex-shrink-16 {\n  -webkit-flex-shrink: 16;\n      -ms-flex-negative: 16;\n          flex-shrink: 16; }\n\n.react-flex-v2--flex-shrink-17 {\n  -webkit-flex-shrink: 17;\n      -ms-flex-negative: 17;\n          flex-shrink: 17; }\n\n.react-flex-v2--flex-shrink-18 {\n  -webkit-flex-shrink: 18;\n      -ms-flex-negative: 18;\n          flex-shrink: 18; }\n\n.react-flex-v2--flex-shrink-19 {\n  -webkit-flex-shrink: 19;\n      -ms-flex-negative: 19;\n          flex-shrink: 19; }\n\n.react-flex-v2--flex-shrink-20 {\n  -webkit-flex-shrink: 20;\n      -ms-flex-negative: 20;\n          flex-shrink: 20; }\n\n.react-flex-v2--flex-shrink-21 {\n  -webkit-flex-shrink: 21;\n      -ms-flex-negative: 21;\n          flex-shrink: 21; }\n\n.react-flex-v2--flex-shrink-22 {\n  -webkit-flex-shrink: 22;\n      -ms-flex-negative: 22;\n          flex-shrink: 22; }\n\n.react-flex-v2--flex-shrink-23 {\n  -webkit-flex-shrink: 23;\n      -ms-flex-negative: 23;\n          flex-shrink: 23; }\n\n.react-flex-v2--flex-shrink-24 {\n  -webkit-flex-shrink: 24;\n      -ms-flex-negative: 24;\n          flex-shrink: 24; }\n\n.react-flex-v2--flex-shrink-25 {\n  -webkit-flex-shrink: 25;\n      -ms-flex-negative: 25;\n          flex-shrink: 25; }\n\n.react-flex-v2--flex-shrink-26 {\n  -webkit-flex-shrink: 26;\n      -ms-flex-negative: 26;\n          flex-shrink: 26; }\n\n.react-flex-v2--flex-shrink-27 {\n  -webkit-flex-shrink: 27;\n      -ms-flex-negative: 27;\n          flex-shrink: 27; }\n\n.react-flex-v2--flex-shrink-28 {\n  -webkit-flex-shrink: 28;\n      -ms-flex-negative: 28;\n          flex-shrink: 28; }\n\n.react-flex-v2--flex-shrink-29 {\n  -webkit-flex-shrink: 29;\n      -ms-flex-negative: 29;\n          flex-shrink: 29; }\n\n.react-flex-v2--flex-shrink-30 {\n  -webkit-flex-shrink: 30;\n      -ms-flex-negative: 30;\n          flex-shrink: 30; }\n\n.react-flex-v2--flex-shrink-31 {\n  -webkit-flex-shrink: 31;\n      -ms-flex-negative: 31;\n          flex-shrink: 31; }\n\n.react-flex-v2--flex-shrink-32 {\n  -webkit-flex-shrink: 32;\n      -ms-flex-negative: 32;\n          flex-shrink: 32; }\n\n.react-flex-v2--flex-shrink-33 {\n  -webkit-flex-shrink: 33;\n      -ms-flex-negative: 33;\n          flex-shrink: 33; }\n\n.react-flex-v2--flex-shrink-34 {\n  -webkit-flex-shrink: 34;\n      -ms-flex-negative: 34;\n          flex-shrink: 34; }\n\n.react-flex-v2--flex-shrink-35 {\n  -webkit-flex-shrink: 35;\n      -ms-flex-negative: 35;\n          flex-shrink: 35; }\n\n.react-flex-v2--flex-shrink-36 {\n  -webkit-flex-shrink: 36;\n      -ms-flex-negative: 36;\n          flex-shrink: 36; }\n\n.react-flex-v2--flex-shrink-37 {\n  -webkit-flex-shrink: 37;\n      -ms-flex-negative: 37;\n          flex-shrink: 37; }\n\n.react-flex-v2--flex-shrink-38 {\n  -webkit-flex-shrink: 38;\n      -ms-flex-negative: 38;\n          flex-shrink: 38; }\n\n.react-flex-v2--flex-shrink-39 {\n  -webkit-flex-shrink: 39;\n      -ms-flex-negative: 39;\n          flex-shrink: 39; }\n\n.react-flex-v2--flex-shrink-40 {\n  -webkit-flex-shrink: 40;\n      -ms-flex-negative: 40;\n          flex-shrink: 40; }\n\n.react-flex-v2--flex-shrink-41 {\n  -webkit-flex-shrink: 41;\n      -ms-flex-negative: 41;\n          flex-shrink: 41; }\n\n.react-flex-v2--flex-shrink-42 {\n  -webkit-flex-shrink: 42;\n      -ms-flex-negative: 42;\n          flex-shrink: 42; }\n\n.react-flex-v2--flex-shrink-43 {\n  -webkit-flex-shrink: 43;\n      -ms-flex-negative: 43;\n          flex-shrink: 43; }\n\n.react-flex-v2--flex-shrink-44 {\n  -webkit-flex-shrink: 44;\n      -ms-flex-negative: 44;\n          flex-shrink: 44; }\n\n.react-flex-v2--flex-shrink-45 {\n  -webkit-flex-shrink: 45;\n      -ms-flex-negative: 45;\n          flex-shrink: 45; }\n\n.react-flex-v2--flex-shrink-46 {\n  -webkit-flex-shrink: 46;\n      -ms-flex-negative: 46;\n          flex-shrink: 46; }\n\n.react-flex-v2--flex-shrink-47 {\n  -webkit-flex-shrink: 47;\n      -ms-flex-negative: 47;\n          flex-shrink: 47; }\n\n.react-flex-v2--flex-shrink-48 {\n  -webkit-flex-shrink: 48;\n      -ms-flex-negative: 48;\n          flex-shrink: 48; }\n\n.react-flex-v2--flex-shrink-49 {\n  -webkit-flex-shrink: 49;\n      -ms-flex-negative: 49;\n          flex-shrink: 49; }\n\n.react-flex-v2--flex-shrink-50 {\n  -webkit-flex-shrink: 50;\n      -ms-flex-negative: 50;\n          flex-shrink: 50; }\n\n.react-flex-v2--flex-shrink-51 {\n  -webkit-flex-shrink: 51;\n      -ms-flex-negative: 51;\n          flex-shrink: 51; }\n\n.react-flex-v2--flex-shrink-52 {\n  -webkit-flex-shrink: 52;\n      -ms-flex-negative: 52;\n          flex-shrink: 52; }\n\n.react-flex-v2--flex-shrink-53 {\n  -webkit-flex-shrink: 53;\n      -ms-flex-negative: 53;\n          flex-shrink: 53; }\n\n.react-flex-v2--flex-shrink-54 {\n  -webkit-flex-shrink: 54;\n      -ms-flex-negative: 54;\n          flex-shrink: 54; }\n\n.react-flex-v2--flex-shrink-55 {\n  -webkit-flex-shrink: 55;\n      -ms-flex-negative: 55;\n          flex-shrink: 55; }\n\n.react-flex-v2--flex-shrink-56 {\n  -webkit-flex-shrink: 56;\n      -ms-flex-negative: 56;\n          flex-shrink: 56; }\n\n.react-flex-v2--flex-shrink-57 {\n  -webkit-flex-shrink: 57;\n      -ms-flex-negative: 57;\n          flex-shrink: 57; }\n\n.react-flex-v2--flex-shrink-58 {\n  -webkit-flex-shrink: 58;\n      -ms-flex-negative: 58;\n          flex-shrink: 58; }\n\n.react-flex-v2--flex-shrink-59 {\n  -webkit-flex-shrink: 59;\n      -ms-flex-negative: 59;\n          flex-shrink: 59; }\n\n.react-flex-v2--flex-shrink-60 {\n  -webkit-flex-shrink: 60;\n      -ms-flex-negative: 60;\n          flex-shrink: 60; }\n\n.react-flex-v2--flex-shrink-61 {\n  -webkit-flex-shrink: 61;\n      -ms-flex-negative: 61;\n          flex-shrink: 61; }\n\n.react-flex-v2--flex-shrink-62 {\n  -webkit-flex-shrink: 62;\n      -ms-flex-negative: 62;\n          flex-shrink: 62; }\n\n.react-flex-v2--flex-shrink-63 {\n  -webkit-flex-shrink: 63;\n      -ms-flex-negative: 63;\n          flex-shrink: 63; }\n\n.react-flex-v2--flex-shrink-64 {\n  -webkit-flex-shrink: 64;\n      -ms-flex-negative: 64;\n          flex-shrink: 64; }\n\n.react-flex-v2--flex-shrink-65 {\n  -webkit-flex-shrink: 65;\n      -ms-flex-negative: 65;\n          flex-shrink: 65; }\n\n.react-flex-v2--flex-shrink-66 {\n  -webkit-flex-shrink: 66;\n      -ms-flex-negative: 66;\n          flex-shrink: 66; }\n\n.react-flex-v2--flex-shrink-67 {\n  -webkit-flex-shrink: 67;\n      -ms-flex-negative: 67;\n          flex-shrink: 67; }\n\n.react-flex-v2--flex-shrink-68 {\n  -webkit-flex-shrink: 68;\n      -ms-flex-negative: 68;\n          flex-shrink: 68; }\n\n.react-flex-v2--flex-shrink-69 {\n  -webkit-flex-shrink: 69;\n      -ms-flex-negative: 69;\n          flex-shrink: 69; }\n\n.react-flex-v2--flex-shrink-70 {\n  -webkit-flex-shrink: 70;\n      -ms-flex-negative: 70;\n          flex-shrink: 70; }\n\n.react-flex-v2--flex-shrink-71 {\n  -webkit-flex-shrink: 71;\n      -ms-flex-negative: 71;\n          flex-shrink: 71; }\n\n.react-flex-v2--flex-shrink-72 {\n  -webkit-flex-shrink: 72;\n      -ms-flex-negative: 72;\n          flex-shrink: 72; }\n\n.react-flex-v2--flex-shrink-73 {\n  -webkit-flex-shrink: 73;\n      -ms-flex-negative: 73;\n          flex-shrink: 73; }\n\n.react-flex-v2--flex-shrink-74 {\n  -webkit-flex-shrink: 74;\n      -ms-flex-negative: 74;\n          flex-shrink: 74; }\n\n.react-flex-v2--flex-shrink-75 {\n  -webkit-flex-shrink: 75;\n      -ms-flex-negative: 75;\n          flex-shrink: 75; }\n\n.react-flex-v2--flex-shrink-76 {\n  -webkit-flex-shrink: 76;\n      -ms-flex-negative: 76;\n          flex-shrink: 76; }\n\n.react-flex-v2--flex-shrink-77 {\n  -webkit-flex-shrink: 77;\n      -ms-flex-negative: 77;\n          flex-shrink: 77; }\n\n.react-flex-v2--flex-shrink-78 {\n  -webkit-flex-shrink: 78;\n      -ms-flex-negative: 78;\n          flex-shrink: 78; }\n\n.react-flex-v2--flex-shrink-79 {\n  -webkit-flex-shrink: 79;\n      -ms-flex-negative: 79;\n          flex-shrink: 79; }\n\n.react-flex-v2--flex-shrink-80 {\n  -webkit-flex-shrink: 80;\n      -ms-flex-negative: 80;\n          flex-shrink: 80; }\n\n.react-flex-v2--flex-shrink-81 {\n  -webkit-flex-shrink: 81;\n      -ms-flex-negative: 81;\n          flex-shrink: 81; }\n\n.react-flex-v2--flex-shrink-82 {\n  -webkit-flex-shrink: 82;\n      -ms-flex-negative: 82;\n          flex-shrink: 82; }\n\n.react-flex-v2--flex-shrink-83 {\n  -webkit-flex-shrink: 83;\n      -ms-flex-negative: 83;\n          flex-shrink: 83; }\n\n.react-flex-v2--flex-shrink-84 {\n  -webkit-flex-shrink: 84;\n      -ms-flex-negative: 84;\n          flex-shrink: 84; }\n\n.react-flex-v2--flex-shrink-85 {\n  -webkit-flex-shrink: 85;\n      -ms-flex-negative: 85;\n          flex-shrink: 85; }\n\n.react-flex-v2--flex-shrink-86 {\n  -webkit-flex-shrink: 86;\n      -ms-flex-negative: 86;\n          flex-shrink: 86; }\n\n.react-flex-v2--flex-shrink-87 {\n  -webkit-flex-shrink: 87;\n      -ms-flex-negative: 87;\n          flex-shrink: 87; }\n\n.react-flex-v2--flex-shrink-88 {\n  -webkit-flex-shrink: 88;\n      -ms-flex-negative: 88;\n          flex-shrink: 88; }\n\n.react-flex-v2--flex-shrink-89 {\n  -webkit-flex-shrink: 89;\n      -ms-flex-negative: 89;\n          flex-shrink: 89; }\n\n.react-flex-v2--flex-shrink-90 {\n  -webkit-flex-shrink: 90;\n      -ms-flex-negative: 90;\n          flex-shrink: 90; }\n\n.react-flex-v2--flex-shrink-91 {\n  -webkit-flex-shrink: 91;\n      -ms-flex-negative: 91;\n          flex-shrink: 91; }\n\n.react-flex-v2--flex-shrink-92 {\n  -webkit-flex-shrink: 92;\n      -ms-flex-negative: 92;\n          flex-shrink: 92; }\n\n.react-flex-v2--flex-shrink-93 {\n  -webkit-flex-shrink: 93;\n      -ms-flex-negative: 93;\n          flex-shrink: 93; }\n\n.react-flex-v2--flex-shrink-94 {\n  -webkit-flex-shrink: 94;\n      -ms-flex-negative: 94;\n          flex-shrink: 94; }\n\n.react-flex-v2--flex-shrink-95 {\n  -webkit-flex-shrink: 95;\n      -ms-flex-negative: 95;\n          flex-shrink: 95; }\n\n.react-flex-v2--flex-shrink-96 {\n  -webkit-flex-shrink: 96;\n      -ms-flex-negative: 96;\n          flex-shrink: 96; }\n\n.react-flex-v2--flex-shrink-97 {\n  -webkit-flex-shrink: 97;\n      -ms-flex-negative: 97;\n          flex-shrink: 97; }\n\n.react-flex-v2--flex-shrink-98 {\n  -webkit-flex-shrink: 98;\n      -ms-flex-negative: 98;\n          flex-shrink: 98; }\n\n.react-flex-v2--flex-shrink-99 {\n  -webkit-flex-shrink: 99;\n      -ms-flex-negative: 99;\n          flex-shrink: 99; }\n\n.react-flex-v2--flex-shrink-100 {\n  -webkit-flex-shrink: 100;\n      -ms-flex-negative: 100;\n          flex-shrink: 100; }\n\n.react-date-field--theme-default {\n  border: 1px solid gray; }\n  .react-date-field--theme-default.react-date-field--focused {\n    border: 1px solid #349aef; }\n  .react-date-field--theme-default > .react-date-field__picker {\n    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.34375);\n    border: 1px solid #349aef; }\n  .react-date-field--theme-default .react-date-field__calendar-icon {\n    border: 2px solid gray; }\n    .react-date-field--theme-default .react-date-field__calendar-icon:before, .react-date-field--theme-default .react-date-field__calendar-icon:after {\n      width: 2px;\n      height: 5px;\n      top: -5px; }\n    .react-date-field--theme-default .react-date-field__calendar-icon:before {\n      left: 2px; }\n    .react-date-field--theme-default .react-date-field__calendar-icon:after {\n      right: 1px;\n      left: auto; }\n  .react-date-field--theme-default .react-date-field__clear-icon {\n    color: gray;\n    fill: gray; }\n  .react-date-field--theme-default .react-date-field__clear-icon:hover {\n    color: #4d4d4d;\n    fill: #4d4d4d; }\n  .react-date-field--theme-default.react-date-field--focused .react-date-field__clear-icon {\n    color: #349aef;\n    fill: #349aef; }\n  .react-date-field--theme-default:not(.react-date-field--disabled) .react-date-field__calendar-icon:hover {\n    border-color: #4d4d4d;\n    cursor: pointer; }\n    .react-date-field--theme-default:not(.react-date-field--disabled) .react-date-field__calendar-icon:hover:after, .react-date-field--theme-default:not(.react-date-field--disabled) .react-date-field__calendar-icon:hover:before,\n    .react-date-field--theme-default:not(.react-date-field--disabled) .react-date-field__calendar-icon:hover .react-date-field__calendar-icon-inner {\n      background: #4d4d4d; }\n  .react-date-field--theme-default .react-date-field__calendar-icon:after,\n  .react-date-field--theme-default .react-date-field__calendar-icon:before {\n    background: gray; }\n  .react-date-field--theme-default .react-date-field__calendar-icon-inner {\n    background: gray; }\n  .react-date-field--theme-default.react-date-field--focused .react-date-field__calendar-icon,\n  .react-date-field--theme-default.react-date-field--focused .react-date-field__calendar-icon:hover,\n  .react-date-field--theme-default.react-date-field--focused .react-date-field__calendar-icon:active,\n  .react-date-field--theme-default:not(.react-date-field--disabled) .react-date-field__calendar-icon:active {\n    border-color: #349aef; }\n    .react-date-field--theme-default.react-date-field--focused .react-date-field__calendar-icon:after, .react-date-field--theme-default.react-date-field--focused .react-date-field__calendar-icon:before,\n    .react-date-field--theme-default.react-date-field--focused .react-date-field__calendar-icon .react-date-field__calendar-icon-inner,\n    .react-date-field--theme-default.react-date-field--focused .react-date-field__calendar-icon:hover:after,\n    .react-date-field--theme-default.react-date-field--focused .react-date-field__calendar-icon:hover:before,\n    .react-date-field--theme-default.react-date-field--focused .react-date-field__calendar-icon:hover .react-date-field__calendar-icon-inner,\n    .react-date-field--theme-default.react-date-field--focused .react-date-field__calendar-icon:active:after,\n    .react-date-field--theme-default.react-date-field--focused .react-date-field__calendar-icon:active:before,\n    .react-date-field--theme-default.react-date-field--focused .react-date-field__calendar-icon:active .react-date-field__calendar-icon-inner,\n    .react-date-field--theme-default:not(.react-date-field--disabled) .react-date-field__calendar-icon:active:after,\n    .react-date-field--theme-default:not(.react-date-field--disabled) .react-date-field__calendar-icon:active:before,\n    .react-date-field--theme-default:not(.react-date-field--disabled) .react-date-field__calendar-icon:active .react-date-field__calendar-icon-inner {\n      background: #349aef; }\n\n.react-date-picker__clock--theme-default .react-date-picker__clock-hand-second {\n  background: red; }\n\n.react-date-picker__clock--theme-default .react-date-picker__clock-center {\n  background: #e6e6e6; }\n\n.react-date-picker__clock--theme-default .react-date-picker__clock-overlay {\n  background: white;\n  border-style: solid;\n  border-color: gray; }\n\n.react-date-picker__footer--theme-default {\n  padding: 5px; }\n  .react-date-picker__footer--theme-default .react-date-picker__footer-button {\n    padding: 3px 4px;\n    outline: none;\n    position: relative;\n    -webkit-user-select: none;\n       -moz-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n    border: 1px solid gray;\n    background: white;\n    font-size: 0.9em; }\n    .react-date-picker__footer--theme-default .react-date-picker__footer-button:active {\n      top: 1px; }\n    .react-date-picker__footer--theme-default .react-date-picker__footer-button:not(.react-date-picker__footer-button--disabled) {\n      cursor: pointer; }\n      .react-date-picker__footer--theme-default .react-date-picker__footer-button:not(.react-date-picker__footer-button--disabled):hover {\n        background: #349aef;\n        border-color: #349aef;\n        color: white; }\n  .react-date-picker__footer--theme-default .react-date-picker__footer-button + .react-date-picker__footer-button {\n    margin-left: 3px; }\n\n.react-date-picker__date-format-spinner--theme-default {\n  border: 1px solid gray; }\n  .react-date-picker__date-format-spinner--theme-default input {\n    padding: 5px;\n    border: none;\n    outline: none; }\n  .react-date-picker__date-format-spinner--theme-default:not([disabled]).react-date-picker__date-format-spinner--focused {\n    border: 1px solid #349aef; }\n  .react-date-picker__date-format-spinner--theme-default:not([disabled]) .react-date-picker__date-format-spinner-arrow {\n    position: relative;\n    cursor: pointer; }\n    .react-date-picker__date-format-spinner--theme-default:not([disabled]) .react-date-picker__date-format-spinner-arrow:active {\n      fill: #349aef;\n      top: 1px; }\n\n.react-date-picker__year-view--theme-default {\n  border: 1px solid gray;\n  padding: 2px; }\n  .react-date-picker__year-view--theme-default .react-date-picker__year-view-month {\n    padding: 5px;\n    cursor: pointer;\n    border: 2px solid transparent; }\n    .react-date-picker__year-view--theme-default .react-date-picker__year-view-month--disabled {\n      color: #D8D8D8; }\n  .react-date-picker__year-view--theme-default .react-date-picker__year-view-month--active {\n    border: 2px solid #349aef; }\n  .react-date-picker__year-view--theme-default .react-date-picker__year-view-month--value {\n    color: white;\n    background: #349aef padding-box;\n    border: 2px solid #349aef; }\n  .react-date-picker__year-view--theme-default .react-date-picker__year-view-month--active.react-date-picker__year-view-month--value {\n    background: #4ca6f1 padding-box; }\n\n.react-date-picker__decade-view--theme-default {\n  border: 1px solid gray;\n  padding: 2px; }\n  .react-date-picker__decade-view--theme-default .react-date-picker__decade-view-arrow {\n    cursor: pointer;\n    position: relative;\n    fill: #676767;\n    -webkit-user-select: none;\n       -moz-user-select: none;\n        -ms-user-select: none;\n            user-select: none; }\n    .react-date-picker__decade-view--theme-default .react-date-picker__decade-view-arrow--disabled {\n      fill: #C5C5C5; }\n    .react-date-picker__decade-view--theme-default .react-date-picker__decade-view-arrow:not(.react-date-picker__decade-view-arrow--disabled):active {\n      left: 1px; }\n  .react-date-picker__decade-view--theme-default .react-date-picker__decade-view-year {\n    padding: 5px;\n    cursor: pointer;\n    border: 2px solid transparent; }\n    .react-date-picker__decade-view--theme-default .react-date-picker__decade-view-year--disabled {\n      color: #D8D8D8; }\n  .react-date-picker__decade-view--theme-default .react-date-picker__decade-view-year--active {\n    border: 2px solid #349aef; }\n  .react-date-picker__decade-view--theme-default .react-date-picker__decade-view-year--value {\n    color: white;\n    background: #349aef padding-box;\n    border: 2px solid #349aef; }\n  .react-date-picker__decade-view--theme-default .react-date-picker__decade-view-year--active.react-date-picker__decade-view-year--value {\n    background: #4ca6f1 padding-box; }\n\n.react-date-picker__history-view--theme-default {\n  border: 1px solid gray;\n  padding: 2px; }\n  .react-date-picker__history-view--theme-default .react-date-picker__year-view--theme-default,\n  .react-date-picker__history-view--theme-default .react-date-picker__decade-view--theme-default {\n    border: none; }\n\n.react-date-picker__nav-bar .react-date-picker__history-view--theme-default {\n  font-size: 0.833em; }\n\n.react-date-picker__nav-bar--theme-default {\n  padding-top: 5px;\n  padding-bottom: 5px;\n  font-size: 1.2rem; }\n  .react-date-picker__nav-bar--theme-default .react-date-picker__nav-bar-secondary-arrow {\n    margin-right: 7px; }\n  .react-date-picker__nav-bar--theme-default .react-date-picker__nav-bar-history-view {\n    background: white; }\n  .react-date-picker__nav-bar--theme-default.react-date-picker__nav-bar--with-history-view .react-date-picker__nav-bar-date {\n    cursor: pointer; }\n  .react-date-picker__nav-bar--theme-default .react-date-picker__nav-bar-arrow {\n    position: relative;\n    fill: #676767; }\n    .react-date-picker__nav-bar--theme-default .react-date-picker__nav-bar-arrow--disabled {\n      fill: #C5C5C5; }\n    .react-date-picker__nav-bar--theme-default .react-date-picker__nav-bar-arrow:not(.react-date-picker__nav-bar-arrow--disabled):hover {\n      fill: #9a9a9a; }\n    .react-date-picker__nav-bar--theme-default .react-date-picker__nav-bar-arrow:not(.react-date-picker__nav-bar-arrow--disabled):active {\n      top: 1px; }\n\n.react-date-picker__calendar--theme-default {\n  border: 1px solid gray; }\n  .react-date-picker__calendar--theme-default .react-date-picker__month-view--theme-default {\n    border: none; }\n  .react-date-picker__calendar--theme-default .react-date-picker__clock {\n    margin: 10px; }\n\n.react-date-picker__calendar--theme-default,\n.react-date-picker__month-view--theme-default,\n.react-date-picker__date-field--theme-default,\n.react-date-picker__transition-month-view--theme-default {\n  font-size: 16px;\n  font-size: 1em; }\n\n.react-date-picker__transition-month-view--theme-default {\n  border: 1px solid gray; }\n  .react-date-picker__transition-month-view--theme-default .react-date-picker__month-view--theme-default,\n  .react-date-picker__transition-month-view--theme-default .react-date-picker__multi-month-view--theme-default,\n  .react-date-picker__transition-month-view--theme-default .react-date-picker__calendar--theme-default {\n    border: none; }\n\n.react-date-picker__navigation-view--theme-default {\n  border: 1px solid gray; }\n  .react-date-picker__navigation-view--theme-default .react-date-picker__month-view,\n  .react-date-picker__navigation-view--theme-default .react-date-picker__multi-month-view {\n    border: none; }\n\n.react-date-picker__month-view--theme-default {\n  background: white;\n  position: relative;\n  border: 1px solid gray;\n  overflow: hidden; }\n  .react-date-picker__month-view--theme-default .react-date-picker__month-view-week-day-names {\n    text-transform: uppercase; }\n  .react-date-picker__month-view--theme-default .react-date-picker__month-view-week-number {\n    color: #B1B1B1;\n    font-size: 0.8em; }\n  .react-date-picker__month-view--theme-default .react-date-picker__month-view-cell {\n    min-width: 40px; }\n  .react-date-picker__month-view--theme-default .react-date-picker__month-view-day {\n    z-index: 10; }\n    .react-date-picker__month-view--theme-default .react-date-picker__month-view-day .react-date-picker__month-view-day-text {\n      border: 2px solid transparent;\n      border-radius: 50%;\n      cursor: pointer;\n      text-align: center;\n      min-width: 40px;\n      min-height: 40px;\n      max-width: 40px;\n      max-height: 40px;\n      display: -webkit-box;\n      display: -webkit-flex;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-align: center;\n      -webkit-align-items: center;\n          -ms-flex-align: center;\n              align-items: center;\n      -webkit-box-pack: center;\n      -webkit-justify-content: center;\n          -ms-flex-pack: center;\n              justify-content: center; }\n      .react-date-picker__month-view--theme-default .react-date-picker__month-view-day .react-date-picker__month-view-day-text:hover {\n        background: #D8EDFF padding-box; }\n    .react-date-picker__month-view--theme-default .react-date-picker__month-view-day--in-hover-range, .react-date-picker__month-view--theme-default .react-date-picker__month-view-day--in-range {\n      overflow: hidden; }\n      .react-date-picker__month-view--theme-default .react-date-picker__month-view-day--in-hover-range .react-date-picker__month-view-day-text, .react-date-picker__month-view--theme-default .react-date-picker__month-view-day--in-range .react-date-picker__month-view-day-text {\n        position: relative; }\n        .react-date-picker__month-view--theme-default .react-date-picker__month-view-day--in-hover-range .react-date-picker__month-view-day-text:after, .react-date-picker__month-view--theme-default .react-date-picker__month-view-day--in-hover-range .react-date-picker__month-view-day-text:before, .react-date-picker__month-view--theme-default .react-date-picker__month-view-day--in-range .react-date-picker__month-view-day-text:after, .react-date-picker__month-view--theme-default .react-date-picker__month-view-day--in-range .react-date-picker__month-view-day-text:before {\n          position: absolute;\n          height: 100%;\n          top: 0px;\n          bottom: 0px;\n          width: 500%;\n          background: #349aef;\n          z-index: -1;\n          content: ''; }\n        .react-date-picker__month-view--theme-default .react-date-picker__month-view-day--in-hover-range .react-date-picker__month-view-day-text:before, .react-date-picker__month-view--theme-default .react-date-picker__month-view-day--in-range .react-date-picker__month-view-day-text:before {\n          right: 50%; }\n        .react-date-picker__month-view--theme-default .react-date-picker__month-view-day--in-hover-range .react-date-picker__month-view-day-text:after, .react-date-picker__month-view--theme-default .react-date-picker__month-view-day--in-range .react-date-picker__month-view-day-text:after {\n          left: 50%; }\n      .react-date-picker__month-view--theme-default .react-date-picker__month-view-day--in-hover-range.react-date-picker__month-view-day--hover-range-start .react-date-picker__month-view-day-text:before, .react-date-picker__month-view--theme-default .react-date-picker__month-view-day--in-hover-range.react-date-picker__month-view-day--range-start:not(.react-date-picker__month-view-day--in-hover-range) .react-date-picker__month-view-day-text:before, .react-date-picker__month-view--theme-default .react-date-picker__month-view-day--in-range.react-date-picker__month-view-day--hover-range-start .react-date-picker__month-view-day-text:before, .react-date-picker__month-view--theme-default .react-date-picker__month-view-day--in-range.react-date-picker__month-view-day--range-start:not(.react-date-picker__month-view-day--in-hover-range) .react-date-picker__month-view-day-text:before {\n        display: none; }\n      .react-date-picker__month-view--theme-default .react-date-picker__month-view-day--in-hover-range.react-date-picker__month-view-day--hover-range-end .react-date-picker__month-view-day-text:after, .react-date-picker__month-view--theme-default .react-date-picker__month-view-day--in-hover-range.react-date-picker__month-view-day--range-end:not(.react-date-picker__month-view-day--in-hover-range) .react-date-picker__month-view-day-text:after, .react-date-picker__month-view--theme-default .react-date-picker__month-view-day--in-range.react-date-picker__month-view-day--hover-range-end .react-date-picker__month-view-day-text:after, .react-date-picker__month-view--theme-default .react-date-picker__month-view-day--in-range.react-date-picker__month-view-day--range-end:not(.react-date-picker__month-view-day--in-hover-range) .react-date-picker__month-view-day-text:after {\n        display: none; }\n      .react-date-picker__month-view--theme-default .react-date-picker__month-view-day--in-hover-range.react-date-picker__month-view-day--hover-range-start:not(.react-date-picker__month-view-day--hover-range-end) .react-date-picker__month-view-day-text:after, .react-date-picker__month-view--theme-default .react-date-picker__month-view-day--in-range.react-date-picker__month-view-day--hover-range-start:not(.react-date-picker__month-view-day--hover-range-end) .react-date-picker__month-view-day-text:after {\n        display: inherit; }\n      .react-date-picker__month-view--theme-default .react-date-picker__month-view-day--in-hover-range.react-date-picker__month-view-day--hover-range-end:not(.react-date-picker__month-view-day--hover-range-start) .react-date-picker__month-view-day-text:before, .react-date-picker__month-view--theme-default .react-date-picker__month-view-day--in-range.react-date-picker__month-view-day--hover-range-end:not(.react-date-picker__month-view-day--hover-range-start) .react-date-picker__month-view-day-text:before {\n        display: inherit; }\n      .react-date-picker__month-view--theme-default .react-date-picker__month-view-day--in-hover-range.react-date-picker__month-view-day--active:not(.react-date-picker__month-view-day--range-start):not(.react-date-picker__month-view-day--range-end):not(.react-date-picker__month-view-day--hover-range-start):not(.react-date-picker__month-view-day--hover-range-end) .react-date-picker__month-view-day-text, .react-date-picker__month-view--theme-default .react-date-picker__month-view-day--in-range.react-date-picker__month-view-day--active:not(.react-date-picker__month-view-day--range-start):not(.react-date-picker__month-view-day--range-end):not(.react-date-picker__month-view-day--hover-range-start):not(.react-date-picker__month-view-day--hover-range-end) .react-date-picker__month-view-day-text {\n        background: #93c9f6 padding-box; }\n        .react-date-picker__month-view--theme-default .react-date-picker__month-view-day--in-hover-range.react-date-picker__month-view-day--active:not(.react-date-picker__month-view-day--range-start):not(.react-date-picker__month-view-day--range-end):not(.react-date-picker__month-view-day--hover-range-start):not(.react-date-picker__month-view-day--hover-range-end) .react-date-picker__month-view-day-text:hover, .react-date-picker__month-view--theme-default .react-date-picker__month-view-day--in-range.react-date-picker__month-view-day--active:not(.react-date-picker__month-view-day--range-start):not(.react-date-picker__month-view-day--range-end):not(.react-date-picker__month-view-day--hover-range-start):not(.react-date-picker__month-view-day--hover-range-end) .react-date-picker__month-view-day-text:hover {\n          background: #93c9f6 padding-box; }\n    .react-date-picker__month-view--theme-default .react-date-picker__month-view-day--in-hover-range .react-date-picker__month-view-day-text, .react-date-picker__month-view--theme-default .react-date-picker__month-view-day--in-range .react-date-picker__month-view-day-text, .react-date-picker__month-view--theme-default .react-date-picker__month-view-day--value .react-date-picker__month-view-day-text {\n      border: 2px solid transparent;\n      background: #349aef padding-box;\n      color: white; }\n      .react-date-picker__month-view--theme-default .react-date-picker__month-view-day--in-hover-range .react-date-picker__month-view-day-text:hover, .react-date-picker__month-view--theme-default .react-date-picker__month-view-day--in-range .react-date-picker__month-view-day-text:hover, .react-date-picker__month-view--theme-default .react-date-picker__month-view-day--value .react-date-picker__month-view-day-text:hover {\n        background: #349aef padding-box; }\n    .react-date-picker__month-view--theme-default .react-date-picker__month-view-day--in-hover-range.react-date-picker__month-view-day--today-highlight .react-date-picker__month-view-day-text, .react-date-picker__month-view--theme-default .react-date-picker__month-view-day--in-range.react-date-picker__month-view-day--today-highlight .react-date-picker__month-view-day-text, .react-date-picker__month-view--theme-default .react-date-picker__month-view-day--value.react-date-picker__month-view-day--today-highlight .react-date-picker__month-view-day-text {\n      color: #ffccff; }\n    .react-date-picker__month-view--theme-default .react-date-picker__month-view-day--in-hover-range .react-date-picker__month-view-day-text {\n      background: #d9ecfc padding-box; }\n      .react-date-picker__month-view--theme-default .react-date-picker__month-view-day--in-hover-range .react-date-picker__month-view-day-text:after, .react-date-picker__month-view--theme-default .react-date-picker__month-view-day--in-hover-range .react-date-picker__month-view-day-text:before {\n        background: #d9ecfc; }\n    .react-date-picker__month-view--theme-default .react-date-picker__month-view-day--hover-range-start .react-date-picker__month-view-day-text, .react-date-picker__month-view--theme-default .react-date-picker__month-view-day--hover-range-end .react-date-picker__month-view-day-text, .react-date-picker__month-view--theme-default .react-date-picker__month-view-day--range-start .react-date-picker__month-view-day-text, .react-date-picker__month-view--theme-default .react-date-picker__month-view-day--range-end .react-date-picker__month-view-day-text {\n      background: #63b2f3 padding-box; }\n      .react-date-picker__month-view--theme-default .react-date-picker__month-view-day--hover-range-start .react-date-picker__month-view-day-text:hover, .react-date-picker__month-view--theme-default .react-date-picker__month-view-day--hover-range-end .react-date-picker__month-view-day-text:hover, .react-date-picker__month-view--theme-default .react-date-picker__month-view-day--range-start .react-date-picker__month-view-day-text:hover, .react-date-picker__month-view--theme-default .react-date-picker__month-view-day--range-end .react-date-picker__month-view-day-text:hover {\n        background: #63b2f3 padding-box; }\n    .react-date-picker__month-view--theme-default .react-date-picker__month-view-day--active .react-date-picker__month-view-day-text {\n      border: 2px solid #349aef; }\n  .react-date-picker__month-view--theme-default .react-date-picker__month-view-day--prev-month,\n  .react-date-picker__month-view--theme-default .react-date-picker__month-view-day--next-month {\n    color: #b3b3b3; }\n  .react-date-picker__month-view--theme-default .react-date-picker__month-view-day--weekend-highlight {\n    color: red; }\n    .react-date-picker__month-view--theme-default .react-date-picker__month-view-day--weekend-highlight.react-date-picker__month-view-day--prev-month, .react-date-picker__month-view--theme-default .react-date-picker__month-view-day--weekend-highlight.react-date-picker__month-view-day--next-month {\n      color: #d68e8e; }\n  .react-date-picker__month-view--theme-default .react-date-picker__month-view-day--today-highlight {\n    color: magenta; }\n    .react-date-picker__month-view--theme-default .react-date-picker__month-view-day--today-highlight.react-date-picker__month-view-day--prev-month, .react-date-picker__month-view--theme-default .react-date-picker__month-view-day--today-highlight.react-date-picker__month-view-day--next-month {\n      color: #ff66ff; }\n  .react-date-picker__month-view--theme-default .react-date-picker__month-view-day--disabled {\n    color: #D8D8D8; }\n    .react-date-picker__month-view--theme-default .react-date-picker__month-view-day--disabled .react-date-picker__month-view-day-text {\n      cursor: default; }\n      .react-date-picker__month-view--theme-default .react-date-picker__month-view-day--disabled .react-date-picker__month-view-day-text:hover {\n        background: none; }\n    .react-date-picker__month-view--theme-default .react-date-picker__month-view-day--disabled.react-date-picker__month-view-day--prev-month, .react-date-picker__month-view--theme-default .react-date-picker__month-view-day--disabled.react-date-picker__month-view-day--next-month {\n      color: #D8D8D8; }\n\n.react-date-picker__multi-month-view {\n  border: 1px solid gray; }\n  .react-date-picker__multi-month-view .react-date-picker__month-view {\n    border: none; }\n"],"sourceRoot":"webpack://"}]);
	
	// exports


/***/ }),

/***/ 2485:
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(283)();
	// imports
	
	
	// module
	exports.push([module.id, ".input-table{border:1px solid #000}.input-table input[type=text]{border-radius:0;width:100%;background-color:#d9d9d9;border:0;text-align:center;padding:0;height:auto;box-shadow:none}.input-table td{background-color:#d9d9d9;text-align:center;padding:6px;width:50px}.input-table thead td{border:3px solid #000;background-color:#595959;color:#fff}.input-table tbody td{border:2px solid #000}.input-table tbody tr:nth-child(2n),.input-table tbody tr:nth-child(2n) input{color:blue}.input-table tbody tr:nth-child(odd),.input-table tbody tr:nth-child(odd) input{color:red}.yellow-input-table input[type=text]{border-radius:0;width:100%;background-color:#fffd38;border:0;text-align:center;padding:0;height:auto;box-shadow:none}.yellow-input-table td{text-align:center;padding:6px;width:50px}.yellow-input-table tbody td{border:1px solid #000;background-color:#fffd38}.yellow-input-table tbody td:first-child{background-color:#fff}.sk-fading-circle{margin:100px auto;width:40px;height:40px;position:relative}.sk-fading-circle .sk-circle{width:100%;height:100%;position:absolute;left:0;top:0}.sk-fading-circle .sk-circle:before{content:\"\";display:block;margin:0 auto;width:15%;height:15%;background-color:#333;border-radius:100%;-webkit-animation:sk-circleFadeDelay 1.2s infinite ease-in-out both;animation:sk-circleFadeDelay 1.2s infinite ease-in-out both}.sk-fading-circle .sk-circle2{-webkit-transform:rotate(30deg);transform:rotate(30deg)}.sk-fading-circle .sk-circle3{-webkit-transform:rotate(60deg);transform:rotate(60deg)}.sk-fading-circle .sk-circle4{-webkit-transform:rotate(90deg);transform:rotate(90deg)}.sk-fading-circle .sk-circle5{-webkit-transform:rotate(120deg);transform:rotate(120deg)}.sk-fading-circle .sk-circle6{-webkit-transform:rotate(150deg);transform:rotate(150deg)}.sk-fading-circle .sk-circle7{-webkit-transform:rotate(180deg);transform:rotate(180deg)}.sk-fading-circle .sk-circle8{-webkit-transform:rotate(210deg);transform:rotate(210deg)}.sk-fading-circle .sk-circle9{-webkit-transform:rotate(240deg);transform:rotate(240deg)}.sk-fading-circle .sk-circle10{-webkit-transform:rotate(270deg);transform:rotate(270deg)}.sk-fading-circle .sk-circle11{-webkit-transform:rotate(300deg);transform:rotate(300deg)}.sk-fading-circle .sk-circle12{-webkit-transform:rotate(330deg);transform:rotate(330deg)}.sk-fading-circle .sk-circle2:before{-webkit-animation-delay:-1.1s;animation-delay:-1.1s}.sk-fading-circle .sk-circle3:before{-webkit-animation-delay:-1s;animation-delay:-1s}.sk-fading-circle .sk-circle4:before{-webkit-animation-delay:-.9s;animation-delay:-.9s}.sk-fading-circle .sk-circle5:before{-webkit-animation-delay:-.8s;animation-delay:-.8s}.sk-fading-circle .sk-circle6:before{-webkit-animation-delay:-.7s;animation-delay:-.7s}.sk-fading-circle .sk-circle7:before{-webkit-animation-delay:-.6s;animation-delay:-.6s}.sk-fading-circle .sk-circle8:before{-webkit-animation-delay:-.5s;animation-delay:-.5s}.sk-fading-circle .sk-circle9:before{-webkit-animation-delay:-.4s;animation-delay:-.4s}.sk-fading-circle .sk-circle10:before{-webkit-animation-delay:-.3s;animation-delay:-.3s}.sk-fading-circle .sk-circle11:before{-webkit-animation-delay:-.2s;animation-delay:-.2s}.sk-fading-circle .sk-circle12:before{-webkit-animation-delay:-.1s;animation-delay:-.1s}@-webkit-keyframes sk-circleFadeDelay{0%,39%,to{opacity:0}40%{opacity:1}}@keyframes sk-circleFadeDelay{0%,39%,to{opacity:0}40%{opacity:1}}.privacy-policy li,.privacy-policy p{font-size:12px}.privacy-policy br,.privacy-policy li,.privacy-policy p{margin:0;padding:0}.privacy-policy strong{font-size:18px}", "", {"version":3,"sources":["/../../../../../../sass-loader/index.js?sourceMap!/Users/RicardoRS/Documents/xtna/XTNA/web_app/src/src/App/app.scss"],"names":[],"mappings":"AAAA,aACE,qBAAwB,CAD1B,8BAII,gBACA,WACA,yBACA,SACA,kBACA,UACA,YACA,eAAiB,CAXrB,gBAeI,yBACA,kBACA,YACA,UAAY,CAlBhB,sBAsBI,sBACA,yBACA,UAAa,CAxBjB,sBA6BM,qBAAwB,CA7B9B,8EAoCQ,UACD,CArCP,gFA2CQ,SACD,CAAC,qCAQJ,gBACA,WACA,yBACA,SACA,kBACA,UACA,YACA,eAAiB,CAVrB,uBAcI,kBACA,YACA,UAAY,CAhBhB,6BAqBM,sBACA,wBAA0B,CAtBhC,yCA0BM,qBAAwB,CACzB,kBAMH,kBACA,WACA,YACA,iBAAmB,CACpB,6BAGC,WACA,YACA,kBACA,OACA,KAAO,CACR,oCAGC,WACA,cACA,cACA,UACA,WACA,sBACA,mBACA,oEACQ,2DAA6D,CACtE,8BAEC,gCACI,AACI,uBAAiB,CAC1B,8BAEC,gCACI,AACI,uBAAiB,CAC1B,8BAEC,gCACI,AACI,uBAAiB,CAC1B,8BAEC,iCACI,AACI,wBAAiB,CAC1B,8BAEC,iCACI,AACI,wBAAiB,CAC1B,8BAEC,iCACI,AACI,wBAAiB,CAC1B,8BAEC,iCACI,AACI,wBAAiB,CAC1B,8BAEC,iCACI,AACI,wBAAiB,CAC1B,+BAEC,iCACI,AACI,wBAAiB,CAC1B,+BAEC,iCACI,AACI,wBAAiB,CAC1B,+BAEC,iCACI,AACI,wBAAiB,CAC1B,qCAEC,8BACQ,qBAAuB,CAChC,qCAEC,4BACQ,mBAAqB,CAC9B,qCAEC,6BACQ,oBAAuB,CAChC,qCAEC,6BACQ,oBAAuB,CAChC,qCAEC,6BACQ,oBAAuB,CAChC,qCAEC,6BACQ,oBAAuB,CAChC,qCAEC,6BACQ,oBAAuB,CAChC,qCAEC,6BACQ,oBAAuB,CAChC,sCAEC,6BACQ,oBAAuB,CAChC,sCAEC,6BACQ,oBAAuB,CAChC,sCAEC,6BACQ,oBAAuB,CAChC,sCAGC,UAAgB,SAAW,CAC3B,IAAM,SAAW,CAAA,CAGnB,8BACE,UAAgB,SAAW,CAC3B,IAAM,SAAW,CAAA,CAGnB,qCAEI,cAAgB,CAFpB,wDAKI,SACA,SAAa,CANjB,uBASI,cAAgB,CACjB","file":"app.scss","sourcesContent":[".input-table {\n  border: 1px solid black;\n\n  input[type=text] {\n    border-radius: 0px;\n    width: 100%;\n    background-color: rgb(217, 217, 217);\n    border: 0px;\n    text-align: center;\n    padding: 0px;\n    height: auto;\n    box-shadow: none;\n  }\n\n  td {\n    background-color: rgb(217, 217, 217);\n    text-align: center;\n    padding: 6px;\n    width: 50px;\n  }\n\n  thead td {\n    border: 3px solid black;\n    background-color: rgb(89, 89, 89);\n    color: white;\n  }\n\n  tbody {\n    td {\n      border: 2px solid black;\n    }\n\n    tr:nth-child(even) {\n      color: blue;\n\n      input {\n        color: blue\n      }\n    }\n    tr:nth-child(odd) {\n      color: red;\n\n      input {\n        color:red\n      }\n    }\n  }\n}\n\n.yellow-input-table {\n\n  input[type=text] {\n    border-radius: 0px;\n    width: 100%;\n    background-color: #fffd38;\n    border: 0px;\n    text-align: center;\n    padding: 0px;\n    height: auto;\n    box-shadow: none;\n  }\n\n  td {\n    text-align: center;\n    padding: 6px;\n    width: 50px;\n  }\n\n  tbody {\n    td {\n      border: 1px solid black;\n      background-color: #fffd38;\n    }\n\n    td:first-child {\n      background-color: white;\n    }\n\n  }\n}\n\n.sk-fading-circle {\n  margin: 100px auto;\n  width: 40px;\n  height: 40px;\n  position: relative;\n}\n\n.sk-fading-circle .sk-circle {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  left: 0;\n  top: 0;\n}\n\n.sk-fading-circle .sk-circle:before {\n  content: '';\n  display: block;\n  margin: 0 auto;\n  width: 15%;\n  height: 15%;\n  background-color: #333;\n  border-radius: 100%;\n  -webkit-animation: sk-circleFadeDelay 1.2s infinite ease-in-out both;\n          animation: sk-circleFadeDelay 1.2s infinite ease-in-out both;\n}\n.sk-fading-circle .sk-circle2 {\n  -webkit-transform: rotate(30deg);\n      -ms-transform: rotate(30deg);\n          transform: rotate(30deg);\n}\n.sk-fading-circle .sk-circle3 {\n  -webkit-transform: rotate(60deg);\n      -ms-transform: rotate(60deg);\n          transform: rotate(60deg);\n}\n.sk-fading-circle .sk-circle4 {\n  -webkit-transform: rotate(90deg);\n      -ms-transform: rotate(90deg);\n          transform: rotate(90deg);\n}\n.sk-fading-circle .sk-circle5 {\n  -webkit-transform: rotate(120deg);\n      -ms-transform: rotate(120deg);\n          transform: rotate(120deg);\n}\n.sk-fading-circle .sk-circle6 {\n  -webkit-transform: rotate(150deg);\n      -ms-transform: rotate(150deg);\n          transform: rotate(150deg);\n}\n.sk-fading-circle .sk-circle7 {\n  -webkit-transform: rotate(180deg);\n      -ms-transform: rotate(180deg);\n          transform: rotate(180deg);\n}\n.sk-fading-circle .sk-circle8 {\n  -webkit-transform: rotate(210deg);\n      -ms-transform: rotate(210deg);\n          transform: rotate(210deg);\n}\n.sk-fading-circle .sk-circle9 {\n  -webkit-transform: rotate(240deg);\n      -ms-transform: rotate(240deg);\n          transform: rotate(240deg);\n}\n.sk-fading-circle .sk-circle10 {\n  -webkit-transform: rotate(270deg);\n      -ms-transform: rotate(270deg);\n          transform: rotate(270deg);\n}\n.sk-fading-circle .sk-circle11 {\n  -webkit-transform: rotate(300deg);\n      -ms-transform: rotate(300deg);\n          transform: rotate(300deg); \n}\n.sk-fading-circle .sk-circle12 {\n  -webkit-transform: rotate(330deg);\n      -ms-transform: rotate(330deg);\n          transform: rotate(330deg); \n}\n.sk-fading-circle .sk-circle2:before {\n  -webkit-animation-delay: -1.1s;\n          animation-delay: -1.1s; \n}\n.sk-fading-circle .sk-circle3:before {\n  -webkit-animation-delay: -1s;\n          animation-delay: -1s; \n}\n.sk-fading-circle .sk-circle4:before {\n  -webkit-animation-delay: -0.9s;\n          animation-delay: -0.9s; \n}\n.sk-fading-circle .sk-circle5:before {\n  -webkit-animation-delay: -0.8s;\n          animation-delay: -0.8s; \n}\n.sk-fading-circle .sk-circle6:before {\n  -webkit-animation-delay: -0.7s;\n          animation-delay: -0.7s; \n}\n.sk-fading-circle .sk-circle7:before {\n  -webkit-animation-delay: -0.6s;\n          animation-delay: -0.6s; \n}\n.sk-fading-circle .sk-circle8:before {\n  -webkit-animation-delay: -0.5s;\n          animation-delay: -0.5s; \n}\n.sk-fading-circle .sk-circle9:before {\n  -webkit-animation-delay: -0.4s;\n          animation-delay: -0.4s;\n}\n.sk-fading-circle .sk-circle10:before {\n  -webkit-animation-delay: -0.3s;\n          animation-delay: -0.3s;\n}\n.sk-fading-circle .sk-circle11:before {\n  -webkit-animation-delay: -0.2s;\n          animation-delay: -0.2s;\n}\n.sk-fading-circle .sk-circle12:before {\n  -webkit-animation-delay: -0.1s;\n          animation-delay: -0.1s;\n}\n\n@-webkit-keyframes sk-circleFadeDelay {\n  0%, 39%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n}\n\n@keyframes sk-circleFadeDelay {\n  0%, 39%, 100% { opacity: 0; }\n  40% { opacity: 1; } \n}\n\n.privacy-policy {\n  p, li {\n    font-size: 12px;\n  }\n  br, p, li {\n    margin: 0px;\n    padding: 0px;\n  }\n  strong {\n    font-size: 18px;\n  }\n}\n"],"sourceRoot":"webpack://"}]);
	
	// exports


/***/ }),

/***/ 2810:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "669b561618d077aa47d9b92317ca9647.png";

/***/ }),

/***/ 2811:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b6c21db7355a03afdd8b59415b1eb9ed.png";

/***/ }),

/***/ 2812:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d6c0fbc4c4910e59570c0b0070e8d76b.png";

/***/ }),

/***/ 2813:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "32f65eef12672bb96824af271424fa3a.png";

/***/ }),

/***/ 2814:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "cc86515fde3db39833d5915b5d49ae81.png";

/***/ }),

/***/ 2815:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "4f7bfca3e4110decb3996a4a2d014144.png";

/***/ }),

/***/ 3964:
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(2484);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(439)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../css-loader/index.js?sourceMap!./index.css", function() {
				var newContent = require("!!../css-loader/index.js?sourceMap!./index.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ })

});


// WEBPACK FOOTER //
// app.f577b0cf0e0d84f1d8b4.js